import { CircularProgress } from "@mui/material";
import Lottie from "lottie-react";

const json = {
    "v": "5.6.8",
    "fr": 30,
    "ip": 0,
    "op": 90,
    "w": 200,
    "h": 200,
    "nm": "Loader",
    "ddd": 0,
    "assets": [
        {
            "id": "comp_0",
            "layers": [
                {
                    "ddd": 0,
                    "ind": 1,
                    "ty": 4,
                    "nm": "Layer 5",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                350,
                                350,
                                0
                            ],
                            "ix": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0,
                                0
                            ],
                            "ix": 1
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    -2.303,
                                                    0.323
                                                ],
                                                [
                                                    -0.072,
                                                    0.01
                                                ],
                                                [
                                                    0.013,
                                                    -0.003
                                                ],
                                                [
                                                    0.343,
                                                    -0.115
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.957,
                                                    -0.305
                                                ],
                                                [
                                                    0.025,
                                                    -0.001
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.072,
                                                    -0.01
                                                ],
                                                [
                                                    -0.013,
                                                    0.002
                                                ],
                                                [
                                                    -0.343,
                                                    0.102
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.932,
                                                    0.33
                                                ],
                                                [
                                                    -0.036,
                                                    0
                                                ],
                                                [
                                                    2.262,
                                                    -0.422
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    94.078,
                                                    -148.201
                                                ],
                                                [
                                                    94.296,
                                                    -148.233
                                                ],
                                                [
                                                    94.256,
                                                    -148.226
                                                ],
                                                [
                                                    93.226,
                                                    -147.921
                                                ],
                                                [
                                                    93.188,
                                                    -147.921
                                                ],
                                                [
                                                    87.341,
                                                    -146.98
                                                ],
                                                [
                                                    87.246,
                                                    -146.968
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 1,
                                    "ty": "sh",
                                    "ix": 2,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    -0.221,
                                                    0.029
                                                ],
                                                [
                                                    0.024,
                                                    -0.012
                                                ],
                                                [
                                                    0.14,
                                                    -0.025
                                                ],
                                                [
                                                    0.051,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.024,
                                                    0
                                                ],
                                                [
                                                    -0.14,
                                                    0.026
                                                ],
                                                [
                                                    -0.038,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.221,
                                                    -0.03
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    82.674,
                                                    -146.255
                                                ],
                                                [
                                                    82.613,
                                                    -146.243
                                                ],
                                                [
                                                    82.181,
                                                    -146.18
                                                ],
                                                [
                                                    82.054,
                                                    -146.167
                                                ],
                                                [
                                                    82.013,
                                                    -146.167
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 2",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 2,
                                    "ty": "sh",
                                    "ix": 3,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    -3.187,
                                                    0.352
                                                ],
                                                [
                                                    -2.37,
                                                    0.142
                                                ],
                                                [
                                                    0.006,
                                                    -0.001
                                                ],
                                                [
                                                    1.284,
                                                    -0.241
                                                ],
                                                [
                                                    0.89,
                                                    -0.089
                                                ],
                                                [
                                                    1.169,
                                                    -0.127
                                                ],
                                                [
                                                    2.059,
                                                    -0.153
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.094,
                                                    -0.006
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    2.326,
                                                    -0.257
                                                ],
                                                [
                                                    -0.006,
                                                    0.001
                                                ],
                                                [
                                                    -1.271,
                                                    0.28
                                                ],
                                                [
                                                    -0.89,
                                                    0.115
                                                ],
                                                [
                                                    -1.169,
                                                    0.127
                                                ],
                                                [
                                                    -2.046,
                                                    0.153
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.094,
                                                    0.005
                                                ],
                                                [
                                                    3.127,
                                                    -0.381
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    63.418,
                                                    -144.354
                                                ],
                                                [
                                                    70.479,
                                                    -144.811
                                                ],
                                                [
                                                    70.462,
                                                    -144.807
                                                ],
                                                [
                                                    66.636,
                                                    -144.006
                                                ],
                                                [
                                                    63.98,
                                                    -143.701
                                                ],
                                                [
                                                    60.472,
                                                    -143.32
                                                ],
                                                [
                                                    54.307,
                                                    -142.9
                                                ],
                                                [
                                                    54.269,
                                                    -142.9
                                                ],
                                                [
                                                    53.989,
                                                    -142.879
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 3",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 3,
                                    "ty": "sh",
                                    "ix": 4,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    -0.779,
                                                    -0.132
                                                ],
                                                [
                                                    -0.979,
                                                    -0.204
                                                ],
                                                [
                                                    0.023,
                                                    0.005
                                                ],
                                                [
                                                    1.538,
                                                    0.28
                                                ],
                                                [
                                                    0.14,
                                                    0.025
                                                ],
                                                [
                                                    0.027,
                                                    0.005
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.953,
                                                    0.161
                                                ],
                                                [
                                                    -0.023,
                                                    -0.004
                                                ],
                                                [
                                                    -1.563,
                                                    -0.267
                                                ],
                                                [
                                                    -0.14,
                                                    -0.025
                                                ],
                                                [
                                                    -0.035,
                                                    -0.009
                                                ],
                                                [
                                                    0.759,
                                                    0.121
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -154.075,
                                                    -147.386
                                                ],
                                                [
                                                    -151.173,
                                                    -146.828
                                                ],
                                                [
                                                    -151.242,
                                                    -146.841
                                                ],
                                                [
                                                    -155.881,
                                                    -147.667
                                                ],
                                                [
                                                    -156.288,
                                                    -147.743
                                                ],
                                                [
                                                    -156.376,
                                                    -147.761
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 4",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 4,
                                    "ty": "sh",
                                    "ix": 5,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.826,
                                                    1.551
                                                ],
                                                [
                                                    -0.508,
                                                    1.004
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.449,
                                                    2.174
                                                ],
                                                [
                                                    -2.237,
                                                    2.669
                                                ],
                                                [
                                                    -2.923,
                                                    2.834
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.326,
                                                    1.868
                                                ],
                                                [
                                                    -2.008,
                                                    1.271
                                                ],
                                                [
                                                    -0.979,
                                                    0.648
                                                ],
                                                [
                                                    -1.144,
                                                    0.852
                                                ],
                                                [
                                                    -1.665,
                                                    0.928
                                                ],
                                                [
                                                    -1.843,
                                                    0.686
                                                ],
                                                [
                                                    -1.525,
                                                    0.699
                                                ],
                                                [
                                                    -1.182,
                                                    0.584
                                                ],
                                                [
                                                    -1.881,
                                                    0.687
                                                ],
                                                [
                                                    -3.915,
                                                    1.081
                                                ],
                                                [
                                                    -1.169,
                                                    0.356
                                                ],
                                                [
                                                    -2.034,
                                                    0.369
                                                ],
                                                [
                                                    -1.945,
                                                    0.165
                                                ],
                                                [
                                                    -1.64,
                                                    0.229
                                                ],
                                                [
                                                    -1.563,
                                                    0.293
                                                ],
                                                [
                                                    -1.856,
                                                    0.204
                                                ],
                                                [
                                                    -2.097,
                                                    0.089
                                                ],
                                                [
                                                    -1.487,
                                                    0.114
                                                ],
                                                [
                                                    -1.449,
                                                    0.153
                                                ],
                                                [
                                                    -1.97,
                                                    0.064
                                                ],
                                                [
                                                    -3.8,
                                                    0
                                                ],
                                                [
                                                    -1.817,
                                                    -0.241
                                                ],
                                                [
                                                    -1.843,
                                                    -0.064
                                                ],
                                                [
                                                    -1.716,
                                                    0.051
                                                ],
                                                [
                                                    -1.652,
                                                    -0.14
                                                ],
                                                [
                                                    -1.932,
                                                    -0.356
                                                ],
                                                [
                                                    -1.589,
                                                    -0.204
                                                ],
                                                [
                                                    -1.703,
                                                    -0.051
                                                ],
                                                [
                                                    -1.538,
                                                    -0.267
                                                ],
                                                [
                                                    -1.868,
                                                    -0.572
                                                ],
                                                [
                                                    -1.576,
                                                    -0.369
                                                ],
                                                [
                                                    -0.343,
                                                    -0.051
                                                ],
                                                [
                                                    -0.28,
                                                    -0.064
                                                ],
                                                [
                                                    -1.652,
                                                    -0.216
                                                ],
                                                [
                                                    -1.36,
                                                    -0.356
                                                ],
                                                [
                                                    -1.881,
                                                    -0.623
                                                ],
                                                [
                                                    -1.271,
                                                    -0.382
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.402,
                                                    -0.826
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.313,
                                                    -0.928
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.428,
                                                    -1.144
                                                ],
                                                [
                                                    -1.665,
                                                    -1.042
                                                ],
                                                [
                                                    -1.131,
                                                    -0.635
                                                ],
                                                [
                                                    -1.856,
                                                    -1.309
                                                ],
                                                [
                                                    -0.775,
                                                    -0.534
                                                ],
                                                [
                                                    -2.453,
                                                    -2.097
                                                ],
                                                [
                                                    -0.686,
                                                    -0.572
                                                ],
                                                [
                                                    -1.309,
                                                    -1.461
                                                ],
                                                [
                                                    -1.309,
                                                    -2.097
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.966,
                                                    -1.182
                                                ],
                                                [
                                                    -0.521,
                                                    -0.941
                                                ],
                                                [
                                                    -0.597,
                                                    -1.499
                                                ],
                                                [
                                                    -0.724,
                                                    -1.385
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.75,
                                                    -1.36
                                                ],
                                                [
                                                    2.974,
                                                    -0.433
                                                ],
                                                [
                                                    3.381,
                                                    -0.458
                                                ],
                                                [
                                                    3.381,
                                                    -0.42
                                                ],
                                                [
                                                    3.381,
                                                    -0.382
                                                ],
                                                [
                                                    3.394,
                                                    -0.355
                                                ],
                                                [
                                                    3.381,
                                                    -0.318
                                                ],
                                                [
                                                    3.381,
                                                    -0.28
                                                ],
                                                [
                                                    3.381,
                                                    -0.242
                                                ],
                                                [
                                                    3.394,
                                                    -0.203
                                                ],
                                                [
                                                    3.394,
                                                    -0.166
                                                ],
                                                [
                                                    3.394,
                                                    -0.127
                                                ],
                                                [
                                                    3.394,
                                                    -0.089
                                                ],
                                                [
                                                    3.394,
                                                    -0.051
                                                ],
                                                [
                                                    3.394,
                                                    -0.012
                                                ],
                                                [
                                                    3.381,
                                                    0.038
                                                ],
                                                [
                                                    3.381,
                                                    0.089
                                                ],
                                                [
                                                    3.368,
                                                    0.127
                                                ],
                                                [
                                                    3.355,
                                                    0.165
                                                ],
                                                [
                                                    3.355,
                                                    0.216
                                                ],
                                                [
                                                    3.33,
                                                    0.267
                                                ],
                                                [
                                                    3.33,
                                                    0.318
                                                ],
                                                [
                                                    3.305,
                                                    0.369
                                                ],
                                                [
                                                    3.279,
                                                    0.42
                                                ],
                                                [
                                                    3.254,
                                                    0.483
                                                ],
                                                [
                                                    3.203,
                                                    0.534
                                                ],
                                                [
                                                    3.127,
                                                    0.598
                                                ],
                                                [
                                                    3.012,
                                                    0.648
                                                ],
                                                [
                                                    2.631,
                                                    0.534
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.635,
                                                    -1.462
                                                ],
                                                [
                                                    0.547,
                                                    -0.991
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.271,
                                                    -2.567
                                                ],
                                                [
                                                    1.83,
                                                    -2.72
                                                ],
                                                [
                                                    1.881,
                                                    -2.224
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.301,
                                                    -2.224
                                                ],
                                                [
                                                    1.665,
                                                    -1.335
                                                ],
                                                [
                                                    1.004,
                                                    -0.648
                                                ],
                                                [
                                                    1.182,
                                                    -0.801
                                                ],
                                                [
                                                    1.741,
                                                    -1.271
                                                ],
                                                [
                                                    1.474,
                                                    -0.826
                                                ],
                                                [
                                                    1.474,
                                                    -0.534
                                                ],
                                                [
                                                    1.207,
                                                    -0.559
                                                ],
                                                [
                                                    2.008,
                                                    -1.004
                                                ],
                                                [
                                                    2.809,
                                                    -1.03
                                                ],
                                                [
                                                    1.195,
                                                    -0.318
                                                ],
                                                [
                                                    2.25,
                                                    -0.686
                                                ],
                                                [
                                                    1.729,
                                                    -0.318
                                                ],
                                                [
                                                    1.652,
                                                    -0.153
                                                ],
                                                [
                                                    1.563,
                                                    -0.229
                                                ],
                                                [
                                                    1.983,
                                                    -0.369
                                                ],
                                                [
                                                    1.932,
                                                    -0.204
                                                ],
                                                [
                                                    1.5,
                                                    -0.051
                                                ],
                                                [
                                                    1.462,
                                                    -0.102
                                                ],
                                                [
                                                    2.135,
                                                    -0.204
                                                ],
                                                [
                                                    3.292,
                                                    -0.127
                                                ],
                                                [
                                                    1.614,
                                                    0
                                                ],
                                                [
                                                    1.703,
                                                    0.216
                                                ],
                                                [
                                                    1.729,
                                                    0.063
                                                ],
                                                [
                                                    1.881,
                                                    -0.051
                                                ],
                                                [
                                                    1.792,
                                                    0.14
                                                ],
                                                [
                                                    1.602,
                                                    0.292
                                                ],
                                                [
                                                    1.856,
                                                    0.228
                                                ],
                                                [
                                                    1.843,
                                                    0.076
                                                ],
                                                [
                                                    1.729,
                                                    0.305
                                                ],
                                                [
                                                    1.563,
                                                    0.483
                                                ],
                                                [
                                                    0.661,
                                                    0.152
                                                ],
                                                [
                                                    0.14,
                                                    0.025
                                                ],
                                                [
                                                    1.779,
                                                    0.407
                                                ],
                                                [
                                                    1.627,
                                                    0.216
                                                ],
                                                [
                                                    1.818,
                                                    0.47
                                                ],
                                                [
                                                    1.284,
                                                    0.432
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.555,
                                                    0.763
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.593,
                                                    0.889
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.771,
                                                    1.118
                                                ],
                                                [
                                                    1.627,
                                                    0.775
                                                ],
                                                [
                                                    1.131,
                                                    0.712
                                                ],
                                                [
                                                    1.881,
                                                    1.055
                                                ],
                                                [
                                                    0.775,
                                                    0.559
                                                ],
                                                [
                                                    2.491,
                                                    1.716
                                                ],
                                                [
                                                    0.699,
                                                    0.597
                                                ],
                                                [
                                                    1.779,
                                                    1.475
                                                ],
                                                [
                                                    1.5,
                                                    1.703
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.991,
                                                    1.538
                                                ],
                                                [
                                                    0.915,
                                                    1.131
                                                ],
                                                [
                                                    0.725,
                                                    1.297
                                                ],
                                                [
                                                    0.547,
                                                    1.36
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.763,
                                                    1.475
                                                ],
                                                [
                                                    -3.038,
                                                    0.483
                                                ],
                                                [
                                                    -3.432,
                                                    0.495
                                                ],
                                                [
                                                    -3.432,
                                                    0.47
                                                ],
                                                [
                                                    -3.444,
                                                    0.432
                                                ],
                                                [
                                                    -3.444,
                                                    0.393
                                                ],
                                                [
                                                    -3.457,
                                                    0.369
                                                ],
                                                [
                                                    -3.457,
                                                    0.318
                                                ],
                                                [
                                                    -3.47,
                                                    0.292
                                                ],
                                                [
                                                    -3.47,
                                                    0.241
                                                ],
                                                [
                                                    -3.47,
                                                    0.217
                                                ],
                                                [
                                                    -3.47,
                                                    0.177
                                                ],
                                                [
                                                    -3.483,
                                                    0.14
                                                ],
                                                [
                                                    -3.483,
                                                    0.089
                                                ],
                                                [
                                                    -3.495,
                                                    0.051
                                                ],
                                                [
                                                    -3.495,
                                                    0
                                                ],
                                                [
                                                    -3.495,
                                                    -0.038
                                                ],
                                                [
                                                    -3.495,
                                                    -0.076
                                                ],
                                                [
                                                    -3.495,
                                                    -0.127
                                                ],
                                                [
                                                    -3.508,
                                                    -0.178
                                                ],
                                                [
                                                    -3.508,
                                                    -0.229
                                                ],
                                                [
                                                    -3.521,
                                                    -0.28
                                                ],
                                                [
                                                    -3.521,
                                                    -0.331
                                                ],
                                                [
                                                    -3.546,
                                                    -0.394
                                                ],
                                                [
                                                    -3.546,
                                                    -0.457
                                                ],
                                                [
                                                    -3.572,
                                                    -0.521
                                                ],
                                                [
                                                    -3.622,
                                                    -0.597
                                                ],
                                                [
                                                    -3.711,
                                                    -0.699
                                                ],
                                                [
                                                    -3.546,
                                                    -0.763
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -179.535,
                                                    -177.167
                                                ],
                                                [
                                                    -177.273,
                                                    -181.667
                                                ],
                                                [
                                                    -175.684,
                                                    -184.666
                                                ],
                                                [
                                                    -174.832,
                                                    -186.395
                                                ],
                                                [
                                                    -170.918,
                                                    -193.563
                                                ],
                                                [
                                                    -164.791,
                                                    -201.685
                                                ],
                                                [
                                                    -157.75,
                                                    -209.095
                                                ],
                                                [
                                                    -156.975,
                                                    -209.845
                                                ],
                                                [
                                                    -150.175,
                                                    -216.047
                                                ],
                                                [
                                                    -144.608,
                                                    -219.861
                                                ],
                                                [
                                                    -141.621,
                                                    -221.792
                                                ],
                                                [
                                                    -138.138,
                                                    -224.284
                                                ],
                                                [
                                                    -133.105,
                                                    -227.69
                                                ],
                                                [
                                                    -128.033,
                                                    -229.838
                                                ],
                                                [
                                                    -123.521,
                                                    -231.631
                                                ],
                                                [
                                                    -119.95,
                                                    -233.359
                                                ],
                                                [
                                                    -114.154,
                                                    -235.99
                                                ],
                                                [
                                                    -104.303,
                                                    -239.079
                                                ],
                                                [
                                                    -100.757,
                                                    -240.108
                                                ],
                                                [
                                                    -94.351,
                                                    -241.799
                                                ],
                                                [
                                                    -88.848,
                                                    -242.447
                                                ],
                                                [
                                                    -83.891,
                                                    -242.98
                                                ],
                                                [
                                                    -79.213,
                                                    -243.781
                                                ],
                                                [
                                                    -73.494,
                                                    -244.696
                                                ],
                                                [
                                                    -67.482,
                                                    -245.077
                                                ],
                                                [
                                                    -62.995,
                                                    -245.306
                                                ],
                                                [
                                                    -58.635,
                                                    -245.7
                                                ],
                                                [
                                                    -52.509,
                                                    -246.171
                                                ],
                                                [
                                                    -41.985,
                                                    -246.361
                                                ],
                                                [
                                                    -36.825,
                                                    -245.904
                                                ],
                                                [
                                                    -31.512,
                                                    -245.395
                                                ],
                                                [
                                                    -26.352,
                                                    -245.434
                                                ],
                                                [
                                                    -21.026,
                                                    -245.408
                                                ],
                                                [
                                                    -15.459,
                                                    -244.582
                                                ],
                                                [
                                                    -10.68,
                                                    -243.806
                                                ],
                                                [
                                                    -5.354,
                                                    -243.464
                                                ],
                                                [
                                                    -0.245,
                                                    -243.07
                                                ],
                                                [
                                                    5.119,
                                                    -241.646
                                                ],
                                                [
                                                    9.822,
                                                    -240.311
                                                ],
                                                [
                                                    11.156,
                                                    -240.057
                                                ],
                                                [
                                                    11.715,
                                                    -239.956
                                                ],
                                                [
                                                    16.85,
                                                    -239.104
                                                ],
                                                [
                                                    21.375,
                                                    -238.329
                                                ],
                                                [
                                                    26.866,
                                                    -236.651
                                                ],
                                                [
                                                    30.679,
                                                    -235.431
                                                ],
                                                [
                                                    32.484,
                                                    -234.897
                                                ],
                                                [
                                                    39.945,
                                                    -232.571
                                                ],
                                                [
                                                    41.699,
                                                    -231.961
                                                ],
                                                [
                                                    49.045,
                                                    -229.304
                                                ],
                                                [
                                                    50.113,
                                                    -228.885
                                                ],
                                                [
                                                    57.917,
                                                    -225.58
                                                ],
                                                [
                                                    62.772,
                                                    -222.784
                                                ],
                                                [
                                                    66.153,
                                                    -220.725
                                                ],
                                                [
                                                    71.631,
                                                    -217.115
                                                ],
                                                [
                                                    73.97,
                                                    -215.463
                                                ],
                                                [
                                                    81.317,
                                                    -209.794
                                                ],
                                                [
                                                    83.401,
                                                    -208.04
                                                ],
                                                [
                                                    88.18,
                                                    -203.706
                                                ],
                                                [
                                                    92.235,
                                                    -197.923
                                                ],
                                                [
                                                    93.277,
                                                    -196.258
                                                ],
                                                [
                                                    96.315,
                                                    -192.19
                                                ],
                                                [
                                                    98.628,
                                                    -189.038
                                                ],
                                                [
                                                    100.522,
                                                    -184.844
                                                ],
                                                [
                                                    102.365,
                                                    -180.688
                                                ],
                                                [
                                                    103.521,
                                                    -178.413
                                                ],
                                                [
                                                    105.758,
                                                    -174.142
                                                ],
                                                [
                                                    96.658,
                                                    -172.756
                                                ],
                                                [
                                                    86.464,
                                                    -171.091
                                                ],
                                                [
                                                    76.22,
                                                    -169.896
                                                ],
                                                [
                                                    65.95,
                                                    -168.867
                                                ],
                                                [
                                                    55.68,
                                                    -167.927
                                                ],
                                                [
                                                    45.448,
                                                    -166.681
                                                ],
                                                [
                                                    35.204,
                                                    -165.448
                                                ],
                                                [
                                                    24.871,
                                                    -165.423
                                                ],
                                                [
                                                    14.588,
                                                    -164.711
                                                ],
                                                [
                                                    4.318,
                                                    -163.732
                                                ],
                                                [
                                                    -5.964,
                                                    -163.021
                                                ],
                                                [
                                                    -16.298,
                                                    -163.453
                                                ],
                                                [
                                                    -26.593,
                                                    -162.894
                                                ],
                                                [
                                                    -36.914,
                                                    -162.487
                                                ],
                                                [
                                                    -47.235,
                                                    -162.423
                                                ],
                                                [
                                                    -57.555,
                                                    -162.588
                                                ],
                                                [
                                                    -67.85,
                                                    -163.376
                                                ],
                                                [
                                                    -78.133,
                                                    -163.821
                                                ],
                                                [
                                                    -88.416,
                                                    -164.571
                                                ],
                                                [
                                                    -98.66,
                                                    -165.575
                                                ],
                                                [
                                                    -108.93,
                                                    -166.427
                                                ],
                                                [
                                                    -119.238,
                                                    -166.758
                                                ],
                                                [
                                                    -129.47,
                                                    -168.003
                                                ],
                                                [
                                                    -139.663,
                                                    -169.49
                                                ],
                                                [
                                                    -149.882,
                                                    -170.812
                                                ],
                                                [
                                                    -159.873,
                                                    -173.405
                                                ],
                                                [
                                                    -169.939,
                                                    -175.502
                                                ],
                                                [
                                                    -179.535,
                                                    -176.926
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 5",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 5,
                                    "ty": "sh",
                                    "ix": 6,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    1.384,
                                                    -0.177
                                                ],
                                                [
                                                    3.354,
                                                    -1.198
                                                ],
                                                [
                                                    0.859,
                                                    -0.374
                                                ],
                                                [
                                                    -0.043,
                                                    0.017
                                                ],
                                                [
                                                    -0.025,
                                                    0.013
                                                ],
                                                [
                                                    -0.33,
                                                    0.14
                                                ],
                                                [
                                                    -3.94,
                                                    0.445
                                                ],
                                                [
                                                    -1.64,
                                                    -0.038
                                                ],
                                                [
                                                    -0.013,
                                                    -0.013
                                                ],
                                                [
                                                    -0.134,
                                                    -0.002
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -3.626,
                                                    0.466
                                                ],
                                                [
                                                    -0.897,
                                                    0.321
                                                ],
                                                [
                                                    0.047,
                                                    -0.021
                                                ],
                                                [
                                                    0.025,
                                                    0
                                                ],
                                                [
                                                    0.331,
                                                    -0.14
                                                ],
                                                [
                                                    3.254,
                                                    -1.36
                                                ],
                                                [
                                                    1.589,
                                                    -0.178
                                                ],
                                                [
                                                    0.013,
                                                    -0.013
                                                ],
                                                [
                                                    0.134,
                                                    0.001
                                                ],
                                                [
                                                    -1.394,
                                                    0.025
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -136.122,
                                                    -130.163
                                                ],
                                                [
                                                    -146.65,
                                                    -127.615
                                                ],
                                                [
                                                    -149.282,
                                                    -126.571
                                                ],
                                                [
                                                    -149.145,
                                                    -126.631
                                                ],
                                                [
                                                    -149.056,
                                                    -126.669
                                                ],
                                                [
                                                    -148.065,
                                                    -127.101
                                                ],
                                                [
                                                    -137.236,
                                                    -130.228
                                                ],
                                                [
                                                    -132.393,
                                                    -130.444
                                                ],
                                                [
                                                    -132.355,
                                                    -130.444
                                                ],
                                                [
                                                    -131.952,
                                                    -130.434
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 6",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 6,
                                    "ty": "sh",
                                    "ix": 7,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.094,
                                                    -0.112
                                                ],
                                                [
                                                    1.753,
                                                    -2.482
                                                ],
                                                [
                                                    0.846,
                                                    -1.328
                                                ],
                                                [
                                                    -0.003,
                                                    0.006
                                                ],
                                                [
                                                    -0.013,
                                                    0.012
                                                ],
                                                [
                                                    -1.538,
                                                    1.958
                                                ],
                                                [
                                                    -1.78,
                                                    1.805
                                                ],
                                                [
                                                    -0.002,
                                                    0.002
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.972,
                                                    2.356
                                                ],
                                                [
                                                    -0.892,
                                                    1.263
                                                ],
                                                [
                                                    0.003,
                                                    -0.006
                                                ],
                                                [
                                                    0.013,
                                                    -0.025
                                                ],
                                                [
                                                    0.991,
                                                    -2.021
                                                ],
                                                [
                                                    1.398,
                                                    -1.792
                                                ],
                                                [
                                                    0.002,
                                                    -0.002
                                                ],
                                                [
                                                    -0.095,
                                                    0.111
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -76.372,
                                                    -104.473
                                                ],
                                                [
                                                    -81.936,
                                                    -97.154
                                                ],
                                                [
                                                    -84.535,
                                                    -93.248
                                                ],
                                                [
                                                    -84.526,
                                                    -93.267
                                                ],
                                                [
                                                    -84.501,
                                                    -93.317
                                                ],
                                                [
                                                    -80.815,
                                                    -99.343
                                                ],
                                                [
                                                    -76.087,
                                                    -104.795
                                                ],
                                                [
                                                    -76.082,
                                                    -104.8
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 7",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 7,
                                    "ty": "sh",
                                    "ix": 8,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    2.529,
                                                    -2.402
                                                ],
                                                [
                                                    2.745,
                                                    -2.174
                                                ],
                                                [
                                                    3.305,
                                                    -1.487
                                                ],
                                                [
                                                    3.648,
                                                    -0.724
                                                ],
                                                [
                                                    3.775,
                                                    -0.076
                                                ],
                                                [
                                                    3.762,
                                                    0.433
                                                ],
                                                [
                                                    3.686,
                                                    0.788
                                                ],
                                                [
                                                    3.61,
                                                    1.055
                                                ],
                                                [
                                                    3.178,
                                                    1.182
                                                ],
                                                [
                                                    3.038,
                                                    1.462
                                                ],
                                                [
                                                    2.847,
                                                    1.805
                                                ],
                                                [
                                                    2.542,
                                                    2.212
                                                ],
                                                [
                                                    1.785,
                                                    2.115
                                                ],
                                                [
                                                    0.147,
                                                    0.983
                                                ],
                                                [
                                                    0.159,
                                                    0.768
                                                ],
                                                [
                                                    0.014,
                                                    0.079
                                                ],
                                                [
                                                    0.106,
                                                    0.45
                                                ],
                                                [
                                                    0.026,
                                                    0.08
                                                ],
                                                [
                                                    0.055,
                                                    0.238
                                                ],
                                                [
                                                    0.106,
                                                    0.291
                                                ],
                                                [
                                                    0.027,
                                                    0.053
                                                ],
                                                [
                                                    0.132,
                                                    0.45
                                                ],
                                                [
                                                    0.045,
                                                    0.144
                                                ],
                                                [
                                                    1.616,
                                                    2.755
                                                ],
                                                [
                                                    0.768,
                                                    1.007
                                                ],
                                                [
                                                    0.142,
                                                    0.192
                                                ],
                                                [
                                                    0.503,
                                                    0.583
                                                ],
                                                [
                                                    0.178,
                                                    0.194
                                                ],
                                                [
                                                    -0.312,
                                                    2.362
                                                ],
                                                [
                                                    -1.093,
                                                    2.719
                                                ],
                                                [
                                                    -1.945,
                                                    1.971
                                                ],
                                                [
                                                    -3.457,
                                                    0
                                                ],
                                                [
                                                    -3.699,
                                                    -0.801
                                                ],
                                                [
                                                    -1.894,
                                                    -0.318
                                                ],
                                                [
                                                    -3.419,
                                                    -0.012
                                                ],
                                                [
                                                    -3.406,
                                                    0.457
                                                ],
                                                [
                                                    -3.343,
                                                    0.827
                                                ],
                                                [
                                                    -3.241,
                                                    1.144
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.915,
                                                    1.703
                                                ],
                                                [
                                                    -3.826,
                                                    1.779
                                                ],
                                                [
                                                    -3.826,
                                                    1.665
                                                ],
                                                [
                                                    -3.889,
                                                    1.36
                                                ],
                                                [
                                                    -3.101,
                                                    0.305
                                                ],
                                                [
                                                    -2.745,
                                                    -1.665
                                                ],
                                                [
                                                    -1.919,
                                                    -3.012
                                                ],
                                                [
                                                    -1.042,
                                                    -3.152
                                                ],
                                                [
                                                    -0.381,
                                                    -3.318
                                                ],
                                                [
                                                    0.191,
                                                    -3.33
                                                ],
                                                [
                                                    0.674,
                                                    -3.254
                                                ],
                                                [
                                                    1.106,
                                                    -3.127
                                                ],
                                                [
                                                    1.551,
                                                    -3.063
                                                ],
                                                [
                                                    1.932,
                                                    -2.872
                                                ],
                                                [
                                                    2.262,
                                                    -2.644
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -2.428,
                                                    2.313
                                                ],
                                                [
                                                    -2.834,
                                                    2.237
                                                ],
                                                [
                                                    -3.19,
                                                    1.437
                                                ],
                                                [
                                                    -3.368,
                                                    0.686
                                                ],
                                                [
                                                    -3.419,
                                                    0.063
                                                ],
                                                [
                                                    -3.406,
                                                    -0.381
                                                ],
                                                [
                                                    -3.368,
                                                    -0.724
                                                ],
                                                [
                                                    -3.508,
                                                    -1.029
                                                ],
                                                [
                                                    -3.444,
                                                    -1.283
                                                ],
                                                [
                                                    -3.33,
                                                    -1.589
                                                ],
                                                [
                                                    -3.114,
                                                    -1.958
                                                ],
                                                [
                                                    -2.229,
                                                    -1.95
                                                ],
                                                [
                                                    -0.151,
                                                    -0.99
                                                ],
                                                [
                                                    -0.132,
                                                    -0.795
                                                ],
                                                [
                                                    -0.016,
                                                    -0.079
                                                ],
                                                [
                                                    -0.079,
                                                    -0.424
                                                ],
                                                [
                                                    0,
                                                    -0.079
                                                ],
                                                [
                                                    -0.057,
                                                    -0.238
                                                ],
                                                [
                                                    -0.08,
                                                    -0.318
                                                ],
                                                [
                                                    0,
                                                    -0.08
                                                ],
                                                [
                                                    -0.106,
                                                    -0.45
                                                ],
                                                [
                                                    -0.042,
                                                    -0.145
                                                ],
                                                [
                                                    -1.033,
                                                    -3.259
                                                ],
                                                [
                                                    -0.795,
                                                    -1.298
                                                ],
                                                [
                                                    -0.141,
                                                    -0.192
                                                ],
                                                [
                                                    -0.503,
                                                    -0.636
                                                ],
                                                [
                                                    -0.173,
                                                    -0.203
                                                ],
                                                [
                                                    -0.128,
                                                    -2.412
                                                ],
                                                [
                                                    0.292,
                                                    -2.275
                                                ],
                                                [
                                                    0.966,
                                                    -2.39
                                                ],
                                                [
                                                    2.936,
                                                    -2.961
                                                ],
                                                [
                                                    2.606,
                                                    0
                                                ],
                                                [
                                                    1.818,
                                                    0.381
                                                ],
                                                [
                                                    3.203,
                                                    0.534
                                                ],
                                                [
                                                    3.229,
                                                    0.013
                                                ],
                                                [
                                                    3.19,
                                                    -0.433
                                                ],
                                                [
                                                    3.127,
                                                    -0.788
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    4.055,
                                                    -1.423
                                                ],
                                                [
                                                    3.966,
                                                    -1.729
                                                ],
                                                [
                                                    3.737,
                                                    -1.729
                                                ],
                                                [
                                                    3.839,
                                                    -1.665
                                                ],
                                                [
                                                    3.978,
                                                    -1.385
                                                ],
                                                [
                                                    4.309,
                                                    -0.432
                                                ],
                                                [
                                                    2.123,
                                                    1.284
                                                ],
                                                [
                                                    1.716,
                                                    2.682
                                                ],
                                                [
                                                    0.991,
                                                    3
                                                ],
                                                [
                                                    0.369,
                                                    3.139
                                                ],
                                                [
                                                    -0.178,
                                                    3.165
                                                ],
                                                [
                                                    -0.648,
                                                    3.114
                                                ],
                                                [
                                                    -1.144,
                                                    3.216
                                                ],
                                                [
                                                    -1.538,
                                                    3.025
                                                ],
                                                [
                                                    -1.894,
                                                    2.796
                                                ],
                                                [
                                                    -2.186,
                                                    2.554
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -51.772,
                                                    142.165
                                                ],
                                                [
                                                    -59.538,
                                                    148.889
                                                ],
                                                [
                                                    -68.728,
                                                    154.493
                                                ],
                                                [
                                                    -79.035,
                                                    157.544
                                                ],
                                                [
                                                    -89.712,
                                                    159.006
                                                ],
                                                [
                                                    -100.478,
                                                    158.205
                                                ],
                                                [
                                                    -111.141,
                                                    156.59
                                                ],
                                                [
                                                    -121.627,
                                                    153.998
                                                ],
                                                [
                                                    -131.58,
                                                    150.413
                                                ],
                                                [
                                                    -141.354,
                                                    146.422
                                                ],
                                                [
                                                    -150.569,
                                                    141.262
                                                ],
                                                [
                                                    -159.021,
                                                    134.971
                                                ],
                                                [
                                                    -165.039,
                                                    128.887
                                                ],
                                                [
                                                    -165.514,
                                                    125.93
                                                ],
                                                [
                                                    -165.61,
                                                    123.516
                                                ],
                                                [
                                                    -165.858,
                                                    123.4
                                                ],
                                                [
                                                    -166.049,
                                                    122.109
                                                ],
                                                [
                                                    -166.236,
                                                    121.876
                                                ],
                                                [
                                                    -166.4,
                                                    121.412
                                                ],
                                                [
                                                    -166.381,
                                                    120.413
                                                ],
                                                [
                                                    -166.418,
                                                    120.199
                                                ],
                                                [
                                                    -166.982,
                                                    118.866
                                                ],
                                                [
                                                    -166.937,
                                                    118.537
                                                ],
                                                [
                                                    -170.909,
                                                    109.438
                                                ],
                                                [
                                                    -173.175,
                                                    105.951
                                                ],
                                                [
                                                    -173.636,
                                                    105.698
                                                ],
                                                [
                                                    -174.976,
                                                    103.704
                                                ],
                                                [
                                                    -175.511,
                                                    103.121
                                                ],
                                                [
                                                    -175.265,
                                                    95.925
                                                ],
                                                [
                                                    -173.218,
                                                    88.172
                                                ],
                                                [
                                                    -168.846,
                                                    81.511
                                                ],
                                                [
                                                    -159.682,
                                                    77.418
                                                ],
                                                [
                                                    -150.391,
                                                    78.804
                                                ],
                                                [
                                                    -144.849,
                                                    80.037
                                                ],
                                                [
                                                    -134.897,
                                                    80.85
                                                ],
                                                [
                                                    -124.932,
                                                    80.177
                                                ],
                                                [
                                                    -115.094,
                                                    78.372
                                                ],
                                                [
                                                    -105.536,
                                                    75.436
                                                ],
                                                [
                                                    -105.549,
                                                    75.372
                                                ],
                                                [
                                                    -93.627,
                                                    70.581
                                                ],
                                                [
                                                    -81.933,
                                                    65.242
                                                ],
                                                [
                                                    -70.52,
                                                    60.196
                                                ],
                                                [
                                                    -58.915,
                                                    55.646
                                                ],
                                                [
                                                    -48.353,
                                                    52.926
                                                ],
                                                [
                                                    -37.753,
                                                    54.769
                                                ],
                                                [
                                                    -31.893,
                                                    61.302
                                                ],
                                                [
                                                    -27.597,
                                                    70.009
                                                ],
                                                [
                                                    -25.5,
                                                    79.516
                                                ],
                                                [
                                                    -25.233,
                                                    89.252
                                                ],
                                                [
                                                    -26.631,
                                                    98.886
                                                ],
                                                [
                                                    -29.3,
                                                    108.241
                                                ],
                                                [
                                                    -33.253,
                                                    117.71
                                                ],
                                                [
                                                    -38.63,
                                                    126.455
                                                ],
                                                [
                                                    -44.642,
                                                    134.78
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 8",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 8,
                                    "ty": "sh",
                                    "ix": 9,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    4.736,
                                                    0.532
                                                ],
                                                [
                                                    4.737,
                                                    0.532
                                                ],
                                                [
                                                    4.745,
                                                    0.533
                                                ],
                                                [
                                                    4.745,
                                                    0.532
                                                ],
                                                [
                                                    2.57,
                                                    3.629
                                                ],
                                                [
                                                    0.424,
                                                    2.199
                                                ],
                                                [
                                                    -0.185,
                                                    1.749
                                                ],
                                                [
                                                    -0.553,
                                                    4.897
                                                ],
                                                [
                                                    -0.553,
                                                    4.897
                                                ],
                                                [
                                                    -0.553,
                                                    4.898
                                                ],
                                                [
                                                    -0.554,
                                                    4.906
                                                ],
                                                [
                                                    -0.554,
                                                    4.906
                                                ],
                                                [
                                                    -2.855,
                                                    2.557
                                                ],
                                                [
                                                    -4.073,
                                                    0
                                                ],
                                                [
                                                    -0.609,
                                                    -0.053
                                                ],
                                                [
                                                    -4.73,
                                                    -0.533
                                                ],
                                                [
                                                    -4.735,
                                                    -0.534
                                                ],
                                                [
                                                    -4.736,
                                                    -0.534
                                                ],
                                                [
                                                    -4.737,
                                                    -0.534
                                                ],
                                                [
                                                    -4.745,
                                                    -0.535
                                                ],
                                                [
                                                    -4.745,
                                                    -0.534
                                                ],
                                                [
                                                    -2.702,
                                                    -3.365
                                                ],
                                                [
                                                    0.477,
                                                    -4.292
                                                ],
                                                [
                                                    0.551,
                                                    -4.897
                                                ],
                                                [
                                                    0.551,
                                                    -4.897
                                                ],
                                                [
                                                    0.551,
                                                    -4.898
                                                ],
                                                [
                                                    0.552,
                                                    -4.906
                                                ],
                                                [
                                                    0.547,
                                                    -4.907
                                                ],
                                                [
                                                    0.715,
                                                    -1.51
                                                ],
                                                [
                                                    1.033,
                                                    -1.139
                                                ],
                                                [
                                                    2.434,
                                                    -0.948
                                                ],
                                                [
                                                    2.685,
                                                    0.3
                                                ],
                                                [
                                                    4.73,
                                                    0.531
                                                ],
                                                [
                                                    4.735,
                                                    0.532
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -4.737,
                                                    -0.532
                                                ],
                                                [
                                                    -4.745,
                                                    -0.533
                                                ],
                                                [
                                                    -4.745,
                                                    -0.533
                                                ],
                                                [
                                                    -4.742,
                                                    -0.53
                                                ],
                                                [
                                                    -1.272,
                                                    -1.775
                                                ],
                                                [
                                                    -0.371,
                                                    -1.616
                                                ],
                                                [
                                                    0.548,
                                                    -4.897
                                                ],
                                                [
                                                    0.553,
                                                    -4.897
                                                ],
                                                [
                                                    0.553,
                                                    -4.899
                                                ],
                                                [
                                                    0.554,
                                                    -4.906
                                                ],
                                                [
                                                    0.554,
                                                    -4.906
                                                ],
                                                [
                                                    0.461,
                                                    -4.1
                                                ],
                                                [
                                                    2.883,
                                                    -2.582
                                                ],
                                                [
                                                    0.61,
                                                    0
                                                ],
                                                [
                                                    4.73,
                                                    0.526
                                                ],
                                                [
                                                    4.735,
                                                    0.534
                                                ],
                                                [
                                                    4.736,
                                                    0.534
                                                ],
                                                [
                                                    4.737,
                                                    0.534
                                                ],
                                                [
                                                    4.745,
                                                    0.535
                                                ],
                                                [
                                                    4.745,
                                                    0.535
                                                ],
                                                [
                                                    4.265,
                                                    0.477
                                                ],
                                                [
                                                    2.702,
                                                    3.391
                                                ],
                                                [
                                                    -0.549,
                                                    4.897
                                                ],
                                                [
                                                    -0.551,
                                                    4.897
                                                ],
                                                [
                                                    -0.551,
                                                    4.898
                                                ],
                                                [
                                                    -0.552,
                                                    4.906
                                                ],
                                                [
                                                    -0.552,
                                                    4.906
                                                ],
                                                [
                                                    -0.186,
                                                    1.749
                                                ],
                                                [
                                                    -0.636,
                                                    1.43
                                                ],
                                                [
                                                    -1.709,
                                                    1.965
                                                ],
                                                [
                                                    -2.358,
                                                    0.918
                                                ],
                                                [
                                                    -4.73,
                                                    -0.53
                                                ],
                                                [
                                                    -4.735,
                                                    -0.532
                                                ],
                                                [
                                                    -4.736,
                                                    -0.532
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -31.634,
                                                    38.955
                                                ],
                                                [
                                                    -41.11,
                                                    37.909
                                                ],
                                                [
                                                    -50.597,
                                                    36.825
                                                ],
                                                [
                                                    -60.063,
                                                    35.557
                                                ],
                                                [
                                                    -71.448,
                                                    28.942
                                                ],
                                                [
                                                    -74.119,
                                                    22.908
                                                ],
                                                [
                                                    -74.416,
                                                    17.801
                                                ],
                                                [
                                                    -73.238,
                                                    8.015
                                                ],
                                                [
                                                    -72.115,
                                                    -1.777
                                                ],
                                                [
                                                    -71.115,
                                                    -11.587
                                                ],
                                                [
                                                    -69.786,
                                                    -21.375
                                                ],
                                                [
                                                    -68.785,
                                                    -31.2
                                                ],
                                                [
                                                    -63.461,
                                                    -41.375
                                                ],
                                                [
                                                    -52.764,
                                                    -45.633
                                                ],
                                                [
                                                    -50.932,
                                                    -45.483
                                                ],
                                                [
                                                    -41.488,
                                                    -44.283
                                                ],
                                                [
                                                    -32.017,
                                                    -43.228
                                                ],
                                                [
                                                    -22.534,
                                                    -42.255
                                                ],
                                                [
                                                    -13.07,
                                                    -41.104
                                                ],
                                                [
                                                    -3.58,
                                                    -40.044
                                                ],
                                                [
                                                    5.919,
                                                    -39.058
                                                ],
                                                [
                                                    16.7,
                                                    -33.061
                                                ],
                                                [
                                                    20.103,
                                                    -21.191
                                                ],
                                                [
                                                    18.954,
                                                    -11.403
                                                ],
                                                [
                                                    17.852,
                                                    -1.608
                                                ],
                                                [
                                                    16.788,
                                                    8.193
                                                ],
                                                [
                                                    15.797,
                                                    18.019
                                                ],
                                                [
                                                    14.639,
                                                    27.825
                                                ],
                                                [
                                                    13.244,
                                                    32.747
                                                ],
                                                [
                                                    10.715,
                                                    36.599
                                                ],
                                                [
                                                    4.469,
                                                    41.162
                                                ],
                                                [
                                                    -3.229,
                                                    42.11
                                                ],
                                                [
                                                    -12.677,
                                                    40.941
                                                ],
                                                [
                                                    -22.153,
                                                    39.934
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 9",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 9,
                                    "ty": "sh",
                                    "ix": 10,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.737,
                                                    0.521
                                                ],
                                                [
                                                    0.28,
                                                    0.013
                                                ],
                                                [
                                                    0.343,
                                                    -0.483
                                                ],
                                                [
                                                    2.644,
                                                    -2.834
                                                ],
                                                [
                                                    2.771,
                                                    -2.059
                                                ],
                                                [
                                                    1.306,
                                                    -0.786
                                                ],
                                                [
                                                    0.007,
                                                    -0.007
                                                ],
                                                [
                                                    0.051,
                                                    -0.025
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.622,
                                                    -0.788
                                                ],
                                                [
                                                    0.699,
                                                    -0.114
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.013,
                                                    0
                                                ],
                                                [
                                                    0.013,
                                                    0
                                                ],
                                                [
                                                    0.013,
                                                    0
                                                ],
                                                [
                                                    0.025,
                                                    -0.005
                                                ],
                                                [
                                                    0.38,
                                                    0.034
                                                ],
                                                [
                                                    3.228,
                                                    1.868
                                                ],
                                                [
                                                    1.868,
                                                    2.517
                                                ],
                                                [
                                                    0.61,
                                                    3.304
                                                ],
                                                [
                                                    -1.093,
                                                    3.966
                                                ],
                                                [
                                                    -0.085,
                                                    0.286
                                                ],
                                                [
                                                    -0.192,
                                                    0.508
                                                ],
                                                [
                                                    -0.102,
                                                    0.241
                                                ],
                                                [
                                                    -1.741,
                                                    2.389
                                                ],
                                                [
                                                    0,
                                                    0.012
                                                ],
                                                [
                                                    0.026,
                                                    0.063
                                                ],
                                                [
                                                    -0.318,
                                                    0.394
                                                ],
                                                [
                                                    -3.127,
                                                    2.796
                                                ],
                                                [
                                                    -3.228,
                                                    2.593
                                                ],
                                                [
                                                    -0.013,
                                                    0
                                                ],
                                                [
                                                    -2.364,
                                                    2.123
                                                ],
                                                [
                                                    -1.818,
                                                    1.817
                                                ],
                                                [
                                                    -0.331,
                                                    0.331
                                                ],
                                                [
                                                    -1.22,
                                                    1.36
                                                ],
                                                [
                                                    -0.712,
                                                    0.865
                                                ],
                                                [
                                                    0.178,
                                                    0.515
                                                ],
                                                [
                                                    -3,
                                                    -0.886
                                                ],
                                                [
                                                    -2.141,
                                                    -1.012
                                                ],
                                                [
                                                    0.132,
                                                    -1.173
                                                ],
                                                [
                                                    0.552,
                                                    -4.909
                                                ],
                                                [
                                                    0.549,
                                                    -4.909
                                                ],
                                                [
                                                    -0.53,
                                                    -2.702
                                                ],
                                                [
                                                    -2.212,
                                                    -3.109
                                                ],
                                                [
                                                    -3.339,
                                                    -1.975
                                                ],
                                                [
                                                    -3.348,
                                                    -0.547
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.402,
                                                    -0.991
                                                ],
                                                [
                                                    2.618,
                                                    -1.182
                                                ],
                                                [
                                                    2.58,
                                                    -1.208
                                                ],
                                                [
                                                    3.8,
                                                    -1.665
                                                ],
                                                [
                                                    0.152,
                                                    -0.064
                                                ],
                                                [
                                                    0.007,
                                                    -0.003
                                                ],
                                                [
                                                    -0.896,
                                                    0.962
                                                ],
                                                [
                                                    -1.589,
                                                    2.25
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.254,
                                                    -0.19
                                                ],
                                                [
                                                    -0.547,
                                                    -0.025
                                                ],
                                                [
                                                    -1.525,
                                                    2.161
                                                ],
                                                [
                                                    -2.161,
                                                    2.326
                                                ],
                                                [
                                                    -1.223,
                                                    0.906
                                                ],
                                                [
                                                    -0.007,
                                                    0.001
                                                ],
                                                [
                                                    -0.051,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.851,
                                                    1.347
                                                ],
                                                [
                                                    -0.712,
                                                    0.153
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.013,
                                                    0
                                                ],
                                                [
                                                    -0.013,
                                                    0
                                                ],
                                                [
                                                    -0.013,
                                                    0
                                                ],
                                                [
                                                    -0.025,
                                                    0.004
                                                ],
                                                [
                                                    -0.376,
                                                    -0.016
                                                ],
                                                [
                                                    -3.063,
                                                    -0.267
                                                ],
                                                [
                                                    -3,
                                                    -1.729
                                                ],
                                                [
                                                    -1.932,
                                                    -2.606
                                                ],
                                                [
                                                    -0.699,
                                                    -3.775
                                                ],
                                                [
                                                    0.072,
                                                    -0.298
                                                ],
                                                [
                                                    0.159,
                                                    -0.511
                                                ],
                                                [
                                                    0.089,
                                                    -0.254
                                                ],
                                                [
                                                    1.055,
                                                    -2.644
                                                ],
                                                [
                                                    0,
                                                    -0.013
                                                ],
                                                [
                                                    0.051,
                                                    -0.115
                                                ],
                                                [
                                                    0.292,
                                                    -0.407
                                                ],
                                                [
                                                    2.618,
                                                    -3.241
                                                ],
                                                [
                                                    3.139,
                                                    -2.797
                                                ],
                                                [
                                                    0.013,
                                                    -0.013
                                                ],
                                                [
                                                    2.186,
                                                    -1.754
                                                ],
                                                [
                                                    1.894,
                                                    -1.69
                                                ],
                                                [
                                                    0.343,
                                                    -0.331
                                                ],
                                                [
                                                    1.347,
                                                    -1.36
                                                ],
                                                [
                                                    0.788,
                                                    -0.89
                                                ],
                                                [
                                                    0.381,
                                                    -0.456
                                                ],
                                                [
                                                    3.112,
                                                    0.27
                                                ],
                                                [
                                                    2.263,
                                                    0.668
                                                ],
                                                [
                                                    -0.082,
                                                    0.746
                                                ],
                                                [
                                                    -0.552,
                                                    4.909
                                                ],
                                                [
                                                    -0.552,
                                                    4.909
                                                ],
                                                [
                                                    -0.318,
                                                    2.887
                                                ],
                                                [
                                                    0.758,
                                                    3.823
                                                ],
                                                [
                                                    2.219,
                                                    3.119
                                                ],
                                                [
                                                    2.779,
                                                    1.643
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.479,
                                                    0.852
                                                ],
                                                [
                                                    -2.669,
                                                    1.106
                                                ],
                                                [
                                                    -2.644,
                                                    1.195
                                                ],
                                                [
                                                    -3.699,
                                                    1.716
                                                ],
                                                [
                                                    -0.153,
                                                    0.063
                                                ],
                                                [
                                                    -0.007,
                                                    0.003
                                                ],
                                                [
                                                    1.005,
                                                    -0.952
                                                ],
                                                [
                                                    2.707,
                                                    -2.923
                                                ],
                                                [
                                                    0.534,
                                                    -0.737
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -88.784,
                                                    48.533
                                                ],
                                                [
                                                    -89.61,
                                                    48.241
                                                ],
                                                [
                                                    -91.021,
                                                    48.965
                                                ],
                                                [
                                                    -97.465,
                                                    56.655
                                                ],
                                                [
                                                    -104.875,
                                                    63.417
                                                ],
                                                [
                                                    -108.668,
                                                    65.973
                                                ],
                                                [
                                                    -108.688,
                                                    65.979
                                                ],
                                                [
                                                    -108.828,
                                                    66.018
                                                ],
                                                [
                                                    -108.841,
                                                    65.992
                                                ],
                                                [
                                                    -120.026,
                                                    69.297
                                                ],
                                                [
                                                    -122.149,
                                                    69.704
                                                ],
                                                [
                                                    -122.187,
                                                    69.704
                                                ],
                                                [
                                                    -122.212,
                                                    69.704
                                                ],
                                                [
                                                    -122.238,
                                                    69.704
                                                ],
                                                [
                                                    -122.263,
                                                    69.704
                                                ],
                                                [
                                                    -122.337,
                                                    69.715
                                                ],
                                                [
                                                    -123.47,
                                                    69.645
                                                ],
                                                [
                                                    -132.914,
                                                    66.556
                                                ],
                                                [
                                                    -140.222,
                                                    60.176
                                                ],
                                                [
                                                    -144.175,
                                                    51.317
                                                ],
                                                [
                                                    -143.502,
                                                    39.534
                                                ],
                                                [
                                                    -143.251,
                                                    38.663
                                                ],
                                                [
                                                    -142.752,
                                                    37.132
                                                ],
                                                [
                                                    -142.472,
                                                    36.395
                                                ],
                                                [
                                                    -138.227,
                                                    28.82
                                                ],
                                                [
                                                    -138.214,
                                                    28.794
                                                ],
                                                [
                                                    -138.176,
                                                    28.527
                                                ],
                                                [
                                                    -137.248,
                                                    27.32
                                                ],
                                                [
                                                    -128.491,
                                                    18.334
                                                ],
                                                [
                                                    -118.831,
                                                    10.288
                                                ],
                                                [
                                                    -118.793,
                                                    10.263
                                                ],
                                                [
                                                    -111.828,
                                                    4.467
                                                ],
                                                [
                                                    -106.261,
                                                    -0.846
                                                ],
                                                [
                                                    -105.257,
                                                    -1.85
                                                ],
                                                [
                                                    -101.406,
                                                    -5.943
                                                ],
                                                [
                                                    -99.143,
                                                    -8.587
                                                ],
                                                [
                                                    -98.85,
                                                    -10.147
                                                ],
                                                [
                                                    -89.652,
                                                    -8.444
                                                ],
                                                [
                                                    -83.05,
                                                    -5.888
                                                ],
                                                [
                                                    -83.363,
                                                    -3.081
                                                ],
                                                [
                                                    -84.389,
                                                    6.746
                                                ],
                                                [
                                                    -85.486,
                                                    16.565
                                                ],
                                                [
                                                    -85.068,
                                                    24.95
                                                ],
                                                [
                                                    -80.655,
                                                    35.509
                                                ],
                                                [
                                                    -72.219,
                                                    43.292
                                                ],
                                                [
                                                    -62.942,
                                                    46.532
                                                ],
                                                [
                                                    -62.944,
                                                    46.533
                                                ],
                                                [
                                                    -62.957,
                                                    46.533
                                                ],
                                                [
                                                    -70.342,
                                                    49.151
                                                ],
                                                [
                                                    -78.209,
                                                    52.761
                                                ],
                                                [
                                                    -86.026,
                                                    56.422
                                                ],
                                                [
                                                    -97.287,
                                                    61.557
                                                ],
                                                [
                                                    -97.732,
                                                    61.747
                                                ],
                                                [
                                                    -97.753,
                                                    61.756
                                                ],
                                                [
                                                    -94.885,
                                                    58.879
                                                ],
                                                [
                                                    -88.416,
                                                    50.808
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 10",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 10,
                                    "ty": "sh",
                                    "ix": 11,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    1.551,
                                                    -3.61
                                                ],
                                                [
                                                    0.521,
                                                    -3.94
                                                ],
                                                [
                                                    0.017,
                                                    -0.151
                                                ],
                                                [
                                                    0.03,
                                                    0.015
                                                ],
                                                [
                                                    3.436,
                                                    0.981
                                                ],
                                                [
                                                    3.481,
                                                    -0.074
                                                ],
                                                [
                                                    0.009,
                                                    0.042
                                                ],
                                                [
                                                    0.152,
                                                    0.635
                                                ],
                                                [
                                                    0.102,
                                                    0.559
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.191,
                                                    0.19
                                                ],
                                                [
                                                    0.026,
                                                    0.076
                                                ],
                                                [
                                                    0.025,
                                                    0.229
                                                ],
                                                [
                                                    -0.013,
                                                    0.102
                                                ],
                                                [
                                                    0,
                                                    0.102
                                                ],
                                                [
                                                    0,
                                                    0.369
                                                ],
                                                [
                                                    0.025,
                                                    0.127
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.013,
                                                    0.076
                                                ],
                                                [
                                                    0,
                                                    0.012
                                                ],
                                                [
                                                    -0.115,
                                                    0.318
                                                ],
                                                [
                                                    -0.242,
                                                    1.22
                                                ],
                                                [
                                                    -0.61,
                                                    1.652
                                                ],
                                                [
                                                    -0.648,
                                                    1.296
                                                ],
                                                [
                                                    -0.61,
                                                    1.474
                                                ],
                                                [
                                                    0.013,
                                                    0.928
                                                ],
                                                [
                                                    -0.445,
                                                    0.979
                                                ],
                                                [
                                                    -0.674,
                                                    1.716
                                                ],
                                                [
                                                    -0.801,
                                                    2.148
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.572,
                                                    1.296
                                                ],
                                                [
                                                    -0.661,
                                                    1.83
                                                ],
                                                [
                                                    -0.001,
                                                    0.004
                                                ],
                                                [
                                                    -0.844,
                                                    -0.122
                                                ],
                                                [
                                                    -0.597,
                                                    -0.076
                                                ],
                                                [
                                                    -4.779,
                                                    -0.534
                                                ],
                                                [
                                                    -2.707,
                                                    -0.267
                                                ],
                                                [
                                                    -0.102,
                                                    -0.013
                                                ],
                                                [
                                                    -0.394,
                                                    -0.051
                                                ],
                                                [
                                                    -0.305,
                                                    -0.038
                                                ],
                                                [
                                                    -0.254,
                                                    -0.026
                                                ],
                                                [
                                                    -0.242,
                                                    -0.039
                                                ],
                                                [
                                                    -0.369,
                                                    -0.051
                                                ],
                                                [
                                                    -3.597,
                                                    -0.407
                                                ],
                                                [
                                                    -4.792,
                                                    -0.547
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.165,
                                                    -1.08
                                                ],
                                                [
                                                    -0.559,
                                                    -3.063
                                                ],
                                                [
                                                    -2.199,
                                                    -2.987
                                                ],
                                                [
                                                    -3.419,
                                                    -1.983
                                                ],
                                                [
                                                    -0.803,
                                                    -0.37
                                                ],
                                                [
                                                    0.002,
                                                    0
                                                ],
                                                [
                                                    3.483,
                                                    0.585
                                                ],
                                                [
                                                    1.678,
                                                    0.355
                                                ],
                                                [
                                                    3.343,
                                                    0.191
                                                ],
                                                [
                                                    3.254,
                                                    -1.271
                                                ],
                                                [
                                                    2.682,
                                                    -2.707
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.385,
                                                    3.254
                                                ],
                                                [
                                                    -0.018,
                                                    0.151
                                                ],
                                                [
                                                    -0.026,
                                                    -0.023
                                                ],
                                                [
                                                    -3.134,
                                                    -1.924
                                                ],
                                                [
                                                    -3.496,
                                                    -0.998
                                                ],
                                                [
                                                    -0.009,
                                                    -0.042
                                                ],
                                                [
                                                    -0.165,
                                                    -0.699
                                                ],
                                                [
                                                    -0.152,
                                                    -0.597
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.076,
                                                    -0.407
                                                ],
                                                [
                                                    -0.013,
                                                    -0.089
                                                ],
                                                [
                                                    -0.038,
                                                    -0.166
                                                ],
                                                [
                                                    -0.013,
                                                    -0.038
                                                ],
                                                [
                                                    0,
                                                    -0.102
                                                ],
                                                [
                                                    0.127,
                                                    -0.191
                                                ],
                                                [
                                                    0,
                                                    -0.115
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -0.025
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.114,
                                                    -0.28
                                                ],
                                                [
                                                    0.953,
                                                    -2.581
                                                ],
                                                [
                                                    0.191,
                                                    -1.03
                                                ],
                                                [
                                                    0.483,
                                                    -1.182
                                                ],
                                                [
                                                    0.699,
                                                    -1.411
                                                ],
                                                [
                                                    0.242,
                                                    -0.597
                                                ],
                                                [
                                                    0.419,
                                                    -0.979
                                                ],
                                                [
                                                    0.75,
                                                    -1.665
                                                ],
                                                [
                                                    0.839,
                                                    -2.11
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.496,
                                                    -1.309
                                                ],
                                                [
                                                    0.737,
                                                    -1.69
                                                ],
                                                [
                                                    0.001,
                                                    -0.004
                                                ],
                                                [
                                                    0.815,
                                                    0.208
                                                ],
                                                [
                                                    0.584,
                                                    0.127
                                                ],
                                                [
                                                    4.779,
                                                    0.547
                                                ],
                                                [
                                                    3.889,
                                                    0.445
                                                ],
                                                [
                                                    0.102,
                                                    0.013
                                                ],
                                                [
                                                    0.33,
                                                    0.026
                                                ],
                                                [
                                                    0.254,
                                                    0.038
                                                ],
                                                [
                                                    0.305,
                                                    0.038
                                                ],
                                                [
                                                    0.267,
                                                    0.025
                                                ],
                                                [
                                                    0.47,
                                                    0.051
                                                ],
                                                [
                                                    2.25,
                                                    0.292
                                                ],
                                                [
                                                    4.792,
                                                    0.547
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    1.067
                                                ],
                                                [
                                                    -0.47,
                                                    3.203
                                                ],
                                                [
                                                    0.699,
                                                    3.788
                                                ],
                                                [
                                                    2.135,
                                                    2.885
                                                ],
                                                [
                                                    0.812,
                                                    0.47
                                                ],
                                                [
                                                    -0.002,
                                                    0
                                                ],
                                                [
                                                    -3.838,
                                                    0.177
                                                ],
                                                [
                                                    -1.754,
                                                    -0.292
                                                ],
                                                [
                                                    -3.127,
                                                    -0.673
                                                ],
                                                [
                                                    -3.203,
                                                    -0.165
                                                ],
                                                [
                                                    -2.733,
                                                    1.055
                                                ],
                                                [
                                                    -2.53,
                                                    2.555
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -181.899,
                                                    83.914
                                                ],
                                                [
                                                    -185.013,
                                                    94.667
                                                ],
                                                [
                                                    -185.06,
                                                    95.121
                                                ],
                                                [
                                                    -185.141,
                                                    95.056
                                                ],
                                                [
                                                    -195.216,
                                                    90.983
                                                ],
                                                [
                                                    -205.728,
                                                    89.355
                                                ],
                                                [
                                                    -205.756,
                                                    89.226
                                                ],
                                                [
                                                    -206.227,
                                                    87.206
                                                ],
                                                [
                                                    -206.57,
                                                    85.452
                                                ],
                                                [
                                                    -206.735,
                                                    84.549
                                                ],
                                                [
                                                    -207.205,
                                                    83.672
                                                ],
                                                [
                                                    -207.269,
                                                    83.431
                                                ],
                                                [
                                                    -207.371,
                                                    82.871
                                                ],
                                                [
                                                    -207.358,
                                                    82.592
                                                ],
                                                [
                                                    -207.345,
                                                    82.287
                                                ],
                                                [
                                                    -207.091,
                                                    81.423
                                                ],
                                                [
                                                    -207.142,
                                                    81.054
                                                ],
                                                [
                                                    -207.142,
                                                    80.914
                                                ],
                                                [
                                                    -207.155,
                                                    80.774
                                                ],
                                                [
                                                    -207.155,
                                                    80.762
                                                ],
                                                [
                                                    -206.811,
                                                    79.859
                                                ],
                                                [
                                                    -205.324,
                                                    74.546
                                                ],
                                                [
                                                    -204.358,
                                                    71.051
                                                ],
                                                [
                                                    -202.617,
                                                    67.34
                                                ],
                                                [
                                                    -200.609,
                                                    63.031
                                                ],
                                                [
                                                    -200.177,
                                                    60.705
                                                ],
                                                [
                                                    -198.88,
                                                    57.781
                                                ],
                                                [
                                                    -196.707,
                                                    52.735
                                                ],
                                                [
                                                    -194.279,
                                                    46.355
                                                ],
                                                [
                                                    -193.11,
                                                    43.253
                                                ],
                                                [
                                                    -191.483,
                                                    39.339
                                                ],
                                                [
                                                    -189.335,
                                                    34.077
                                                ],
                                                [
                                                    -189.331,
                                                    34.065
                                                ],
                                                [
                                                    -186.844,
                                                    34.565
                                                ],
                                                [
                                                    -185.064,
                                                    34.87
                                                ],
                                                [
                                                    -175.506,
                                                    35.937
                                                ],
                                                [
                                                    -168.172,
                                                    36.649
                                                ],
                                                [
                                                    -167.854,
                                                    36.687
                                                ],
                                                [
                                                    -166.761,
                                                    36.802
                                                ],
                                                [
                                                    -165.923,
                                                    36.903
                                                ],
                                                [
                                                    -165.084,
                                                    36.992
                                                ],
                                                [
                                                    -164.334,
                                                    37.082
                                                ],
                                                [
                                                    -163.088,
                                                    37.234
                                                ],
                                                [
                                                    -156.365,
                                                    38.124
                                                ],
                                                [
                                                    -146.781,
                                                    39.229
                                                ],
                                                [
                                                    -146.768,
                                                    39.229
                                                ],
                                                [
                                                    -147.429,
                                                    42.445
                                                ],
                                                [
                                                    -147.391,
                                                    51.914
                                                ],
                                                [
                                                    -142.968,
                                                    62.121
                                                ],
                                                [
                                                    -134.617,
                                                    69.479
                                                ],
                                                [
                                                    -132.196,
                                                    70.72
                                                ],
                                                [
                                                    -132.202,
                                                    70.721
                                                ],
                                                [
                                                    -143.209,
                                                    70.339
                                                ],
                                                [
                                                    -148.332,
                                                    69.221
                                                ],
                                                [
                                                    -158.068,
                                                    67.644
                                                ],
                                                [
                                                    -167.766,
                                                    69.068
                                                ],
                                                [
                                                    -176.027,
                                                    74.419
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 11",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 11,
                                    "ty": "sh",
                                    "ix": 12,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.869,
                                                    1.296
                                                ],
                                                [
                                                    -0.801,
                                                    0.534
                                                ],
                                                [
                                                    -0.966,
                                                    0.585
                                                ],
                                                [
                                                    -1.856,
                                                    1.437
                                                ],
                                                [
                                                    -1.017,
                                                    0.89
                                                ],
                                                [
                                                    -0.661,
                                                    0.559
                                                ],
                                                [
                                                    -3.165,
                                                    3.127
                                                ],
                                                [
                                                    -0.712,
                                                    0.686
                                                ],
                                                [
                                                    -1.389,
                                                    1.49
                                                ],
                                                [
                                                    0.02,
                                                    -0.179
                                                ],
                                                [
                                                    0.008,
                                                    -1.443
                                                ],
                                                [
                                                    0.278,
                                                    -2.466
                                                ],
                                                [
                                                    0.219,
                                                    -1.294
                                                ],
                                                [
                                                    0.329,
                                                    -2.906
                                                ],
                                                [
                                                    -0.077,
                                                    -1.865
                                                ],
                                                [
                                                    -0.872,
                                                    -3.013
                                                ],
                                                [
                                                    -2.847,
                                                    -3.572
                                                ],
                                                [
                                                    -2.059,
                                                    -1.586
                                                ],
                                                [
                                                    0.386,
                                                    -1.021
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.807,
                                                    -2.036
                                                ],
                                                [
                                                    0.681,
                                                    -1.515
                                                ],
                                                [
                                                    0.625,
                                                    -1.55
                                                ],
                                                [
                                                    -0.005,
                                                    -0.902
                                                ],
                                                [
                                                    0.38,
                                                    -0.763
                                                ],
                                                [
                                                    0.676,
                                                    -1.698
                                                ],
                                                [
                                                    0.251,
                                                    -1.297
                                                ],
                                                [
                                                    0.641,
                                                    -1.719
                                                ],
                                                [
                                                    0.486,
                                                    -0.982
                                                ],
                                                [
                                                    0.091,
                                                    -0.187
                                                ],
                                                [
                                                    -0.193,
                                                    0.834
                                                ],
                                                [
                                                    -0.445,
                                                    1.373
                                                ],
                                                [
                                                    -0.597,
                                                    1.411
                                                ],
                                                [
                                                    -0.47,
                                                    1.322
                                                ],
                                                [
                                                    -0.14,
                                                    0.648
                                                ],
                                                [
                                                    -0.229,
                                                    0.484
                                                ],
                                                [
                                                    -0.051,
                                                    0.14
                                                ],
                                                [
                                                    -0.216,
                                                    0.699
                                                ],
                                                [
                                                    -0.267,
                                                    0.648
                                                ],
                                                [
                                                    0.121,
                                                    3.068
                                                ],
                                                [
                                                    -0.001,
                                                    0.421
                                                ],
                                                [
                                                    0.182,
                                                    0.871
                                                ],
                                                [
                                                    0.022,
                                                    0.089
                                                ],
                                                [
                                                    0.147,
                                                    0.678
                                                ],
                                                [
                                                    0.355,
                                                    0.549
                                                ],
                                                [
                                                    0.235,
                                                    0.325
                                                ],
                                                [
                                                    0.064,
                                                    0.15
                                                ],
                                                [
                                                    0.043,
                                                    0.095
                                                ],
                                                [
                                                    1.269,
                                                    1.351
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.815,
                                                    0.575
                                                ],
                                                [
                                                    0.299,
                                                    0.155
                                                ],
                                                [
                                                    0.478,
                                                    0.135
                                                ],
                                                [
                                                    0.011,
                                                    0.005
                                                ],
                                                [
                                                    0.449,
                                                    0.208
                                                ],
                                                [
                                                    1.996,
                                                    0.262
                                                ],
                                                [
                                                    0.339,
                                                    0.09
                                                ],
                                                [
                                                    1.702,
                                                    -0.158
                                                ],
                                                [
                                                    0.775,
                                                    -0.573
                                                ],
                                                [
                                                    3.145,
                                                    -1.402
                                                ],
                                                [
                                                    0.975,
                                                    -0.612
                                                ],
                                                [
                                                    0.441,
                                                    1.285
                                                ],
                                                [
                                                    0,
                                                    0.003
                                                ],
                                                [
                                                    0.329,
                                                    1.679
                                                ],
                                                [
                                                    0.307,
                                                    1.153
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.712,
                                                    0.409
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    2.097,
                                                    -1.182
                                                ],
                                                [
                                                    0.775,
                                                    -0.547
                                                ],
                                                [
                                                    0.928,
                                                    -0.623
                                                ],
                                                [
                                                    1.779,
                                                    -1.08
                                                ],
                                                [
                                                    1.03,
                                                    -0.813
                                                ],
                                                [
                                                    0.61,
                                                    -0.547
                                                ],
                                                [
                                                    3.355,
                                                    -2.86
                                                ],
                                                [
                                                    0.699,
                                                    -0.686
                                                ],
                                                [
                                                    1.382,
                                                    -1.312
                                                ],
                                                [
                                                    -0.019,
                                                    0.168
                                                ],
                                                [
                                                    -0.342,
                                                    3.045
                                                ],
                                                [
                                                    -0.008,
                                                    1.34
                                                ],
                                                [
                                                    -0.294,
                                                    2.607
                                                ],
                                                [
                                                    -0.248,
                                                    1.443
                                                ],
                                                [
                                                    -0.232,
                                                    2.056
                                                ],
                                                [
                                                    -0.136,
                                                    3.52
                                                ],
                                                [
                                                    1.144,
                                                    3.966
                                                ],
                                                [
                                                    1.64,
                                                    2.039
                                                ],
                                                [
                                                    -0.435,
                                                    1.014
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.772,
                                                    2.068
                                                ],
                                                [
                                                    -0.62,
                                                    1.557
                                                ],
                                                [
                                                    -0.689,
                                                    1.535
                                                ],
                                                [
                                                    -0.235,
                                                    0.585
                                                ],
                                                [
                                                    -0.355,
                                                    0.771
                                                ],
                                                [
                                                    -0.719,
                                                    1.44
                                                ],
                                                [
                                                    -0.991,
                                                    2.613
                                                ],
                                                [
                                                    -0.198,
                                                    1.029
                                                ],
                                                [
                                                    -0.708,
                                                    1.903
                                                ],
                                                [
                                                    -0.087,
                                                    0.175
                                                ],
                                                [
                                                    0.201,
                                                    -0.828
                                                ],
                                                [
                                                    0.343,
                                                    -1.563
                                                ],
                                                [
                                                    0.407,
                                                    -1.284
                                                ],
                                                [
                                                    0.572,
                                                    -1.322
                                                ],
                                                [
                                                    0.28,
                                                    -0.788
                                                ],
                                                [
                                                    0.407,
                                                    -0.445
                                                ],
                                                [
                                                    0.064,
                                                    -0.127
                                                ],
                                                [
                                                    0.254,
                                                    -0.687
                                                ],
                                                [
                                                    0.191,
                                                    -0.635
                                                ],
                                                [
                                                    1.597,
                                                    -3.976
                                                ],
                                                [
                                                    0.019,
                                                    -0.441
                                                ],
                                                [
                                                    0.578,
                                                    -1.319
                                                ],
                                                [
                                                    -0.018,
                                                    -0.093
                                                ],
                                                [
                                                    0.264,
                                                    -0.989
                                                ],
                                                [
                                                    -0.23,
                                                    -1.15
                                                ],
                                                [
                                                    -0.227,
                                                    -0.533
                                                ],
                                                [
                                                    -0.059,
                                                    -0.138
                                                ],
                                                [
                                                    -0.04,
                                                    -0.097
                                                ],
                                                [
                                                    -0.973,
                                                    -2.138
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.452,
                                                    -0.556
                                                ],
                                                [
                                                    -0.267,
                                                    -0.21
                                                ],
                                                [
                                                    -0.729,
                                                    -0.421
                                                ],
                                                [
                                                    -0.011,
                                                    -0.004
                                                ],
                                                [
                                                    -0.297,
                                                    -0.2
                                                ],
                                                [
                                                    -2.004,
                                                    -0.912
                                                ],
                                                [
                                                    -0.334,
                                                    -0.048
                                                ],
                                                [
                                                    -1.202,
                                                    -0.311
                                                ],
                                                [
                                                    -1.44,
                                                    0.076
                                                ],
                                                [
                                                    -4.446,
                                                    0.568
                                                ],
                                                [
                                                    -1.173,
                                                    0.529
                                                ],
                                                [
                                                    -0.604,
                                                    -1.411
                                                ],
                                                [
                                                    0,
                                                    -0.003
                                                ],
                                                [
                                                    -0.521,
                                                    -1.512
                                                ],
                                                [
                                                    -0.246,
                                                    -1.256
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.718,
                                                    -0.409
                                                ],
                                                [
                                                    0,
                                                    0
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -249.772,
                                                    8.936
                                                ],
                                                [
                                                    -243.874,
                                                    5.11
                                                ],
                                                [
                                                    -241.498,
                                                    3.471
                                                ],
                                                [
                                                    -238.638,
                                                    1.678
                                                ],
                                                [
                                                    -233.172,
                                                    -1.944
                                                ],
                                                [
                                                    -230.122,
                                                    -4.524
                                                ],
                                                [
                                                    -228.241,
                                                    -6.164
                                                ],
                                                [
                                                    -218.606,
                                                    -15.214
                                                ],
                                                [
                                                    -216.471,
                                                    -17.273
                                                ],
                                                [
                                                    -212.276,
                                                    -21.446
                                                ],
                                                [
                                                    -212.333,
                                                    -20.946
                                                ],
                                                [
                                                    -212.694,
                                                    -14.822
                                                ],
                                                [
                                                    -212.985,
                                                    -9.857
                                                ],
                                                [
                                                    -213.72,
                                                    -4.664
                                                ],
                                                [
                                                    -214.543,
                                                    1.131
                                                ],
                                                [
                                                    -214.766,
                                                    6.998
                                                ],
                                                [
                                                    -213.675,
                                                    16.74
                                                ],
                                                [
                                                    -207.676,
                                                    28.091
                                                ],
                                                [
                                                    -202.101,
                                                    33.519
                                                ],
                                                [
                                                    -203.349,
                                                    36.568
                                                ],
                                                [
                                                    -204.531,
                                                    39.72
                                                ],
                                                [
                                                    -206.879,
                                                    45.887
                                                ],
                                                [
                                                    -208.865,
                                                    50.482
                                                ],
                                                [
                                                    -210.866,
                                                    55.097
                                                ],
                                                [
                                                    -211.302,
                                                    57.352
                                                ],
                                                [
                                                    -212.419,
                                                    59.649
                                                ],
                                                [
                                                    -214.554,
                                                    64.278
                                                ],
                                                [
                                                    -216.077,
                                                    69.66
                                                ],
                                                [
                                                    -217.071,
                                                    73.22
                                                ],
                                                [
                                                    -218.685,
                                                    76.953
                                                ],
                                                [
                                                    -218.952,
                                                    77.497
                                                ],
                                                [
                                                    -218.365,
                                                    75.003
                                                ],
                                                [
                                                    -217.246,
                                                    70.581
                                                ],
                                                [
                                                    -215.67,
                                                    66.539
                                                ],
                                                [
                                                    -214.082,
                                                    62.586
                                                ],
                                                [
                                                    -213.484,
                                                    60.4
                                                ],
                                                [
                                                    -212.531,
                                                    58.989
                                                ],
                                                [
                                                    -212.366,
                                                    58.582
                                                ],
                                                [
                                                    -211.679,
                                                    56.485
                                                ],
                                                [
                                                    -211.031,
                                                    54.566
                                                ],
                                                [
                                                    -209.363,
                                                    43.712
                                                ],
                                                [
                                                    -209.331,
                                                    42.417
                                                ],
                                                [
                                                    -208.959,
                                                    39.021
                                                ],
                                                [
                                                    -209.029,
                                                    38.76
                                                ],
                                                [
                                                    -208.964,
                                                    36.206
                                                ],
                                                [
                                                    -210.043,
                                                    33.653
                                                ],
                                                [
                                                    -210.775,
                                                    32.365
                                                ],
                                                [
                                                    -210.96,
                                                    31.936
                                                ],
                                                [
                                                    -211.083,
                                                    31.648
                                                ],
                                                [
                                                    -214.375,
                                                    26.525
                                                ],
                                                [
                                                    -214.562,
                                                    26.301
                                                ],
                                                [
                                                    -216.515,
                                                    24.33
                                                ],
                                                [
                                                    -217.367,
                                                    23.781
                                                ],
                                                [
                                                    -219.254,
                                                    23.013
                                                ],
                                                [
                                                    -219.286,
                                                    23
                                                ],
                                                [
                                                    -220.4,
                                                    22.367
                                                ],
                                                [
                                                    -226.466,
                                                    20.593
                                                ],
                                                [
                                                    -227.476,
                                                    20.357
                                                ],
                                                [
                                                    -232.034,
                                                    19.776
                                                ],
                                                [
                                                    -235.34,
                                                    20.985
                                                ],
                                                [
                                                    -246.632,
                                                    23.912
                                                ],
                                                [
                                                    -249.849,
                                                    25.645
                                                ],
                                                [
                                                    -251.458,
                                                    21.609
                                                ],
                                                [
                                                    -251.461,
                                                    21.601
                                                ],
                                                [
                                                    -252.623,
                                                    16.822
                                                ],
                                                [
                                                    -253.419,
                                                    13.194
                                                ],
                                                [
                                                    -253.925,
                                                    11.321
                                                ],
                                                [
                                                    -251.78,
                                                    10.093
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 12",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 12,
                                    "ty": "sh",
                                    "ix": 13,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    -0.683,
                                                    -0.963
                                                ],
                                                [
                                                    0.581,
                                                    -0.508
                                                ],
                                                [
                                                    0.303,
                                                    0.071
                                                ],
                                                [
                                                    0.003,
                                                    0.001
                                                ],
                                                [
                                                    0.031,
                                                    0.019
                                                ],
                                                [
                                                    0,
                                                    0.583
                                                ],
                                                [
                                                    -0.026,
                                                    0.106
                                                ],
                                                [
                                                    0.036,
                                                    0.032
                                                ],
                                                [
                                                    0,
                                                    0.02
                                                ],
                                                [
                                                    -0.147,
                                                    1.016
                                                ],
                                                [
                                                    -0.04,
                                                    0.184
                                                ],
                                                [
                                                    -0.142,
                                                    0.674
                                                ],
                                                [
                                                    0.017,
                                                    0.008
                                                ],
                                                [
                                                    -0.001,
                                                    0.007
                                                ],
                                                [
                                                    0.005,
                                                    0.304
                                                ],
                                                [
                                                    -0.02,
                                                    0.109
                                                ],
                                                [
                                                    -0.425,
                                                    -0.641
                                                ],
                                                [
                                                    0.105,
                                                    -0.364
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.08,
                                                    -0.29
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.619,
                                                    0.456
                                                ],
                                                [
                                                    -0.569,
                                                    0.482
                                                ],
                                                [
                                                    -0.003,
                                                    -0.001
                                                ],
                                                [
                                                    -0.058,
                                                    -0.024
                                                ],
                                                [
                                                    -0.371,
                                                    -0.212
                                                ],
                                                [
                                                    0,
                                                    -0.106
                                                ],
                                                [
                                                    0,
                                                    -0.033
                                                ],
                                                [
                                                    0.052,
                                                    -0.007
                                                ],
                                                [
                                                    0.172,
                                                    -1.004
                                                ],
                                                [
                                                    0.04,
                                                    -0.184
                                                ],
                                                [
                                                    0.184,
                                                    -0.658
                                                ],
                                                [
                                                    0.001,
                                                    -0.007
                                                ],
                                                [
                                                    0.02,
                                                    -0.001
                                                ],
                                                [
                                                    0.054,
                                                    -0.291
                                                ],
                                                [
                                                    0.02,
                                                    -0.108
                                                ],
                                                [
                                                    0.408,
                                                    0.634
                                                ],
                                                [
                                                    -0.107,
                                                    0.364
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.082,
                                                    0.29
                                                ],
                                                [
                                                    0.62,
                                                    0.955
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -225.525,
                                                    96.312
                                                ],
                                                [
                                                    -227.335,
                                                    97.752
                                                ],
                                                [
                                                    -228.783,
                                                    98.214
                                                ],
                                                [
                                                    -228.793,
                                                    98.212
                                                ],
                                                [
                                                    -228.932,
                                                    98.145
                                                ],
                                                [
                                                    -229.492,
                                                    96.785
                                                ],
                                                [
                                                    -229.392,
                                                    96.522
                                                ],
                                                [
                                                    -229.468,
                                                    96.425
                                                ],
                                                [
                                                    -229.371,
                                                    96.389
                                                ],
                                                [
                                                    -228.919,
                                                    93.357
                                                ],
                                                [
                                                    -228.799,
                                                    92.802
                                                ],
                                                [
                                                    -228.292,
                                                    90.81
                                                ],
                                                [
                                                    -228.324,
                                                    90.788
                                                ],
                                                [
                                                    -228.283,
                                                    90.78
                                                ],
                                                [
                                                    -228.233,
                                                    89.882
                                                ],
                                                [
                                                    -228.171,
                                                    89.558
                                                ],
                                                [
                                                    -226.919,
                                                    91.47
                                                ],
                                                [
                                                    -227.234,
                                                    92.562
                                                ],
                                                [
                                                    -227.234,
                                                    92.562
                                                ],
                                                [
                                                    -227.485,
                                                    93.431
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 13",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 13,
                                    "ty": "sh",
                                    "ix": 14,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    -0.113,
                                                    -0.276
                                                ],
                                                [
                                                    -0.635,
                                                    -1.347
                                                ],
                                                [
                                                    -1.004,
                                                    -1.614
                                                ],
                                                [
                                                    -0.686,
                                                    -1.157
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.296,
                                                    -2.047
                                                ],
                                                [
                                                    -0.953,
                                                    -1.22
                                                ],
                                                [
                                                    -0.107,
                                                    -0.136
                                                ],
                                                [
                                                    0.559,
                                                    -0.46
                                                ],
                                                [
                                                    1.847,
                                                    0.225
                                                ],
                                                [
                                                    1.033,
                                                    3.047
                                                ],
                                                [
                                                    0,
                                                    2.596
                                                ],
                                                [
                                                    -0.08,
                                                    1.51
                                                ],
                                                [
                                                    0.036,
                                                    0.151
                                                ],
                                                [
                                                    0,
                                                    0.071
                                                ],
                                                [
                                                    -0.447,
                                                    2.79
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.585,
                                                    1.462
                                                ],
                                                [
                                                    0.801,
                                                    1.703
                                                ],
                                                [
                                                    0.559,
                                                    1.182
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.284,
                                                    2.16
                                                ],
                                                [
                                                    0.877,
                                                    1.373
                                                ],
                                                [
                                                    0.108,
                                                    0.136
                                                ],
                                                [
                                                    -0.547,
                                                    0.614
                                                ],
                                                [
                                                    -1.773,
                                                    1.299
                                                ],
                                                [
                                                    -3.391,
                                                    -0.424
                                                ],
                                                [
                                                    -0.821,
                                                    -2.384
                                                ],
                                                [
                                                    0,
                                                    -1.59
                                                ],
                                                [
                                                    0,
                                                    -0.141
                                                ],
                                                [
                                                    -0.004,
                                                    -0.075
                                                ],
                                                [
                                                    0.147,
                                                    -2.819
                                                ],
                                                [
                                                    0.11,
                                                    0.281
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -218.098,
                                                    151.634
                                                ],
                                                [
                                                    -216.255,
                                                    155.828
                                                ],
                                                [
                                                    -213.459,
                                                    160.811
                                                ],
                                                [
                                                    -211.603,
                                                    164.331
                                                ],
                                                [
                                                    -211.222,
                                                    164.967
                                                ],
                                                [
                                                    -207.383,
                                                    171.296
                                                ],
                                                [
                                                    -204.549,
                                                    175.147
                                                ],
                                                [
                                                    -204.234,
                                                    175.557
                                                ],
                                                [
                                                    -205.892,
                                                    177.185
                                                ],
                                                [
                                                    -211.346,
                                                    178.77
                                                ],
                                                [
                                                    -218.249,
                                                    172.155
                                                ],
                                                [
                                                    -219.198,
                                                    164.579
                                                ],
                                                [
                                                    -219.243,
                                                    159.915
                                                ],
                                                [
                                                    -219.325,
                                                    159.47
                                                ],
                                                [
                                                    -219.333,
                                                    159.247
                                                ],
                                                [
                                                    -218.427,
                                                    150.784
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 14",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 14,
                                    "ty": "sh",
                                    "ix": 15,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.012,
                                                    0.014
                                                ],
                                                [
                                                    0.013,
                                                    -0.018
                                                ],
                                                [
                                                    0.007,
                                                    -0.01
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.012,
                                                    0.005
                                                ],
                                                [
                                                    -0.008,
                                                    0.011
                                                ],
                                                [
                                                    -0.012,
                                                    -0.015
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -218.244,
                                                    132.47
                                                ],
                                                [
                                                    -218.193,
                                                    132.482
                                                ],
                                                [
                                                    -218.21,
                                                    132.51
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 15",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 15,
                                    "ty": "sh",
                                    "ix": 16,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    -0.547,
                                                    4.906
                                                ],
                                                [
                                                    -0.546,
                                                    4.906
                                                ],
                                                [
                                                    -1.969,
                                                    2.345
                                                ],
                                                [
                                                    -0.051,
                                                    -0.228
                                                ],
                                                [
                                                    -0.026,
                                                    -0.076
                                                ],
                                                [
                                                    -0.419,
                                                    -2.314
                                                ],
                                                [
                                                    -0.267,
                                                    -1.691
                                                ],
                                                [
                                                    -0.178,
                                                    -1.665
                                                ],
                                                [
                                                    -0.115,
                                                    -3.724
                                                ],
                                                [
                                                    0.191,
                                                    -3.686
                                                ],
                                                [
                                                    0.508,
                                                    -3.623
                                                ],
                                                [
                                                    0.864,
                                                    -3.508
                                                ],
                                                [
                                                    0.775,
                                                    -2.643
                                                ],
                                                [
                                                    0.33,
                                                    -0.737
                                                ],
                                                [
                                                    0.001,
                                                    -0.002
                                                ],
                                                [
                                                    0.971,
                                                    1.211
                                                ],
                                                [
                                                    -0.483,
                                                    4.283
                                                ],
                                                [
                                                    -0.546,
                                                    4.893
                                                ],
                                                [
                                                    -0.547,
                                                    4.906
                                                ],
                                                [
                                                    -0.559,
                                                    4.893
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.559,
                                                    -4.906
                                                ],
                                                [
                                                    0.363,
                                                    -3.241
                                                ],
                                                [
                                                    0.05,
                                                    0.215
                                                ],
                                                [
                                                    0,
                                                    0.101
                                                ],
                                                [
                                                    0.635,
                                                    2.44
                                                ],
                                                [
                                                    0.318,
                                                    1.639
                                                ],
                                                [
                                                    0.254,
                                                    1.652
                                                ],
                                                [
                                                    0.432,
                                                    3.687
                                                ],
                                                [
                                                    0.114,
                                                    3.724
                                                ],
                                                [
                                                    -0.203,
                                                    3.762
                                                ],
                                                [
                                                    -0.534,
                                                    3.762
                                                ],
                                                [
                                                    -0.699,
                                                    2.657
                                                ],
                                                [
                                                    -0.241,
                                                    0.763
                                                ],
                                                [
                                                    -0.001,
                                                    0.002
                                                ],
                                                [
                                                    -1.257,
                                                    -0.859
                                                ],
                                                [
                                                    -2.682,
                                                    -3.368
                                                ],
                                                [
                                                    0.547,
                                                    -4.906
                                                ],
                                                [
                                                    0.559,
                                                    -4.894
                                                ],
                                                [
                                                    0.559,
                                                    -4.894
                                                ],
                                                [
                                                    0.547,
                                                    -4.906
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -193.529,
                                                    -33.397
                                                ],
                                                [
                                                    -192.551,
                                                    -43.222
                                                ],
                                                [
                                                    -188.928,
                                                    -51.715
                                                ],
                                                [
                                                    -188.852,
                                                    -51.056
                                                ],
                                                [
                                                    -188.102,
                                                    -50.929
                                                ],
                                                [
                                                    -186.818,
                                                    -43.697
                                                ],
                                                [
                                                    -186.589,
                                                    -38.587
                                                ],
                                                [
                                                    -185.128,
                                                    -33.72
                                                ],
                                                [
                                                    -185.102,
                                                    -22.547
                                                ],
                                                [
                                                    -184.607,
                                                    -11.413
                                                ],
                                                [
                                                    -185.522,
                                                    -0.292
                                                ],
                                                [
                                                    -188.216,
                                                    10.525
                                                ],
                                                [
                                                    -189.919,
                                                    18.634
                                                ],
                                                [
                                                    -191.216,
                                                    20.718
                                                ],
                                                [
                                                    -191.218,
                                                    20.724
                                                ],
                                                [
                                                    -194.648,
                                                    17.685
                                                ],
                                                [
                                                    -197.99,
                                                    5.802
                                                ],
                                                [
                                                    -196.897,
                                                    -3.998
                                                ],
                                                [
                                                    -195.919,
                                                    -13.81
                                                ],
                                                [
                                                    -194.648,
                                                    -23.584
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 16",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 16,
                                    "ty": "sh",
                                    "ix": 17,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.099,
                                                    -1.033
                                                ],
                                                [
                                                    0.31,
                                                    -2.094
                                                ],
                                                [
                                                    0.218,
                                                    -1.142
                                                ],
                                                [
                                                    0.624,
                                                    -2.456
                                                ],
                                                [
                                                    0.198,
                                                    -0.701
                                                ],
                                                [
                                                    0.001,
                                                    -0.008
                                                ],
                                                [
                                                    0.035,
                                                    -0.116
                                                ],
                                                [
                                                    0.349,
                                                    -1.167
                                                ],
                                                [
                                                    0.031,
                                                    -0.091
                                                ],
                                                [
                                                    0.053,
                                                    -0.186
                                                ],
                                                [
                                                    0.08,
                                                    -0.362
                                                ],
                                                [
                                                    0.013,
                                                    -0.039
                                                ],
                                                [
                                                    0.053,
                                                    -0.159
                                                ],
                                                [
                                                    0.162,
                                                    -0.246
                                                ],
                                                [
                                                    0.054,
                                                    -0.145
                                                ],
                                                [
                                                    0.053,
                                                    -0.159
                                                ],
                                                [
                                                    0.096,
                                                    -0.277
                                                ],
                                                [
                                                    -0.022,
                                                    -0.052
                                                ],
                                                [
                                                    0.055,
                                                    -0.146
                                                ],
                                                [
                                                    0.122,
                                                    -0.339
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.015,
                                                    -0.037
                                                ],
                                                [
                                                    1.072,
                                                    -1.937
                                                ],
                                                [
                                                    0.926,
                                                    -1.166
                                                ],
                                                [
                                                    2.797,
                                                    -1.434
                                                ],
                                                [
                                                    1.542,
                                                    -0.561
                                                ],
                                                [
                                                    1.526,
                                                    -0.247
                                                ],
                                                [
                                                    3.161,
                                                    0.184
                                                ],
                                                [
                                                    1.56,
                                                    0.155
                                                ],
                                                [
                                                    1.497,
                                                    0.365
                                                ],
                                                [
                                                    3.101,
                                                    1.174
                                                ],
                                                [
                                                    2.922,
                                                    1.613
                                                ],
                                                [
                                                    2.66,
                                                    2.072
                                                ],
                                                [
                                                    0.316,
                                                    0.253
                                                ],
                                                [
                                                    2.044,
                                                    2.207
                                                ],
                                                [
                                                    1.928,
                                                    2.867
                                                ],
                                                [
                                                    1.129,
                                                    1.976
                                                ],
                                                [
                                                    0.507,
                                                    1.042
                                                ],
                                                [
                                                    1.146,
                                                    3.309
                                                ],
                                                [
                                                    0.233,
                                                    0.805
                                                ],
                                                [
                                                    0.608,
                                                    2.56
                                                ],
                                                [
                                                    0.523,
                                                    3.472
                                                ],
                                                [
                                                    0.279,
                                                    3.498
                                                ],
                                                [
                                                    0.074,
                                                    3.55
                                                ],
                                                [
                                                    -0.006,
                                                    1.053
                                                ],
                                                [
                                                    -0.001,
                                                    0.029
                                                ],
                                                [
                                                    0,
                                                    0.378
                                                ],
                                                [
                                                    0.003,
                                                    0.192
                                                ],
                                                [
                                                    -0.052,
                                                    1.83
                                                ],
                                                [
                                                    -0.248,
                                                    3.52
                                                ],
                                                [
                                                    -0.162,
                                                    1.788
                                                ],
                                                [
                                                    -0.115,
                                                    1.449
                                                ],
                                                [
                                                    -0.344,
                                                    3.229
                                                ],
                                                [
                                                    -0.484,
                                                    3.204
                                                ],
                                                [
                                                    -0.683,
                                                    3.165
                                                ],
                                                [
                                                    -0.187,
                                                    0.892
                                                ],
                                                [
                                                    -0.675,
                                                    2.23
                                                ],
                                                [
                                                    -1.247,
                                                    3.003
                                                ],
                                                [
                                                    -1.473,
                                                    2.534
                                                ],
                                                [
                                                    -1.895,
                                                    2.216
                                                ],
                                                [
                                                    -0.079,
                                                    0.053
                                                ],
                                                [
                                                    -0.079,
                                                    0.08
                                                ],
                                                [
                                                    -0.174,
                                                    0.222
                                                ],
                                                [
                                                    -0.096,
                                                    0.096
                                                ],
                                                [
                                                    -0.021,
                                                    0.029
                                                ],
                                                [
                                                    -0.126,
                                                    0.126
                                                ],
                                                [
                                                    -0.041,
                                                    0.087
                                                ],
                                                [
                                                    -0.029,
                                                    0.034
                                                ],
                                                [
                                                    -0.029,
                                                    0.059
                                                ],
                                                [
                                                    -0.065,
                                                    0.065
                                                ],
                                                [
                                                    -0.019,
                                                    0.111
                                                ],
                                                [
                                                    -0.035,
                                                    0.026
                                                ],
                                                [
                                                    -0.008,
                                                    0.01
                                                ],
                                                [
                                                    -0.097,
                                                    0.097
                                                ],
                                                [
                                                    -0.226,
                                                    0.211
                                                ],
                                                [
                                                    -0.848,
                                                    0.689
                                                ],
                                                [
                                                    -1.5,
                                                    0.806
                                                ],
                                                [
                                                    -2.337,
                                                    0.615
                                                ],
                                                [
                                                    -3.051,
                                                    -1.353
                                                ],
                                                [
                                                    -0.588,
                                                    -2.848
                                                ],
                                                [
                                                    -0.037,
                                                    -0.278
                                                ],
                                                [
                                                    -0.093,
                                                    -0.38
                                                ],
                                                [
                                                    0.124,
                                                    -0.922
                                                ],
                                                [
                                                    0.595,
                                                    -1.534
                                                ],
                                                [
                                                    0.901,
                                                    -2.4
                                                ],
                                                [
                                                    0.324,
                                                    -0.924
                                                ],
                                                [
                                                    1.022,
                                                    -3.389
                                                ],
                                                [
                                                    0.366,
                                                    -1.234
                                                ],
                                                [
                                                    0.554,
                                                    -2.177
                                                ],
                                                [
                                                    0.014,
                                                    -0.09
                                                ],
                                                [
                                                    0.001,
                                                    -0.002
                                                ],
                                                [
                                                    0.006,
                                                    0.01
                                                ],
                                                [
                                                    0.096,
                                                    -0.567
                                                ],
                                                [
                                                    0.013,
                                                    -0.052
                                                ],
                                                [
                                                    -0.039,
                                                    -0.072
                                                ],
                                                [
                                                    0.027,
                                                    -0.068
                                                ],
                                                [
                                                    0.068,
                                                    -0.175
                                                ],
                                                [
                                                    0.059,
                                                    -0.221
                                                ],
                                                [
                                                    0.01,
                                                    -0.143
                                                ],
                                                [
                                                    0.012,
                                                    -0.042
                                                ],
                                                [
                                                    0.009,
                                                    -0.094
                                                ],
                                                [
                                                    0.026,
                                                    -0.079
                                                ],
                                                [
                                                    0.079,
                                                    -0.397
                                                ],
                                                [
                                                    0.673,
                                                    -3.748
                                                ],
                                                [
                                                    0.369,
                                                    -2.816
                                                ],
                                                [
                                                    0.124,
                                                    -0.947
                                                ],
                                                [
                                                    0.085,
                                                    -1.038
                                                ],
                                                [
                                                    0.228,
                                                    -2.734
                                                ],
                                                [
                                                    -0.032,
                                                    -0.087
                                                ],
                                                [
                                                    0,
                                                    -0.041
                                                ],
                                                [
                                                    -0.735,
                                                    -0.594
                                                ],
                                                [
                                                    -0.577,
                                                    -0.08
                                                ],
                                                [
                                                    -0.265,
                                                    1.563
                                                ],
                                                [
                                                    -1.396,
                                                    2.484
                                                ],
                                                [
                                                    -0.563,
                                                    0.781
                                                ],
                                                [
                                                    -1.27,
                                                    1.199
                                                ],
                                                [
                                                    -1.743,
                                                    1.08
                                                ],
                                                [
                                                    -0.003,
                                                    0.03
                                                ],
                                                [
                                                    -0.025,
                                                    0.026
                                                ],
                                                [
                                                    -0.008,
                                                    0.004
                                                ],
                                                [
                                                    -0.005,
                                                    0.017
                                                ],
                                                [
                                                    -0.067,
                                                    0.045
                                                ],
                                                [
                                                    -0.053,
                                                    0.026
                                                ],
                                                [
                                                    -0.083,
                                                    0.069
                                                ],
                                                [
                                                    -0.025,
                                                    0.009
                                                ],
                                                [
                                                    -0.215,
                                                    0.116
                                                ],
                                                [
                                                    -0.051,
                                                    0.031
                                                ],
                                                [
                                                    -0.026,
                                                    0.027
                                                ],
                                                [
                                                    -0.109,
                                                    0.088
                                                ],
                                                [
                                                    -0.132,
                                                    0.066
                                                ],
                                                [
                                                    -0.159,
                                                    0.08
                                                ],
                                                [
                                                    0,
                                                    0.026
                                                ],
                                                [
                                                    -0.003,
                                                    0.059
                                                ],
                                                [
                                                    -0.048,
                                                    0.032
                                                ],
                                                [
                                                    -0.132,
                                                    0.053
                                                ],
                                                [
                                                    -0.227,
                                                    0.18
                                                ],
                                                [
                                                    -0.058,
                                                    0.024
                                                ],
                                                [
                                                    -0.012,
                                                    0.005
                                                ],
                                                [
                                                    -0.318,
                                                    0.106
                                                ],
                                                [
                                                    -0.03,
                                                    -0.025
                                                ],
                                                [
                                                    -0.035,
                                                    0.017
                                                ],
                                                [
                                                    -2.067,
                                                    0.265
                                                ],
                                                [
                                                    0,
                                                    0.007
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.016,
                                                    0
                                                ],
                                                [
                                                    -0.046,
                                                    0.139
                                                ],
                                                [
                                                    -0.008,
                                                    0.001
                                                ],
                                                [
                                                    -0.013,
                                                    0.001
                                                ],
                                                [
                                                    -0.212,
                                                    0.027
                                                ],
                                                [
                                                    -0.069,
                                                    0.05
                                                ],
                                                [
                                                    -0.398,
                                                    0.005
                                                ],
                                                [
                                                    -0.239,
                                                    0
                                                ],
                                                [
                                                    -0.007,
                                                    0.001
                                                ],
                                                [
                                                    -0.152,
                                                    -0.025
                                                ],
                                                [
                                                    -3.134,
                                                    -1.119
                                                ],
                                                [
                                                    -2.375,
                                                    -1.577
                                                ],
                                                [
                                                    -0.364,
                                                    -0.262
                                                ],
                                                [
                                                    -0.292,
                                                    -0.239
                                                ],
                                                [
                                                    -1.325,
                                                    -1.431
                                                ],
                                                [
                                                    -0.379,
                                                    -0.425
                                                ],
                                                [
                                                    -0.061,
                                                    -0.073
                                                ],
                                                [
                                                    -0.98,
                                                    -1.643
                                                ],
                                                [
                                                    -0.693,
                                                    -1.493
                                                ],
                                                [
                                                    -0.304,
                                                    -0.883
                                                ],
                                                [
                                                    -0.008,
                                                    -0.017
                                                ],
                                                [
                                                    -0.026,
                                                    -0.08
                                                ],
                                                [
                                                    -0.133,
                                                    -0.53
                                                ],
                                                [
                                                    -0.05,
                                                    -0.071
                                                ],
                                                [
                                                    -0.008,
                                                    -0.03
                                                ],
                                                [
                                                    -0.065,
                                                    -0.107
                                                ],
                                                [
                                                    -0.027,
                                                    -0.12
                                                ],
                                                [
                                                    -0.084,
                                                    -0.303
                                                ],
                                                [
                                                    -0.021,
                                                    -0.081
                                                ],
                                                [
                                                    -0.159,
                                                    -1.166
                                                ],
                                                [
                                                    -0.126,
                                                    -0.384
                                                ],
                                                [
                                                    -0.037,
                                                    -0.347
                                                ],
                                                [
                                                    0.025,
                                                    -1.522
                                                ],
                                                [
                                                    0.027,
                                                    -0.522
                                                ],
                                                [
                                                    -0.004,
                                                    -0.179
                                                ],
                                                [
                                                    0.016,
                                                    -0.248
                                                ],
                                                [
                                                    0.954,
                                                    -3.312
                                                ],
                                                [
                                                    0.45,
                                                    -0.186
                                                ],
                                                [
                                                    0.132,
                                                    0
                                                ],
                                                [
                                                    0.132,
                                                    0
                                                ],
                                                [
                                                    0.003,
                                                    0.005
                                                ],
                                                [
                                                    0.016,
                                                    0
                                                ],
                                                [
                                                    0.177,
                                                    0.015
                                                ],
                                                [
                                                    0.043,
                                                    0.01
                                                ],
                                                [
                                                    0.556,
                                                    0.159
                                                ],
                                                [
                                                    0.318,
                                                    0.106
                                                ],
                                                [
                                                    0.317,
                                                    0.069
                                                ],
                                                [
                                                    0.287,
                                                    0.144
                                                ],
                                                [
                                                    0.265,
                                                    0.159
                                                ],
                                                [
                                                    1.245,
                                                    2.835
                                                ],
                                                [
                                                    0.132,
                                                    0.371
                                                ],
                                                [
                                                    0.106,
                                                    0.265
                                                ],
                                                [
                                                    0.141,
                                                    0.228
                                                ],
                                                [
                                                    0.078,
                                                    0.246
                                                ],
                                                [
                                                    0.069,
                                                    0.321
                                                ],
                                                [
                                                    0.022,
                                                    0.168
                                                ],
                                                [
                                                    0.032,
                                                    0.022
                                                ],
                                                [
                                                    0.111,
                                                    0.111
                                                ],
                                                [
                                                    0.184,
                                                    0.025
                                                ],
                                                [
                                                    0.026,
                                                    0.053
                                                ],
                                                [
                                                    0.978,
                                                    1.431
                                                ],
                                                [
                                                    0.753,
                                                    0.686
                                                ],
                                                [
                                                    1.219,
                                                    0.53
                                                ],
                                                [
                                                    0.053,
                                                    0.027
                                                ],
                                                [
                                                    0.219,
                                                    0.017
                                                ],
                                                [
                                                    0.134,
                                                    0.049
                                                ],
                                                [
                                                    0.45,
                                                    0.106
                                                ],
                                                [
                                                    0.086,
                                                    0.051
                                                ],
                                                [
                                                    0.068,
                                                    0.011
                                                ],
                                                [
                                                    0.344,
                                                    0.026
                                                ],
                                                [
                                                    2.46,
                                                    -0.872
                                                ],
                                                [
                                                    0.838,
                                                    -0.428
                                                ],
                                                [
                                                    2.062,
                                                    -2.666
                                                ],
                                                [
                                                    0.012,
                                                    -0.084
                                                ],
                                                [
                                                    0.042,
                                                    -0.062
                                                ],
                                                [
                                                    0.006,
                                                    -0.008
                                                ],
                                                [
                                                    -0.044,
                                                    -0.119
                                                ],
                                                [
                                                    0.084,
                                                    -0.126
                                                ],
                                                [
                                                    0.004,
                                                    -0.05
                                                ],
                                                [
                                                    0.027,
                                                    -0.041
                                                ],
                                                [
                                                    0.159,
                                                    -0.239
                                                ],
                                                [
                                                    0.019,
                                                    -0.017
                                                ],
                                                [
                                                    0.011,
                                                    -0.011
                                                ],
                                                [
                                                    0.034,
                                                    -0.149
                                                ],
                                                [
                                                    0.108,
                                                    -0.216
                                                ],
                                                [
                                                    0.005,
                                                    -0.108
                                                ],
                                                [
                                                    0.061,
                                                    -0.084
                                                ],
                                                [
                                                    0.028,
                                                    -0.063
                                                ],
                                                [
                                                    0.063,
                                                    -0.121
                                                ],
                                                [
                                                    0.212,
                                                    -0.503
                                                ],
                                                [
                                                    0.574,
                                                    -3.781
                                                ],
                                                [
                                                    0.16,
                                                    -2.255
                                                ],
                                                [
                                                    0.057,
                                                    -0.765
                                                ],
                                                [
                                                    0.044,
                                                    -0.791
                                                ],
                                                [
                                                    0.015,
                                                    -0.483
                                                ],
                                                [
                                                    0,
                                                    -1.198
                                                ],
                                                [
                                                    -0.09,
                                                    -1.062
                                                ],
                                                [
                                                    -0.729,
                                                    -2.134
                                                ],
                                                [
                                                    -1.937,
                                                    -1.833
                                                ],
                                                [
                                                    -0.899,
                                                    -0.51
                                                ],
                                                [
                                                    -1.73,
                                                    -0.202
                                                ],
                                                [
                                                    -3.005,
                                                    2.325
                                                ],
                                                [
                                                    -0.735,
                                                    0.778
                                                ],
                                                [
                                                    -0.477,
                                                    0.583
                                                ],
                                                [
                                                    0.016,
                                                    0.077
                                                ],
                                                [
                                                    -0.046,
                                                    0.062
                                                ],
                                                [
                                                    -0.101,
                                                    0.153
                                                ],
                                                [
                                                    -0.166,
                                                    0.238
                                                ],
                                                [
                                                    -0.032,
                                                    0.139
                                                ],
                                                [
                                                    -0.148,
                                                    0.211
                                                ],
                                                [
                                                    -0.044,
                                                    0.098
                                                ],
                                                [
                                                    -0.077,
                                                    0.123
                                                ],
                                                [
                                                    -0.079,
                                                    0.159
                                                ],
                                                [
                                                    -0.041,
                                                    0.237
                                                ],
                                                [
                                                    -0.046,
                                                    0.081
                                                ],
                                                [
                                                    -0.006,
                                                    0.011
                                                ],
                                                [
                                                    -0.002,
                                                    0.003
                                                ],
                                                [
                                                    -0.004,
                                                    0.007
                                                ],
                                                [
                                                    -0.503,
                                                    1.325
                                                ],
                                                [
                                                    -0.344,
                                                    0.795
                                                ],
                                                [
                                                    0.045,
                                                    0.052
                                                ],
                                                [
                                                    -0.028,
                                                    0.069
                                                ],
                                                [
                                                    -1.539,
                                                    2.073
                                                ],
                                                [
                                                    -3.197,
                                                    0.015
                                                ],
                                                [
                                                    -1.57,
                                                    -1.185
                                                ],
                                                [
                                                    -0.438,
                                                    -0.498
                                                ],
                                                [
                                                    0,
                                                    -5.087
                                                ],
                                                [
                                                    -0.011,
                                                    -0.898
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.212,
                                                    2.115
                                                ],
                                                [
                                                    -0.227,
                                                    1.148
                                                ],
                                                [
                                                    -0.482,
                                                    2.532
                                                ],
                                                [
                                                    -0.19,
                                                    0.708
                                                ],
                                                [
                                                    -0.002,
                                                    0.009
                                                ],
                                                [
                                                    -0.055,
                                                    0.094
                                                ],
                                                [
                                                    -0.319,
                                                    1.154
                                                ],
                                                [
                                                    -0.031,
                                                    0.091
                                                ],
                                                [
                                                    -0.053,
                                                    0.186
                                                ],
                                                [
                                                    -0.096,
                                                    0.359
                                                ],
                                                [
                                                    -0.011,
                                                    0.039
                                                ],
                                                [
                                                    -0.053,
                                                    0.159
                                                ],
                                                [
                                                    -0.087,
                                                    0.244
                                                ],
                                                [
                                                    -0.097,
                                                    0.123
                                                ],
                                                [
                                                    -0.053,
                                                    0.159
                                                ],
                                                [
                                                    -0.093,
                                                    0.278
                                                ],
                                                [
                                                    -0.016,
                                                    0.041
                                                ],
                                                [
                                                    -0.078,
                                                    0.072
                                                ],
                                                [
                                                    -0.104,
                                                    0.311
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.015,
                                                    0.037
                                                ],
                                                [
                                                    -0.669,
                                                    1.697
                                                ],
                                                [
                                                    -0.744,
                                                    1.259
                                                ],
                                                [
                                                    -2.044,
                                                    2.552
                                                ],
                                                [
                                                    -1.442,
                                                    0.74
                                                ],
                                                [
                                                    -1.446,
                                                    0.467
                                                ],
                                                [
                                                    -3.109,
                                                    0.504
                                                ],
                                                [
                                                    -1.597,
                                                    -0.093
                                                ],
                                                [
                                                    -1.591,
                                                    -0.261
                                                ],
                                                [
                                                    -3.403,
                                                    -0.828
                                                ],
                                                [
                                                    -3.257,
                                                    -1.233
                                                ],
                                                [
                                                    -3.019,
                                                    -1.667
                                                ],
                                                [
                                                    -0.319,
                                                    -0.249
                                                ],
                                                [
                                                    -2.318,
                                                    -1.9
                                                ],
                                                [
                                                    -2.287,
                                                    -2.469
                                                ],
                                                [
                                                    -1.238,
                                                    -1.841
                                                ],
                                                [
                                                    -0.5,
                                                    -1.026
                                                ],
                                                [
                                                    -1.449,
                                                    -2.977
                                                ],
                                                [
                                                    -0.27,
                                                    -0.78
                                                ],
                                                [
                                                    -0.66,
                                                    -2.424
                                                ],
                                                [
                                                    -0.763,
                                                    -3.213
                                                ],
                                                [
                                                    -0.492,
                                                    -3.269
                                                ],
                                                [
                                                    -0.264,
                                                    -3.283
                                                ],
                                                [
                                                    -0.021,
                                                    -1.031
                                                ],
                                                [
                                                    0.001,
                                                    -0.029
                                                ],
                                                [
                                                    0.038,
                                                    -0.344
                                                ],
                                                [
                                                    0,
                                                    -0.191
                                                ],
                                                [
                                                    0.069,
                                                    -1.769
                                                ],
                                                [
                                                    0.095,
                                                    -3.323
                                                ],
                                                [
                                                    0.125,
                                                    -1.781
                                                ],
                                                [
                                                    0.18,
                                                    -1.439
                                                ],
                                                [
                                                    0.257,
                                                    -3.227
                                                ],
                                                [
                                                    0.343,
                                                    -3.227
                                                ],
                                                [
                                                    0.486,
                                                    -3.212
                                                ],
                                                [
                                                    0.192,
                                                    -0.891
                                                ],
                                                [
                                                    0.52,
                                                    -2.275
                                                ],
                                                [
                                                    0.938,
                                                    -3.1
                                                ],
                                                [
                                                    1.243,
                                                    -2.989
                                                ],
                                                [
                                                    1.634,
                                                    -2.812
                                                ],
                                                [
                                                    0.053,
                                                    -0.08
                                                ],
                                                [
                                                    0.053,
                                                    -0.08
                                                ],
                                                [
                                                    0.167,
                                                    -0.185
                                                ],
                                                [
                                                    0.089,
                                                    -0.083
                                                ],
                                                [
                                                    0.021,
                                                    -0.027
                                                ],
                                                [
                                                    0.154,
                                                    -0.051
                                                ],
                                                [
                                                    0.095,
                                                    -0.108
                                                ],
                                                [
                                                    0.036,
                                                    -0.006
                                                ],
                                                [
                                                    0.04,
                                                    -0.04
                                                ],
                                                [
                                                    0.075,
                                                    -0.065
                                                ],
                                                [
                                                    0.071,
                                                    -0.053
                                                ],
                                                [
                                                    0.02,
                                                    -0.043
                                                ],
                                                [
                                                    0.009,
                                                    -0.009
                                                ],
                                                [
                                                    0.111,
                                                    -0.078
                                                ],
                                                [
                                                    0.224,
                                                    -0.213
                                                ],
                                                [
                                                    0.768,
                                                    -0.715
                                                ],
                                                [
                                                    1.193,
                                                    -0.922
                                                ],
                                                [
                                                    2.095,
                                                    -1.043
                                                ],
                                                [
                                                    4.399,
                                                    -1.158
                                                ],
                                                [
                                                    2.351,
                                                    1.065
                                                ],
                                                [
                                                    -0.004,
                                                    0.274
                                                ],
                                                [
                                                    0.043,
                                                    0.34
                                                ],
                                                [
                                                    0.054,
                                                    0.855
                                                ],
                                                [
                                                    -0.25,
                                                    1.392
                                                ],
                                                [
                                                    -0.951,
                                                    2.358
                                                ],
                                                [
                                                    -0.361,
                                                    0.909
                                                ],
                                                [
                                                    -1.166,
                                                    3.324
                                                ],
                                                [
                                                    -0.371,
                                                    1.231
                                                ],
                                                [
                                                    -0.699,
                                                    2.139
                                                ],
                                                [
                                                    -0.023,
                                                    0.092
                                                ],
                                                [
                                                    -0.001,
                                                    0.002
                                                ],
                                                [
                                                    -0.006,
                                                    -0.01
                                                ],
                                                [
                                                    -0.397,
                                                    0.509
                                                ],
                                                [
                                                    -0.011,
                                                    0.044
                                                ],
                                                [
                                                    -0.013,
                                                    0.064
                                                ],
                                                [
                                                    0.02,
                                                    0.071
                                                ],
                                                [
                                                    -0.035,
                                                    0.176
                                                ],
                                                [
                                                    -0.122,
                                                    0.21
                                                ],
                                                [
                                                    -0.041,
                                                    0.143
                                                ],
                                                [
                                                    -0.011,
                                                    0.04
                                                ],
                                                [
                                                    -0.027,
                                                    0.094
                                                ],
                                                [
                                                    -0.051,
                                                    0.08
                                                ],
                                                [
                                                    -0.106,
                                                    0.45
                                                ],
                                                [
                                                    -0.84,
                                                    3.647
                                                ],
                                                [
                                                    -0.497,
                                                    2.768
                                                ],
                                                [
                                                    -0.162,
                                                    0.938
                                                ],
                                                [
                                                    -0.135,
                                                    1.03
                                                ],
                                                [
                                                    -0.344,
                                                    2.713
                                                ],
                                                [
                                                    -0.019,
                                                    0.074
                                                ],
                                                [
                                                    -0.045,
                                                    0.034
                                                ],
                                                [
                                                    0,
                                                    0.916
                                                ],
                                                [
                                                    0.428,
                                                    0.36
                                                ],
                                                [
                                                    1.59,
                                                    0.159
                                                ],
                                                [
                                                    0.43,
                                                    -2.713
                                                ],
                                                [
                                                    0.474,
                                                    -0.818
                                                ],
                                                [
                                                    1.001,
                                                    -1.389
                                                ],
                                                [
                                                    1.449,
                                                    -1.353
                                                ],
                                                [
                                                    0.015,
                                                    -0.007
                                                ],
                                                [
                                                    0.023,
                                                    -0.032
                                                ],
                                                [
                                                    0.015,
                                                    0.005
                                                ],
                                                [
                                                    0.013,
                                                    -0.008
                                                ],
                                                [
                                                    0.074,
                                                    -0.026
                                                ],
                                                [
                                                    0.027,
                                                    -0.027
                                                ],
                                                [
                                                    0.095,
                                                    -0.055
                                                ],
                                                [
                                                    0.025,
                                                    -0.01
                                                ],
                                                [
                                                    0.249,
                                                    -0.007
                                                ],
                                                [
                                                    0.052,
                                                    -0.028
                                                ],
                                                [
                                                    0.027,
                                                    -0.026
                                                ],
                                                [
                                                    0.118,
                                                    -0.066
                                                ],
                                                [
                                                    0.145,
                                                    -0.025
                                                ],
                                                [
                                                    0.132,
                                                    -0.079
                                                ],
                                                [
                                                    0.021,
                                                    -0.009
                                                ],
                                                [
                                                    0.028,
                                                    -0.009
                                                ],
                                                [
                                                    0.04,
                                                    -0.031
                                                ],
                                                [
                                                    0.106,
                                                    -0.027
                                                ],
                                                [
                                                    0.239,
                                                    -0.109
                                                ],
                                                [
                                                    0.059,
                                                    -0.022
                                                ],
                                                [
                                                    0.012,
                                                    -0.006
                                                ],
                                                [
                                                    0.318,
                                                    -0.106
                                                ],
                                                [
                                                    0.018,
                                                    -0.009
                                                ],
                                                [
                                                    0.063,
                                                    0.062
                                                ],
                                                [
                                                    2.013,
                                                    -0.715
                                                ],
                                                [
                                                    0.002,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.008,
                                                    0.067
                                                ],
                                                [
                                                    0.153,
                                                    -0.012
                                                ],
                                                [
                                                    0.008,
                                                    -0.001
                                                ],
                                                [
                                                    0.013,
                                                    0.007
                                                ],
                                                [
                                                    0.265,
                                                    -0.026
                                                ],
                                                [
                                                    0.142,
                                                    -0.01
                                                ],
                                                [
                                                    0.399,
                                                    -0.021
                                                ],
                                                [
                                                    0.24,
                                                    0.067
                                                ],
                                                [
                                                    0.007,
                                                    0
                                                ],
                                                [
                                                    0.154,
                                                    0.001
                                                ],
                                                [
                                                    3.208,
                                                    0.081
                                                ],
                                                [
                                                    2.614,
                                                    0.933
                                                ],
                                                [
                                                    0.369,
                                                    0.254
                                                ],
                                                [
                                                    0.318,
                                                    0.212
                                                ],
                                                [
                                                    1.563,
                                                    1.166
                                                ],
                                                [
                                                    0.408,
                                                    0.431
                                                ],
                                                [
                                                    0.063,
                                                    0.072
                                                ],
                                                [
                                                    1.245,
                                                    1.484
                                                ],
                                                [
                                                    0.797,
                                                    1.374
                                                ],
                                                [
                                                    0.347,
                                                    0.856
                                                ],
                                                [
                                                    0.006,
                                                    0.018
                                                ],
                                                [
                                                    0.027,
                                                    0.08
                                                ],
                                                [
                                                    0.133,
                                                    0.397
                                                ],
                                                [
                                                    0.019,
                                                    0.077
                                                ],
                                                [
                                                    -0.025,
                                                    0.039
                                                ],
                                                [
                                                    0.04,
                                                    0.106
                                                ],
                                                [
                                                    0.028,
                                                    0.118
                                                ],
                                                [
                                                    0.076,
                                                    0.306
                                                ],
                                                [
                                                    0.022,
                                                    0.081
                                                ],
                                                [
                                                    0.291,
                                                    1.166
                                                ],
                                                [
                                                    0.07,
                                                    0.394
                                                ],
                                                [
                                                    -0.001,
                                                    0.353
                                                ],
                                                [
                                                    0.177,
                                                    1.516
                                                ],
                                                [
                                                    -0.035,
                                                    0.527
                                                ],
                                                [
                                                    0.011,
                                                    0.187
                                                ],
                                                [
                                                    -0.024,
                                                    0.252
                                                ],
                                                [
                                                    -0.159,
                                                    3.365
                                                ],
                                                [
                                                    -0.106,
                                                    0.371
                                                ],
                                                [
                                                    -0.106,
                                                    0.079
                                                ],
                                                [
                                                    -0.106,
                                                    0.026
                                                ],
                                                [
                                                    -0.005,
                                                    0
                                                ],
                                                [
                                                    0.002,
                                                    -0.097
                                                ],
                                                [
                                                    -0.087,
                                                    -0.022
                                                ],
                                                [
                                                    -0.037,
                                                    -0.013
                                                ],
                                                [
                                                    -0.53,
                                                    -0.079
                                                ],
                                                [
                                                    -0.318,
                                                    -0.08
                                                ],
                                                [
                                                    -0.305,
                                                    -0.106
                                                ],
                                                [
                                                    -0.259,
                                                    -0.199
                                                ],
                                                [
                                                    -0.265,
                                                    -0.106
                                                ],
                                                [
                                                    -2.835,
                                                    -1.563
                                                ],
                                                [
                                                    -0.159,
                                                    -0.371
                                                ],
                                                [
                                                    -0.106,
                                                    -0.265
                                                ],
                                                [
                                                    -0.079,
                                                    -0.237
                                                ],
                                                [
                                                    -0.006,
                                                    -0.261
                                                ],
                                                [
                                                    -0.094,
                                                    -0.516
                                                ],
                                                [
                                                    0.007,
                                                    -0.109
                                                ],
                                                [
                                                    -0.01,
                                                    -0.072
                                                ],
                                                [
                                                    -0.015,
                                                    -0.096
                                                ],
                                                [
                                                    -0.131,
                                                    -0.131
                                                ],
                                                [
                                                    -0.026,
                                                    -0.053
                                                ],
                                                [
                                                    -0.511,
                                                    -1.466
                                                ],
                                                [
                                                    -0.511,
                                                    -0.819
                                                ],
                                                [
                                                    -0.954,
                                                    -0.848
                                                ],
                                                [
                                                    -0.053,
                                                    -0.026
                                                ],
                                                [
                                                    -0.331,
                                                    -0.134
                                                ],
                                                [
                                                    -0.08,
                                                    -0.027
                                                ],
                                                [
                                                    -0.45,
                                                    -0.133
                                                ],
                                                [
                                                    -0.092,
                                                    -0.015
                                                ],
                                                [
                                                    -0.058,
                                                    -0.065
                                                ],
                                                [
                                                    -0.344,
                                                    -0.053
                                                ],
                                                [
                                                    -2.813,
                                                    -0.355
                                                ],
                                                [
                                                    -0.907,
                                                    0.275
                                                ],
                                                [
                                                    -3.341,
                                                    1.705
                                                ],
                                                [
                                                    -0.037,
                                                    0.062
                                                ],
                                                [
                                                    -0.092,
                                                    0.017
                                                ],
                                                [
                                                    -0.04,
                                                    -0.048
                                                ],
                                                [
                                                    -0.085,
                                                    0.12
                                                ],
                                                [
                                                    -0.026,
                                                    0.074
                                                ],
                                                [
                                                    -0.026,
                                                    0.026
                                                ],
                                                [
                                                    -0.08,
                                                    0.002
                                                ],
                                                [
                                                    -0.185,
                                                    0.291
                                                ],
                                                [
                                                    -0.016,
                                                    0.032
                                                ],
                                                [
                                                    -0.061,
                                                    -0.02
                                                ],
                                                [
                                                    -0.084,
                                                    0.127
                                                ],
                                                [
                                                    -0.186,
                                                    0.249
                                                ],
                                                [
                                                    -0.058,
                                                    0.077
                                                ],
                                                [
                                                    -0.071,
                                                    0.079
                                                ],
                                                [
                                                    -0.062,
                                                    0.046
                                                ],
                                                [
                                                    -0.061,
                                                    0.122
                                                ],
                                                [
                                                    -0.238,
                                                    0.477
                                                ],
                                                [
                                                    -1.52,
                                                    3.409
                                                ],
                                                [
                                                    -0.322,
                                                    2.118
                                                ],
                                                [
                                                    -0.07,
                                                    0.75
                                                ],
                                                [
                                                    -0.066,
                                                    0.772
                                                ],
                                                [
                                                    -0.024,
                                                    0.459
                                                ],
                                                [
                                                    -0.048,
                                                    1.106
                                                ],
                                                [
                                                    0,
                                                    1.03
                                                ],
                                                [
                                                    0.144,
                                                    2.173
                                                ],
                                                [
                                                    0.948,
                                                    2.794
                                                ],
                                                [
                                                    0.79,
                                                    0.747
                                                ],
                                                [
                                                    1.496,
                                                    0.984
                                                ],
                                                [
                                                    3.459,
                                                    0.443
                                                ],
                                                [
                                                    0.775,
                                                    -0.581
                                                ],
                                                [
                                                    0.53,
                                                    -0.556
                                                ],
                                                [
                                                    0.034,
                                                    -0.045
                                                ],
                                                [
                                                    0.045,
                                                    -0.055
                                                ],
                                                [
                                                    0.21,
                                                    -0.304
                                                ],
                                                [
                                                    0.145,
                                                    -0.078
                                                ],
                                                [
                                                    0.151,
                                                    -0.217
                                                ],
                                                [
                                                    0.074,
                                                    -0.105
                                                ],
                                                [
                                                    0.056,
                                                    -0.09
                                                ],
                                                [
                                                    0.118,
                                                    -0.095
                                                ],
                                                [
                                                    0.106,
                                                    -0.159
                                                ],
                                                [
                                                    0.172,
                                                    -0.293
                                                ],
                                                [
                                                    0.029,
                                                    -0.055
                                                ],
                                                [
                                                    0.007,
                                                    -0.011
                                                ],
                                                [
                                                    0.002,
                                                    -0.003
                                                ],
                                                [
                                                    0.085,
                                                    0.056
                                                ],
                                                [
                                                    1.166,
                                                    -2.066
                                                ],
                                                [
                                                    0.344,
                                                    -0.848
                                                ],
                                                [
                                                    0.024,
                                                    -0.059
                                                ],
                                                [
                                                    0.046,
                                                    -0.022
                                                ],
                                                [
                                                    1.361,
                                                    -3.277
                                                ],
                                                [
                                                    2.056,
                                                    -2.771
                                                ],
                                                [
                                                    1.9,
                                                    0.04
                                                ],
                                                [
                                                    0.523,
                                                    0.416
                                                ],
                                                [
                                                    3.418,
                                                    3.868
                                                ],
                                                [
                                                    0,
                                                    0.885
                                                ],
                                                [
                                                    -0.104,
                                                    1.028
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -169.568,
                                                    176.55
                                                ],
                                                [
                                                    -170.339,
                                                    182.869
                                                ],
                                                [
                                                    -171.015,
                                                    186.305
                                                ],
                                                [
                                                    -172.651,
                                                    193.799
                                                ],
                                                [
                                                    -173.231,
                                                    195.915
                                                ],
                                                [
                                                    -173.23,
                                                    195.937
                                                ],
                                                [
                                                    -173.504,
                                                    196.103
                                                ],
                                                [
                                                    -174.271,
                                                    199.662
                                                ],
                                                [
                                                    -174.364,
                                                    199.934
                                                ],
                                                [
                                                    -174.795,
                                                    200.383
                                                ],
                                                [
                                                    -174.895,
                                                    201.478
                                                ],
                                                [
                                                    -174.922,
                                                    201.594
                                                ],
                                                [
                                                    -175.092,
                                                    202.069
                                                ],
                                                [
                                                    -175.525,
                                                    202.786
                                                ],
                                                [
                                                    -175.767,
                                                    203.18
                                                ],
                                                [
                                                    -175.921,
                                                    203.672
                                                ],
                                                [
                                                    -176.104,
                                                    204.228
                                                ],
                                                [
                                                    -176.084,
                                                    204.37
                                                ],
                                                [
                                                    -176.323,
                                                    204.657
                                                ],
                                                [
                                                    -176.511,
                                                    205.701
                                                ],
                                                [
                                                    -176.511,
                                                    205.702
                                                ],
                                                [
                                                    -176.554,
                                                    205.816
                                                ],
                                                [
                                                    -179.138,
                                                    211.413
                                                ],
                                                [
                                                    -181.643,
                                                    215.087
                                                ],
                                                [
                                                    -189.001,
                                                    220.904
                                                ],
                                                [
                                                    -193.475,
                                                    222.887
                                                ],
                                                [
                                                    -197.936,
                                                    223.97
                                                ],
                                                [
                                                    -207.416,
                                                    224.22
                                                ],
                                                [
                                                    -212.167,
                                                    223.879
                                                ],
                                                [
                                                    -216.81,
                                                    222.924
                                                ],
                                                [
                                                    -226.616,
                                                    220.068
                                                ],
                                                [
                                                    -235.75,
                                                    215.524
                                                ],
                                                [
                                                    -244.375,
                                                    210.1
                                                ],
                                                [
                                                    -245.321,
                                                    209.34
                                                ],
                                                [
                                                    -251.83,
                                                    203.146
                                                ],
                                                [
                                                    -258.03,
                                                    195.072
                                                ],
                                                [
                                                    -261.612,
                                                    189.366
                                                ],
                                                [
                                                    -263.115,
                                                    186.264
                                                ],
                                                [
                                                    -267.336,
                                                    176.97
                                                ],
                                                [
                                                    -268.087,
                                                    174.593
                                                ],
                                                [
                                                    -269.838,
                                                    167.073
                                                ],
                                                [
                                                    -271.797,
                                                    157.065
                                                ],
                                                [
                                                    -273.048,
                                                    146.932
                                                ],
                                                [
                                                    -273.682,
                                                    136.686
                                                ],
                                                [
                                                    -273.698,
                                                    133.557
                                                ],
                                                [
                                                    -273.695,
                                                    133.47
                                                ],
                                                [
                                                    -273.631,
                                                    132.391
                                                ],
                                                [
                                                    -273.644,
                                                    131.816
                                                ],
                                                [
                                                    -273.431,
                                                    126.42
                                                ],
                                                [
                                                    -273.061,
                                                    116.15
                                                ],
                                                [
                                                    -272.615,
                                                    110.795
                                                ],
                                                [
                                                    -272.141,
                                                    106.465
                                                ],
                                                [
                                                    -271.239,
                                                    96.782
                                                ],
                                                [
                                                    -270.119,
                                                    87.123
                                                ],
                                                [
                                                    -268.385,
                                                    77.555
                                                ],
                                                [
                                                    -267.821,
                                                    74.879
                                                ],
                                                [
                                                    -266.061,
                                                    68.112
                                                ],
                                                [
                                                    -262.698,
                                                    58.99
                                                ],
                                                [
                                                    -258.646,
                                                    50.697
                                                ],
                                                [
                                                    -253.401,
                                                    43.117
                                                ],
                                                [
                                                    -253.094,
                                                    43.027
                                                ],
                                                [
                                                    -253.083,
                                                    42.618
                                                ],
                                                [
                                                    -252.593,
                                                    41.993
                                                ],
                                                [
                                                    -252.322,
                                                    41.738
                                                ],
                                                [
                                                    -252.257,
                                                    41.651
                                                ],
                                                [
                                                    -251.724,
                                                    41.496
                                                ],
                                                [
                                                    -251.606,
                                                    41.238
                                                ],
                                                [
                                                    -251.506,
                                                    41.185
                                                ],
                                                [
                                                    -251.41,
                                                    41.025
                                                ],
                                                [
                                                    -251.194,
                                                    40.831
                                                ],
                                                [
                                                    -251.109,
                                                    40.529
                                                ],
                                                [
                                                    -251.038,
                                                    40.411
                                                ],
                                                [
                                                    -251.016,
                                                    40.381
                                                ],
                                                [
                                                    -250.633,
                                                    40.217
                                                ],
                                                [
                                                    -250.307,
                                                    39.661
                                                ],
                                                [
                                                    -247.712,
                                                    37.807
                                                ],
                                                [
                                                    -243.632,
                                                    35.192
                                                ],
                                                [
                                                    -236.882,
                                                    32.664
                                                ],
                                                [
                                                    -225.07,
                                                    32.708
                                                ],
                                                [
                                                    -220.625,
                                                    38.453
                                                ],
                                                [
                                                    -220.582,
                                                    39.279
                                                ],
                                                [
                                                    -220.374,
                                                    40.337
                                                ],
                                                [
                                                    -220.498,
                                                    43.012
                                                ],
                                                [
                                                    -221.805,
                                                    47.397
                                                ],
                                                [
                                                    -224.594,
                                                    54.538
                                                ],
                                                [
                                                    -225.63,
                                                    57.285
                                                ],
                                                [
                                                    -228.695,
                                                    67.435
                                                ],
                                                [
                                                    -229.802,
                                                    71.132
                                                ],
                                                [
                                                    -231.755,
                                                    77.586
                                                ],
                                                [
                                                    -231.786,
                                                    77.854
                                                ],
                                                [
                                                    -231.789,
                                                    77.859
                                                ],
                                                [
                                                    -231.81,
                                                    77.83
                                                ],
                                                [
                                                    -232.066,
                                                    79.138
                                                ],
                                                [
                                                    -232.101,
                                                    79.275
                                                ],
                                                [
                                                    -232.034,
                                                    79.483
                                                ],
                                                [
                                                    -232.024,
                                                    79.692
                                                ],
                                                [
                                                    -232.195,
                                                    80.218
                                                ],
                                                [
                                                    -232.51,
                                                    80.859
                                                ],
                                                [
                                                    -232.546,
                                                    81.287
                                                ],
                                                [
                                                    -232.579,
                                                    81.406
                                                ],
                                                [
                                                    -232.624,
                                                    81.69
                                                ],
                                                [
                                                    -232.753,
                                                    81.926
                                                ],
                                                [
                                                    -232.823,
                                                    83.245
                                                ],
                                                [
                                                    -235.393,
                                                    94.286
                                                ],
                                                [
                                                    -236.644,
                                                    102.674
                                                ],
                                                [
                                                    -237.078,
                                                    105.5
                                                ],
                                                [
                                                    -237.398,
                                                    108.604
                                                ],
                                                [
                                                    -238.288,
                                                    116.775
                                                ],
                                                [
                                                    -238.232,
                                                    117.02
                                                ],
                                                [
                                                    -238.313,
                                                    117.131
                                                ],
                                                [
                                                    -237.101,
                                                    119.539
                                                ],
                                                [
                                                    -235.573,
                                                    120.23
                                                ],
                                                [
                                                    -232.125,
                                                    117.578
                                                ],
                                                [
                                                    -229.37,
                                                    109.731
                                                ],
                                                [
                                                    -227.813,
                                                    107.331
                                                ],
                                                [
                                                    -224.393,
                                                    103.446
                                                ],
                                                [
                                                    -219.594,
                                                    99.788
                                                ],
                                                [
                                                    -219.571,
                                                    99.726
                                                ],
                                                [
                                                    -219.499,
                                                    99.638
                                                ],
                                                [
                                                    -219.458,
                                                    99.648
                                                ],
                                                [
                                                    -219.438,
                                                    99.604
                                                ],
                                                [
                                                    -219.211,
                                                    99.542
                                                ],
                                                [
                                                    -219.224,
                                                    99.295
                                                ],
                                                [
                                                    -218.966,
                                                    99.098
                                                ],
                                                [
                                                    -218.893,
                                                    99.066
                                                ],
                                                [
                                                    -218.161,
                                                    98.969
                                                ],
                                                [
                                                    -218.144,
                                                    98.749
                                                ],
                                                [
                                                    -218.009,
                                                    98.744
                                                ],
                                                [
                                                    -217.676,
                                                    98.502
                                                ],
                                                [
                                                    -217.25,
                                                    98.385
                                                ],
                                                [
                                                    -216.818,
                                                    98.152
                                                ],
                                                [
                                                    -216.719,
                                                    98.21
                                                ],
                                                [
                                                    -216.682,
                                                    98.091
                                                ],
                                                [
                                                    -216.553,
                                                    97.993
                                                ],
                                                [
                                                    -216.191,
                                                    97.961
                                                ],
                                                [
                                                    -215.556,
                                                    97.374
                                                ],
                                                [
                                                    -215.38,
                                                    97.309
                                                ],
                                                [
                                                    -215.315,
                                                    97.421
                                                ],
                                                [
                                                    -214.411,
                                                    96.974
                                                ],
                                                [
                                                    -214.334,
                                                    97.01
                                                ],
                                                [
                                                    -214.16,
                                                    97.152
                                                ],
                                                [
                                                    -208.101,
                                                    95.541
                                                ],
                                                [
                                                    -208.1,
                                                    95.523
                                                ],
                                                [
                                                    -208.099,
                                                    95.523
                                                ],
                                                [
                                                    -208.066,
                                                    95.67
                                                ],
                                                [
                                                    -207.783,
                                                    95.493
                                                ],
                                                [
                                                    -207.759,
                                                    95.491
                                                ],
                                                [
                                                    -207.722,
                                                    95.623
                                                ],
                                                [
                                                    -206.984,
                                                    95.53
                                                ],
                                                [
                                                    -206.708,
                                                    95.416
                                                ],
                                                [
                                                    -205.512,
                                                    95.375
                                                ],
                                                [
                                                    -204.793,
                                                    95.522
                                                ],
                                                [
                                                    -204.772,
                                                    95.515
                                                ],
                                                [
                                                    -204.296,
                                                    95.557
                                                ],
                                                [
                                                    -194.736,
                                                    97.273
                                                ],
                                                [
                                                    -187.234,
                                                    101.064
                                                ],
                                                [
                                                    -186.134,
                                                    101.838
                                                ],
                                                [
                                                    -185.143,
                                                    102.376
                                                ],
                                                [
                                                    -180.714,
                                                    106.199
                                                ],
                                                [
                                                    -179.515,
                                                    107.468
                                                ],
                                                [
                                                    -179.322,
                                                    107.684
                                                ],
                                                [
                                                    -176.13,
                                                    112.523
                                                ],
                                                [
                                                    -173.854,
                                                    116.82
                                                ],
                                                [
                                                    -172.872,
                                                    119.426
                                                ],
                                                [
                                                    -173.127,
                                                    119.578
                                                ],
                                                [
                                                    -172.83,
                                                    119.714
                                                ],
                                                [
                                                    -172.62,
                                                    121.116
                                                ],
                                                [
                                                    -172.484,
                                                    121.331
                                                ],
                                                [
                                                    -172.518,
                                                    121.438
                                                ],
                                                [
                                                    -172.346,
                                                    121.755
                                                ],
                                                [
                                                    -172.256,
                                                    122.104
                                                ],
                                                [
                                                    -172.155,
                                                    122.731
                                                ],
                                                [
                                                    -171.859,
                                                    122.825
                                                ],
                                                [
                                                    -171.382,
                                                    126.34
                                                ],
                                                [
                                                    -171.049,
                                                    127.5
                                                ],
                                                [
                                                    -171.018,
                                                    128.553
                                                ],
                                                [
                                                    -170.809,
                                                    133.118
                                                ],
                                                [
                                                    -170.907,
                                                    134.692
                                                ],
                                                [
                                                    -170.886,
                                                    135.238
                                                ],
                                                [
                                                    -170.957,
                                                    135.987
                                                ],
                                                [
                                                    -172.425,
                                                    146.075
                                                ],
                                                [
                                                    -173.265,
                                                    146.997
                                                ],
                                                [
                                                    -173.685,
                                                    146.859
                                                ],
                                                [
                                                    -174.036,
                                                    147.115
                                                ],
                                                [
                                                    -174.045,
                                                    147.098
                                                ],
                                                [
                                                    -174.052,
                                                    146.882
                                                ],
                                                [
                                                    -174.46,
                                                    146.871
                                                ],
                                                [
                                                    -174.565,
                                                    146.831
                                                ],
                                                [
                                                    -176.21,
                                                    146.58
                                                ],
                                                [
                                                    -177.155,
                                                    146.282
                                                ],
                                                [
                                                    -178.096,
                                                    146.048
                                                ],
                                                [
                                                    -178.898,
                                                    145.497
                                                ],
                                                [
                                                    -179.828,
                                                    145.413
                                                ],
                                                [
                                                    -186.022,
                                                    138.39
                                                ],
                                                [
                                                    -186.398,
                                                    137.265
                                                ],
                                                [
                                                    -186.666,
                                                    136.465
                                                ],
                                                [
                                                    -187.026,
                                                    135.775
                                                ],
                                                [
                                                    -187.117,
                                                    135.005
                                                ],
                                                [
                                                    -187.352,
                                                    134.053
                                                ],
                                                [
                                                    -187.37,
                                                    133.646
                                                ],
                                                [
                                                    -187.437,
                                                    133.52
                                                ],
                                                [
                                                    -187.583,
                                                    133.275
                                                ],
                                                [
                                                    -187.906,
                                                    133.154
                                                ],
                                                [
                                                    -187.795,
                                                    133.018
                                                ],
                                                [
                                                    -189.969,
                                                    128.569
                                                ],
                                                [
                                                    -191.84,
                                                    126.286
                                                ],
                                                [
                                                    -195.198,
                                                    124.231
                                                ],
                                                [
                                                    -195.382,
                                                    124.295
                                                ],
                                                [
                                                    -196.066,
                                                    124.203
                                                ],
                                                [
                                                    -196.373,
                                                    124.095
                                                ],
                                                [
                                                    -197.717,
                                                    123.676
                                                ],
                                                [
                                                    -197.98,
                                                    123.558
                                                ],
                                                [
                                                    -198.164,
                                                    123.422
                                                ],
                                                [
                                                    -199.18,
                                                    123.112
                                                ],
                                                [
                                                    -207.147,
                                                    124.052
                                                ],
                                                [
                                                    -209.77,
                                                    125.1
                                                ],
                                                [
                                                    -217.963,
                                                    132.136
                                                ],
                                                [
                                                    -218.024,
                                                    132.366
                                                ],
                                                [
                                                    -218.249,
                                                    132.464
                                                ],
                                                [
                                                    -218.331,
                                                    132.385
                                                ],
                                                [
                                                    -218.329,
                                                    132.743
                                                ],
                                                [
                                                    -218.465,
                                                    133.017
                                                ],
                                                [
                                                    -218.498,
                                                    133.141
                                                ],
                                                [
                                                    -218.687,
                                                    133.188
                                                ],
                                                [
                                                    -219.219,
                                                    134.025
                                                ],
                                                [
                                                    -219.272,
                                                    134.087
                                                ],
                                                [
                                                    -219.4,
                                                    134.06
                                                ],
                                                [
                                                    -219.564,
                                                    134.482
                                                ],
                                                [
                                                    -220.036,
                                                    135.183
                                                ],
                                                [
                                                    -220.112,
                                                    135.47
                                                ],
                                                [
                                                    -220.299,
                                                    135.718
                                                ],
                                                [
                                                    -220.442,
                                                    135.879
                                                ],
                                                [
                                                    -220.601,
                                                    136.102
                                                ],
                                                [
                                                    -221.194,
                                                    137.677
                                                ],
                                                [
                                                    -224.261,
                                                    148.442
                                                ],
                                                [
                                                    -224.942,
                                                    155.01
                                                ],
                                                [
                                                    -225.136,
                                                    157.279
                                                ],
                                                [
                                                    -225.309,
                                                    159.617
                                                ],
                                                [
                                                    -225.358,
                                                    161.054
                                                ],
                                                [
                                                    -225.446,
                                                    164.5
                                                ],
                                                [
                                                    -225.312,
                                                    167.646
                                                ],
                                                [
                                                    -224.105,
                                                    174.17
                                                ],
                                                [
                                                    -219.479,
                                                    181.136
                                                ],
                                                [
                                                    -216.937,
                                                    183.02
                                                ],
                                                [
                                                    -212.091,
                                                    184.891
                                                ],
                                                [
                                                    -202.336,
                                                    182.018
                                                ],
                                                [
                                                    -200.066,
                                                    180.006
                                                ],
                                                [
                                                    -198.584,
                                                    178.348
                                                ],
                                                [
                                                    -198.578,
                                                    178.152
                                                ],
                                                [
                                                    -198.443,
                                                    177.979
                                                ],
                                                [
                                                    -198.012,
                                                    177.406
                                                ],
                                                [
                                                    -197.553,
                                                    176.996
                                                ],
                                                [
                                                    -197.34,
                                                    176.502
                                                ],
                                                [
                                                    -197.042,
                                                    176.08
                                                ],
                                                [
                                                    -196.899,
                                                    175.793
                                                ],
                                                [
                                                    -196.584,
                                                    175.481
                                                ],
                                                [
                                                    -196.28,
                                                    175.006
                                                ],
                                                [
                                                    -196.188,
                                                    174.313
                                                ],
                                                [
                                                    -196.082,
                                                    174.118
                                                ],
                                                [
                                                    -196.011,
                                                    174.174
                                                ],
                                                [
                                                    -196.006,
                                                    174.164
                                                ],
                                                [
                                                    -195.814,
                                                    174.283
                                                ],
                                                [
                                                    -193.385,
                                                    168.872
                                                ],
                                                [
                                                    -192.354,
                                                    166.445
                                                ],
                                                [
                                                    -192.417,
                                                    166.281
                                                ],
                                                [
                                                    -192.297,
                                                    166.171
                                                ],
                                                [
                                                    -188.18,
                                                    157.998
                                                ],
                                                [
                                                    -180.473,
                                                    153.697
                                                ],
                                                [
                                                    -175.102,
                                                    155.633
                                                ],
                                                [
                                                    -173.654,
                                                    157.01
                                                ],
                                                [
                                                    -169.271,
                                                    170.779
                                                ],
                                                [
                                                    -169.234,
                                                    173.457
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 17",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 17,
                                    "ty": "sh",
                                    "ix": 18,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.496,
                                                    -4.296
                                                ],
                                                [
                                                    0.559,
                                                    -4.982
                                                ],
                                                [
                                                    0.559,
                                                    -4.983
                                                ],
                                                [
                                                    0.559,
                                                    -4.982
                                                ],
                                                [
                                                    0.559,
                                                    -4.982
                                                ],
                                                [
                                                    0.013,
                                                    -0.025
                                                ],
                                                [
                                                    0.852,
                                                    -0.687
                                                ],
                                                [
                                                    3.229,
                                                    -2.885
                                                ],
                                                [
                                                    2.72,
                                                    -3.381
                                                ],
                                                [
                                                    0.661,
                                                    -1.08
                                                ],
                                                [
                                                    5.211,
                                                    0.597
                                                ],
                                                [
                                                    1.5,
                                                    0.127
                                                ],
                                                [
                                                    0.191,
                                                    0.013
                                                ],
                                                [
                                                    1.945,
                                                    0.216
                                                ],
                                                [
                                                    1.385,
                                                    0.153
                                                ],
                                                [
                                                    0.089,
                                                    0.013
                                                ],
                                                [
                                                    2.288,
                                                    0.254
                                                ],
                                                [
                                                    5.237,
                                                    0.585
                                                ],
                                                [
                                                    0.559,
                                                    0.102
                                                ],
                                                [
                                                    0.349,
                                                    0.108
                                                ],
                                                [
                                                    0,
                                                    0.004
                                                ],
                                                [
                                                    -0.305,
                                                    1.03
                                                ],
                                                [
                                                    -0.699,
                                                    2.783
                                                ],
                                                [
                                                    -0.521,
                                                    3.279
                                                ],
                                                [
                                                    -0.267,
                                                    3.292
                                                ],
                                                [
                                                    -0.025,
                                                    3.292
                                                ],
                                                [
                                                    0.216,
                                                    3.28
                                                ],
                                                [
                                                    0.445,
                                                    3.229
                                                ],
                                                [
                                                    0.686,
                                                    3.165
                                                ],
                                                [
                                                    0.749,
                                                    2.756
                                                ],
                                                [
                                                    -3.697,
                                                    -0.422
                                                ],
                                                [
                                                    -4.677,
                                                    -0.521
                                                ],
                                                [
                                                    -4.665,
                                                    -0.534
                                                ],
                                                [
                                                    -4.665,
                                                    -0.534
                                                ],
                                                [
                                                    -4.677,
                                                    -0.521
                                                ],
                                                [
                                                    -4.69,
                                                    -0.534
                                                ],
                                                [
                                                    -2.669,
                                                    -3.394
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.572,
                                                    4.982
                                                ],
                                                [
                                                    -0.559,
                                                    4.982
                                                ],
                                                [
                                                    -0.559,
                                                    4.995
                                                ],
                                                [
                                                    -0.559,
                                                    4.995
                                                ],
                                                [
                                                    0,
                                                    0.025
                                                ],
                                                [
                                                    -0.89,
                                                    0.762
                                                ],
                                                [
                                                    -3.317,
                                                    2.656
                                                ],
                                                [
                                                    -3.19,
                                                    2.872
                                                ],
                                                [
                                                    -0.813,
                                                    1.004
                                                ],
                                                [
                                                    -5.198,
                                                    -0.584
                                                ],
                                                [
                                                    -2.936,
                                                    -0.33
                                                ],
                                                [
                                                    -0.165,
                                                    -0.012
                                                ],
                                                [
                                                    -1.03,
                                                    -0.127
                                                ],
                                                [
                                                    -2.745,
                                                    -0.305
                                                ],
                                                [
                                                    -0.089,
                                                    -0.013
                                                ],
                                                [
                                                    -1.156,
                                                    -0.165
                                                ],
                                                [
                                                    -5.237,
                                                    -0.585
                                                ],
                                                [
                                                    -0.585,
                                                    -0.063
                                                ],
                                                [
                                                    -0.361,
                                                    -0.096
                                                ],
                                                [
                                                    0,
                                                    -0.003
                                                ],
                                                [
                                                    0.318,
                                                    -1.016
                                                ],
                                                [
                                                    0.813,
                                                    -2.733
                                                ],
                                                [
                                                    0.788,
                                                    -3.127
                                                ],
                                                [
                                                    0.508,
                                                    -3.204
                                                ],
                                                [
                                                    0.254,
                                                    -3.253
                                                ],
                                                [
                                                    0.013,
                                                    -3.266
                                                ],
                                                [
                                                    -0.203,
                                                    -3.279
                                                ],
                                                [
                                                    -0.445,
                                                    -3.267
                                                ],
                                                [
                                                    -0.622,
                                                    -2.87
                                                ],
                                                [
                                                    2.921,
                                                    -1.765
                                                ],
                                                [
                                                    4.665,
                                                    0.521
                                                ],
                                                [
                                                    4.665,
                                                    0.534
                                                ],
                                                [
                                                    4.677,
                                                    0.521
                                                ],
                                                [
                                                    4.677,
                                                    0.521
                                                ],
                                                [
                                                    4.677,
                                                    0.534
                                                ],
                                                [
                                                    4.283,
                                                    0.47
                                                ],
                                                [
                                                    2.707,
                                                    3.368
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -113.671,
                                                    -34.337
                                                ],
                                                [
                                                    -114.726,
                                                    -24.373
                                                ],
                                                [
                                                    -115.946,
                                                    -14.42
                                                ],
                                                [
                                                    -117.026,
                                                    -4.43
                                                ],
                                                [
                                                    -118.208,
                                                    5.547
                                                ],
                                                [
                                                    -118.221,
                                                    5.624
                                                ],
                                                [
                                                    -120.827,
                                                    7.797
                                                ],
                                                [
                                                    -130.741,
                                                    16.059
                                                ],
                                                [
                                                    -139.803,
                                                    25.261
                                                ],
                                                [
                                                    -142.015,
                                                    28.387
                                                ],
                                                [
                                                    -152.424,
                                                    27.129
                                                ],
                                                [
                                                    -158.157,
                                                    26.583
                                                ],
                                                [
                                                    -158.69,
                                                    26.532
                                                ],
                                                [
                                                    -162.885,
                                                    26.036
                                                ],
                                                [
                                                    -168.325,
                                                    25.426
                                                ],
                                                [
                                                    -168.604,
                                                    25.4
                                                ],
                                                [
                                                    -173.345,
                                                    24.816
                                                ],
                                                [
                                                    -183.806,
                                                    23.608
                                                ],
                                                [
                                                    -185.534,
                                                    23.405
                                                ],
                                                [
                                                    -186.593,
                                                    23.093
                                                ],
                                                [
                                                    -186.589,
                                                    23.082
                                                ],
                                                [
                                                    -185.662,
                                                    20.02
                                                ],
                                                [
                                                    -183.412,
                                                    11.732
                                                ],
                                                [
                                                    -181.289,
                                                    2.136
                                                ],
                                                [
                                                    -180.183,
                                                    -7.638
                                                ],
                                                [
                                                    -179.713,
                                                    -17.476
                                                ],
                                                [
                                                    -180.463,
                                                    -27.288
                                                ],
                                                [
                                                    -181.454,
                                                    -37.049
                                                ],
                                                [
                                                    -183.043,
                                                    -46.722
                                                ],
                                                [
                                                    -184.833,
                                                    -55.243
                                                ],
                                                [
                                                    -174.68,
                                                    -57.406
                                                ],
                                                [
                                                    -165.325,
                                                    -56.453
                                                ],
                                                [
                                                    -156.009,
                                                    -55.271
                                                ],
                                                [
                                                    -146.654,
                                                    -54.331
                                                ],
                                                [
                                                    -137.286,
                                                    -53.365
                                                ],
                                                [
                                                    -127.944,
                                                    -52.094
                                                ],
                                                [
                                                    -117.077,
                                                    -46.26
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 18",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 18,
                                    "ty": "sh",
                                    "ix": 19,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    -0.001,
                                                    0.006
                                                ],
                                                [
                                                    -1.187,
                                                    -0.02
                                                ],
                                                [
                                                    1.242,
                                                    -1.347
                                                ],
                                                [
                                                    -0.203,
                                                    1.894
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    0.854,
                                                    -0.146
                                                ],
                                                [
                                                    -1.074,
                                                    1.287
                                                ],
                                                [
                                                    0.216,
                                                    -1.843
                                                ],
                                                [
                                                    0.001,
                                                    -0.006
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -105.064,
                                                    -10.142
                                                ],
                                                [
                                                    -102,
                                                    -10.326
                                                ],
                                                [
                                                    -105.473,
                                                    -6.362
                                                ],
                                                [
                                                    -105.066,
                                                    -10.125
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 19",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 19,
                                    "ty": "sh",
                                    "ix": 20,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.114,
                                                    3.139
                                                ],
                                                [
                                                    0.61,
                                                    3.089
                                                ],
                                                [
                                                    1.144,
                                                    2.948
                                                ],
                                                [
                                                    1.716,
                                                    2.695
                                                ],
                                                [
                                                    1.347,
                                                    1.512
                                                ],
                                                [
                                                    -1.845,
                                                    -0.207
                                                ],
                                                [
                                                    -4.745,
                                                    -0.533
                                                ],
                                                [
                                                    -4.745,
                                                    -0.528
                                                ],
                                                [
                                                    -1.007,
                                                    0
                                                ],
                                                [
                                                    -3.464,
                                                    1.575
                                                ],
                                                [
                                                    -2.566,
                                                    2.908
                                                ],
                                                [
                                                    -1.162,
                                                    3.786
                                                ],
                                                [
                                                    -0.186,
                                                    1.722
                                                ],
                                                [
                                                    -0.551,
                                                    4.897
                                                ],
                                                [
                                                    -0.551,
                                                    4.897
                                                ],
                                                [
                                                    -0.551,
                                                    4.899
                                                ],
                                                [
                                                    -0.552,
                                                    4.906
                                                ],
                                                [
                                                    -0.074,
                                                    0.597
                                                ],
                                                [
                                                    -1.422,
                                                    -0.12
                                                ],
                                                [
                                                    -2.803,
                                                    0
                                                ],
                                                [
                                                    -1.634,
                                                    0.077
                                                ],
                                                [
                                                    -0.349,
                                                    -3.191
                                                ],
                                                [
                                                    -0.411,
                                                    -3.523
                                                ],
                                                [
                                                    -0.413,
                                                    -3.548
                                                ],
                                                [
                                                    -0.406,
                                                    -3.549
                                                ],
                                                [
                                                    -0.392,
                                                    -3.551
                                                ],
                                                [
                                                    -0.372,
                                                    -3.552
                                                ],
                                                [
                                                    -0.365,
                                                    -3.231
                                                ],
                                                [
                                                    0.163,
                                                    -0.163
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.585,
                                                    -0.534
                                                ],
                                                [
                                                    0.483,
                                                    -0.47
                                                ],
                                                [
                                                    0.521,
                                                    -0.598
                                                ],
                                                [
                                                    0.674,
                                                    -0.61
                                                ],
                                                [
                                                    0.534,
                                                    -0.394
                                                ],
                                                [
                                                    0.47,
                                                    -0.42
                                                ],
                                                [
                                                    2.491,
                                                    -1.906
                                                ],
                                                [
                                                    3.025,
                                                    -2.009
                                                ],
                                                [
                                                    2.682,
                                                    -1.512
                                                ],
                                                [
                                                    2.161,
                                                    -0.979
                                                ],
                                                [
                                                    1.017,
                                                    -0.483
                                                ],
                                                [
                                                    2.936,
                                                    -1.144
                                                ],
                                                [
                                                    0.915,
                                                    -0.369
                                                ],
                                                [
                                                    1.957,
                                                    -0.521
                                                ],
                                                [
                                                    1.868,
                                                    -0.025
                                                ],
                                                [
                                                    -0.076,
                                                    0.33
                                                ],
                                                [
                                                    -0.318,
                                                    3.114
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.127,
                                                    -3.266
                                                ],
                                                [
                                                    -0.636,
                                                    -3.19
                                                ],
                                                [
                                                    -1.182,
                                                    -2.999
                                                ],
                                                [
                                                    -1.258,
                                                    -1.969
                                                ],
                                                [
                                                    0.967,
                                                    0.116
                                                ],
                                                [
                                                    4.745,
                                                    0.533
                                                ],
                                                [
                                                    4.745,
                                                    0.533
                                                ],
                                                [
                                                    1.033,
                                                    0.106
                                                ],
                                                [
                                                    3.98,
                                                    0
                                                ],
                                                [
                                                    3.539,
                                                    -1.61
                                                ],
                                                [
                                                    2.527,
                                                    -2.864
                                                ],
                                                [
                                                    0.477,
                                                    -1.589
                                                ],
                                                [
                                                    0.547,
                                                    -4.897
                                                ],
                                                [
                                                    0.551,
                                                    -4.897
                                                ],
                                                [
                                                    0.551,
                                                    -4.898
                                                ],
                                                [
                                                    0.552,
                                                    -4.906
                                                ],
                                                [
                                                    0.094,
                                                    -0.832
                                                ],
                                                [
                                                    1.422,
                                                    0.171
                                                ],
                                                [
                                                    2.809,
                                                    0.236
                                                ],
                                                [
                                                    1.635,
                                                    0
                                                ],
                                                [
                                                    0.427,
                                                    3.185
                                                ],
                                                [
                                                    0.387,
                                                    3.542
                                                ],
                                                [
                                                    0.414,
                                                    3.548
                                                ],
                                                [
                                                    0.413,
                                                    3.548
                                                ],
                                                [
                                                    0.406,
                                                    3.549
                                                ],
                                                [
                                                    0.392,
                                                    3.551
                                                ],
                                                [
                                                    0.339,
                                                    3.234
                                                ],
                                                [
                                                    -0.163,
                                                    0.163
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.559,
                                                    0.572
                                                ],
                                                [
                                                    -0.508,
                                                    0.47
                                                ],
                                                [
                                                    -0.559,
                                                    0.559
                                                ],
                                                [
                                                    -0.572,
                                                    0.661
                                                ],
                                                [
                                                    -0.483,
                                                    0.483
                                                ],
                                                [
                                                    -0.509,
                                                    0.369
                                                ],
                                                [
                                                    -3.051,
                                                    2.695
                                                ],
                                                [
                                                    -2.682,
                                                    2.059
                                                ],
                                                [
                                                    -3.432,
                                                    2.275
                                                ],
                                                [
                                                    -2.072,
                                                    1.169
                                                ],
                                                [
                                                    -1.03,
                                                    0.457
                                                ],
                                                [
                                                    -3.559,
                                                    1.678
                                                ],
                                                [
                                                    -0.979,
                                                    0.369
                                                ],
                                                [
                                                    -2.212,
                                                    0.89
                                                ],
                                                [
                                                    -4.08,
                                                    1.106
                                                ],
                                                [
                                                    0.089,
                                                    -0.331
                                                ],
                                                [
                                                    0.737,
                                                    -3.191
                                                ],
                                                [
                                                    0.33,
                                                    -3.254
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -15.243,
                                                    83.253
                                                ],
                                                [
                                                    -16.412,
                                                    73.707
                                                ],
                                                [
                                                    -19.145,
                                                    64.505
                                                ],
                                                [
                                                    -23.492,
                                                    55.951
                                                ],
                                                [
                                                    -27.392,
                                                    50.729
                                                ],
                                                [
                                                    -23.456,
                                                    51.185
                                                ],
                                                [
                                                    -13.964,
                                                    52.229
                                                ],
                                                [
                                                    -4.475,
                                                    53.294
                                                ],
                                                [
                                                    -1.395,
                                                    53.302
                                                ],
                                                [
                                                    9.861,
                                                    50.944
                                                ],
                                                [
                                                    19.179,
                                                    44.141
                                                ],
                                                [
                                                    24.838,
                                                    34.068
                                                ],
                                                [
                                                    25.863,
                                                    29.075
                                                ],
                                                [
                                                    26.803,
                                                    19.264
                                                ],
                                                [
                                                    28.027,
                                                    9.483
                                                ],
                                                [
                                                    29.161,
                                                    -0.311
                                                ],
                                                [
                                                    30.174,
                                                    -10.134
                                                ],
                                                [
                                                    30.422,
                                                    -12.246
                                                ],
                                                [
                                                    34.688,
                                                    -11.812
                                                ],
                                                [
                                                    43.107,
                                                    -11.403
                                                ],
                                                [
                                                    48.011,
                                                    -11.531
                                                ],
                                                [
                                                    49.341,
                                                    -1.986
                                                ],
                                                [
                                                    50.569,
                                                    8.61
                                                ],
                                                [
                                                    51.697,
                                                    19.268
                                                ],
                                                [
                                                    52.703,
                                                    29.939
                                                ],
                                                [
                                                    54,
                                                    40.577
                                                ],
                                                [
                                                    55.069,
                                                    51.239
                                                ],
                                                [
                                                    56.36,
                                                    60.915
                                                ],
                                                [
                                                    55.871,
                                                    61.417
                                                ],
                                                [
                                                    55.172,
                                                    62.154
                                                ],
                                                [
                                                    53.443,
                                                    63.806
                                                ],
                                                [
                                                    51.943,
                                                    65.217
                                                ],
                                                [
                                                    50.329,
                                                    66.971
                                                ],
                                                [
                                                    48.499,
                                                    68.903
                                                ],
                                                [
                                                    46.936,
                                                    70.161
                                                ],
                                                [
                                                    45.461,
                                                    71.318
                                                ],
                                                [
                                                    37.339,
                                                    78.067
                                                ],
                                                [
                                                    28.734,
                                                    84.193
                                                ],
                                                [
                                                    19.761,
                                                    89.748
                                                ],
                                                [
                                                    13.304,
                                                    92.9
                                                ],
                                                [
                                                    10.241,
                                                    94.31
                                                ],
                                                [
                                                    0.581,
                                                    98.505
                                                ],
                                                [
                                                    -2.253,
                                                    99.624
                                                ],
                                                [
                                                    -8.519,
                                                    101.885
                                                ],
                                                [
                                                    -17.442,
                                                    103.322
                                                ],
                                                [
                                                    -17.2,
                                                    102.344
                                                ],
                                                [
                                                    -15.522,
                                                    92.874
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 20",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 20,
                                    "ty": "sh",
                                    "ix": 21,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    -3.77,
                                                    -1.028
                                                ],
                                                [
                                                    -2.984,
                                                    -2.702
                                                ],
                                                [
                                                    -2.241,
                                                    -3.113
                                                ],
                                                [
                                                    -2.696,
                                                    -3.852
                                                ],
                                                [
                                                    -3.672,
                                                    -1.034
                                                ],
                                                [
                                                    -2.536,
                                                    2.164
                                                ],
                                                [
                                                    -2.678,
                                                    3.105
                                                ],
                                                [
                                                    -3.202,
                                                    2.743
                                                ],
                                                [
                                                    -3.669,
                                                    2.288
                                                ],
                                                [
                                                    -3.227,
                                                    1.455
                                                ],
                                                [
                                                    -3.39,
                                                    0.954
                                                ],
                                                [
                                                    -3.501,
                                                    0.354
                                                ],
                                                [
                                                    -3.523,
                                                    -0.354
                                                ],
                                                [
                                                    -3.406,
                                                    -1.136
                                                ],
                                                [
                                                    -2.736,
                                                    -1.551
                                                ],
                                                [
                                                    -2.436,
                                                    -2.01
                                                ],
                                                [
                                                    -2.094,
                                                    -2.364
                                                ],
                                                [
                                                    -1.727,
                                                    -2.63
                                                ],
                                                [
                                                    -1.338,
                                                    -2.83
                                                ],
                                                [
                                                    -1.278,
                                                    -4.056
                                                ],
                                                [
                                                    -1.108,
                                                    -4.085
                                                ],
                                                [
                                                    -1.023,
                                                    -3.349
                                                ],
                                                [
                                                    -0.752,
                                                    -3.404
                                                ],
                                                [
                                                    -0.565,
                                                    -3.517
                                                ],
                                                [
                                                    -0.086,
                                                    -0.593
                                                ],
                                                [
                                                    3.105,
                                                    0.195
                                                ],
                                                [
                                                    1.952,
                                                    0.26
                                                ],
                                                [
                                                    0.794,
                                                    2.752
                                                ],
                                                [
                                                    2.277,
                                                    2.86
                                                ],
                                                [
                                                    3.106,
                                                    1.718
                                                ],
                                                [
                                                    3.633,
                                                    0.411
                                                ],
                                                [
                                                    4.73,
                                                    0.531
                                                ],
                                                [
                                                    4.735,
                                                    0.532
                                                ],
                                                [
                                                    4.736,
                                                    0.532
                                                ],
                                                [
                                                    4.737,
                                                    0.532
                                                ],
                                                [
                                                    4.744,
                                                    0.533
                                                ],
                                                [
                                                    4.744,
                                                    0.534
                                                ],
                                                [
                                                    3.359,
                                                    -0.972
                                                ],
                                                [
                                                    2.789,
                                                    -2.223
                                                ],
                                                [
                                                    1.756,
                                                    -3.165
                                                ],
                                                [
                                                    0.417,
                                                    -3.684
                                                ],
                                                [
                                                    0.551,
                                                    -4.899
                                                ],
                                                [
                                                    0.241,
                                                    -2.045
                                                ],
                                                [
                                                    0.223,
                                                    0.086
                                                ],
                                                [
                                                    3.077,
                                                    0.64
                                                ],
                                                [
                                                    3.145,
                                                    0.119
                                                ],
                                                [
                                                    1.119,
                                                    -0.068
                                                ],
                                                [
                                                    -0.001,
                                                    0.014
                                                ],
                                                [
                                                    -0.724,
                                                    6.444
                                                ],
                                                [
                                                    0.991,
                                                    3.406
                                                ],
                                                [
                                                    2.275,
                                                    2.86
                                                ],
                                                [
                                                    3.114,
                                                    1.716
                                                ],
                                                [
                                                    3.635,
                                                    0.419
                                                ],
                                                [
                                                    4.665,
                                                    0.521
                                                ],
                                                [
                                                    4.665,
                                                    0.534
                                                ],
                                                [
                                                    4.665,
                                                    0.521
                                                ],
                                                [
                                                    4.677,
                                                    0.521
                                                ],
                                                [
                                                    4.677,
                                                    0.521
                                                ],
                                                [
                                                    0.947,
                                                    0.015
                                                ],
                                                [
                                                    -1.8,
                                                    2.913
                                                ],
                                                [
                                                    -2.684,
                                                    3.313
                                                ],
                                                [
                                                    -2.987,
                                                    2.594
                                                ],
                                                [
                                                    -3.312,
                                                    1.828
                                                ],
                                                [
                                                    -3.66,
                                                    0.698
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    3.854,
                                                    1.051
                                                ],
                                                [
                                                    2.973,
                                                    2.692
                                                ],
                                                [
                                                    2.748,
                                                    3.816
                                                ],
                                                [
                                                    2.029,
                                                    2.898
                                                ],
                                                [
                                                    3.601,
                                                    1.014
                                                ],
                                                [
                                                    3.128,
                                                    -2.669
                                                ],
                                                [
                                                    2.821,
                                                    -3.272
                                                ],
                                                [
                                                    3.199,
                                                    -2.741
                                                ],
                                                [
                                                    2.98,
                                                    -1.858
                                                ],
                                                [
                                                    3.222,
                                                    -1.453
                                                ],
                                                [
                                                    3.411,
                                                    -0.959
                                                ],
                                                [
                                                    3.512,
                                                    -0.355
                                                ],
                                                [
                                                    3.473,
                                                    0.349
                                                ],
                                                [
                                                    3.006,
                                                    1.003
                                                ],
                                                [
                                                    2.74,
                                                    1.553
                                                ],
                                                [
                                                    2.427,
                                                    2.002
                                                ],
                                                [
                                                    2.091,
                                                    2.361
                                                ],
                                                [
                                                    1.74,
                                                    2.649
                                                ],
                                                [
                                                    1.818,
                                                    3.844
                                                ],
                                                [
                                                    1.276,
                                                    4.051
                                                ],
                                                [
                                                    0.912,
                                                    3.366
                                                ],
                                                [
                                                    1.022,
                                                    3.348
                                                ],
                                                [
                                                    0.767,
                                                    3.47
                                                ],
                                                [
                                                    0.095,
                                                    0.591
                                                ],
                                                [
                                                    -3.098,
                                                    0.123
                                                ],
                                                [
                                                    -1.956,
                                                    -0.123
                                                ],
                                                [
                                                    0.109,
                                                    -2.925
                                                ],
                                                [
                                                    -0.984,
                                                    -3.409
                                                ],
                                                [
                                                    -2.289,
                                                    -2.858
                                                ],
                                                [
                                                    -3.112,
                                                    -1.722
                                                ],
                                                [
                                                    -4.729,
                                                    -0.532
                                                ],
                                                [
                                                    -4.735,
                                                    -0.532
                                                ],
                                                [
                                                    -4.736,
                                                    -0.532
                                                ],
                                                [
                                                    -4.737,
                                                    -0.532
                                                ],
                                                [
                                                    -4.745,
                                                    -0.533
                                                ],
                                                [
                                                    -4.745,
                                                    -0.533
                                                ],
                                                [
                                                    -3.684,
                                                    -0.417
                                                ],
                                                [
                                                    -3.477,
                                                    1.006
                                                ],
                                                [
                                                    -2.789,
                                                    2.223
                                                ],
                                                [
                                                    -1.697,
                                                    3.058
                                                ],
                                                [
                                                    -0.552,
                                                    4.899
                                                ],
                                                [
                                                    -0.391,
                                                    3.479
                                                ],
                                                [
                                                    -0.222,
                                                    -0.089
                                                ],
                                                [
                                                    -2.94,
                                                    -1.137
                                                ],
                                                [
                                                    -3.082,
                                                    -0.641
                                                ],
                                                [
                                                    -0.946,
                                                    -0.035
                                                ],
                                                [
                                                    0.002,
                                                    -0.014
                                                ],
                                                [
                                                    0.725,
                                                    -6.444
                                                ],
                                                [
                                                    0.407,
                                                    -3.635
                                                ],
                                                [
                                                    -0.979,
                                                    -3.419
                                                ],
                                                [
                                                    -2.275,
                                                    -2.86
                                                ],
                                                [
                                                    -3.114,
                                                    -1.716
                                                ],
                                                [
                                                    -4.677,
                                                    -0.521
                                                ],
                                                [
                                                    -4.677,
                                                    -0.521
                                                ],
                                                [
                                                    -4.677,
                                                    -0.521
                                                ],
                                                [
                                                    -4.677,
                                                    -0.521
                                                ],
                                                [
                                                    -4.677,
                                                    -0.534
                                                ],
                                                [
                                                    -0.948,
                                                    -0.096
                                                ],
                                                [
                                                    1.487,
                                                    -3.134
                                                ],
                                                [
                                                    2.24,
                                                    -3.624
                                                ],
                                                [
                                                    2.246,
                                                    -2.772
                                                ],
                                                [
                                                    2.847,
                                                    -2.472
                                                ],
                                                [
                                                    3.39,
                                                    -1.871
                                                ],
                                                [
                                                    3.719,
                                                    -0.709
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    -124.423,
                                                    -106.893
                                                ],
                                                [
                                                    -114.265,
                                                    -100.745
                                                ],
                                                [
                                                    -106.544,
                                                    -91.691
                                                ],
                                                [
                                                    -98.664,
                                                    -79.994
                                                ],
                                                [
                                                    -90.444,
                                                    -71.697
                                                ],
                                                [
                                                    -81.055,
                                                    -75.519
                                                ],
                                                [
                                                    -72.529,
                                                    -84.404
                                                ],
                                                [
                                                    -63.744,
                                                    -93.639
                                                ],
                                                [
                                                    -53.375,
                                                    -101.068
                                                ],
                                                [
                                                    -43.995,
                                                    -105.968
                                                ],
                                                [
                                                    -34.117,
                                                    -109.78
                                                ],
                                                [
                                                    -23.67,
                                                    -111.409
                                                ],
                                                [
                                                    -13.113,
                                                    -111.773
                                                ],
                                                [
                                                    -2.85,
                                                    -109.284
                                                ],
                                                [
                                                    5.783,
                                                    -105.53
                                                ],
                                                [
                                                    13.669,
                                                    -100.329
                                                ],
                                                [
                                                    20.444,
                                                    -93.725
                                                ],
                                                [
                                                    25.967,
                                                    -86.064
                                                ],
                                                [
                                                    30.943,
                                                    -78.019
                                                ],
                                                [
                                                    35.451,
                                                    -66.081
                                                ],
                                                [
                                                    38.687,
                                                    -53.758
                                                ],
                                                [
                                                    41.886,
                                                    -43.762
                                                ],
                                                [
                                                    44.667,
                                                    -33.65
                                                ],
                                                [
                                                    46.474,
                                                    -23.129
                                                ],
                                                [
                                                    46.74,
                                                    -21.352
                                                ],
                                                [
                                                    37.428,
                                                    -21.449
                                                ],
                                                [
                                                    31.565,
                                                    -22.039
                                                ],
                                                [
                                                    30.538,
                                                    -30.618
                                                ],
                                                [
                                                    25.494,
                                                    -40.054
                                                ],
                                                [
                                                    17.312,
                                                    -46.906
                                                ],
                                                [
                                                    7.166,
                                                    -50.259
                                                ],
                                                [
                                                    -2.291,
                                                    -51.343
                                                ],
                                                [
                                                    -11.763,
                                                    -52.392
                                                ],
                                                [
                                                    -21.244,
                                                    -53.365
                                                ],
                                                [
                                                    -30.706,
                                                    -54.539
                                                ],
                                                [
                                                    -40.2,
                                                    -55.554
                                                ],
                                                [
                                                    -49.695,
                                                    -56.571
                                                ],
                                                [
                                                    -60.331,
                                                    -55.7
                                                ],
                                                [
                                                    -69.775,
                                                    -50.743
                                                ],
                                                [
                                                    -76.724,
                                                    -42.648
                                                ],
                                                [
                                                    -79.908,
                                                    -32.465
                                                ],
                                                [
                                                    -81.139,
                                                    -22.681
                                                ],
                                                [
                                                    -81.905,
                                                    -16.144
                                                ],
                                                [
                                                    -82.57,
                                                    -16.416
                                                ],
                                                [
                                                    -91.616,
                                                    -19.084
                                                ],
                                                [
                                                    -100.979,
                                                    -20.2
                                                ],
                                                [
                                                    -104.104,
                                                    -20.176
                                                ],
                                                [
                                                    -104.1,
                                                    -20.216
                                                ],
                                                [
                                                    -102.46,
                                                    -33.092
                                                ],
                                                [
                                                    -103.465,
                                                    -43.73
                                                ],
                                                [
                                                    -108.383,
                                                    -53.2
                                                ],
                                                [
                                                    -116.48,
                                                    -60.177
                                                ],
                                                [
                                                    -126.699,
                                                    -63.317
                                                ],
                                                [
                                                    -136.015,
                                                    -64.524
                                                ],
                                                [
                                                    -145.357,
                                                    -65.567
                                                ],
                                                [
                                                    -154.699,
                                                    -66.621
                                                ],
                                                [
                                                    -164.067,
                                                    -67.638
                                                ],
                                                [
                                                    -173.422,
                                                    -68.642
                                                ],
                                                [
                                                    -176.254,
                                                    -68.891
                                                ],
                                                [
                                                    -171.084,
                                                    -77.935
                                                ],
                                                [
                                                    -163.639,
                                                    -88.349
                                                ],
                                                [
                                                    -155.631,
                                                    -96.434
                                                ],
                                                [
                                                    -146.345,
                                                    -102.972
                                                ],
                                                [
                                                    -135.764,
                                                    -107.024
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 21",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 21,
                                    "ty": "sh",
                                    "ix": 22,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.141,
                                                    -2.019
                                                ],
                                                [
                                                    0.403,
                                                    -2.266
                                                ],
                                                [
                                                    0.182,
                                                    -1.2
                                                ],
                                                [
                                                    0.142,
                                                    -1.07
                                                ],
                                                [
                                                    0.513,
                                                    -2.175
                                                ],
                                                [
                                                    0.858,
                                                    -2.615
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.224,
                                                    -2.986
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.344,
                                                    -2.667
                                                ],
                                                [
                                                    1.186,
                                                    -1.818
                                                ],
                                                [
                                                    0.695,
                                                    -1.154
                                                ],
                                                [
                                                    0.521,
                                                    -0.891
                                                ],
                                                [
                                                    1.333,
                                                    -1.873
                                                ],
                                                [
                                                    0.529,
                                                    -0.759
                                                ],
                                                [
                                                    1.544,
                                                    -1.853
                                                ],
                                                [
                                                    0.585,
                                                    -0.716
                                                ],
                                                [
                                                    1.684,
                                                    -1.734
                                                ],
                                                [
                                                    1.617,
                                                    -1.285
                                                ],
                                                [
                                                    1.106,
                                                    -0.975
                                                ],
                                                [
                                                    0.003,
                                                    -0.001
                                                ],
                                                [
                                                    1.208,
                                                    -1.307
                                                ],
                                                [
                                                    1.138,
                                                    -1.023
                                                ],
                                                [
                                                    0.986,
                                                    -0.855
                                                ],
                                                [
                                                    1.585,
                                                    -1.484
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.14,
                                                    -2.143
                                                ],
                                                [
                                                    0.938,
                                                    -0.876
                                                ],
                                                [
                                                    1.531,
                                                    -1.674
                                                ],
                                                [
                                                    2.547,
                                                    -3.149
                                                ],
                                                [
                                                    1.678,
                                                    -2.472
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.392,
                                                    -1.497
                                                ],
                                                [
                                                    0.03,
                                                    -0.203
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.597,
                                                    -1.017
                                                ],
                                                [
                                                    -0.928,
                                                    -1.003
                                                ],
                                                [
                                                    -1.22,
                                                    0.61
                                                ],
                                                [
                                                    -0.674,
                                                    0.254
                                                ],
                                                [
                                                    -1.131,
                                                    0.445
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.682,
                                                    0.521
                                                ],
                                                [
                                                    -3.381,
                                                    0.076
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.529,
                                                    -0.381
                                                ],
                                                [
                                                    -2.733,
                                                    -0.94
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.644,
                                                    -1.5
                                                ],
                                                [
                                                    -1.487,
                                                    -2.567
                                                ],
                                                [
                                                    -0.213,
                                                    -2.094
                                                ],
                                                [
                                                    1.107,
                                                    -3.092
                                                ],
                                                [
                                                    1.232,
                                                    -2.275
                                                ],
                                                [
                                                    0.484,
                                                    -0.947
                                                ],
                                                [
                                                    0.649,
                                                    -1.579
                                                ],
                                                [
                                                    0.657,
                                                    -1.273
                                                ],
                                                [
                                                    0.671,
                                                    -1.397
                                                ],
                                                [
                                                    0.804,
                                                    -1.512
                                                ],
                                                [
                                                    0.908,
                                                    -1.404
                                                ],
                                                [
                                                    0.81,
                                                    -1.455
                                                ],
                                                [
                                                    0.962,
                                                    -1.525
                                                ],
                                                [
                                                    0.724,
                                                    -1.229
                                                ],
                                                [
                                                    0.652,
                                                    -1.17
                                                ],
                                                [
                                                    1.01,
                                                    -1.583
                                                ],
                                                [
                                                    0.62,
                                                    -1.009
                                                ],
                                                [
                                                    1.128,
                                                    -1.614
                                                ],
                                                [
                                                    1.365,
                                                    -1.71
                                                ],
                                                [
                                                    0.671,
                                                    -0.866
                                                ],
                                                [
                                                    1.617,
                                                    -1.832
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.631,
                                                    -0.808
                                                ],
                                                [
                                                    0.759,
                                                    -0.8
                                                ],
                                                [
                                                    2.418,
                                                    -2.29
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.027,
                                                    -2.636
                                                ],
                                                [
                                                    1.705,
                                                    -1.296
                                                ],
                                                [
                                                    1.28,
                                                    -1.049
                                                ],
                                                [
                                                    1.093,
                                                    -0.912
                                                ],
                                                [
                                                    1.809,
                                                    -1.424
                                                ],
                                                [
                                                    1.424,
                                                    -1.364
                                                ],
                                                [
                                                    1.264,
                                                    -0.981
                                                ],
                                                [
                                                    1.357,
                                                    -0.848
                                                ],
                                                [
                                                    1.633,
                                                    -1.281
                                                ],
                                                [
                                                    1.932,
                                                    -1.587
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.213,
                                                    -1.122
                                                ],
                                                [
                                                    1.371,
                                                    -1.005
                                                ],
                                                [
                                                    2.562,
                                                    -1.686
                                                ],
                                                [
                                                    3.11,
                                                    -1.824
                                                ],
                                                [
                                                    1.913,
                                                    -0.903
                                                ],
                                                [
                                                    0.919,
                                                    -0.456
                                                ],
                                                [
                                                    0.398,
                                                    -0.21
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.991,
                                                    -0.926
                                                ],
                                                [
                                                    2.862,
                                                    -1.152
                                                ],
                                                [
                                                    2.09,
                                                    -0.68
                                                ],
                                                [
                                                    1.061,
                                                    -0.365
                                                ],
                                                [
                                                    3.276,
                                                    -0.94
                                                ],
                                                [
                                                    0.299,
                                                    -0.149
                                                ],
                                                [
                                                    0.176,
                                                    -0.113
                                                ],
                                                [
                                                    0.171,
                                                    -0.134
                                                ],
                                                [
                                                    1.646,
                                                    -0.397
                                                ],
                                                [
                                                    0.647,
                                                    -0.15
                                                ],
                                                [
                                                    2.712,
                                                    -0.299
                                                ],
                                                [
                                                    1.047,
                                                    -0.134
                                                ],
                                                [
                                                    1.096,
                                                    -0.158
                                                ],
                                                [
                                                    2.349,
                                                    -0.035
                                                ],
                                                [
                                                    1.061,
                                                    0.041
                                                ],
                                                [
                                                    0.307,
                                                    -0.055
                                                ],
                                                [
                                                    2.004,
                                                    0.26
                                                ],
                                                [
                                                    0.981,
                                                    0.088
                                                ],
                                                [
                                                    1.227,
                                                    0.317
                                                ],
                                                [
                                                    1.865,
                                                    0.91
                                                ],
                                                [
                                                    0.842,
                                                    0.379
                                                ],
                                                [
                                                    0.665,
                                                    0.289
                                                ],
                                                [
                                                    1.55,
                                                    1.073
                                                ],
                                                [
                                                    1.849,
                                                    1.939
                                                ],
                                                [
                                                    1.052,
                                                    1.537
                                                ],
                                                [
                                                    0.103,
                                                    0.545
                                                ],
                                                [
                                                    -0.021,
                                                    0.224
                                                ],
                                                [
                                                    -0.455,
                                                    0.184
                                                ],
                                                [
                                                    -0.013,
                                                    0
                                                ],
                                                [
                                                    -0.597,
                                                    0.216
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.707,
                                                    1.068
                                                ],
                                                [
                                                    -0.712,
                                                    0.267
                                                ],
                                                [
                                                    -1.957,
                                                    0.877
                                                ],
                                                [
                                                    -0.14,
                                                    0.254
                                                ],
                                                [
                                                    -0.14,
                                                    0.076
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    0.165
                                                ],
                                                [
                                                    -0.229,
                                                    0.114
                                                ],
                                                [
                                                    -0.025,
                                                    0.051
                                                ],
                                                [
                                                    -1.131,
                                                    0.547
                                                ],
                                                [
                                                    -1.83,
                                                    1.08
                                                ],
                                                [
                                                    -1.373,
                                                    0.763
                                                ],
                                                [
                                                    -1.474,
                                                    0.865
                                                ],
                                                [
                                                    -0.013,
                                                    0.013
                                                ],
                                                [
                                                    -1.551,
                                                    0.966
                                                ],
                                                [
                                                    -1.195,
                                                    0.966
                                                ],
                                                [
                                                    -1.551,
                                                    1.106
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.026,
                                                    0.013
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.025,
                                                    0
                                                ],
                                                [
                                                    -0.203,
                                                    0.318
                                                ],
                                                [
                                                    -0.102,
                                                    0.063
                                                ],
                                                [
                                                    -0.28,
                                                    0.305
                                                ],
                                                [
                                                    -0.076,
                                                    0.05
                                                ],
                                                [
                                                    -0.178,
                                                    0.127
                                                ],
                                                [
                                                    -1.131,
                                                    1.093
                                                ],
                                                [
                                                    -1.691,
                                                    1.385
                                                ],
                                                [
                                                    -3.05,
                                                    2.783
                                                ],
                                                [
                                                    -0.013,
                                                    0.012
                                                ],
                                                [
                                                    -2.745,
                                                    2.784
                                                ],
                                                [
                                                    -0.28,
                                                    0.433
                                                ],
                                                [
                                                    -0.165,
                                                    0.178
                                                ],
                                                [
                                                    -0.038,
                                                    0.063
                                                ],
                                                [
                                                    -0.013,
                                                    0.012
                                                ],
                                                [
                                                    -0.14,
                                                    0.191
                                                ],
                                                [
                                                    -0.267,
                                                    0.28
                                                ],
                                                [
                                                    -0.343,
                                                    0.318
                                                ],
                                                [
                                                    -0.33,
                                                    0.343
                                                ],
                                                [
                                                    -0.102,
                                                    0.114
                                                ],
                                                [
                                                    -1.894,
                                                    2.224
                                                ],
                                                [
                                                    -1.779,
                                                    2.301
                                                ],
                                                [
                                                    -0.521,
                                                    0.776
                                                ],
                                                [
                                                    -0.076,
                                                    0.089
                                                ],
                                                [
                                                    -1.055,
                                                    1.487
                                                ],
                                                [
                                                    -0.305,
                                                    0.496
                                                ],
                                                [
                                                    -0.089,
                                                    0.152
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.038,
                                                    0.063
                                                ],
                                                [
                                                    0,
                                                    0.025
                                                ],
                                                [
                                                    -0.063,
                                                    0.076
                                                ],
                                                [
                                                    -0.063,
                                                    0.089
                                                ],
                                                [
                                                    -0.013,
                                                    0.038
                                                ],
                                                [
                                                    -0.064,
                                                    0.305
                                                ],
                                                [
                                                    -0.152,
                                                    0.242
                                                ],
                                                [
                                                    -0.013,
                                                    0.254
                                                ],
                                                [
                                                    -0.051,
                                                    0.28
                                                ],
                                                [
                                                    0.203,
                                                    0.432
                                                ],
                                                [
                                                    0,
                                                    0.012
                                                ],
                                                [
                                                    0.051,
                                                    0.114
                                                ],
                                                [
                                                    0.038,
                                                    0.063
                                                ],
                                                [
                                                    0.254,
                                                    0.05
                                                ],
                                                [
                                                    0.025,
                                                    0.013
                                                ],
                                                [
                                                    0.076,
                                                    0.025
                                                ],
                                                [
                                                    0.852,
                                                    1.068
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.017,
                                                    1.423
                                                ],
                                                [
                                                    1.042,
                                                    2.021
                                                ],
                                                [
                                                    0.407,
                                                    0.648
                                                ],
                                                [
                                                    0.229,
                                                    0.559
                                                ],
                                                [
                                                    0.191,
                                                    0.356
                                                ],
                                                [
                                                    0.14,
                                                    0.432
                                                ],
                                                [
                                                    0.725,
                                                    1.805
                                                ],
                                                [
                                                    0.33,
                                                    1.5
                                                ],
                                                [
                                                    0.343,
                                                    1.907
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.013,
                                                    0.204
                                                ],
                                                [
                                                    0,
                                                    0.006
                                                ],
                                                [
                                                    0.026,
                                                    0.483
                                                ],
                                                [
                                                    0.229,
                                                    3.444
                                                ],
                                                [
                                                    0.144,
                                                    3.262
                                                ],
                                                [
                                                    0.144,
                                                    3.262
                                                ],
                                                [
                                                    0.144,
                                                    3.262
                                                ],
                                                [
                                                    0.156,
                                                    3.551
                                                ],
                                                [
                                                    0.156,
                                                    3.551
                                                ],
                                                [
                                                    0.096,
                                                    2.013
                                                ],
                                                [
                                                    0.063,
                                                    1.844
                                                ],
                                                [
                                                    0.228,
                                                    0.735
                                                ],
                                                [
                                                    0.109,
                                                    1.34
                                                ],
                                                [
                                                    0.025,
                                                    2.221
                                                ],
                                                [
                                                    0,
                                                    3.038
                                                ],
                                                [
                                                    -0.038,
                                                    3.063
                                                ],
                                                [
                                                    -0.076,
                                                    3.062
                                                ],
                                                [
                                                    0.216,
                                                    1.398
                                                ],
                                                [
                                                    0,
                                                    0.038
                                                ],
                                                [
                                                    0.343,
                                                    0.635
                                                ],
                                                [
                                                    -0.165,
                                                    3.241
                                                ],
                                                [
                                                    -0.191,
                                                    3.254
                                                ],
                                                [
                                                    -0.216,
                                                    3.266
                                                ],
                                                [
                                                    0.343,
                                                    3.661
                                                ],
                                                [
                                                    0.966,
                                                    3.609
                                                ],
                                                [
                                                    1.551,
                                                    3.445
                                                ],
                                                [
                                                    2.059,
                                                    3.216
                                                ],
                                                [
                                                    2.453,
                                                    2.949
                                                ],
                                                [
                                                    2.758,
                                                    2.669
                                                ],
                                                [
                                                    0.343,
                                                    0.33
                                                ],
                                                [
                                                    2.847,
                                                    2.098
                                                ],
                                                [
                                                    3.114,
                                                    1.716
                                                ],
                                                [
                                                    3.317,
                                                    1.31
                                                ],
                                                [
                                                    3.444,
                                                    0.877
                                                ],
                                                [
                                                    3.546,
                                                    0.445
                                                ],
                                                [
                                                    3.572,
                                                    0
                                                ],
                                                [
                                                    3.546,
                                                    -0.444
                                                ],
                                                [
                                                    3.47,
                                                    -0.902
                                                ],
                                                [
                                                    3.33,
                                                    -1.335
                                                ],
                                                [
                                                    3.127,
                                                    -1.767
                                                ],
                                                [
                                                    2.885,
                                                    -2.173
                                                ],
                                                [
                                                    2.148,
                                                    -1.97
                                                ],
                                                [
                                                    1.83,
                                                    -2.237
                                                ],
                                                [
                                                    1.385,
                                                    -2.542
                                                ],
                                                [
                                                    1.322,
                                                    3.317
                                                ],
                                                [
                                                    1.551,
                                                    2.923
                                                ],
                                                [
                                                    1.868,
                                                    2.008
                                                ],
                                                [
                                                    3.038,
                                                    1.602
                                                ],
                                                [
                                                    3.355,
                                                    0.788
                                                ],
                                                [
                                                    3.394,
                                                    0.102
                                                ],
                                                [
                                                    3.266,
                                                    -0.534
                                                ],
                                                [
                                                    2.949,
                                                    -1.246
                                                ],
                                                [
                                                    2.745,
                                                    -1.996
                                                ],
                                                [
                                                    2.339,
                                                    -2.466
                                                ],
                                                [
                                                    1.945,
                                                    -2.783
                                                ],
                                                [
                                                    1.576,
                                                    -2.962
                                                ],
                                                [
                                                    1.334,
                                                    -3.038
                                                ],
                                                [
                                                    1.22,
                                                    -3.012
                                                ],
                                                [
                                                    1.284,
                                                    -2.923
                                                ],
                                                [
                                                    1.5,
                                                    -2.834
                                                ],
                                                [
                                                    -0.076,
                                                    -0.089
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.004,
                                                    -0.005
                                                ],
                                                [
                                                    0.015,
                                                    -0.109
                                                ],
                                                [
                                                    0.454,
                                                    -0.806
                                                ],
                                                [
                                                    0.021,
                                                    -0.032
                                                ],
                                                [
                                                    0.013,
                                                    -0.012
                                                ],
                                                [
                                                    1.144,
                                                    -1.919
                                                ],
                                                [
                                                    1.843,
                                                    -2.733
                                                ],
                                                [
                                                    0.822,
                                                    -1.125
                                                ],
                                                [
                                                    0.586,
                                                    -0.789
                                                ],
                                                [
                                                    1.133,
                                                    -1.219
                                                ],
                                                [
                                                    0.887,
                                                    -1.078
                                                ],
                                                [
                                                    0.764,
                                                    -0.998
                                                ],
                                                [
                                                    1.082,
                                                    -1.184
                                                ],
                                                [
                                                    1.427,
                                                    -1.357
                                                ],
                                                [
                                                    0.761,
                                                    -0.75
                                                ],
                                                [
                                                    3.02,
                                                    -2.581
                                                ],
                                                [
                                                    0.676,
                                                    -0.597
                                                ],
                                                [
                                                    0.842,
                                                    -0.663
                                                ],
                                                [
                                                    1.579,
                                                    -0.958
                                                ],
                                                [
                                                    1.063,
                                                    -0.715
                                                ],
                                                [
                                                    0.839,
                                                    -0.585
                                                ],
                                                [
                                                    1.638,
                                                    -0.925
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.066,
                                                    -0.576
                                                ],
                                                [
                                                    -0.092,
                                                    0.672
                                                ],
                                                [
                                                    -0.699,
                                                    2.059
                                                ],
                                                [
                                                    -0.318,
                                                    1.043
                                                ],
                                                [
                                                    -0.318,
                                                    1.424
                                                ],
                                                [
                                                    -0.623,
                                                    1.5
                                                ],
                                                [
                                                    -0.864,
                                                    1.398
                                                ],
                                                [
                                                    -0.801,
                                                    1.754
                                                ],
                                                [
                                                    -1.614,
                                                    2.834
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.462,
                                                    2.25
                                                ],
                                                [
                                                    -0.813,
                                                    1.449
                                                ],
                                                [
                                                    -0.966,
                                                    1.386
                                                ],
                                                [
                                                    -1.093,
                                                    1.297
                                                ],
                                                [
                                                    -1.131,
                                                    1.576
                                                ],
                                                [
                                                    -0.915,
                                                    1.576
                                                ],
                                                [
                                                    -0.852,
                                                    1.22
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.703,
                                                    2.568
                                                ],
                                                [
                                                    -0.902,
                                                    1.144
                                                ],
                                                [
                                                    -1.182,
                                                    1.919
                                                ],
                                                [
                                                    -0.864,
                                                    1.83
                                                ],
                                                [
                                                    -0.699,
                                                    1.245
                                                ],
                                                [
                                                    -0.699,
                                                    1.131
                                                ],
                                                [
                                                    -1.03,
                                                    2.097
                                                ],
                                                [
                                                    -0.635,
                                                    1.932
                                                ],
                                                [
                                                    -0.534,
                                                    1.233
                                                ],
                                                [
                                                    -0.509,
                                                    1.093
                                                ],
                                                [
                                                    -0.852,
                                                    2.262
                                                ],
                                                [
                                                    -0.788,
                                                    2.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.572,
                                                    1.31
                                                ],
                                                [
                                                    -0.635,
                                                    2.288
                                                ],
                                                [
                                                    -0.089,
                                                    1.182
                                                ],
                                                [
                                                    -0.013,
                                                    0.063
                                                ],
                                                [
                                                    -3.127,
                                                    -0.864
                                                ],
                                                [
                                                    -3.305,
                                                    -0.737
                                                ],
                                                [
                                                    -3.343,
                                                    -0.598
                                                ],
                                                [
                                                    -3.381,
                                                    -0.445
                                                ],
                                                [
                                                    -3.406,
                                                    -0.305
                                                ],
                                                [
                                                    -3.432,
                                                    -0.191
                                                ],
                                                [
                                                    -1.169,
                                                    -0.051
                                                ],
                                                [
                                                    -3.483,
                                                    -0.331
                                                ],
                                                [
                                                    -3.495,
                                                    -0.292
                                                ],
                                                [
                                                    -3.495,
                                                    -0.229
                                                ],
                                                [
                                                    -3.495,
                                                    -0.19
                                                ],
                                                [
                                                    -3.495,
                                                    -0.127
                                                ],
                                                [
                                                    -3.495,
                                                    -0.089
                                                ],
                                                [
                                                    -3.495,
                                                    -0.051
                                                ],
                                                [
                                                    -3.495,
                                                    0
                                                ],
                                                [
                                                    -1.347,
                                                    0.025
                                                ],
                                                [
                                                    -2.555,
                                                    0.063
                                                ],
                                                [
                                                    -1.258,
                                                    0.012
                                                ],
                                                [
                                                    -1.576,
                                                    -0.038
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.059,
                                                    0.025
                                                ],
                                                [
                                                    -3.686,
                                                    0.102
                                                ],
                                                [
                                                    -3.622,
                                                    0.126
                                                ],
                                                [
                                                    -1.754,
                                                    0.292
                                                ],
                                                [
                                                    -0.013,
                                                    0
                                                ],
                                                [
                                                    -1.792,
                                                    0.076
                                                ],
                                                [
                                                    -2.135,
                                                    0.229
                                                ],
                                                [
                                                    -1.398,
                                                    0.076
                                                ],
                                                [
                                                    -1.627,
                                                    0.216
                                                ],
                                                [
                                                    -1.894,
                                                    0.127
                                                ],
                                                [
                                                    -3.521,
                                                    0.292
                                                ],
                                                [
                                                    -3.508,
                                                    0.343
                                                ],
                                                [
                                                    -3.483,
                                                    0.406
                                                ],
                                                [
                                                    -3.444,
                                                    0.47
                                                ],
                                                [
                                                    -1.805,
                                                    0.445
                                                ],
                                                [
                                                    -1.627,
                                                    0.254
                                                ],
                                                [
                                                    -2.644,
                                                    0.635
                                                ],
                                                [
                                                    -0.75,
                                                    0.14
                                                ],
                                                [
                                                    -3.33,
                                                    0.775
                                                ],
                                                [
                                                    0.013,
                                                    0.025
                                                ],
                                                [
                                                    -0.025,
                                                    0
                                                ],
                                                [
                                                    -1.22,
                                                    0.318
                                                ],
                                                [
                                                    -2.656,
                                                    0.444
                                                ],
                                                [
                                                    -2.428,
                                                    0.432
                                                ],
                                                [
                                                    -0.267,
                                                    -0.114
                                                ],
                                                [
                                                    -0.458,
                                                    -0.14
                                                ],
                                                [
                                                    -0.877,
                                                    -0.28
                                                ],
                                                [
                                                    -1.157,
                                                    -0.064
                                                ],
                                                [
                                                    -0.508,
                                                    -0.101
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.47,
                                                    -0.191
                                                ],
                                                [
                                                    -1.03,
                                                    -0.102
                                                ],
                                                [
                                                    -2.491,
                                                    0.076
                                                ],
                                                [
                                                    -1.894,
                                                    0.343
                                                ],
                                                [
                                                    -1.195,
                                                    0.089
                                                ],
                                                [
                                                    -1.411,
                                                    0.013
                                                ],
                                                [
                                                    -1.894,
                                                    0.178
                                                ],
                                                [
                                                    -1.754,
                                                    0.267
                                                ],
                                                [
                                                    -0.953,
                                                    0.114
                                                ],
                                                [
                                                    -0.509,
                                                    0.038
                                                ],
                                                [
                                                    -0.623,
                                                    0.102
                                                ],
                                                [
                                                    -2.059,
                                                    0.012
                                                ],
                                                [
                                                    -1.042,
                                                    0.025
                                                ],
                                                [
                                                    -3.241,
                                                    -0.267
                                                ],
                                                [
                                                    -2.872,
                                                    -0.724
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.491,
                                                    -1.271
                                                ],
                                                [
                                                    -2.034,
                                                    -1.894
                                                ],
                                                [
                                                    -2.084,
                                                    -3.229
                                                ],
                                                [
                                                    -1.296,
                                                    -3.203
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.483,
                                                    -2.517
                                                ],
                                                [
                                                    -0.153,
                                                    -4.004
                                                ],
                                                [
                                                    -0.01,
                                                    -0.655
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.142,
                                                    2.088
                                                ],
                                                [
                                                    -0.211,
                                                    1.19
                                                ],
                                                [
                                                    -0.16,
                                                    1.069
                                                ],
                                                [
                                                    -0.321,
                                                    2.407
                                                ],
                                                [
                                                    -0.585,
                                                    2.49
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.042,
                                                    3.248
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.197,
                                                    2.933
                                                ],
                                                [
                                                    -0.876,
                                                    1.746
                                                ],
                                                [
                                                    -0.738,
                                                    1.133
                                                ],
                                                [
                                                    -0.534,
                                                    0.886
                                                ],
                                                [
                                                    -1.25,
                                                    2.142
                                                ],
                                                [
                                                    -0.537,
                                                    0.752
                                                ],
                                                [
                                                    -1.486,
                                                    2.132
                                                ],
                                                [
                                                    -0.591,
                                                    0.708
                                                ],
                                                [
                                                    -1.654,
                                                    2.021
                                                ],
                                                [
                                                    -1.269,
                                                    1.304
                                                ],
                                                [
                                                    -1.157,
                                                    0.92
                                                ],
                                                [
                                                    -0.003,
                                                    0.003
                                                ],
                                                [
                                                    -1.397,
                                                    1.239
                                                ],
                                                [
                                                    -1.122,
                                                    1.216
                                                ],
                                                [
                                                    -0.946,
                                                    0.851
                                                ],
                                                [
                                                    -1.59,
                                                    1.379
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.164,
                                                    2.025
                                                ],
                                                [
                                                    -0.903,
                                                    0.9
                                                ],
                                                [
                                                    -1.555,
                                                    1.454
                                                ],
                                                [
                                                    -2.108,
                                                    2.306
                                                ],
                                                [
                                                    -2.095,
                                                    2.591
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.91,
                                                    1.338
                                                ],
                                                [
                                                    -0.053,
                                                    0.202
                                                ],
                                                [
                                                    0,
                                                    0.012
                                                ],
                                                [
                                                    -0.763,
                                                    0.941
                                                ],
                                                [
                                                    -0.686,
                                                    1.131
                                                ],
                                                [
                                                    0.877,
                                                    0.979
                                                ],
                                                [
                                                    0.635,
                                                    -0.318
                                                ],
                                                [
                                                    1.119,
                                                    0.33
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.771,
                                                    -1.093
                                                ],
                                                [
                                                    2.847,
                                                    -0.559
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.898,
                                                    -0.064
                                                ],
                                                [
                                                    2.517,
                                                    0.382
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.114,
                                                    1.068
                                                ],
                                                [
                                                    4.194,
                                                    2.364
                                                ],
                                                [
                                                    1.094,
                                                    1.885
                                                ],
                                                [
                                                    -0.259,
                                                    2.465
                                                ],
                                                [
                                                    -0.761,
                                                    2.127
                                                ],
                                                [
                                                    -0.51,
                                                    0.943
                                                ],
                                                [
                                                    -0.839,
                                                    1.637
                                                ],
                                                [
                                                    -0.607,
                                                    1.474
                                                ],
                                                [
                                                    -0.708,
                                                    1.374
                                                ],
                                                [
                                                    -0.738,
                                                    1.542
                                                ],
                                                [
                                                    -0.703,
                                                    1.324
                                                ],
                                                [
                                                    -0.909,
                                                    1.403
                                                ],
                                                [
                                                    -0.874,
                                                    1.574
                                                ],
                                                [
                                                    -0.762,
                                                    1.209
                                                ],
                                                [
                                                    -0.684,
                                                    1.153
                                                ],
                                                [
                                                    -0.917,
                                                    1.639
                                                ],
                                                [
                                                    -0.636,
                                                    0.997
                                                ],
                                                [
                                                    -1.106,
                                                    1.795
                                                ],
                                                [
                                                    -1.168,
                                                    1.669
                                                ],
                                                [
                                                    -0.684,
                                                    0.854
                                                ],
                                                [
                                                    -1.403,
                                                    1.806
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.671,
                                                    0.772
                                                ],
                                                [
                                                    -0.665,
                                                    0.85
                                                ],
                                                [
                                                    -2.167,
                                                    2.299
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.485,
                                                    2.359
                                                ],
                                                [
                                                    -1.504,
                                                    1.309
                                                ],
                                                [
                                                    -1.323,
                                                    1.005
                                                ],
                                                [
                                                    -1.106,
                                                    0.903
                                                ],
                                                [
                                                    -1.774,
                                                    1.48
                                                ],
                                                [
                                                    -1.678,
                                                    1.319
                                                ],
                                                [
                                                    -1.315,
                                                    1.261
                                                ],
                                                [
                                                    -1.098,
                                                    0.851
                                                ],
                                                [
                                                    -1.609,
                                                    1.005
                                                ],
                                                [
                                                    -1.972,
                                                    1.548
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.283,
                                                    1.042
                                                ],
                                                [
                                                    -1.416,
                                                    1.308
                                                ],
                                                [
                                                    -3.169,
                                                    2.323
                                                ],
                                                [
                                                    -2.747,
                                                    1.808
                                                ],
                                                [
                                                    -1.667,
                                                    0.978
                                                ],
                                                [
                                                    -0.93,
                                                    0.441
                                                ],
                                                [
                                                    -0.422,
                                                    0.102
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.945,
                                                    1.033
                                                ],
                                                [
                                                    -3.038,
                                                    1.408
                                                ],
                                                [
                                                    -1.9,
                                                    0.763
                                                ],
                                                [
                                                    -1.069,
                                                    0.349
                                                ],
                                                [
                                                    -2.723,
                                                    0.935
                                                ],
                                                [
                                                    -0.321,
                                                    0.094
                                                ],
                                                [
                                                    -0.168,
                                                    0.085
                                                ],
                                                [
                                                    -0.19,
                                                    0.112
                                                ],
                                                [
                                                    -1.788,
                                                    0.496
                                                ],
                                                [
                                                    -0.62,
                                                    -0.091
                                                ],
                                                [
                                                    -2.712,
                                                    0.621
                                                ],
                                                [
                                                    -1.077,
                                                    0.12
                                                ],
                                                [
                                                    -1.125,
                                                    0.143
                                                ],
                                                [
                                                    -2.699,
                                                    0.39
                                                ],
                                                [
                                                    -0.427,
                                                    -0.11
                                                ],
                                                [
                                                    -0.321,
                                                    0
                                                ],
                                                [
                                                    -2.18,
                                                    -0.103
                                                ],
                                                [
                                                    -0.983,
                                                    -0.13
                                                ],
                                                [
                                                    -1.577,
                                                    -0.139
                                                ],
                                                [
                                                    -1.713,
                                                    -0.444
                                                ],
                                                [
                                                    -0.842,
                                                    -0.41
                                                ],
                                                [
                                                    -0.665,
                                                    -0.299
                                                ],
                                                [
                                                    -2.095,
                                                    -0.906
                                                ],
                                                [
                                                    -2.306,
                                                    -1.599
                                                ],
                                                [
                                                    -1.107,
                                                    -1.163
                                                ],
                                                [
                                                    0.066,
                                                    -0.792
                                                ],
                                                [
                                                    0.046,
                                                    -0.236
                                                ],
                                                [
                                                    0.466,
                                                    -0.163
                                                ],
                                                [
                                                    0.026,
                                                    -0.013
                                                ],
                                                [
                                                    0.597,
                                                    -0.217
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.758,
                                                    -0.953
                                                ],
                                                [
                                                    0.699,
                                                    -0.28
                                                ],
                                                [
                                                    2.085,
                                                    -0.61
                                                ],
                                                [
                                                    0.229,
                                                    -0.089
                                                ],
                                                [
                                                    0.14,
                                                    -0.076
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.305,
                                                    -0.127
                                                ],
                                                [
                                                    0.305,
                                                    0.039
                                                ],
                                                [
                                                    0.153,
                                                    -0.051
                                                ],
                                                [
                                                    1.119,
                                                    -0.546
                                                ],
                                                [
                                                    1.906,
                                                    -0.928
                                                ],
                                                [
                                                    1.398,
                                                    -0.712
                                                ],
                                                [
                                                    1.754,
                                                    -0.966
                                                ],
                                                [
                                                    0.013,
                                                    -0.012
                                                ],
                                                [
                                                    1.64,
                                                    -0.839
                                                ],
                                                [
                                                    1.296,
                                                    -0.813
                                                ],
                                                [
                                                    1.627,
                                                    -1.094
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.026,
                                                    -0.013
                                                ],
                                                [
                                                    0.076,
                                                    0.076
                                                ],
                                                [
                                                    0.025,
                                                    0
                                                ],
                                                [
                                                    0.318,
                                                    -0.216
                                                ],
                                                [
                                                    0.115,
                                                    -0.038
                                                ],
                                                [
                                                    0.419,
                                                    -0.254
                                                ],
                                                [
                                                    0.089,
                                                    -0.051
                                                ],
                                                [
                                                    0.178,
                                                    -0.127
                                                ],
                                                [
                                                    1.258,
                                                    -0.915
                                                ],
                                                [
                                                    1.754,
                                                    -1.195
                                                ],
                                                [
                                                    2.618,
                                                    -2.135
                                                ],
                                                [
                                                    0.013,
                                                    -0.013
                                                ],
                                                [
                                                    2.415,
                                                    -2.199
                                                ],
                                                [
                                                    0.47,
                                                    -0.445
                                                ],
                                                [
                                                    0.14,
                                                    -0.216
                                                ],
                                                [
                                                    0.051,
                                                    -0.064
                                                ],
                                                [
                                                    0.026,
                                                    -0.013
                                                ],
                                                [
                                                    0.254,
                                                    -0.267
                                                ],
                                                [
                                                    0.267,
                                                    -0.267
                                                ],
                                                [
                                                    0.318,
                                                    -0.343
                                                ],
                                                [
                                                    0.381,
                                                    -0.356
                                                ],
                                                [
                                                    0.127,
                                                    -0.089
                                                ],
                                                [
                                                    1.97,
                                                    -2.123
                                                ],
                                                [
                                                    1.881,
                                                    -2.224
                                                ],
                                                [
                                                    0.572,
                                                    -0.737
                                                ],
                                                [
                                                    0.076,
                                                    -0.089
                                                ],
                                                [
                                                    1.182,
                                                    -1.449
                                                ],
                                                [
                                                    0.343,
                                                    -0.458
                                                ],
                                                [
                                                    0.089,
                                                    -0.14
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.064,
                                                    -0.063
                                                ],
                                                [
                                                    0.013,
                                                    -0.013
                                                ],
                                                [
                                                    0.051,
                                                    -0.076
                                                ],
                                                [
                                                    0.089,
                                                    -0.102
                                                ],
                                                [
                                                    0.165,
                                                    0.026
                                                ],
                                                [
                                                    0.165,
                                                    -0.229
                                                ],
                                                [
                                                    0.178,
                                                    -0.216
                                                ],
                                                [
                                                    0.14,
                                                    -0.216
                                                ],
                                                [
                                                    0.305,
                                                    -0.203
                                                ],
                                                [
                                                    0.063,
                                                    -0.406
                                                ],
                                                [
                                                    0,
                                                    -0.013
                                                ],
                                                [
                                                    -0.025,
                                                    -0.115
                                                ],
                                                [
                                                    0.051,
                                                    -0.102
                                                ],
                                                [
                                                    -0.076,
                                                    -0.153
                                                ],
                                                [
                                                    -0.013,
                                                    -0.026
                                                ],
                                                [
                                                    -0.178,
                                                    -0.165
                                                ],
                                                [
                                                    -0.902,
                                                    -0.89
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.297,
                                                    -1.512
                                                ],
                                                [
                                                    -1.042,
                                                    -1.92
                                                ],
                                                [
                                                    -0.318,
                                                    -0.673
                                                ],
                                                [
                                                    -0.152,
                                                    -0.56
                                                ],
                                                [
                                                    -0.165,
                                                    -0.369
                                                ],
                                                [
                                                    -0.038,
                                                    -0.444
                                                ],
                                                [
                                                    -0.674,
                                                    -1.818
                                                ],
                                                [
                                                    -0.458,
                                                    -1.551
                                                ],
                                                [
                                                    -0.521,
                                                    -2.288
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.025,
                                                    -0.204
                                                ],
                                                [
                                                    0,
                                                    -0.007
                                                ],
                                                [
                                                    -0.017,
                                                    -0.484
                                                ],
                                                [
                                                    -0.182,
                                                    -3.445
                                                ],
                                                [
                                                    -0.144,
                                                    -3.262
                                                ],
                                                [
                                                    -0.144,
                                                    -3.262
                                                ],
                                                [
                                                    -0.143,
                                                    -3.262
                                                ],
                                                [
                                                    -0.156,
                                                    -3.551
                                                ],
                                                [
                                                    -0.156,
                                                    -3.551
                                                ],
                                                [
                                                    -0.089,
                                                    -2.013
                                                ],
                                                [
                                                    0.076,
                                                    -1.831
                                                ],
                                                [
                                                    -0.013,
                                                    -0.748
                                                ],
                                                [
                                                    -0.106,
                                                    -1.34
                                                ],
                                                [
                                                    0.025,
                                                    -2.209
                                                ],
                                                [
                                                    -0.038,
                                                    -3.012
                                                ],
                                                [
                                                    0.013,
                                                    -3.012
                                                ],
                                                [
                                                    0.051,
                                                    -3
                                                ],
                                                [
                                                    0.775,
                                                    -1.22
                                                ],
                                                [
                                                    0,
                                                    -0.038
                                                ],
                                                [
                                                    -0.114,
                                                    -0.712
                                                ],
                                                [
                                                    0.115,
                                                    -3.127
                                                ],
                                                [
                                                    0.14,
                                                    -3.101
                                                ],
                                                [
                                                    0.178,
                                                    -3.101
                                                ],
                                                [
                                                    0.267,
                                                    -3.775
                                                ],
                                                [
                                                    -0.343,
                                                    -3.724
                                                ],
                                                [
                                                    -0.953,
                                                    -3.559
                                                ],
                                                [
                                                    -1.5,
                                                    -3.317
                                                ],
                                                [
                                                    -1.945,
                                                    -3.05
                                                ],
                                                [
                                                    -2.313,
                                                    -2.784
                                                ],
                                                [
                                                    -0.343,
                                                    -0.331
                                                ],
                                                [
                                                    -2.618,
                                                    -2.491
                                                ],
                                                [
                                                    -2.911,
                                                    -2.123
                                                ],
                                                [
                                                    -3.14,
                                                    -1.728
                                                ],
                                                [
                                                    -3.33,
                                                    -1.309
                                                ],
                                                [
                                                    -3.47,
                                                    -0.877
                                                ],
                                                [
                                                    -3.546,
                                                    -0.432
                                                ],
                                                [
                                                    -3.572,
                                                    0
                                                ],
                                                [
                                                    -3.533,
                                                    0.445
                                                ],
                                                [
                                                    -3.445,
                                                    0.89
                                                ],
                                                [
                                                    -3.292,
                                                    1.322
                                                ],
                                                [
                                                    -3.089,
                                                    1.728
                                                ],
                                                [
                                                    -2.555,
                                                    1.92
                                                ],
                                                [
                                                    -2.364,
                                                    2.186
                                                ],
                                                [
                                                    -2.059,
                                                    2.491
                                                ],
                                                [
                                                    -0.902,
                                                    -3.279
                                                ],
                                                [
                                                    -1.347,
                                                    -3.381
                                                ],
                                                [
                                                    -1.957,
                                                    -3.661
                                                ],
                                                [
                                                    -2.313,
                                                    -2.453
                                                ],
                                                [
                                                    -2.949,
                                                    -1.55
                                                ],
                                                [
                                                    -3.279,
                                                    -0.776
                                                ],
                                                [
                                                    -3.445,
                                                    -0.101
                                                ],
                                                [
                                                    -3.495,
                                                    0.572
                                                ],
                                                [
                                                    -2.936,
                                                    1.245
                                                ],
                                                [
                                                    -2.567,
                                                    1.855
                                                ],
                                                [
                                                    -2.199,
                                                    2.301
                                                ],
                                                [
                                                    -1.919,
                                                    2.796
                                                ],
                                                [
                                                    -1.589,
                                                    3.025
                                                ],
                                                [
                                                    -1.398,
                                                    3.178
                                                ],
                                                [
                                                    -1.22,
                                                    3.026
                                                ],
                                                [
                                                    -1.309,
                                                    2.987
                                                ],
                                                [
                                                    -0.025,
                                                    0.038
                                                ],
                                                [
                                                    -0.013,
                                                    0
                                                ],
                                                [
                                                    0.004,
                                                    0.006
                                                ],
                                                [
                                                    -0.04,
                                                    0.102
                                                ],
                                                [
                                                    -0.429,
                                                    0.812
                                                ],
                                                [
                                                    -0.02,
                                                    0.032
                                                ],
                                                [
                                                    -0.013,
                                                    0.025
                                                ],
                                                [
                                                    -1.207,
                                                    1.881
                                                ],
                                                [
                                                    -1.691,
                                                    2.822
                                                ],
                                                [
                                                    -0.782,
                                                    1.159
                                                ],
                                                [
                                                    -0.863,
                                                    0.374
                                                ],
                                                [
                                                    -0.868,
                                                    1.17
                                                ],
                                                [
                                                    -0.957,
                                                    1.029
                                                ],
                                                [
                                                    -0.802,
                                                    0.973
                                                ],
                                                [
                                                    -1.082,
                                                    1.414
                                                ],
                                                [
                                                    -1.237,
                                                    1.355
                                                ],
                                                [
                                                    -0.767,
                                                    0.731
                                                ],
                                                [
                                                    -3.017,
                                                    2.991
                                                ],
                                                [
                                                    -0.695,
                                                    0.583
                                                ],
                                                [
                                                    -0.855,
                                                    0.755
                                                ],
                                                [
                                                    -1.325,
                                                    1.026
                                                ],
                                                [
                                                    -1.117,
                                                    0.676
                                                ],
                                                [
                                                    -0.863,
                                                    0.578
                                                ],
                                                [
                                                    -1.734,
                                                    1.209
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.121,
                                                    0.647
                                                ],
                                                [
                                                    0.043,
                                                    -0.761
                                                ],
                                                [
                                                    0.254,
                                                    -1.83
                                                ],
                                                [
                                                    0.356,
                                                    -1.029
                                                ],
                                                [
                                                    0.419,
                                                    -1.385
                                                ],
                                                [
                                                    0.432,
                                                    -1.856
                                                ],
                                                [
                                                    0.508,
                                                    -1.233
                                                ],
                                                [
                                                    0.928,
                                                    -1.475
                                                ],
                                                [
                                                    1.449,
                                                    -3.101
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.385,
                                                    -2.453
                                                ],
                                                [
                                                    0.89,
                                                    -1.385
                                                ],
                                                [
                                                    0.915,
                                                    -1.626
                                                ],
                                                [
                                                    0.852,
                                                    -1.232
                                                ],
                                                [
                                                    1.157,
                                                    -1.373
                                                ],
                                                [
                                                    1.131,
                                                    -1.601
                                                ],
                                                [
                                                    0.826,
                                                    -1.398
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.703,
                                                    -2.44
                                                ],
                                                [
                                                    0.699,
                                                    -1.067
                                                ],
                                                [
                                                    1.258,
                                                    -1.602
                                                ],
                                                [
                                                    1.118,
                                                    -1.843
                                                ],
                                                [
                                                    0.597,
                                                    -1.271
                                                ],
                                                [
                                                    0.623,
                                                    -1.131
                                                ],
                                                [
                                                    1.131,
                                                    -1.779
                                                ],
                                                [
                                                    0.979,
                                                    -1.97
                                                ],
                                                [
                                                    0.47,
                                                    -1.411
                                                ],
                                                [
                                                    0.47,
                                                    -1.093
                                                ],
                                                [
                                                    0.94,
                                                    -2.008
                                                ],
                                                [
                                                    0.941,
                                                    -2.479
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.381,
                                                    -1.169
                                                ],
                                                [
                                                    0.775,
                                                    -1.83
                                                ],
                                                [
                                                    0.381,
                                                    -1.424
                                                ],
                                                [
                                                    0.013,
                                                    -0.076
                                                ],
                                                [
                                                    3.114,
                                                    1.004
                                                ],
                                                [
                                                    3.254,
                                                    0.903
                                                ],
                                                [
                                                    3.279,
                                                    0.737
                                                ],
                                                [
                                                    3.292,
                                                    0.585
                                                ],
                                                [
                                                    3.305,
                                                    0.433
                                                ],
                                                [
                                                    3.317,
                                                    0.292
                                                ],
                                                [
                                                    1.144,
                                                    0.05
                                                ],
                                                [
                                                    3.432,
                                                    0.382
                                                ],
                                                [
                                                    3.445,
                                                    0.33
                                                ],
                                                [
                                                    3.445,
                                                    0.279
                                                ],
                                                [
                                                    3.444,
                                                    0.229
                                                ],
                                                [
                                                    3.457,
                                                    0.178
                                                ],
                                                [
                                                    3.457,
                                                    0.14
                                                ],
                                                [
                                                    3.457,
                                                    0.089
                                                ],
                                                [
                                                    3.47,
                                                    0.038
                                                ],
                                                [
                                                    1.119,
                                                    0.026
                                                ],
                                                [
                                                    2.034,
                                                    0.013
                                                ],
                                                [
                                                    1.157,
                                                    0.038
                                                ],
                                                [
                                                    1.462,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.894,
                                                    0.114
                                                ],
                                                [
                                                    3.317,
                                                    -0.051
                                                ],
                                                [
                                                    3.381,
                                                    -0.076
                                                ],
                                                [
                                                    1.716,
                                                    -0.051
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.754,
                                                    0.076
                                                ],
                                                [
                                                    2.084,
                                                    -0.089
                                                ],
                                                [
                                                    1.385,
                                                    0.039
                                                ],
                                                [
                                                    1.614,
                                                    -0.089
                                                ],
                                                [
                                                    1.881,
                                                    -0.051
                                                ],
                                                [
                                                    3.483,
                                                    -0.242
                                                ],
                                                [
                                                    3.495,
                                                    -0.28
                                                ],
                                                [
                                                    3.508,
                                                    -0.343
                                                ],
                                                [
                                                    3.508,
                                                    -0.394
                                                ],
                                                [
                                                    1.856,
                                                    -0.254
                                                ],
                                                [
                                                    1.665,
                                                    -0.165
                                                ],
                                                [
                                                    2.745,
                                                    -0.445
                                                ],
                                                [
                                                    0.763,
                                                    -0.14
                                                ],
                                                [
                                                    3.533,
                                                    -0.686
                                                ],
                                                [
                                                    -0.025,
                                                    -0.025
                                                ],
                                                [
                                                    0.026,
                                                    0
                                                ],
                                                [
                                                    1.246,
                                                    -0.28
                                                ],
                                                [
                                                    2.784,
                                                    -0.419
                                                ],
                                                [
                                                    2.974,
                                                    -0.509
                                                ],
                                                [
                                                    0.267,
                                                    0.102
                                                ],
                                                [
                                                    0.419,
                                                    0.165
                                                ],
                                                [
                                                    0.623,
                                                    0.635
                                                ],
                                                [
                                                    1.551,
                                                    0.483
                                                ],
                                                [
                                                    0.508,
                                                    0.038
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.012,
                                                    0.598
                                                ],
                                                [
                                                    1.004,
                                                    0.05
                                                ],
                                                [
                                                    2.237,
                                                    0.19
                                                ],
                                                [
                                                    2.123,
                                                    -0.064
                                                ],
                                                [
                                                    1.36,
                                                    -0.241
                                                ],
                                                [
                                                    1.411,
                                                    -0.114
                                                ],
                                                [
                                                    1.767,
                                                    -0.026
                                                ],
                                                [
                                                    1.754,
                                                    -0.165
                                                ],
                                                [
                                                    1.017,
                                                    -0.153
                                                ],
                                                [
                                                    0.508,
                                                    -0.013
                                                ],
                                                [
                                                    0.623,
                                                    -0.051
                                                ],
                                                [
                                                    1.932,
                                                    -0.114
                                                ],
                                                [
                                                    1.055,
                                                    -0.013
                                                ],
                                                [
                                                    3.292,
                                                    -0.063
                                                ],
                                                [
                                                    2.72,
                                                    0.216
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.381,
                                                    0.839
                                                ],
                                                [
                                                    3,
                                                    1.525
                                                ],
                                                [
                                                    1.818,
                                                    1.677
                                                ],
                                                [
                                                    1.513,
                                                    2.339
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.068,
                                                    2.555
                                                ],
                                                [
                                                    0.559,
                                                    2.962
                                                ],
                                                [
                                                    0.025,
                                                    0.637
                                                ],
                                                [
                                                    -0.031,
                                                    1.817
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    251.464,
                                                    -96.953
                                                ],
                                                [
                                                    250.539,
                                                    -90.457
                                                ],
                                                [
                                                    249.935,
                                                    -86.877
                                                ],
                                                [
                                                    249.489,
                                                    -83.668
                                                ],
                                                [
                                                    248.353,
                                                    -76.81
                                                ],
                                                [
                                                    246.101,
                                                    -69.236
                                                ],
                                                [
                                                    245.28,
                                                    -66.715
                                                ],
                                                [
                                                    242.028,
                                                    -57.412
                                                ],
                                                [
                                                    241.617,
                                                    -56.409
                                                ],
                                                [
                                                    237.945,
                                                    -48.038
                                                ],
                                                [
                                                    234.76,
                                                    -42.757
                                                ],
                                                [
                                                    232.588,
                                                    -39.335
                                                ],
                                                [
                                                    231.009,
                                                    -36.666
                                                ],
                                                [
                                                    227.244,
                                                    -30.628
                                                ],
                                                [
                                                    225.648,
                                                    -28.357
                                                ],
                                                [
                                                    221.213,
                                                    -22.358
                                                ],
                                                [
                                                    219.454,
                                                    -20.219
                                                ],
                                                [
                                                    214.556,
                                                    -14.553
                                                ],
                                                [
                                                    210.145,
                                                    -10.75
                                                ],
                                                [
                                                    206.725,
                                                    -7.931
                                                ],
                                                [
                                                    206.717,
                                                    -7.925
                                                ],
                                                [
                                                    202.863,
                                                    -4.029
                                                ],
                                                [
                                                    199.542,
                                                    -0.642
                                                ],
                                                [
                                                    196.635,
                                                    1.91
                                                ],
                                                [
                                                    191.844,
                                                    6.177
                                                ],
                                                [
                                                    190.858,
                                                    7.101
                                                ],
                                                [
                                                    184.359,
                                                    13.324
                                                ],
                                                [
                                                    181.583,
                                                    15.975
                                                ],
                                                [
                                                    176.891,
                                                    20.604
                                                ],
                                                [
                                                    170.069,
                                                    28.6
                                                ],
                                                [
                                                    164.559,
                                                    36.218
                                                ],
                                                [
                                                    164.011,
                                                    37.024
                                                ],
                                                [
                                                    163.257,
                                                    41.489
                                                ],
                                                [
                                                    163.132,
                                                    42.097
                                                ],
                                                [
                                                    163.132,
                                                    42.11
                                                ],
                                                [
                                                    161.073,
                                                    45.033
                                                ],
                                                [
                                                    161.849,
                                                    48.82
                                                ],
                                                [
                                                    165.102,
                                                    49.024
                                                ],
                                                [
                                                    167.06,
                                                    48.172
                                                ],
                                                [
                                                    170.53,
                                                    48.007
                                                ],
                                                [
                                                    171.33,
                                                    47.702
                                                ],
                                                [
                                                    179.401,
                                                    45.058
                                                ],
                                                [
                                                    189.023,
                                                    44.614
                                                ],
                                                [
                                                    190.459,
                                                    44.588
                                                ],
                                                [
                                                    198.632,
                                                    44.842
                                                ],
                                                [
                                                    206.449,
                                                    47.066
                                                ],
                                                [
                                                    207.822,
                                                    47.537
                                                ],
                                                [
                                                    216.604,
                                                    51.185
                                                ],
                                                [
                                                    225.031,
                                                    58.493
                                                ],
                                                [
                                                    227.007,
                                                    64.522
                                                ],
                                                [
                                                    224.702,
                                                    72.868
                                                ],
                                                [
                                                    221.547,
                                                    79.419
                                                ],
                                                [
                                                    220.045,
                                                    82.249
                                                ],
                                                [
                                                    217.886,
                                                    87.096
                                                ],
                                                [
                                                    216.047,
                                                    91.237
                                                ],
                                                [
                                                    213.998,
                                                    95.404
                                                ],
                                                [
                                                    211.716,
                                                    100.004
                                                ],
                                                [
                                                    209.244,
                                                    104.06
                                                ],
                                                [
                                                    206.623,
                                                    108.322
                                                ],
                                                [
                                                    203.823,
                                                    112.944
                                                ],
                                                [
                                                    201.573,
                                                    116.593
                                                ],
                                                [
                                                    199.582,
                                                    120.085
                                                ],
                                                [
                                                    196.742,
                                                    124.949
                                                ],
                                                [
                                                    194.866,
                                                    127.962
                                                ],
                                                [
                                                    191.59,
                                                    133.069
                                                ],
                                                [
                                                    187.763,
                                                    138.062
                                                ],
                                                [
                                                    185.724,
                                                    140.636
                                                ],
                                                [
                                                    181.177,
                                                    146.004
                                                ],
                                                [
                                                    179.533,
                                                    147.871
                                                ],
                                                [
                                                    177.599,
                                                    150.258
                                                ],
                                                [
                                                    175.517,
                                                    152.765
                                                ],
                                                [
                                                    168.647,
                                                    159.516
                                                ],
                                                [
                                                    167.658,
                                                    160.455
                                                ],
                                                [
                                                    159.466,
                                                    167.879
                                                ],
                                                [
                                                    154.643,
                                                    171.71
                                                ],
                                                [
                                                    150.72,
                                                    174.768
                                                ],
                                                [
                                                    147.428,
                                                    177.498
                                                ],
                                                [
                                                    142.076,
                                                    181.88
                                                ],
                                                [
                                                    137.504,
                                                    185.974
                                                ],
                                                [
                                                    133.68,
                                                    189.409
                                                ],
                                                [
                                                    129.942,
                                                    191.908
                                                ],
                                                [
                                                    125.036,
                                                    195.234
                                                ],
                                                [
                                                    119.189,
                                                    199.965
                                                ],
                                                [
                                                    116.926,
                                                    201.822
                                                ],
                                                [
                                                    113.209,
                                                    205.108
                                                ],
                                                [
                                                    109.086,
                                                    208.657
                                                ],
                                                [
                                                    100.57,
                                                    214.615
                                                ],
                                                [
                                                    91.744,
                                                    220.086
                                                ],
                                                [
                                                    86.357,
                                                    222.819
                                                ],
                                                [
                                                    83.575,
                                                    224.155
                                                ],
                                                [
                                                    82.341,
                                                    224.622
                                                ],
                                                [
                                                    80.743,
                                                    225.466
                                                ],
                                                [
                                                    74.87,
                                                    228.455
                                                ],
                                                [
                                                    65.977,
                                                    232.312
                                                ],
                                                [
                                                    60.013,
                                                    234.397
                                                ],
                                                [
                                                    56.814,
                                                    235.458
                                                ],
                                                [
                                                    47.59,
                                                    238.417
                                                ],
                                                [
                                                    46.655,
                                                    238.782
                                                ],
                                                [
                                                    46.131,
                                                    239.085
                                                ],
                                                [
                                                    45.589,
                                                    239.454
                                                ],
                                                [
                                                    40.434,
                                                    240.816
                                                ],
                                                [
                                                    38.518,
                                                    240.892
                                                ],
                                                [
                                                    30.291,
                                                    242.124
                                                ],
                                                [
                                                    27.103,
                                                    242.495
                                                ],
                                                [
                                                    23.774,
                                                    242.956
                                                ],
                                                [
                                                    16.169,
                                                    243.75
                                                ],
                                                [
                                                    13.989,
                                                    243.429
                                                ],
                                                [
                                                    13.045,
                                                    243.513
                                                ],
                                                [
                                                    6.731,
                                                    242.891
                                                ],
                                                [
                                                    3.781,
                                                    242.585
                                                ],
                                                [
                                                    -0.51,
                                                    241.997
                                                ],
                                                [
                                                    -5.849,
                                                    239.783
                                                ],
                                                [
                                                    -8.369,
                                                    238.586
                                                ],
                                                [
                                                    -10.365,
                                                    237.709
                                                ],
                                                [
                                                    -15.987,
                                                    234.874
                                                ],
                                                [
                                                    -22.534,
                                                    229.589
                                                ],
                                                [
                                                    -25.772,
                                                    225.526
                                                ],
                                                [
                                                    -25.884,
                                                    223.49
                                                ],
                                                [
                                                    -25.782,
                                                    222.799
                                                ],
                                                [
                                                    -24.394,
                                                    222.29
                                                ],
                                                [
                                                    -24.331,
                                                    222.265
                                                ],
                                                [
                                                    -22.539,
                                                    221.629
                                                ],
                                                [
                                                    -20.429,
                                                    220.879
                                                ],
                                                [
                                                    -12.256,
                                                    217.791
                                                ],
                                                [
                                                    -10.133,
                                                    216.977
                                                ],
                                                [
                                                    -4.02,
                                                    214.867
                                                ],
                                                [
                                                    -3.486,
                                                    214.308
                                                ],
                                                [
                                                    -3.054,
                                                    214.066
                                                ],
                                                [
                                                    -2.609,
                                                    213.799
                                                ],
                                                [
                                                    -1.732,
                                                    213.354
                                                ],
                                                [
                                                    -0.906,
                                                    213.291
                                                ],
                                                [
                                                    -0.448,
                                                    213.354
                                                ],
                                                [
                                                    1.738,
                                                    212.16
                                                ],
                                                [
                                                    7.318,
                                                    209.096
                                                ],
                                                [
                                                    11.487,
                                                    206.897
                                                ],
                                                [
                                                    16.317,
                                                    204.165
                                                ],
                                                [
                                                    16.355,
                                                    204.14
                                                ],
                                                [
                                                    21.159,
                                                    201.47
                                                ],
                                                [
                                                    24.871,
                                                    198.776
                                                ],
                                                [
                                                    29.637,
                                                    195.458
                                                ],
                                                [
                                                    30.158,
                                                    195.09
                                                ],
                                                [
                                                    30.247,
                                                    195.039
                                                ],
                                                [
                                                    30.387,
                                                    195.191
                                                ],
                                                [
                                                    30.425,
                                                    195.23
                                                ],
                                                [
                                                    31.175,
                                                    194.34
                                                ],
                                                [
                                                    31.505,
                                                    194.175
                                                ],
                                                [
                                                    32.522,
                                                    193.26
                                                ],
                                                [
                                                    32.764,
                                                    193.107
                                                ],
                                                [
                                                    33.31,
                                                    193.132
                                                ],
                                                [
                                                    36.856,
                                                    190.082
                                                ],
                                                [
                                                    42.106,
                                                    186.256
                                                ],
                                                [
                                                    50.532,
                                                    178.948
                                                ],
                                                [
                                                    50.583,
                                                    178.897
                                                ],
                                                [
                                                    58.565,
                                                    171.296
                                                ],
                                                [
                                                    59.62,
                                                    169.936
                                                ],
                                                [
                                                    60.052,
                                                    169.314
                                                ],
                                                [
                                                    60.192,
                                                    169.123
                                                ],
                                                [
                                                    60.23,
                                                    169.072
                                                ],
                                                [
                                                    60.777,
                                                    168.398
                                                ],
                                                [
                                                    61.59,
                                                    167.598
                                                ],
                                                [
                                                    62.62,
                                                    166.619
                                                ],
                                                [
                                                    63.713,
                                                    165.577
                                                ],
                                                [
                                                    64.056,
                                                    165.259
                                                ],
                                                [
                                                    69.75,
                                                    158.637
                                                ],
                                                [
                                                    75.267,
                                                    151.875
                                                ],
                                                [
                                                    76.906,
                                                    149.6
                                                ],
                                                [
                                                    77.135,
                                                    149.321
                                                ],
                                                [
                                                    80.554,
                                                    144.923
                                                ],
                                                [
                                                    81.52,
                                                    143.474
                                                ],
                                                [
                                                    81.787,
                                                    143.042
                                                ],
                                                [
                                                    81.8,
                                                    143.029
                                                ],
                                                [
                                                    81.952,
                                                    142.851
                                                ],
                                                [
                                                    81.965,
                                                    142.787
                                                ],
                                                [
                                                    82.13,
                                                    142.546
                                                ],
                                                [
                                                    82.359,
                                                    142.253
                                                ],
                                                [
                                                    82.677,
                                                    142.267
                                                ],
                                                [
                                                    82.956,
                                                    141.44
                                                ],
                                                [
                                                    83.452,
                                                    140.753
                                                ],
                                                [
                                                    83.681,
                                                    140.067
                                                ],
                                                [
                                                    84.418,
                                                    139.394
                                                ],
                                                [
                                                    84.011,
                                                    138.059
                                                ],
                                                [
                                                    84.011,
                                                    138.034
                                                ],
                                                [
                                                    83.897,
                                                    137.691
                                                ],
                                                [
                                                    84.087,
                                                    137.348
                                                ],
                                                [
                                                    83.503,
                                                    137.106
                                                ],
                                                [
                                                    83.439,
                                                    137.042
                                                ],
                                                [
                                                    83.02,
                                                    136.763
                                                ],
                                                [
                                                    80.465,
                                                    133.788
                                                ],
                                                [
                                                    80.046,
                                                    133.255
                                                ],
                                                [
                                                    76.576,
                                                    128.844
                                                ],
                                                [
                                                    73.538,
                                                    122.87
                                                ],
                                                [
                                                    72.381,
                                                    120.926
                                                ],
                                                [
                                                    71.848,
                                                    119.261
                                                ],
                                                [
                                                    71.301,
                                                    118.193
                                                ],
                                                [
                                                    71.085,
                                                    116.846
                                                ],
                                                [
                                                    68.861,
                                                    111.444
                                                ],
                                                [
                                                    67.666,
                                                    106.881
                                                ],
                                                [
                                                    66.395,
                                                    100.627
                                                ],
                                                [
                                                    66.395,
                                                    100.577
                                                ],
                                                [
                                                    66.331,
                                                    99.979
                                                ],
                                                [
                                                    66.328,
                                                    99.961
                                                ],
                                                [
                                                    66.274,
                                                    98.51
                                                ],
                                                [
                                                    65.331,
                                                    88.193
                                                ],
                                                [
                                                    64.875,
                                                    78.408
                                                ],
                                                [
                                                    64.611,
                                                    68.615
                                                ],
                                                [
                                                    64.221,
                                                    58.828
                                                ],
                                                [
                                                    63.817,
                                                    48.172
                                                ],
                                                [
                                                    63.246,
                                                    37.524
                                                ],
                                                [
                                                    62.965,
                                                    31.486
                                                ],
                                                [
                                                    63.065,
                                                    25.968
                                                ],
                                                [
                                                    62.546,
                                                    23.739
                                                ],
                                                [
                                                    62.213,
                                                    19.719
                                                ],
                                                [
                                                    62.302,
                                                    13.105
                                                ],
                                                [
                                                    61.921,
                                                    4.03
                                                ],
                                                [
                                                    62.264,
                                                    -5.071
                                                ],
                                                [
                                                    62.239,
                                                    -14.222
                                                ],
                                                [
                                                    62.912,
                                                    -18.162
                                                ],
                                                [
                                                    63.675,
                                                    -18.353
                                                ],
                                                [
                                                    62.874,
                                                    -20.335
                                                ],
                                                [
                                                    63.065,
                                                    -29.868
                                                ],
                                                [
                                                    63.154,
                                                    -39.414
                                                ],
                                                [
                                                    64.743,
                                                    -48.883
                                                ],
                                                [
                                                    64.603,
                                                    -60.119
                                                ],
                                                [
                                                    61.959,
                                                    -71.011
                                                ],
                                                [
                                                    58.235,
                                                    -81.497
                                                ],
                                                [
                                                    52.846,
                                                    -91.233
                                                ],
                                                [
                                                    46.732,
                                                    -100.588
                                                ],
                                                [
                                                    39.03,
                                                    -108.722
                                                ],
                                                [
                                                    37.911,
                                                    -108.913
                                                ],
                                                [
                                                    30.222,
                                                    -116.413
                                                ],
                                                [
                                                    20.88,
                                                    -121.725
                                                ],
                                                [
                                                    11.105,
                                                    -126.034
                                                ],
                                                [
                                                    1.166,
                                                    -130.076
                                                ],
                                                [
                                                    -9.523,
                                                    -131.194
                                                ],
                                                [
                                                    -20.149,
                                                    -132.415
                                                ],
                                                [
                                                    -30.876,
                                                    -131.932
                                                ],
                                                [
                                                    -41.49,
                                                    -130.114
                                                ],
                                                [
                                                    -51.556,
                                                    -126.339
                                                ],
                                                [
                                                    -61.076,
                                                    -121.458
                                                ],
                                                [
                                                    -70.265,
                                                    -115.942
                                                ],
                                                [
                                                    -77.053,
                                                    -109.777
                                                ],
                                                [
                                                    -83.764,
                                                    -103.511
                                                ],
                                                [
                                                    -88.517,
                                                    -96.254
                                                ],
                                                [
                                                    -92.013,
                                                    -105.786
                                                ],
                                                [
                                                    -96.321,
                                                    -115.433
                                                ],
                                                [
                                                    -102.562,
                                                    -123.886
                                                ],
                                                [
                                                    -110.252,
                                                    -130.508
                                                ],
                                                [
                                                    -119.861,
                                                    -134.066
                                                ],
                                                [
                                                    -130.042,
                                                    -134.474
                                                ],
                                                [
                                                    -140.222,
                                                    -134.677
                                                ],
                                                [
                                                    -150.047,
                                                    -131.855
                                                ],
                                                [
                                                    -158.436,
                                                    -126.656
                                                ],
                                                [
                                                    -166.113,
                                                    -120.454
                                                ],
                                                [
                                                    -171.985,
                                                    -112.51
                                                ],
                                                [
                                                    -177.146,
                                                    -103.829
                                                ],
                                                [
                                                    -182.064,
                                                    -94.945
                                                ],
                                                [
                                                    -185.763,
                                                    -85.514
                                                ],
                                                [
                                                    -189.259,
                                                    -76.49
                                                ],
                                                [
                                                    -193.631,
                                                    -67.859
                                                ],
                                                [
                                                    -193.516,
                                                    -67.656
                                                ],
                                                [
                                                    -193.516,
                                                    -67.643
                                                ],
                                                [
                                                    -193.506,
                                                    -67.628
                                                ],
                                                [
                                                    -193.612,
                                                    -67.319
                                                ],
                                                [
                                                    -194.944,
                                                    -64.892
                                                ],
                                                [
                                                    -195.004,
                                                    -64.796
                                                ],
                                                [
                                                    -195.042,
                                                    -64.732
                                                ],
                                                [
                                                    -198.74,
                                                    -59.115
                                                ],
                                                [
                                                    -203.964,
                                                    -50.751
                                                ],
                                                [
                                                    -206.385,
                                                    -47.338
                                                ],
                                                [
                                                    -208.611,
                                                    -45.592
                                                ],
                                                [
                                                    -211.684,
                                                    -42.053
                                                ],
                                                [
                                                    -214.481,
                                                    -38.916
                                                ],
                                                [
                                                    -216.814,
                                                    -35.946
                                                ],
                                                [
                                                    -219.999,
                                                    -32.012
                                                ],
                                                [
                                                    -224.013,
                                                    -28.018
                                                ],
                                                [
                                                    -226.308,
                                                    -25.808
                                                ],
                                                [
                                                    -235.305,
                                                    -17.334
                                                ],
                                                [
                                                    -237.36,
                                                    -15.555
                                                ],
                                                [
                                                    -239.906,
                                                    -13.386
                                                ],
                                                [
                                                    -244.305,
                                                    -10.499
                                                ],
                                                [
                                                    -247.594,
                                                    -8.435
                                                ],
                                                [
                                                    -250.141,
                                                    -6.682
                                                ],
                                                [
                                                    -255.148,
                                                    -3.406
                                                ],
                                                [
                                                    -257.262,
                                                    -2.193
                                                ],
                                                [
                                                    -260.534,
                                                    -0.343
                                                ],
                                                [
                                                    -260.334,
                                                    -2.49
                                                ],
                                                [
                                                    -258.707,
                                                    -8.325
                                                ],
                                                [
                                                    -257.678,
                                                    -11.426
                                                ],
                                                [
                                                    -256.61,
                                                    -15.646
                                                ],
                                                [
                                                    -255.161,
                                                    -20.755
                                                ],
                                                [
                                                    -252.962,
                                                    -24.708
                                                ],
                                                [
                                                    -250.28,
                                                    -29.462
                                                ],
                                                [
                                                    -245.73,
                                                    -38.295
                                                ],
                                                [
                                                    -244.79,
                                                    -39.985
                                                ],
                                                [
                                                    -240.633,
                                                    -47.001
                                                ],
                                                [
                                                    -238.117,
                                                    -51.273
                                                ],
                                                [
                                                    -235.371,
                                                    -55.81
                                                ],
                                                [
                                                    -232.384,
                                                    -59.572
                                                ],
                                                [
                                                    -228.902,
                                                    -63.932
                                                ],
                                                [
                                                    -225.889,
                                                    -68.736
                                                ],
                                                [
                                                    -223.424,
                                                    -72.677
                                                ],
                                                [
                                                    -222.674,
                                                    -73.757
                                                ],
                                                [
                                                    -217.539,
                                                    -81.23
                                                ],
                                                [
                                                    -215.073,
                                                    -84.522
                                                ],
                                                [
                                                    -211.336,
                                                    -89.683
                                                ],
                                                [
                                                    -208.451,
                                                    -95.25
                                                ],
                                                [
                                                    -206.544,
                                                    -99.05
                                                ],
                                                [
                                                    -204.524,
                                                    -102.418
                                                ],
                                                [
                                                    -201.206,
                                                    -108.138
                                                ],
                                                [
                                                    -198.931,
                                                    -114.036
                                                ],
                                                [
                                                    -197.482,
                                                    -118.014
                                                ],
                                                [
                                                    -195.995,
                                                    -121.28
                                                ],
                                                [
                                                    -193.224,
                                                    -127.635
                                                ],
                                                [
                                                    -190.682,
                                                    -135.172
                                                ],
                                                [
                                                    -189.894,
                                                    -137.613
                                                ],
                                                [
                                                    -188.42,
                                                    -141.337
                                                ],
                                                [
                                                    -186.132,
                                                    -147.514
                                                ],
                                                [
                                                    -185.56,
                                                    -151.454
                                                ],
                                                [
                                                    -185.534,
                                                    -151.67
                                                ],
                                                [
                                                    -176.154,
                                                    -148.823
                                                ],
                                                [
                                                    -166.202,
                                                    -146.815
                                                ],
                                                [
                                                    -156.301,
                                                    -144.667
                                                ],
                                                [
                                                    -146.323,
                                                    -142.875
                                                ],
                                                [
                                                    -136.231,
                                                    -141.807
                                                ],
                                                [
                                                    -126.089,
                                                    -141.489
                                                ],
                                                [
                                                    -122.644,
                                                    -140.994
                                                ],
                                                [
                                                    -112.197,
                                                    -140.688
                                                ],
                                                [
                                                    -101.8,
                                                    -139.837
                                                ],
                                                [
                                                    -91.441,
                                                    -138.49
                                                ],
                                                [
                                                    -81.006,
                                                    -138.185
                                                ],
                                                [
                                                    -70.571,
                                                    -137.905
                                                ],
                                                [
                                                    -60.161,
                                                    -136.952
                                                ],
                                                [
                                                    -49.713,
                                                    -136.812
                                                ],
                                                [
                                                    -39.278,
                                                    -136.431
                                                ],
                                                [
                                                    -35.592,
                                                    -136.965
                                                ],
                                                [
                                                    -28.69,
                                                    -137.091
                                                ],
                                                [
                                                    -25.055,
                                                    -137.041
                                                ],
                                                [
                                                    -20.479,
                                                    -136.977
                                                ],
                                                [
                                                    -20.441,
                                                    -136.977
                                                ],
                                                [
                                                    -14.518,
                                                    -136.774
                                                ],
                                                [
                                                    -3.994,
                                                    -137.181
                                                ],
                                                [
                                                    6.542,
                                                    -137.091
                                                ],
                                                [
                                                    11.728,
                                                    -137.715
                                                ],
                                                [
                                                    11.741,
                                                    -137.715
                                                ],
                                                [
                                                    17.079,
                                                    -137.664
                                                ],
                                                [
                                                    23.409,
                                                    -138.236
                                                ],
                                                [
                                                    27.591,
                                                    -138.248
                                                ],
                                                [
                                                    32.458,
                                                    -138.77
                                                ],
                                                [
                                                    38.115,
                                                    -138.998
                                                ],
                                                [
                                                    48.639,
                                                    -139.596
                                                ],
                                                [
                                                    59.15,
                                                    -140.511
                                                ],
                                                [
                                                    69.623,
                                                    -141.82
                                                ],
                                                [
                                                    80.109,
                                                    -142.913
                                                ],
                                                [
                                                    85.575,
                                                    -144.057
                                                ],
                                                [
                                                    90.519,
                                                    -144.654
                                                ],
                                                [
                                                    98.552,
                                                    -146.498
                                                ],
                                                [
                                                    100.827,
                                                    -146.917
                                                ],
                                                [
                                                    111.059,
                                                    -149.179
                                                ],
                                                [
                                                    111.008,
                                                    -149.255
                                                ],
                                                [
                                                    111.084,
                                                    -149.268
                                                ],
                                                [
                                                    114.973,
                                                    -149.281
                                                ],
                                                [
                                                    123.057,
                                                    -151.492
                                                ],
                                                [
                                                    131.306,
                                                    -152.751
                                                ],
                                                [
                                                    131.992,
                                                    -151.772
                                                ],
                                                [
                                                    133.314,
                                                    -151.327
                                                ],
                                                [
                                                    135.602,
                                                    -149.929
                                                ],
                                                [
                                                    139.758,
                                                    -149.293
                                                ],
                                                [
                                                    141.296,
                                                    -149.141
                                                ],
                                                [
                                                    141.919,
                                                    -149.014
                                                ],
                                                [
                                                    151.528,
                                                    -147.603
                                                ],
                                                [
                                                    154.578,
                                                    -147.361
                                                ],
                                                [
                                                    161.62,
                                                    -147.044
                                                ],
                                                [
                                                    167.594,
                                                    -147.794
                                                ],
                                                [
                                                    171.445,
                                                    -148.353
                                                ],
                                                [
                                                    175.677,
                                                    -148.493
                                                ],
                                                [
                                                    181.168,
                                                    -148.722
                                                ],
                                                [
                                                    186.443,
                                                    -149.421
                                                ],
                                                [
                                                    189.392,
                                                    -149.853
                                                ],
                                                [
                                                    190.904,
                                                    -149.929
                                                ],
                                                [
                                                    192.76,
                                                    -150.158
                                                ],
                                                [
                                                    198.708,
                                                    -150.298
                                                ],
                                                [
                                                    201.86,
                                                    -150.336
                                                ],
                                                [
                                                    211.901,
                                                    -150.158
                                                ],
                                                [
                                                    220.214,
                                                    -148.544
                                                ],
                                                [
                                                    221.421,
                                                    -148.251
                                                ],
                                                [
                                                    230.153,
                                                    -145.112
                                                ],
                                                [
                                                    237.64,
                                                    -140.028
                                                ],
                                                [
                                                    243.359,
                                                    -132.846
                                                ],
                                                [
                                                    247.388,
                                                    -124.28
                                                ],
                                                [
                                                    248.177,
                                                    -122.348
                                                ],
                                                [
                                                    250.731,
                                                    -114.862
                                                ],
                                                [
                                                    251.672,
                                                    -104.629
                                                ],
                                                [
                                                    251.719,
                                                    -102.686
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 22",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 22,
                                    "ty": "sh",
                                    "ix": 23,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.066,
                                                    1.664
                                                ],
                                                [
                                                    0.695,
                                                    3.632
                                                ],
                                                [
                                                    1.17,
                                                    2.816
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.082,
                                                    3.221
                                                ],
                                                [
                                                    2.509,
                                                    2.319
                                                ],
                                                [
                                                    3.904,
                                                    1.996
                                                ],
                                                [
                                                    4.219,
                                                    1.039
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.61,
                                                    0.292
                                                ],
                                                [
                                                    3.583,
                                                    -0.069
                                                ],
                                                [
                                                    1.013,
                                                    -0.007
                                                ],
                                                [
                                                    2.685,
                                                    -0.198
                                                ],
                                                [
                                                    1.927,
                                                    -0.301
                                                ],
                                                [
                                                    1.526,
                                                    -0.14
                                                ],
                                                [
                                                    1.633,
                                                    -0.023
                                                ],
                                                [
                                                    1.627,
                                                    -0.124
                                                ],
                                                [
                                                    1.569,
                                                    -0.279
                                                ],
                                                [
                                                    1.328,
                                                    -0.04
                                                ],
                                                [
                                                    2.012,
                                                    0.176
                                                ],
                                                [
                                                    1.13,
                                                    0.063
                                                ],
                                                [
                                                    0.955,
                                                    0.133
                                                ],
                                                [
                                                    -0.01,
                                                    0.044
                                                ],
                                                [
                                                    0.076,
                                                    0.813
                                                ],
                                                [
                                                    0.005,
                                                    0.037
                                                ],
                                                [
                                                    0.064,
                                                    0.665
                                                ],
                                                [
                                                    0.003,
                                                    0.127
                                                ],
                                                [
                                                    0.184,
                                                    0.601
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.66,
                                                    1.319
                                                ],
                                                [
                                                    0.951,
                                                    1.195
                                                ],
                                                [
                                                    0.604,
                                                    0.607
                                                ],
                                                [
                                                    5.432,
                                                    -0.983
                                                ],
                                                [
                                                    1.472,
                                                    -0.342
                                                ],
                                                [
                                                    1.446,
                                                    -0.243
                                                ],
                                                [
                                                    1.408,
                                                    -0.258
                                                ],
                                                [
                                                    0.337,
                                                    -0.062
                                                ],
                                                [
                                                    0.665,
                                                    1.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.476,
                                                    1.18
                                                ],
                                                [
                                                    1.056,
                                                    1.897
                                                ],
                                                [
                                                    1.173,
                                                    1.448
                                                ],
                                                [
                                                    0.655,
                                                    1.022
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.132,
                                                    2.392
                                                ],
                                                [
                                                    2.015,
                                                    1.673
                                                ],
                                                [
                                                    0.647,
                                                    0.556
                                                ],
                                                [
                                                    2.83,
                                                    1.939
                                                ],
                                                [
                                                    0.729,
                                                    0.52
                                                ],
                                                [
                                                    2.381,
                                                    1.343
                                                ],
                                                [
                                                    0.986,
                                                    0.619
                                                ],
                                                [
                                                    2.215,
                                                    1.046
                                                ],
                                                [
                                                    2.792,
                                                    1.119
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.611,
                                                    0.895
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.619,
                                                    0.778
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.181,
                                                    0.389
                                                ],
                                                [
                                                    2.165,
                                                    0.562
                                                ],
                                                [
                                                    1.884,
                                                    0.251
                                                ],
                                                [
                                                    1.296,
                                                    0.292
                                                ],
                                                [
                                                    0.329,
                                                    0.052
                                                ],
                                                [
                                                    0.265,
                                                    0.062
                                                ],
                                                [
                                                    1.317,
                                                    0.407
                                                ],
                                                [
                                                    2.413,
                                                    0.418
                                                ],
                                                [
                                                    2.124,
                                                    0.076
                                                ],
                                                [
                                                    1.376,
                                                    0.17
                                                ],
                                                [
                                                    1.392,
                                                    0.254
                                                ],
                                                [
                                                    2.346,
                                                    0.183
                                                ],
                                                [
                                                    2.1,
                                                    -0.065
                                                ],
                                                [
                                                    1.475,
                                                    0.056
                                                ],
                                                [
                                                    1.531,
                                                    0.195
                                                ],
                                                [
                                                    2.311,
                                                    0
                                                ],
                                                [
                                                    0.005,
                                                    0
                                                ],
                                                [
                                                    3.42,
                                                    -0.127
                                                ],
                                                [
                                                    2.202,
                                                    -0.217
                                                ],
                                                [
                                                    1.363,
                                                    -0.099
                                                ],
                                                [
                                                    1.389,
                                                    -0.057
                                                ],
                                                [
                                                    2.298,
                                                    -0.248
                                                ],
                                                [
                                                    2.1,
                                                    -0.387
                                                ],
                                                [
                                                    1.422,
                                                    -0.204
                                                ],
                                                [
                                                    1.462,
                                                    -0.131
                                                ],
                                                [
                                                    2.218,
                                                    -0.401
                                                ],
                                                [
                                                    2.445,
                                                    -0.74
                                                ],
                                                [
                                                    1.095,
                                                    -0.301
                                                ],
                                                [
                                                    3.094,
                                                    -1.13
                                                ],
                                                [
                                                    2.191,
                                                    -1.088
                                                ],
                                                [
                                                    1.098,
                                                    -0.505
                                                ],
                                                [
                                                    1.264,
                                                    -0.466
                                                ],
                                                [
                                                    2.229,
                                                    -1.241
                                                ],
                                                [
                                                    1.929,
                                                    -1.419
                                                ],
                                                [
                                                    1.047,
                                                    -0.702
                                                ],
                                                [
                                                    0.927,
                                                    -0.591
                                                ],
                                                [
                                                    2.143,
                                                    -1.721
                                                ],
                                                [
                                                    2.375,
                                                    -2.303
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.122,
                                                    -2.516
                                                ],
                                                [
                                                    2.044,
                                                    -3.068
                                                ],
                                                [
                                                    1.365,
                                                    -2.767
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.489,
                                                    -0.903
                                                ],
                                                [
                                                    0.569,
                                                    -1.156
                                                ],
                                                [
                                                    0.112,
                                                    -0.035
                                                ],
                                                [
                                                    1.75,
                                                    -0.369
                                                ],
                                                [
                                                    1.178,
                                                    -0.509
                                                ],
                                                [
                                                    0.542,
                                                    -0.624
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.288,
                                                    -3.992
                                                ],
                                                [
                                                    -0.149,
                                                    -1.734
                                                ],
                                                [
                                                    -0.472,
                                                    -2.037
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.28,
                                                    -0.712
                                                ],
                                                [
                                                    -4.15,
                                                    -1.673
                                                ],
                                                [
                                                    0.457,
                                                    -1.066
                                                ],
                                                [
                                                    0.532,
                                                    -1.639
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.831,
                                                    -2.208
                                                ],
                                                [
                                                    0.89,
                                                    -1.905
                                                ],
                                                [
                                                    0.513,
                                                    -1.181
                                                ],
                                                [
                                                    0.524,
                                                    -1.582
                                                ],
                                                [
                                                    0.639,
                                                    -1.293
                                                ],
                                                [
                                                    1.021,
                                                    -1.626
                                                ],
                                                [
                                                    0.721,
                                                    -1.303
                                                ],
                                                [
                                                    0.7,
                                                    -1.479
                                                ],
                                                [
                                                    0.823,
                                                    -1.341
                                                ],
                                                [
                                                    1.106,
                                                    -1.403
                                                ],
                                                [
                                                    0.959,
                                                    -1.446
                                                ],
                                                [
                                                    1.651,
                                                    -2.362
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.892,
                                                    -1.521
                                                ],
                                                [
                                                    0.855,
                                                    -1.202
                                                ],
                                                [
                                                    1.061,
                                                    -1.253
                                                ],
                                                [
                                                    1.152,
                                                    -1.653
                                                ],
                                                [
                                                    0.997,
                                                    -1.776
                                                ],
                                                [
                                                    0.77,
                                                    -1.189
                                                ],
                                                [
                                                    1.403,
                                                    -2.489
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.571,
                                                    -3.38
                                                ],
                                                [
                                                    0.78,
                                                    -1.252
                                                ],
                                                [
                                                    0.86,
                                                    -2.075
                                                ],
                                                [
                                                    0.484,
                                                    -2.11
                                                ],
                                                [
                                                    0.342,
                                                    -1.133
                                                ],
                                                [
                                                    0.313,
                                                    -0.91
                                                ],
                                                [
                                                    0.409,
                                                    -2.878
                                                ],
                                                [
                                                    -0.065,
                                                    -2.674
                                                ],
                                                [
                                                    -0.096,
                                                    -1.844
                                                ],
                                                [
                                                    -0.28,
                                                    -0.635
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.144,
                                                    -4.27
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.165,
                                                    -0.597
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.144,
                                                    -3.076
                                                ],
                                                [
                                                    -0.216,
                                                    -0.495
                                                ],
                                                [
                                                    -0.115,
                                                    -0.267
                                                ],
                                                [
                                                    -0.247,
                                                    -0.614
                                                ],
                                                [
                                                    0.241,
                                                    -0.311
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.425,
                                                    -0.613
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.892,
                                                    -1.563
                                                ],
                                                [
                                                    0.294,
                                                    -0.728
                                                ],
                                                [
                                                    0.107,
                                                    -0.214
                                                ],
                                                [
                                                    0.868,
                                                    -2.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.029,
                                                    -3.363
                                                ],
                                                [
                                                    0.313,
                                                    -0.953
                                                ],
                                                [
                                                    0.553,
                                                    -2.537
                                                ],
                                                [
                                                    0.176,
                                                    -2.108
                                                ],
                                                [
                                                    0.192,
                                                    -1.263
                                                ],
                                                [
                                                    0.246,
                                                    -2.462
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.147,
                                                    -1.208
                                                ],
                                                [
                                                    0.174,
                                                    -2.183
                                                ],
                                                [
                                                    0.088,
                                                    -1.892
                                                ],
                                                [
                                                    0.102,
                                                    -1.463
                                                ],
                                                [
                                                    0.115,
                                                    -1.073
                                                ],
                                                [
                                                    0.067,
                                                    -1.721
                                                ],
                                                [
                                                    -0.028,
                                                    -0.877
                                                ],
                                                [
                                                    0.002,
                                                    -0.037
                                                ],
                                                [
                                                    -0.089,
                                                    -1.665
                                                ],
                                                [
                                                    -0.014,
                                                    -0.253
                                                ],
                                                [
                                                    0.025,
                                                    -0.102
                                                ],
                                                [
                                                    0,
                                                    -1.423
                                                ],
                                                [
                                                    -0.017,
                                                    -0.582
                                                ],
                                                [
                                                    0,
                                                    -0.377
                                                ],
                                                [
                                                    -0.292,
                                                    -3.546
                                                ],
                                                [
                                                    -0.331,
                                                    -2.25
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.521,
                                                    -2.784
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.864,
                                                    -2.986
                                                ],
                                                [
                                                    -1.017,
                                                    -2.123
                                                ],
                                                [
                                                    -0.419,
                                                    -1.03
                                                ],
                                                [
                                                    -0.216,
                                                    -0.763
                                                ],
                                                [
                                                    -0.788,
                                                    -1.525
                                                ],
                                                [
                                                    -0.61,
                                                    -1.144
                                                ],
                                                [
                                                    -0.902,
                                                    -1.067
                                                ],
                                                [
                                                    -0.419,
                                                    -0.635
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.39,
                                                    -2.542
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.139,
                                                    -2.415
                                                ],
                                                [
                                                    -2.44,
                                                    -1.195
                                                ],
                                                [
                                                    -0.991,
                                                    -0.534
                                                ],
                                                [
                                                    -0.686,
                                                    -0.381
                                                ],
                                                [
                                                    -3.114,
                                                    -1.169
                                                ],
                                                [
                                                    -3.559,
                                                    -0.865
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -4.881,
                                                    0
                                                ],
                                                [
                                                    -4.105,
                                                    0.928
                                                ],
                                                [
                                                    -3.686,
                                                    2.148
                                                ],
                                                [
                                                    -2.618,
                                                    3.292
                                                ],
                                                [
                                                    -0.902,
                                                    2.288
                                                ],
                                                [
                                                    -0.648,
                                                    -0.407
                                                ],
                                                [
                                                    -1.144,
                                                    -0.369
                                                ],
                                                [
                                                    -0.305,
                                                    -0.115
                                                ],
                                                [
                                                    -1.36,
                                                    -0.674
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.606,
                                                    -1.017
                                                ],
                                                [
                                                    -1.945,
                                                    -0.483
                                                ],
                                                [
                                                    -0.852,
                                                    -0.254
                                                ],
                                                [
                                                    -0.674,
                                                    -0.153
                                                ],
                                                [
                                                    -0.356,
                                                    -0.102
                                                ],
                                                [
                                                    -0.724,
                                                    -0.254
                                                ],
                                                [
                                                    -1.309,
                                                    -0.305
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.877,
                                                    -0.19
                                                ],
                                                [
                                                    -2.046,
                                                    -0.254
                                                ],
                                                [
                                                    -1.106,
                                                    -0.166
                                                ],
                                                [
                                                    -1.169,
                                                    -0.241
                                                ],
                                                [
                                                    -2.123,
                                                    -0.216
                                                ],
                                                [
                                                    -3.127,
                                                    -0.153
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.051,
                                                    0
                                                ],
                                                [
                                                    -2.224,
                                                    0.33
                                                ],
                                                [
                                                    -1.398,
                                                    0.076
                                                ],
                                                [
                                                    -1.576,
                                                    -0.051
                                                ],
                                                [
                                                    -2.466,
                                                    0.28
                                                ],
                                                [
                                                    -2.161,
                                                    0.547
                                                ],
                                                [
                                                    -1.398,
                                                    0.229
                                                ],
                                                [
                                                    -1.576,
                                                    0.102
                                                ],
                                                [
                                                    -2.402,
                                                    0.508
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.953,
                                                    0.229
                                                ],
                                                [
                                                    -1.309,
                                                    0.483
                                                ],
                                                [
                                                    -0.051,
                                                    0.025
                                                ],
                                                [
                                                    -0.14,
                                                    -0.241
                                                ],
                                                [
                                                    -2.288,
                                                    -2.402
                                                ],
                                                [
                                                    -2.783,
                                                    -1.92
                                                ],
                                                [
                                                    -2.491,
                                                    -1.081
                                                ],
                                                [
                                                    -0.61,
                                                    -0.279
                                                ],
                                                [
                                                    -0.737,
                                                    -0.369
                                                ],
                                                [
                                                    -2.796,
                                                    -0.724
                                                ],
                                                [
                                                    -1.932,
                                                    -0.178
                                                ],
                                                [
                                                    -0.826,
                                                    -0.115
                                                ],
                                                [
                                                    -3.19,
                                                    -0.076
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.699,
                                                    0
                                                ],
                                                [
                                                    -3.101,
                                                    0.444
                                                ],
                                                [
                                                    -1.068,
                                                    0.14
                                                ],
                                                [
                                                    -1.017,
                                                    0.114
                                                ],
                                                [
                                                    -2.568,
                                                    0.483
                                                ],
                                                [
                                                    -0.648,
                                                    0.14
                                                ],
                                                [
                                                    -2.923,
                                                    0.814
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.559,
                                                    0.483
                                                ],
                                                [
                                                    -2.364,
                                                    0.814
                                                ],
                                                [
                                                    -1.004,
                                                    0.331
                                                ],
                                                [
                                                    -2.237,
                                                    0.902
                                                ],
                                                [
                                                    -3.216,
                                                    1.5
                                                ],
                                                [
                                                    -2.059,
                                                    1.093
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.216,
                                                    0.076
                                                ],
                                                [
                                                    -0.165,
                                                    0.089
                                                ],
                                                [
                                                    -1.182,
                                                    0.559
                                                ],
                                                [
                                                    -2.085,
                                                    1.22
                                                ],
                                                [
                                                    -2.898,
                                                    1.907
                                                ],
                                                [
                                                    -3.317,
                                                    2.44
                                                ],
                                                [
                                                    -1.576,
                                                    1.462
                                                ],
                                                [
                                                    -1.106,
                                                    0.902
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.919,
                                                    1.5
                                                ],
                                                [
                                                    -1.436,
                                                    0.902
                                                ],
                                                [
                                                    -1.538,
                                                    1.195
                                                ],
                                                [
                                                    -1.462,
                                                    1.398
                                                ],
                                                [
                                                    -1.258,
                                                    0.991
                                                ],
                                                [
                                                    -1.856,
                                                    1.551
                                                ],
                                                [
                                                    -1.08,
                                                    0.877
                                                ],
                                                [
                                                    -1.22,
                                                    0.915
                                                ],
                                                [
                                                    -1.779,
                                                    1.55
                                                ],
                                                [
                                                    -2.606,
                                                    2.466
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.364,
                                                    2.517
                                                ],
                                                [
                                                    -0.839,
                                                    1.081
                                                ],
                                                [
                                                    -0.547,
                                                    0.623
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.614,
                                                    2.084
                                                ],
                                                [
                                                    -0.648,
                                                    0.813
                                                ],
                                                [
                                                    -1.36,
                                                    1.957
                                                ],
                                                [
                                                    -1.131,
                                                    1.856
                                                ],
                                                [
                                                    -0.61,
                                                    0.941
                                                ],
                                                [
                                                    -0.991,
                                                    1.779
                                                ],
                                                [
                                                    -0.635,
                                                    1.081
                                                ],
                                                [
                                                    -0.712,
                                                    1.118
                                                ],
                                                [
                                                    -0.966,
                                                    1.754
                                                ],
                                                [
                                                    -0.775,
                                                    1.195
                                                ],
                                                [
                                                    -0.928,
                                                    1.741
                                                ],
                                                [
                                                    -0.813,
                                                    1.677
                                                ],
                                                [
                                                    -0.648,
                                                    1.271
                                                ],
                                                [
                                                    -0.674,
                                                    1.614
                                                ],
                                                [
                                                    -0.623,
                                                    1.233
                                                ],
                                                [
                                                    -0.47,
                                                    0.877
                                                ],
                                                [
                                                    -1.042,
                                                    2.911
                                                ],
                                                [
                                                    -0.153,
                                                    4.258
                                                ],
                                                [
                                                    0.045,
                                                    0.767
                                                ],
                                                [
                                                    -0.006,
                                                    0.168
                                                ],
                                                [
                                                    2.466,
                                                    4.218
                                                ],
                                                [
                                                    5.999,
                                                    3.383
                                                ],
                                                [
                                                    3.49,
                                                    1.189
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.492,
                                                    0.534
                                                ],
                                                [
                                                    3.252,
                                                    -0.077
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.321,
                                                    -0.009
                                                ],
                                                [
                                                    -0.026,
                                                    0.029
                                                ],
                                                [
                                                    -1.474,
                                                    1.373
                                                ],
                                                [
                                                    -0.991,
                                                    0.992
                                                ],
                                                [
                                                    -2.084,
                                                    1.945
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.487,
                                                    1.284
                                                ],
                                                [
                                                    -0.991,
                                                    0.902
                                                ],
                                                [
                                                    -1.233,
                                                    1.347
                                                ],
                                                [
                                                    -0.979,
                                                    0.877
                                                ],
                                                [
                                                    -1.017,
                                                    0.801
                                                ],
                                                [
                                                    -1.754,
                                                    1.805
                                                ],
                                                [
                                                    -1.729,
                                                    2.11
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.551,
                                                    2.224
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.322,
                                                    2.262
                                                ],
                                                [
                                                    -0.509,
                                                    0.851
                                                ],
                                                [
                                                    -0.674,
                                                    1.017
                                                ],
                                                [
                                                    -1.144,
                                                    2.288
                                                ],
                                                [
                                                    -1.22,
                                                    3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.055,
                                                    3.305
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.686,
                                                    2.948
                                                ],
                                                [
                                                    -0.343,
                                                    2.567
                                                ],
                                                [
                                                    -0.152,
                                                    1.004
                                                ],
                                                [
                                                    -0.203,
                                                    1.106
                                                ],
                                                [
                                                    -0.178,
                                                    2.669
                                                ],
                                                [
                                                    0.045,
                                                    2.926
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.179,
                                                    -4.489
                                                ],
                                                [
                                                    -0.692,
                                                    -3.619
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.427,
                                                    -3.541
                                                ],
                                                [
                                                    -2.594,
                                                    -4.009
                                                ],
                                                [
                                                    -2.787,
                                                    -2.574
                                                ],
                                                [
                                                    -3.247,
                                                    -1.659
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.177,
                                                    -0.794
                                                ],
                                                [
                                                    -3.717,
                                                    -0.301
                                                ],
                                                [
                                                    -1.002,
                                                    0.019
                                                ],
                                                [
                                                    -2.549,
                                                    0.02
                                                ],
                                                [
                                                    -2.076,
                                                    0.154
                                                ],
                                                [
                                                    -1.531,
                                                    0.239
                                                ],
                                                [
                                                    -1.472,
                                                    0.132
                                                ],
                                                [
                                                    -1.641,
                                                    0.022
                                                ],
                                                [
                                                    -1.75,
                                                    0.132
                                                ],
                                                [
                                                    -1.577,
                                                    0.281
                                                ],
                                                [
                                                    -1.838,
                                                    0.045
                                                ],
                                                [
                                                    -1.146,
                                                    -0.1
                                                ],
                                                [
                                                    -0.962,
                                                    -0.052
                                                ],
                                                [
                                                    0.018,
                                                    -0.068
                                                ],
                                                [
                                                    0.318,
                                                    -1.385
                                                ],
                                                [
                                                    -0.007,
                                                    -0.037
                                                ],
                                                [
                                                    0.147,
                                                    -1.088
                                                ],
                                                [
                                                    -0.016,
                                                    -0.143
                                                ],
                                                [
                                                    0,
                                                    -1.236
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.272,
                                                    -1.535
                                                ],
                                                [
                                                    -0.486,
                                                    -1.002
                                                ],
                                                [
                                                    -0.208,
                                                    -0.366
                                                ],
                                                [
                                                    -3.957,
                                                    -3.873
                                                ],
                                                [
                                                    -1.491,
                                                    0.271
                                                ],
                                                [
                                                    -1.438,
                                                    0.333
                                                ],
                                                [
                                                    -1.398,
                                                    0.237
                                                ],
                                                [
                                                    -0.337,
                                                    0.063
                                                ],
                                                [
                                                    -0.649,
                                                    -1.195
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.478,
                                                    -0.918
                                                ],
                                                [
                                                    -0.665,
                                                    -1.653
                                                ],
                                                [
                                                    -0.989,
                                                    -1.774
                                                ],
                                                [
                                                    -0.858,
                                                    -1.054
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.424,
                                                    -2.285
                                                ],
                                                [
                                                    -1.854,
                                                    -2.079
                                                ],
                                                [
                                                    -0.644,
                                                    -0.534
                                                ],
                                                [
                                                    -2.75,
                                                    -2.363
                                                ],
                                                [
                                                    -0.727,
                                                    -0.498
                                                ],
                                                [
                                                    -1.999,
                                                    -1.424
                                                ],
                                                [
                                                    -0.983,
                                                    -0.554
                                                ],
                                                [
                                                    -1.86,
                                                    -1.167
                                                ],
                                                [
                                                    -2.72,
                                                    -1.287
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.576,
                                                    -1.034
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.597,
                                                    -0.896
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.165,
                                                    -0.347
                                                ],
                                                [
                                                    -1.972,
                                                    -0.651
                                                ],
                                                [
                                                    -1.993,
                                                    -0.516
                                                ],
                                                [
                                                    -1.472,
                                                    -0.197
                                                ],
                                                [
                                                    -0.649,
                                                    -0.147
                                                ],
                                                [
                                                    -0.139,
                                                    -0.02
                                                ],
                                                [
                                                    -1.312,
                                                    -0.305
                                                ],
                                                [
                                                    -2.116,
                                                    -0.653
                                                ],
                                                [
                                                    -2.274,
                                                    -0.394
                                                ],
                                                [
                                                    -1.542,
                                                    -0.055
                                                ],
                                                [
                                                    -1.382,
                                                    -0.171
                                                ],
                                                [
                                                    -2.127,
                                                    -0.387
                                                ],
                                                [
                                                    -2.255,
                                                    -0.178
                                                ],
                                                [
                                                    -1.467,
                                                    0.045
                                                ],
                                                [
                                                    -1.36,
                                                    -0.052
                                                ],
                                                [
                                                    -2.082,
                                                    -0.266
                                                ],
                                                [
                                                    -0.003,
                                                    0
                                                ],
                                                [
                                                    -3.923,
                                                    0.001
                                                ],
                                                [
                                                    -2.317,
                                                    0.085
                                                ],
                                                [
                                                    -1.357,
                                                    0.134
                                                ],
                                                [
                                                    -1.379,
                                                    0.099
                                                ],
                                                [
                                                    -2.18,
                                                    0.091
                                                ],
                                                [
                                                    -2.253,
                                                    0.243
                                                ],
                                                [
                                                    -1.414,
                                                    0.259
                                                ],
                                                [
                                                    -1.448,
                                                    0.208
                                                ],
                                                [
                                                    -2.098,
                                                    0.186
                                                ],
                                                [
                                                    -2.653,
                                                    0.479
                                                ],
                                                [
                                                    -1.082,
                                                    0.327
                                                ],
                                                [
                                                    -4.214,
                                                    1.157
                                                ],
                                                [
                                                    -2.458,
                                                    0.899
                                                ],
                                                [
                                                    -1.077,
                                                    0.536
                                                ],
                                                [
                                                    -1.21,
                                                    0.554
                                                ],
                                                [
                                                    -2.162,
                                                    0.796
                                                ],
                                                [
                                                    -2.261,
                                                    1.261
                                                ],
                                                [
                                                    -1.021,
                                                    0.751
                                                ],
                                                [
                                                    -0.914,
                                                    0.61
                                                ],
                                                [
                                                    -2.167,
                                                    1.377
                                                ],
                                                [
                                                    -2.726,
                                                    2.186
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.199,
                                                    3.093
                                                ],
                                                [
                                                    -2.504,
                                                    2.97
                                                ],
                                                [
                                                    -1.844,
                                                    2.762
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.457,
                                                    0.913
                                                ],
                                                [
                                                    -0.591,
                                                    1.095
                                                ],
                                                [
                                                    -0.107,
                                                    0.027
                                                ],
                                                [
                                                    -1.844,
                                                    -0.255
                                                ],
                                                [
                                                    -0.823,
                                                    -0.107
                                                ],
                                                [
                                                    -1.665,
                                                    0.696
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.341,
                                                    1.705
                                                ],
                                                [
                                                    -0.574,
                                                    1.89
                                                ],
                                                [
                                                    -0.217,
                                                    2.306
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.178,
                                                    0.673
                                                ],
                                                [
                                                    1.771,
                                                    4.217
                                                ],
                                                [
                                                    -0.368,
                                                    1.008
                                                ],
                                                [
                                                    -0.631,
                                                    1.482
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.783,
                                                    2.458
                                                ],
                                                [
                                                    -0.705,
                                                    1.869
                                                ],
                                                [
                                                    -0.558,
                                                    1.189
                                                ],
                                                [
                                                    -0.729,
                                                    1.686
                                                ],
                                                [
                                                    -0.545,
                                                    1.646
                                                ],
                                                [
                                                    -0.783,
                                                    1.583
                                                ],
                                                [
                                                    -0.812,
                                                    1.293
                                                ],
                                                [
                                                    -0.807,
                                                    1.456
                                                ],
                                                [
                                                    -0.778,
                                                    1.639
                                                ],
                                                [
                                                    -0.836,
                                                    1.364
                                                ],
                                                [
                                                    -1.005,
                                                    1.272
                                                ],
                                                [
                                                    -1.649,
                                                    2.486
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.098,
                                                    1.573
                                                ],
                                                [
                                                    -0.847,
                                                    1.436
                                                ],
                                                [
                                                    -0.866,
                                                    1.214
                                                ],
                                                [
                                                    -1.21,
                                                    1.434
                                                ],
                                                [
                                                    -1.264,
                                                    1.818
                                                ],
                                                [
                                                    -0.703,
                                                    1.249
                                                ],
                                                [
                                                    -1.641,
                                                    2.533
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.763,
                                                    3.105
                                                ],
                                                [
                                                    -0.529,
                                                    1.143
                                                ],
                                                [
                                                    -1.066,
                                                    1.71
                                                ],
                                                [
                                                    -0.97,
                                                    2.349
                                                ],
                                                [
                                                    -0.267,
                                                    1.174
                                                ],
                                                [
                                                    -0.281,
                                                    0.919
                                                ],
                                                [
                                                    -0.842,
                                                    2.452
                                                ],
                                                [
                                                    -0.293,
                                                    2.119
                                                ],
                                                [
                                                    -0.042,
                                                    1.546
                                                ],
                                                [
                                                    0.051,
                                                    1.106
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.331,
                                                    3.749
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.14,
                                                    0.572
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.813,
                                                    2.847
                                                ],
                                                [
                                                    0.191,
                                                    0.508
                                                ],
                                                [
                                                    0.127,
                                                    0.254
                                                ],
                                                [
                                                    0.232,
                                                    0.614
                                                ],
                                                [
                                                    -0.228,
                                                    0.404
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.414,
                                                    0.544
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.895,
                                                    1.297
                                                ],
                                                [
                                                    -0.385,
                                                    0.679
                                                ],
                                                [
                                                    -0.107,
                                                    0.269
                                                ],
                                                [
                                                    -0.981,
                                                    1.903
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.285,
                                                    3.097
                                                ],
                                                [
                                                    -0.291,
                                                    0.957
                                                ],
                                                [
                                                    -0.756,
                                                    2.318
                                                ],
                                                [
                                                    -0.5,
                                                    2.27
                                                ],
                                                [
                                                    -0.107,
                                                    1.284
                                                ],
                                                [
                                                    -0.396,
                                                    2.566
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.131,
                                                    1.212
                                                ],
                                                [
                                                    -0.265,
                                                    2.181
                                                ],
                                                [
                                                    -0.15,
                                                    1.895
                                                ],
                                                [
                                                    -0.07,
                                                    1.484
                                                ],
                                                [
                                                    -0.078,
                                                    1.078
                                                ],
                                                [
                                                    -0.182,
                                                    1.722
                                                ],
                                                [
                                                    -0.034,
                                                    0.928
                                                ],
                                                [
                                                    -0.002,
                                                    0.037
                                                ],
                                                [
                                                    -0.064,
                                                    1.831
                                                ],
                                                [
                                                    0.015,
                                                    0.254
                                                ],
                                                [
                                                    -0.026,
                                                    0.101
                                                ],
                                                [
                                                    -0.203,
                                                    0.82
                                                ],
                                                [
                                                    0.012,
                                                    0.59
                                                ],
                                                [
                                                    -0.033,
                                                    0.336
                                                ],
                                                [
                                                    0.089,
                                                    4.042
                                                ],
                                                [
                                                    0.178,
                                                    2.44
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.356,
                                                    2.758
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.547,
                                                    2.962
                                                ],
                                                [
                                                    0.788,
                                                    2.669
                                                ],
                                                [
                                                    0.496,
                                                    1.042
                                                ],
                                                [
                                                    0.305,
                                                    0.724
                                                ],
                                                [
                                                    0.394,
                                                    1.398
                                                ],
                                                [
                                                    0.521,
                                                    1.068
                                                ],
                                                [
                                                    0.864,
                                                    1.512
                                                ],
                                                [
                                                    0.483,
                                                    0.56
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.818,
                                                    2.695
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.529,
                                                    2.707
                                                ],
                                                [
                                                    2.364,
                                                    1.83
                                                ],
                                                [
                                                    1.017,
                                                    0.496
                                                ],
                                                [
                                                    0.686,
                                                    0.381
                                                ],
                                                [
                                                    2.606,
                                                    1.475
                                                ],
                                                [
                                                    3.508,
                                                    1.322
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    4.804,
                                                    1.157
                                                ],
                                                [
                                                    3.572,
                                                    0
                                                ],
                                                [
                                                    3.75,
                                                    -0.852
                                                ],
                                                [
                                                    3.546,
                                                    -2.059
                                                ],
                                                [
                                                    1.792,
                                                    -2.25
                                                ],
                                                [
                                                    0.674,
                                                    0.432
                                                ],
                                                [
                                                    1.411,
                                                    0.851
                                                ],
                                                [
                                                    0.394,
                                                    0.127
                                                ],
                                                [
                                                    0.521,
                                                    0.61
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.364,
                                                    1.169
                                                ],
                                                [
                                                    2.046,
                                                    0.801
                                                ],
                                                [
                                                    0.941,
                                                    0.241
                                                ],
                                                [
                                                    0.661,
                                                    0.204
                                                ],
                                                [
                                                    0.343,
                                                    0.076
                                                ],
                                                [
                                                    0.737,
                                                    0.203
                                                ],
                                                [
                                                    1.131,
                                                    0.382
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.839,
                                                    0.216
                                                ],
                                                [
                                                    2.135,
                                                    0.445
                                                ],
                                                [
                                                    1.08,
                                                    0.14
                                                ],
                                                [
                                                    1.169,
                                                    0.177
                                                ],
                                                [
                                                    1.906,
                                                    0.394
                                                ],
                                                [
                                                    3.254,
                                                    0.318
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.911,
                                                    0.152
                                                ],
                                                [
                                                    2.453,
                                                    0
                                                ],
                                                [
                                                    1.551,
                                                    -0.229
                                                ],
                                                [
                                                    1.398,
                                                    -0.076
                                                ],
                                                [
                                                    2.237,
                                                    0.063
                                                ],
                                                [
                                                    2.428,
                                                    -0.254
                                                ],
                                                [
                                                    1.538,
                                                    -0.394
                                                ],
                                                [
                                                    1.373,
                                                    -0.216
                                                ],
                                                [
                                                    2.237,
                                                    -0.14
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.966,
                                                    -0.203
                                                ],
                                                [
                                                    1.602,
                                                    -0.381
                                                ],
                                                [
                                                    0.051,
                                                    -0.026
                                                ],
                                                [
                                                    0.115,
                                                    0.267
                                                ],
                                                [
                                                    1.97,
                                                    3.369
                                                ],
                                                [
                                                    2.529,
                                                    2.644
                                                ],
                                                [
                                                    2.44,
                                                    1.69
                                                ],
                                                [
                                                    0.61,
                                                    0.267
                                                ],
                                                [
                                                    0.737,
                                                    0.331
                                                ],
                                                [
                                                    2.161,
                                                    1.055
                                                ],
                                                [
                                                    2.11,
                                                    0.534
                                                ],
                                                [
                                                    0.839,
                                                    0.076
                                                ],
                                                [
                                                    2.504,
                                                    0.33
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.47,
                                                    0.102
                                                ],
                                                [
                                                    3.228,
                                                    0
                                                ],
                                                [
                                                    1.03,
                                                    -0.153
                                                ],
                                                [
                                                    0.979,
                                                    -0.127
                                                ],
                                                [
                                                    2.466,
                                                    -0.28
                                                ],
                                                [
                                                    0.635,
                                                    0.102
                                                ],
                                                [
                                                    2.834,
                                                    -0.61
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.724,
                                                    -0.204
                                                ],
                                                [
                                                    2.873,
                                                    -0.865
                                                ],
                                                [
                                                    1.004,
                                                    -0.343
                                                ],
                                                [
                                                    2.173,
                                                    -0.712
                                                ],
                                                [
                                                    3.038,
                                                    -1.22
                                                ],
                                                [
                                                    2.212,
                                                    -1.017
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.216,
                                                    -0.051
                                                ],
                                                [
                                                    0.165,
                                                    -0.063
                                                ],
                                                [
                                                    1.157,
                                                    -0.597
                                                ],
                                                [
                                                    2.046,
                                                    -0.966
                                                ],
                                                [
                                                    3.266,
                                                    -1.919
                                                ],
                                                [
                                                    2.72,
                                                    -1.792
                                                ],
                                                [
                                                    1.869,
                                                    -1.373
                                                ],
                                                [
                                                    1.042,
                                                    -0.966
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.868,
                                                    -1.538
                                                ],
                                                [
                                                    1.156,
                                                    -0.915
                                                ],
                                                [
                                                    1.525,
                                                    -0.941
                                                ],
                                                [
                                                    1.728,
                                                    -1.335
                                                ],
                                                [
                                                    1.284,
                                                    -1.233
                                                ],
                                                [
                                                    1.894,
                                                    -1.488
                                                ],
                                                [
                                                    1.068,
                                                    -0.889
                                                ],
                                                [
                                                    1.169,
                                                    -0.966
                                                ],
                                                [
                                                    1.779,
                                                    -1.347
                                                ],
                                                [
                                                    3.139,
                                                    -2.746
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.427,
                                                    -2.301
                                                ],
                                                [
                                                    1.042,
                                                    -1.106
                                                ],
                                                [
                                                    0.508,
                                                    -0.648
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.665,
                                                    -1.881
                                                ],
                                                [
                                                    0.635,
                                                    -0.827
                                                ],
                                                [
                                                    1.423,
                                                    -1.779
                                                ],
                                                [
                                                    1.322,
                                                    -1.868
                                                ],
                                                [
                                                    0.585,
                                                    -0.953
                                                ],
                                                [
                                                    1.156,
                                                    -1.817
                                                ],
                                                [
                                                    0.597,
                                                    -1.094
                                                ],
                                                [
                                                    0.674,
                                                    -1.144
                                                ],
                                                [
                                                    1.068,
                                                    -1.703
                                                ],
                                                [
                                                    0.699,
                                                    -1.246
                                                ],
                                                [
                                                    0.991,
                                                    -1.538
                                                ],
                                                [
                                                    0.877,
                                                    -1.64
                                                ],
                                                [
                                                    0.623,
                                                    -1.31
                                                ],
                                                [
                                                    0.877,
                                                    -1.69
                                                ],
                                                [
                                                    0.597,
                                                    -1.436
                                                ],
                                                [
                                                    0.445,
                                                    -0.877
                                                ],
                                                [
                                                    1.373,
                                                    -2.53
                                                ],
                                                [
                                                    1.5,
                                                    -4.207
                                                ],
                                                [
                                                    0.026,
                                                    -0.77
                                                ],
                                                [
                                                    0.01,
                                                    -0.168
                                                ],
                                                [
                                                    0.166,
                                                    -4.81
                                                ],
                                                [
                                                    -2.512,
                                                    -4.337
                                                ],
                                                [
                                                    -3.46,
                                                    -1.969
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.07,
                                                    -1.063
                                                ],
                                                [
                                                    -3.476,
                                                    -0.532
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.298,
                                                    0.025
                                                ],
                                                [
                                                    0.026,
                                                    -0.029
                                                ],
                                                [
                                                    1.246,
                                                    -1.347
                                                ],
                                                [
                                                    1.03,
                                                    -0.953
                                                ],
                                                [
                                                    2.059,
                                                    -2.046
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.474,
                                                    -1.385
                                                ],
                                                [
                                                    1.03,
                                                    -0.902
                                                ],
                                                [
                                                    1.513,
                                                    -1.36
                                                ],
                                                [
                                                    1.08,
                                                    -1.157
                                                ],
                                                [
                                                    0.979,
                                                    -0.852
                                                ],
                                                [
                                                    1.818,
                                                    -1.449
                                                ],
                                                [
                                                    2.021,
                                                    -2.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.843,
                                                    -2.224
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.614,
                                                    -2.275
                                                ],
                                                [
                                                    0.496,
                                                    -0.839
                                                ],
                                                [
                                                    0.623,
                                                    -1.042
                                                ],
                                                [
                                                    1.297,
                                                    -1.995
                                                ],
                                                [
                                                    1.538,
                                                    -3.05
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.385,
                                                    -3.381
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.89,
                                                    -2.72
                                                ],
                                                [
                                                    0.635,
                                                    -2.695
                                                ],
                                                [
                                                    0.127,
                                                    -1.004
                                                ],
                                                [
                                                    0.165,
                                                    -1.106
                                                ],
                                                [
                                                    0.432,
                                                    -2.453
                                                ],
                                                [
                                                    0.231,
                                                    -3.339
                                                ],
                                                [
                                                    0.026,
                                                    -1.769
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    262.609,
                                                    -107.883
                                                ],
                                                [
                                                    261.476,
                                                    -119.736
                                                ],
                                                [
                                                    258.285,
                                                    -129.365
                                                ],
                                                [
                                                    257.535,
                                                    -131.186
                                                ],
                                                [
                                                    252.551,
                                                    -141.607
                                                ],
                                                [
                                                    245.072,
                                                    -150.884
                                                ],
                                                [
                                                    235.129,
                                                    -157.676
                                                ],
                                                [
                                                    224.034,
                                                    -161.687
                                                ],
                                                [
                                                    222.859,
                                                    -161.978
                                                ],
                                                [
                                                    212.785,
                                                    -163.883
                                                ],
                                                [
                                                    201.648,
                                                    -164.092
                                                ],
                                                [
                                                    198.628,
                                                    -164.058
                                                ],
                                                [
                                                    190.759,
                                                    -163.821
                                                ],
                                                [
                                                    184.76,
                                                    -163.055
                                                ],
                                                [
                                                    180.175,
                                                    -162.434
                                                ],
                                                [
                                                    175.525,
                                                    -162.256
                                                ],
                                                [
                                                    170.616,
                                                    -162.082
                                                ],
                                                [
                                                    165.678,
                                                    -161.382
                                                ],
                                                [
                                                    161.285,
                                                    -160.796
                                                ],
                                                [
                                                    155.535,
                                                    -161.084
                                                ],
                                                [
                                                    152.12,
                                                    -161.346
                                                ],
                                                [
                                                    149.248,
                                                    -161.644
                                                ],
                                                [
                                                    149.291,
                                                    -161.813
                                                ],
                                                [
                                                    149.418,
                                                    -165.232
                                                ],
                                                [
                                                    149.408,
                                                    -165.339
                                                ],
                                                [
                                                    149.413,
                                                    -168.044
                                                ],
                                                [
                                                    149.376,
                                                    -168.457
                                                ],
                                                [
                                                    148.879,
                                                    -171.301
                                                ],
                                                [
                                                    148.825,
                                                    -171.428
                                                ],
                                                [
                                                    147.409,
                                                    -175.751
                                                ],
                                                [
                                                    145.381,
                                                    -179.096
                                                ],
                                                [
                                                    144.211,
                                                    -180.64
                                                ],
                                                [
                                                    129.215,
                                                    -185.257
                                                ],
                                                [
                                                    124.774,
                                                    -184.305
                                                ],
                                                [
                                                    120.456,
                                                    -183.392
                                                ],
                                                [
                                                    116.242,
                                                    -182.639
                                                ],
                                                [
                                                    115.229,
                                                    -182.452
                                                ],
                                                [
                                                    113.273,
                                                    -186.206
                                                ],
                                                [
                                                    112.073,
                                                    -188.544
                                                ],
                                                [
                                                    110.671,
                                                    -191.756
                                                ],
                                                [
                                                    108.193,
                                                    -197.179
                                                ],
                                                [
                                                    104.819,
                                                    -201.899
                                                ],
                                                [
                                                    102.499,
                                                    -204.974
                                                ],
                                                [
                                                    101.516,
                                                    -206.535
                                                ],
                                                [
                                                    96.343,
                                                    -213.801
                                                ],
                                                [
                                                    90.392,
                                                    -219.28
                                                ],
                                                [
                                                    88.449,
                                                    -220.909
                                                ],
                                                [
                                                    80.158,
                                                    -227.303
                                                ],
                                                [
                                                    77.977,
                                                    -228.838
                                                ],
                                                [
                                                    71.532,
                                                    -233.077
                                                ],
                                                [
                                                    68.59,
                                                    -234.864
                                                ],
                                                [
                                                    62.591,
                                                    -238.285
                                                ],
                                                [
                                                    54.19,
                                                    -241.851
                                                ],
                                                [
                                                    53.13,
                                                    -242.279
                                                ],
                                                [
                                                    45.244,
                                                    -245.133
                                                ],
                                                [
                                                    43.518,
                                                    -245.726
                                                ],
                                                [
                                                    35.593,
                                                    -248.203
                                                ],
                                                [
                                                    33.808,
                                                    -248.733
                                                ],
                                                [
                                                    30.294,
                                                    -249.855
                                                ],
                                                [
                                                    24.118,
                                                    -251.739
                                                ],
                                                [
                                                    18.293,
                                                    -252.767
                                                ],
                                                [
                                                    14.133,
                                                    -253.441
                                                ],
                                                [
                                                    12.823,
                                                    -253.691
                                                ],
                                                [
                                                    12.284,
                                                    -253.794
                                                ],
                                                [
                                                    8.348,
                                                    -254.915
                                                ],
                                                [
                                                    1.633,
                                                    -256.664
                                                ],
                                                [
                                                    -4.962,
                                                    -257.212
                                                ],
                                                [
                                                    -9.336,
                                                    -257.487
                                                ],
                                                [
                                                    -13.491,
                                                    -258.166
                                                ],
                                                [
                                                    -20.164,
                                                    -259.137
                                                ],
                                                [
                                                    -26.686,
                                                    -259.185
                                                ],
                                                [
                                                    -31.1,
                                                    -259.146
                                                ],
                                                [
                                                    -35.437,
                                                    -259.578
                                                ],
                                                [
                                                    -41.984,
                                                    -260.118
                                                ],
                                                [
                                                    -41.995,
                                                    -260.118
                                                ],
                                                [
                                                    -52.907,
                                                    -259.928
                                                ],
                                                [
                                                    -59.703,
                                                    -259.403
                                                ],
                                                [
                                                    -63.783,
                                                    -259.036
                                                ],
                                                [
                                                    -67.941,
                                                    -258.822
                                                ],
                                                [
                                                    -74.674,
                                                    -258.389
                                                ],
                                                [
                                                    -81.2,
                                                    -257.359
                                                ],
                                                [
                                                    -85.448,
                                                    -256.633
                                                ],
                                                [
                                                    -89.82,
                                                    -256.167
                                                ],
                                                [
                                                    -96.302,
                                                    -255.387
                                                ],
                                                [
                                                    -103.929,
                                                    -253.401
                                                ],
                                                [
                                                    -107.197,
                                                    -252.442
                                                ],
                                                [
                                                    -117.909,
                                                    -249.09
                                                ],
                                                [
                                                    -124.822,
                                                    -245.978
                                                ],
                                                [
                                                    -128.079,
                                                    -244.4
                                                ],
                                                [
                                                    -131.817,
                                                    -242.92
                                                ],
                                                [
                                                    -138.441,
                                                    -240.058
                                                ],
                                                [
                                                    -144.622,
                                                    -235.913
                                                ],
                                                [
                                                    -147.711,
                                                    -233.707
                                                ],
                                                [
                                                    -150.479,
                                                    -231.916
                                                ],
                                                [
                                                    -157.029,
                                                    -227.394
                                                ],
                                                [
                                                    -164.588,
                                                    -220.522
                                                ],
                                                [
                                                    -165.363,
                                                    -219.772
                                                ],
                                                [
                                                    -173.16,
                                                    -211.548
                                                ],
                                                [
                                                    -180.017,
                                                    -202.448
                                                ],
                                                [
                                                    -184.642,
                                                    -194.059
                                                ],
                                                [
                                                    -185.473,
                                                    -192.387
                                                ],
                                                [
                                                    -186.905,
                                                    -189.67
                                                ],
                                                [
                                                    -188.664,
                                                    -186.306
                                                ],
                                                [
                                                    -188.99,
                                                    -186.213
                                                ],
                                                [
                                                    -194.374,
                                                    -186.042
                                                ],
                                                [
                                                    -197.5,
                                                    -185.629
                                                ],
                                                [
                                                    -200.718,
                                                    -183.146
                                                ],
                                                [
                                                    -200.819,
                                                    -183.029
                                                ],
                                                [
                                                    -207.203,
                                                    -174.88
                                                ],
                                                [
                                                    -207.71,
                                                    -169.443
                                                ],
                                                [
                                                    -207.091,
                                                    -162.919
                                                ],
                                                [
                                                    -207.015,
                                                    -162.639
                                                ],
                                                [
                                                    -206.366,
                                                    -160.605
                                                ],
                                                [
                                                    -197.235,
                                                    -151.557
                                                ],
                                                [
                                                    -198.492,
                                                    -148.457
                                                ],
                                                [
                                                    -200.309,
                                                    -143.804
                                                ],
                                                [
                                                    -201.11,
                                                    -141.3
                                                ],
                                                [
                                                    -203.462,
                                                    -134.311
                                                ],
                                                [
                                                    -205.901,
                                                    -128.737
                                                ],
                                                [
                                                    -207.523,
                                                    -125.19
                                                ],
                                                [
                                                    -209.319,
                                                    -120.287
                                                ],
                                                [
                                                    -211.018,
                                                    -115.792
                                                ],
                                                [
                                                    -213.787,
                                                    -111.049
                                                ],
                                                [
                                                    -216.122,
                                                    -107.172
                                                ],
                                                [
                                                    -218.34,
                                                    -102.744
                                                ],
                                                [
                                                    -220.673,
                                                    -98.215
                                                ],
                                                [
                                                    -223.663,
                                                    -94.123
                                                ],
                                                [
                                                    -226.664,
                                                    -90.091
                                                ],
                                                [
                                                    -231.642,
                                                    -82.846
                                                ],
                                                [
                                                    -232.401,
                                                    -81.762
                                                ],
                                                [
                                                    -235.316,
                                                    -77.097
                                                ],
                                                [
                                                    -237.817,
                                                    -73.101
                                                ],
                                                [
                                                    -240.743,
                                                    -69.45
                                                ],
                                                [
                                                    -244.358,
                                                    -64.882
                                                ],
                                                [
                                                    -247.653,
                                                    -59.451
                                                ],
                                                [
                                                    -249.823,
                                                    -55.767
                                                ],
                                                [
                                                    -254.317,
                                                    -48.172
                                                ],
                                                [
                                                    -255.252,
                                                    -46.519
                                                ],
                                                [
                                                    -260.204,
                                                    -36.884
                                                ],
                                                [
                                                    -262.251,
                                                    -33.307
                                                ],
                                                [
                                                    -265.278,
                                                    -27.752
                                                ],
                                                [
                                                    -267.277,
                                                    -20.902
                                                ],
                                                [
                                                    -268.151,
                                                    -17.424
                                                ],
                                                [
                                                    -269.056,
                                                    -14.684
                                                ],
                                                [
                                                    -271.175,
                                                    -6.821
                                                ],
                                                [
                                                    -271.512,
                                                    0.279
                                                ],
                                                [
                                                    -271.43,
                                                    5.339
                                                ],
                                                [
                                                    -270.769,
                                                    7.97
                                                ],
                                                [
                                                    -270.769,
                                                    7.996
                                                ],
                                                [
                                                    -268.914,
                                                    20.273
                                                ],
                                                [
                                                    -268.812,
                                                    20.68
                                                ],
                                                [
                                                    -268.367,
                                                    22.434
                                                ],
                                                [
                                                    -267.833,
                                                    24.303
                                                ],
                                                [
                                                    -265.05,
                                                    33.187
                                                ],
                                                [
                                                    -264.414,
                                                    34.674
                                                ],
                                                [
                                                    -264.058,
                                                    35.462
                                                ],
                                                [
                                                    -263.328,
                                                    37.305
                                                ],
                                                [
                                                    -264.022,
                                                    38.404
                                                ],
                                                [
                                                    -264.522,
                                                    39.063
                                                ],
                                                [
                                                    -265.781,
                                                    40.773
                                                ],
                                                [
                                                    -266.387,
                                                    41.655
                                                ],
                                                [
                                                    -269.102,
                                                    45.858
                                                ],
                                                [
                                                    -270.083,
                                                    47.977
                                                ],
                                                [
                                                    -270.401,
                                                    48.732
                                                ],
                                                [
                                                    -273.201,
                                                    54.601
                                                ],
                                                [
                                                    -273.313,
                                                    54.867
                                                ],
                                                [
                                                    -276.958,
                                                    64.529
                                                ],
                                                [
                                                    -277.874,
                                                    67.391
                                                ],
                                                [
                                                    -279.969,
                                                    74.642
                                                ],
                                                [
                                                    -280.827,
                                                    81.2
                                                ],
                                                [
                                                    -281.23,
                                                    85.031
                                                ],
                                                [
                                                    -282.126,
                                                    92.608
                                                ],
                                                [
                                                    -282.398,
                                                    95.292
                                                ],
                                                [
                                                    -282.823,
                                                    98.92
                                                ],
                                                [
                                                    -283.523,
                                                    105.46
                                                ],
                                                [
                                                    -283.852,
                                                    111.141
                                                ],
                                                [
                                                    -284.092,
                                                    115.57
                                                ],
                                                [
                                                    -284.397,
                                                    118.796
                                                ],
                                                [
                                                    -284.822,
                                                    123.957
                                                ],
                                                [
                                                    -284.819,
                                                    126.661
                                                ],
                                                [
                                                    -284.827,
                                                    126.772
                                                ],
                                                [
                                                    -284.7,
                                                    131.971
                                                ],
                                                [
                                                    -284.658,
                                                    132.729
                                                ],
                                                [
                                                    -284.736,
                                                    133.033
                                                ],
                                                [
                                                    -285.215,
                                                    136.399
                                                ],
                                                [
                                                    -285.167,
                                                    138.148
                                                ],
                                                [
                                                    -285.221,
                                                    139.216
                                                ],
                                                [
                                                    -284.649,
                                                    150.655
                                                ],
                                                [
                                                    -283.81,
                                                    157.684
                                                ],
                                                [
                                                    -283.606,
                                                    159.171
                                                ],
                                                [
                                                    -282.234,
                                                    167.318
                                                ],
                                                [
                                                    -281.751,
                                                    169.847
                                                ],
                                                [
                                                    -279.768,
                                                    178.859
                                                ],
                                                [
                                                    -276.819,
                                                    186.066
                                                ],
                                                [
                                                    -275.408,
                                                    189.167
                                                ],
                                                [
                                                    -274.684,
                                                    191.429
                                                ],
                                                [
                                                    -273.044,
                                                    195.954
                                                ],
                                                [
                                                    -271.366,
                                                    199.183
                                                ],
                                                [
                                                    -268.583,
                                                    202.983
                                                ],
                                                [
                                                    -267.198,
                                                    204.75
                                                ],
                                                [
                                                    -266.206,
                                                    206.199
                                                ],
                                                [
                                                    -260.131,
                                                    214.231
                                                ],
                                                [
                                                    -259.813,
                                                    214.562
                                                ],
                                                [
                                                    -251.526,
                                                    222.468
                                                ],
                                                [
                                                    -244.192,
                                                    226.726
                                                ],
                                                [
                                                    -241.167,
                                                    228.251
                                                ],
                                                [
                                                    -239.121,
                                                    229.395
                                                ],
                                                [
                                                    -230.694,
                                                    233.563
                                                ],
                                                [
                                                    -219.941,
                                                    236.64
                                                ],
                                                [
                                                    -219.483,
                                                    236.754
                                                ],
                                                [
                                                    -204.689,
                                                    238.533
                                                ],
                                                [
                                                    -193.173,
                                                    237.529
                                                ],
                                                [
                                                    -181.76,
                                                    233.526
                                                ],
                                                [
                                                    -172.329,
                                                    225.34
                                                ],
                                                [
                                                    -168.439,
                                                    218.362
                                                ],
                                                [
                                                    -166.456,
                                                    219.608
                                                ],
                                                [
                                                    -162.465,
                                                    221.286
                                                ],
                                                [
                                                    -161.347,
                                                    221.655
                                                ],
                                                [
                                                    -158.602,
                                                    223.891
                                                ],
                                                [
                                                    -157.712,
                                                    224.336
                                                ],
                                                [
                                                    -150.289,
                                                    227.743
                                                ],
                                                [
                                                    -144.29,
                                                    229.535
                                                ],
                                                [
                                                    -141.557,
                                                    230.259
                                                ],
                                                [
                                                    -139.549,
                                                    230.768
                                                ],
                                                [
                                                    -138.507,
                                                    231.009
                                                ],
                                                [
                                                    -136.333,
                                                    231.708
                                                ],
                                                [
                                                    -132.609,
                                                    232.827
                                                ],
                                                [
                                                    -132.062,
                                                    232.954
                                                ],
                                                [
                                                    -129.508,
                                                    233.563
                                                ],
                                                [
                                                    -123.203,
                                                    234.53
                                                ],
                                                [
                                                    -119.924,
                                                    234.975
                                                ],
                                                [
                                                    -116.416,
                                                    235.648
                                                ],
                                                [
                                                    -110.404,
                                                    236.678
                                                ],
                                                [
                                                    -100.77,
                                                    237.39
                                                ],
                                                [
                                                    -100.096,
                                                    237.415
                                                ],
                                                [
                                                    -91.11,
                                                    237.708
                                                ],
                                                [
                                                    -84.132,
                                                    237.046
                                                ],
                                                [
                                                    -79.709,
                                                    236.525
                                                ],
                                                [
                                                    -75.273,
                                                    236.551
                                                ],
                                                [
                                                    -68.245,
                                                    236.423
                                                ],
                                                [
                                                    -61.419,
                                                    235.038
                                                ],
                                                [
                                                    -57.034,
                                                    234.034
                                                ],
                                                [
                                                    -52.598,
                                                    233.615
                                                ],
                                                [
                                                    -45.658,
                                                    232.814
                                                ],
                                                [
                                                    -44.718,
                                                    232.61
                                                ],
                                                [
                                                    -41.833,
                                                    231.975
                                                ],
                                                [
                                                    -37.422,
                                                    230.564
                                                ],
                                                [
                                                    -37.27,
                                                    230.501
                                                ],
                                                [
                                                    -36.876,
                                                    231.263
                                                ],
                                                [
                                                    -30.457,
                                                    239.957
                                                ],
                                                [
                                                    -22.221,
                                                    246.681
                                                ],
                                                [
                                                    -14.709,
                                                    250.57
                                                ],
                                                [
                                                    -12.866,
                                                    251.383
                                                ],
                                                [
                                                    -10.655,
                                                    252.438
                                                ],
                                                [
                                                    -3.244,
                                                    255.412
                                                ],
                                                [
                                                    2.806,
                                                    256.302
                                                ],
                                                [
                                                    5.31,
                                                    256.557
                                                ],
                                                [
                                                    13.927,
                                                    257.307
                                                ],
                                                [
                                                    14.029,
                                                    257.307
                                                ],
                                                [
                                                    15.808,
                                                    257.51
                                                ],
                                                [
                                                    25.341,
                                                    256.608
                                                ],
                                                [
                                                    28.493,
                                                    256.163
                                                ],
                                                [
                                                    31.493,
                                                    255.82
                                                ],
                                                [
                                                    39.055,
                                                    254.777
                                                ],
                                                [
                                                    40.987,
                                                    254.726
                                                ],
                                                [
                                                    49.503,
                                                    252.54
                                                ],
                                                [
                                                    50.469,
                                                    252.273
                                                ],
                                                [
                                                    52.401,
                                                    251.218
                                                ],
                                                [
                                                    60.37,
                                                    248.625
                                                ],
                                                [
                                                    63.395,
                                                    247.621
                                                ],
                                                [
                                                    70.055,
                                                    245.283
                                                ],
                                                [
                                                    79.474,
                                                    241.19
                                                ],
                                                [
                                                    85.88,
                                                    237.949
                                                ],
                                                [
                                                    86.375,
                                                    237.682
                                                ],
                                                [
                                                    87.011,
                                                    237.479
                                                ],
                                                [
                                                    87.494,
                                                    237.25
                                                ],
                                                [
                                                    91.027,
                                                    235.534
                                                ],
                                                [
                                                    97.281,
                                                    232.344
                                                ],
                                                [
                                                    106.585,
                                                    226.573
                                                ],
                                                [
                                                    115.558,
                                                    220.294
                                                ],
                                                [
                                                    120.642,
                                                    215.96
                                                ],
                                                [
                                                    123.832,
                                                    213.126
                                                ],
                                                [
                                                    126.146,
                                                    211.232
                                                ],
                                                [
                                                    131.802,
                                                    206.656
                                                ],
                                                [
                                                    135.742,
                                                    204
                                                ],
                                                [
                                                    140.381,
                                                    200.873
                                                ],
                                                [
                                                    145.084,
                                                    196.691
                                                ],
                                                [
                                                    148.846,
                                                    193.298
                                                ],
                                                [
                                                    154.439,
                                                    188.709
                                                ],
                                                [
                                                    157.654,
                                                    186.053
                                                ],
                                                [
                                                    161.264,
                                                    183.244
                                                ],
                                                [
                                                    166.653,
                                                    178.948
                                                ],
                                                [
                                                    175.194,
                                                    171.207
                                                ],
                                                [
                                                    176.173,
                                                    170.279
                                                ],
                                                [
                                                    183.469,
                                                    163.098
                                                ],
                                                [
                                                    186.227,
                                                    159.806
                                                ],
                                                [
                                                    187.79,
                                                    157.875
                                                ],
                                                [
                                                    189.379,
                                                    156.07
                                                ],
                                                [
                                                    194.374,
                                                    150.16
                                                ],
                                                [
                                                    196.306,
                                                    147.719
                                                ],
                                                [
                                                    200.551,
                                                    142.152
                                                ],
                                                [
                                                    204.186,
                                                    136.509
                                                ],
                                                [
                                                    205.966,
                                                    133.661
                                                ],
                                                [
                                                    209.143,
                                                    128.234
                                                ],
                                                [
                                                    210.986,
                                                    124.98
                                                ],
                                                [
                                                    213.083,
                                                    121.599
                                                ],
                                                [
                                                    216.185,
                                                    116.452
                                                ],
                                                [
                                                    218.435,
                                                    112.83
                                                ],
                                                [
                                                    221.383,
                                                    107.949
                                                ],
                                                [
                                                    223.875,
                                                    102.954
                                                ],
                                                [
                                                    225.768,
                                                    99.077
                                                ],
                                                [
                                                    228.005,
                                                    94.082
                                                ],
                                                [
                                                    229.785,
                                                    90.053
                                                ],
                                                [
                                                    231.17,
                                                    87.435
                                                ],
                                                [
                                                    235.009,
                                                    79.376
                                                ],
                                                [
                                                    238.021,
                                                    66.793
                                                ],
                                                [
                                                    237.98,
                                                    64.487
                                                ],
                                                [
                                                    238.015,
                                                    63.983
                                                ],
                                                [
                                                    234.488,
                                                    50.172
                                                ],
                                                [
                                                    222.004,
                                                    38.85
                                                ],
                                                [
                                                    211.355,
                                                    34.365
                                                ],
                                                [
                                                    210.027,
                                                    33.908
                                                ],
                                                [
                                                    200.287,
                                                    31.211
                                                ],
                                                [
                                                    190.203,
                                                    30.831
                                                ],
                                                [
                                                    188.813,
                                                    30.862
                                                ],
                                                [
                                                    184.889,
                                                    30.886
                                                ],
                                                [
                                                    184.969,
                                                    30.798
                                                ],
                                                [
                                                    189.061,
                                                    26.781
                                                ],
                                                [
                                                    192.099,
                                                    23.87
                                                ],
                                                [
                                                    198.34,
                                                    17.909
                                                ],
                                                [
                                                    199.331,
                                                    16.981
                                                ],
                                                [
                                                    203.805,
                                                    12.99
                                                ],
                                                [
                                                    206.855,
                                                    10.309
                                                ],
                                                [
                                                    210.897,
                                                    6.216
                                                ],
                                                [
                                                    213.96,
                                                    3.09
                                                ],
                                                [
                                                    216.96,
                                                    0.636
                                                ],
                                                [
                                                    222.4,
                                                    -4.104
                                                ],
                                                [
                                                    227.929,
                                                    -10.473
                                                ],
                                                [
                                                    229.62,
                                                    -12.531
                                                ],
                                                [
                                                    234.627,
                                                    -19.281
                                                ],
                                                [
                                                    236.165,
                                                    -21.467
                                                ],
                                                [
                                                    240.461,
                                                    -28.33
                                                ],
                                                [
                                                    241.961,
                                                    -30.872
                                                ],
                                                [
                                                    243.931,
                                                    -33.961
                                                ],
                                                [
                                                    247.719,
                                                    -40.303
                                                ],
                                                [
                                                    251.748,
                                                    -49.455
                                                ],
                                                [
                                                    252.155,
                                                    -50.446
                                                ],
                                                [
                                                    255.701,
                                                    -60.551
                                                ],
                                                [
                                                    256.502,
                                                    -63.003
                                                ],
                                                [
                                                    259.006,
                                                    -71.494
                                                ],
                                                [
                                                    260.34,
                                                    -79.413
                                                ],
                                                [
                                                    260.76,
                                                    -82.425
                                                ],
                                                [
                                                    261.319,
                                                    -85.73
                                                ],
                                                [
                                                    262.386,
                                                    -93.394
                                                ],
                                                [
                                                    262.663,
                                                    -102.738
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 23",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.066666670144,
                                            0.027450980619,
                                            0.023529412225,
                                            1
                                        ],
                                        "ix": 4
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 24,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 90,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 2,
                    "ty": 4,
                    "nm": "Layer 4",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                247.794,
                                448.033,
                                0
                            ],
                            "ix": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0,
                                0
                            ],
                            "ix": 1
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    1.646,
                                                    0.774
                                                ],
                                                [
                                                    0.775,
                                                    -1.646
                                                ],
                                                [
                                                    1.864,
                                                    -3.076
                                                ],
                                                [
                                                    2.2,
                                                    -2.837
                                                ],
                                                [
                                                    2.541,
                                                    -2.527
                                                ],
                                                [
                                                    2.883,
                                                    -2.128
                                                ],
                                                [
                                                    3.208,
                                                    -1.612
                                                ],
                                                [
                                                    3.39,
                                                    -0.972
                                                ],
                                                [
                                                    3.511,
                                                    -0.312
                                                ],
                                                [
                                                    3.498,
                                                    0.397
                                                ],
                                                [
                                                    3.327,
                                                    1.163
                                                ],
                                                [
                                                    2.952,
                                                    1.974
                                                ],
                                                [
                                                    2.907,
                                                    3.129
                                                ],
                                                [
                                                    2.459,
                                                    3.245
                                                ],
                                                [
                                                    1.453,
                                                    -1.107
                                                ],
                                                [
                                                    -1.099,
                                                    -1.451
                                                ],
                                                [
                                                    -2.089,
                                                    -2.458
                                                ],
                                                [
                                                    -2.308,
                                                    -2.17
                                                ],
                                                [
                                                    -2.623,
                                                    -1.754
                                                ],
                                                [
                                                    -3.246,
                                                    -1.274
                                                ],
                                                [
                                                    -3.447,
                                                    -0.623
                                                ],
                                                [
                                                    -3.506,
                                                    0
                                                ],
                                                [
                                                    -3.246,
                                                    0.519
                                                ],
                                                [
                                                    -3.127,
                                                    1.01
                                                ],
                                                [
                                                    -2.938,
                                                    1.476
                                                ],
                                                [
                                                    -2.659,
                                                    1.829
                                                ],
                                                [
                                                    -2.407,
                                                    2.156
                                                ],
                                                [
                                                    -2.134,
                                                    2.414
                                                ],
                                                [
                                                    -1.857,
                                                    2.604
                                                ],
                                                [
                                                    -1.58,
                                                    2.722
                                                ],
                                                [
                                                    -1.298,
                                                    2.758
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.644,
                                                    -0.775
                                                ],
                                                [
                                                    -1.587,
                                                    3.373
                                                ],
                                                [
                                                    -1.934,
                                                    3.192
                                                ],
                                                [
                                                    -2.29,
                                                    2.952
                                                ],
                                                [
                                                    -2.651,
                                                    2.637
                                                ],
                                                [
                                                    -3.004,
                                                    2.217
                                                ],
                                                [
                                                    -3.233,
                                                    1.625
                                                ],
                                                [
                                                    -3.477,
                                                    0.997
                                                ],
                                                [
                                                    -3.606,
                                                    0.321
                                                ],
                                                [
                                                    -3.597,
                                                    -0.408
                                                ],
                                                [
                                                    -3.401,
                                                    -1.189
                                                ],
                                                [
                                                    -3.589,
                                                    -2.4
                                                ],
                                                [
                                                    -3.033,
                                                    -3.265
                                                ],
                                                [
                                                    -1.099,
                                                    -1.449
                                                ],
                                                [
                                                    -1.449,
                                                    1.099
                                                ],
                                                [
                                                    1.795,
                                                    2.369
                                                ],
                                                [
                                                    1.973,
                                                    2.322
                                                ],
                                                [
                                                    2.241,
                                                    2.107
                                                ],
                                                [
                                                    2.873,
                                                    1.922
                                                ],
                                                [
                                                    3.199,
                                                    1.255
                                                ],
                                                [
                                                    3.376,
                                                    0.61
                                                ],
                                                [
                                                    3.223,
                                                    0
                                                ],
                                                [
                                                    3.185,
                                                    -0.509
                                                ],
                                                [
                                                    3.068,
                                                    -0.991
                                                ],
                                                [
                                                    3.014,
                                                    -1.515
                                                ],
                                                [
                                                    2.772,
                                                    -1.906
                                                ],
                                                [
                                                    2.507,
                                                    -2.246
                                                ],
                                                [
                                                    2.242,
                                                    -2.536
                                                ],
                                                [
                                                    1.989,
                                                    -2.789
                                                ],
                                                [
                                                    1.763,
                                                    -3.039
                                                ],
                                                [
                                                    0.775,
                                                    -1.647
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    56.927,
                                                    -26.869
                                                ],
                                                [
                                                    52.481,
                                                    -25.34
                                                ],
                                                [
                                                    47.393,
                                                    -15.61
                                                ],
                                                [
                                                    41.212,
                                                    -6.529
                                                ],
                                                [
                                                    33.827,
                                                    1.581
                                                ],
                                                [
                                                    25.521,
                                                    8.722
                                                ],
                                                [
                                                    16.241,
                                                    14.535
                                                ],
                                                [
                                                    6.308,
                                                    18.509
                                                ],
                                                [
                                                    -4.21,
                                                    20.541
                                                ],
                                                [
                                                    -14.918,
                                                    20.358
                                                ],
                                                [
                                                    -25.326,
                                                    17.919
                                                ],
                                                [
                                                    -34.896,
                                                    13.19
                                                ],
                                                [
                                                    -44.604,
                                                    4.724
                                                ],
                                                [
                                                    -52.728,
                                                    -5.301
                                                ],
                                                [
                                                    -57.441,
                                                    -5.893
                                                ],
                                                [
                                                    -58.103,
                                                    -1.226
                                                ],
                                                [
                                                    -52.224,
                                                    6.022
                                                ],
                                                [
                                                    -45.816,
                                                    12.804
                                                ],
                                                [
                                                    -38.525,
                                                    18.613
                                                ],
                                                [
                                                    -29.356,
                                                    23.458
                                                ],
                                                [
                                                    -19.366,
                                                    26.284
                                                ],
                                                [
                                                    -9.019,
                                                    27.193
                                                ],
                                                [
                                                    0.69,
                                                    26.345
                                                ],
                                                [
                                                    10.205,
                                                    24.2
                                                ],
                                                [
                                                    19.249,
                                                    20.517
                                                ],
                                                [
                                                    27.709,
                                                    15.4
                                                ],
                                                [
                                                    35.553,
                                                    9.377
                                                ],
                                                [
                                                    42.509,
                                                    2.348
                                                ],
                                                [
                                                    48.656,
                                                    -5.4
                                                ],
                                                [
                                                    53.894,
                                                    -13.777
                                                ],
                                                [
                                                    58.434,
                                                    -22.538
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.066666670144,
                                            0.027450980619,
                                            0.023529412225,
                                            1
                                        ],
                                        "ix": 4
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 90,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 3,
                    "ty": 4,
                    "nm": "Layer 3",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                331.822,
                                349.876,
                                0
                            ],
                            "ix": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                11,
                                4.5,
                                0
                            ],
                            "ix": 1
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    -3.424,
                                                    1.032
                                                ],
                                                [
                                                    -2.532,
                                                    2.677
                                                ],
                                                [
                                                    -0.881,
                                                    3.724
                                                ],
                                                [
                                                    1.032,
                                                    3.424
                                                ],
                                                [
                                                    1.765,
                                                    2.162
                                                ],
                                                [
                                                    1.218,
                                                    1.447
                                                ],
                                                [
                                                    3.37,
                                                    1.953
                                                ],
                                                [
                                                    3.853,
                                                    0.594
                                                ],
                                                [
                                                    3.813,
                                                    -0.848
                                                ],
                                                [
                                                    3.291,
                                                    -2.088
                                                ],
                                                [
                                                    2.311,
                                                    -3.146
                                                ],
                                                [
                                                    1.193,
                                                    -3.266
                                                ],
                                                [
                                                    0.553,
                                                    -2.978
                                                ],
                                                [
                                                    -1.601,
                                                    -0.379
                                                ],
                                                [
                                                    -0.051,
                                                    -0.01
                                                ],
                                                [
                                                    -0.313,
                                                    1.687
                                                ],
                                                [
                                                    -0.952,
                                                    2.691
                                                ],
                                                [
                                                    -1.735,
                                                    2.362
                                                ],
                                                [
                                                    -2.663,
                                                    1.69
                                                ],
                                                [
                                                    -3.072,
                                                    0.683
                                                ],
                                                [
                                                    -3.115,
                                                    -0.481
                                                ],
                                                [
                                                    -2.269,
                                                    -1.109
                                                ],
                                                [
                                                    1.726,
                                                    -0.52
                                                ],
                                                [
                                                    2.533,
                                                    -2.677
                                                ],
                                                [
                                                    0.882,
                                                    -3.724
                                                ],
                                                [
                                                    -1.032,
                                                    -3.424
                                                ],
                                                [
                                                    -2.677,
                                                    -2.532
                                                ],
                                                [
                                                    -3.724,
                                                    -0.882
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    3.528,
                                                    -1.063
                                                ],
                                                [
                                                    2.458,
                                                    -2.598
                                                ],
                                                [
                                                    0.881,
                                                    -3.723
                                                ],
                                                [
                                                    -0.81,
                                                    -2.686
                                                ],
                                                [
                                                    -0.963,
                                                    -1.621
                                                ],
                                                [
                                                    -2.509,
                                                    -2.982
                                                ],
                                                [
                                                    -3.383,
                                                    -1.96
                                                ],
                                                [
                                                    -3.858,
                                                    -0.595
                                                ],
                                                [
                                                    -3.804,
                                                    0.846
                                                ],
                                                [
                                                    -3.299,
                                                    2.093
                                                ],
                                                [
                                                    -2.24,
                                                    3.048
                                                ],
                                                [
                                                    -1.407,
                                                    3.853
                                                ],
                                                [
                                                    -0.303,
                                                    1.636
                                                ],
                                                [
                                                    0.05,
                                                    0.012
                                                ],
                                                [
                                                    1.687,
                                                    0.312
                                                ],
                                                [
                                                    0.647,
                                                    -3.487
                                                ],
                                                [
                                                    1.175,
                                                    -3.322
                                                ],
                                                [
                                                    1.866,
                                                    -2.541
                                                ],
                                                [
                                                    2.657,
                                                    -1.686
                                                ],
                                                [
                                                    3.079,
                                                    -0.685
                                                ],
                                                [
                                                    2.493,
                                                    0.376
                                                ],
                                                [
                                                    -1.842,
                                                    0.073
                                                ],
                                                [
                                                    -3.528,
                                                    1.063
                                                ],
                                                [
                                                    -2.458,
                                                    2.598
                                                ],
                                                [
                                                    -0.881,
                                                    3.723
                                                ],
                                                [
                                                    1.064,
                                                    3.528
                                                ],
                                                [
                                                    2.598,
                                                    2.458
                                                ],
                                                [
                                                    3.723,
                                                    0.881
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    18.35,
                                                    24.561
                                                ],
                                                [
                                                    27.622,
                                                    18.827
                                                ],
                                                [
                                                    32.796,
                                                    9.235
                                                ],
                                                [
                                                    32.426,
                                                    -1.643
                                                ],
                                                [
                                                    28.529,
                                                    -8.998
                                                ],
                                                [
                                                    25.242,
                                                    -13.606
                                                ],
                                                [
                                                    16.363,
                                                    -21.115
                                                ],
                                                [
                                                    5.426,
                                                    -25.098
                                                ],
                                                [
                                                    -6.22,
                                                    -24.67
                                                ],
                                                [
                                                    -16.958,
                                                    -20.152
                                                ],
                                                [
                                                    -25.547,
                                                    -12.293
                                                ],
                                                [
                                                    -30.594,
                                                    -2.61
                                                ],
                                                [
                                                    -33.292,
                                                    7.978
                                                ],
                                                [
                                                    -30.979,
                                                    11.512
                                                ],
                                                [
                                                    -30.843,
                                                    11.619
                                                ],
                                                [
                                                    -27.231,
                                                    9.103
                                                ],
                                                [
                                                    -24.801,
                                                    -0.113
                                                ],
                                                [
                                                    -20.483,
                                                    -8.572
                                                ],
                                                [
                                                    -13.604,
                                                    -14.963
                                                ],
                                                [
                                                    -4.929,
                                                    -18.609
                                                ],
                                                [
                                                    4.47,
                                                    -18.909
                                                ],
                                                [
                                                    11.651,
                                                    -16.639
                                                ],
                                                [
                                                    6.279,
                                                    -15.73
                                                ],
                                                [
                                                    -2.992,
                                                    -10.039
                                                ],
                                                [
                                                    -8.189,
                                                    -0.467
                                                ],
                                                [
                                                    -7.796,
                                                    10.406
                                                ],
                                                [
                                                    -2.111,
                                                    19.673
                                                ],
                                                [
                                                    7.454,
                                                    24.878
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.066666670144,
                                            0.027450980619,
                                            0.023529412225,
                                            1
                                        ],
                                        "ix": 4
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 90,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 4,
                    "ty": 4,
                    "nm": "Layer 2",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                208.021,
                                340.836,
                                0
                            ],
                            "ix": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                8,
                                5,
                                0
                            ],
                            "ix": 1
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    1.386,
                                                    3.267
                                                ],
                                                [
                                                    2.57,
                                                    2.634
                                                ],
                                                [
                                                    3.303,
                                                    1.601
                                                ],
                                                [
                                                    3.665,
                                                    0.292
                                                ],
                                                [
                                                    3.521,
                                                    -1.059
                                                ],
                                                [
                                                    2.946,
                                                    -2.188
                                                ],
                                                [
                                                    1.953,
                                                    -3.116
                                                ],
                                                [
                                                    -1.541,
                                                    -0.967
                                                ],
                                                [
                                                    -0.965,
                                                    1.541
                                                ],
                                                [
                                                    -3.864,
                                                    1.941
                                                ],
                                                [
                                                    -4.297,
                                                    -0.339
                                                ],
                                                [
                                                    -2.906,
                                                    -1.621
                                                ],
                                                [
                                                    0.267,
                                                    0
                                                ],
                                                [
                                                    2.822,
                                                    -1.635
                                                ],
                                                [
                                                    1.685,
                                                    -2.907
                                                ],
                                                [
                                                    0,
                                                    -3.49
                                                ],
                                                [
                                                    -1.635,
                                                    -2.822
                                                ],
                                                [
                                                    -2.908,
                                                    -1.685
                                                ],
                                                [
                                                    -3.49,
                                                    0
                                                ],
                                                [
                                                    -2.822,
                                                    1.635
                                                ],
                                                [
                                                    -1.457,
                                                    1.735
                                                ],
                                                [
                                                    -0.785,
                                                    -0.039
                                                ],
                                                [
                                                    -0.055,
                                                    0
                                                ],
                                                [
                                                    -0.087,
                                                    1.761
                                                ],
                                                [
                                                    0.453,
                                                    3.82
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -1.436,
                                                    -3.385
                                                ],
                                                [
                                                    -2.563,
                                                    -2.627
                                                ],
                                                [
                                                    -3.311,
                                                    -1.604
                                                ],
                                                [
                                                    -3.667,
                                                    -0.286
                                                ],
                                                [
                                                    -3.516,
                                                    1.058
                                                ],
                                                [
                                                    -2.953,
                                                    2.193
                                                ],
                                                [
                                                    -0.967,
                                                    1.541
                                                ],
                                                [
                                                    1.541,
                                                    0.967
                                                ],
                                                [
                                                    2.292,
                                                    -3.655
                                                ],
                                                [
                                                    3.866,
                                                    -1.942
                                                ],
                                                [
                                                    3.307,
                                                    0.263
                                                ],
                                                [
                                                    -0.264,
                                                    -0.01
                                                ],
                                                [
                                                    -3.49,
                                                    0
                                                ],
                                                [
                                                    -2.908,
                                                    1.685
                                                ],
                                                [
                                                    -1.636,
                                                    2.822
                                                ],
                                                [
                                                    0,
                                                    3.49
                                                ],
                                                [
                                                    1.685,
                                                    2.908
                                                ],
                                                [
                                                    2.822,
                                                    1.635
                                                ],
                                                [
                                                    3.49,
                                                    0
                                                ],
                                                [
                                                    1.972,
                                                    -1.143
                                                ],
                                                [
                                                    0.538,
                                                    0.483
                                                ],
                                                [
                                                    0.055,
                                                    0.002
                                                ],
                                                [
                                                    1.745,
                                                    0
                                                ],
                                                [
                                                    0.138,
                                                    -2.836
                                                ],
                                                [
                                                    -0.384,
                                                    -3.236
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    25.622,
                                                    -5.397
                                                ],
                                                [
                                                    19.577,
                                                    -14.528
                                                ],
                                                [
                                                    10.667,
                                                    -20.925
                                                ],
                                                [
                                                    0.105,
                                                    -23.83
                                                ],
                                                [
                                                    -10.777,
                                                    -22.61
                                                ],
                                                [
                                                    -20.587,
                                                    -17.718
                                                ],
                                                [
                                                    -28,
                                                    -9.664
                                                ],
                                                [
                                                    -27.031,
                                                    -5.115
                                                ],
                                                [
                                                    -22.509,
                                                    -6.22
                                                ],
                                                [
                                                    -12.958,
                                                    -14.752
                                                ],
                                                [
                                                    -0.412,
                                                    -17.326
                                                ],
                                                [
                                                    9.017,
                                                    -14.383
                                                ],
                                                [
                                                    8.222,
                                                    -14.408
                                                ],
                                                [
                                                    -1.361,
                                                    -11.831
                                                ],
                                                [
                                                    -8.357,
                                                    -4.801
                                                ],
                                                [
                                                    -10.966,
                                                    4.77
                                                ],
                                                [
                                                    -8.373,
                                                    14.349
                                                ],
                                                [
                                                    -1.378,
                                                    21.398
                                                ],
                                                [
                                                    8.222,
                                                    23.915
                                                ],
                                                [
                                                    17.796,
                                                    21.356
                                                ],
                                                [
                                                    22.983,
                                                    17.002
                                                ],
                                                [
                                                    24.997,
                                                    17.842
                                                ],
                                                [
                                                    25.161,
                                                    17.85
                                                ],
                                                [
                                                    28.422,
                                                    14.727
                                                ],
                                                [
                                                    28.174,
                                                    4.494
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.066666670144,
                                            0.027450980619,
                                            0.023529412225,
                                            1
                                        ],
                                        "ix": 4
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 90,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 5,
                    "ty": 4,
                    "nm": "Layer 1",
                    "sr": 1,
                    "ks": {
                        "o": {
                            "a": 0,
                            "k": 100,
                            "ix": 11
                        },
                        "r": {
                            "a": 0,
                            "k": 0,
                            "ix": 10
                        },
                        "p": {
                            "a": 0,
                            "k": [
                                350,
                                350,
                                0
                            ],
                            "ix": 2
                        },
                        "a": {
                            "a": 0,
                            "k": [
                                0,
                                0,
                                0
                            ],
                            "ix": 1
                        },
                        "s": {
                            "a": 0,
                            "k": [
                                100,
                                100,
                                100
                            ],
                            "ix": 6
                        }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.267,
                                                    -3.775
                                                ],
                                                [
                                                    0.432,
                                                    -2.059
                                                ],
                                                [
                                                    0.191,
                                                    -1.475
                                                ],
                                                [
                                                    0.127,
                                                    -1.386
                                                ],
                                                [
                                                    0.419,
                                                    -2.046
                                                ],
                                                [
                                                    0.686,
                                                    -1.983
                                                ],
                                                [
                                                    0.407,
                                                    -1.436
                                                ],
                                                [
                                                    0.318,
                                                    -1.386
                                                ],
                                                [
                                                    0.686,
                                                    -1.945
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.991,
                                                    -2.364
                                                ],
                                                [
                                                    1.411,
                                                    -2.809
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.64,
                                                    -2.796
                                                ],
                                                [
                                                    1.271,
                                                    -1.55
                                                ],
                                                [
                                                    0.903,
                                                    -1.347
                                                ],
                                                [
                                                    0.724,
                                                    -1.449
                                                ],
                                                [
                                                    1.106,
                                                    -1.436
                                                ],
                                                [
                                                    1.487,
                                                    -1.499
                                                ],
                                                [
                                                    0.979,
                                                    -1.105
                                                ],
                                                [
                                                    0.902,
                                                    -1.157
                                                ],
                                                [
                                                    1.424,
                                                    -1.436
                                                ],
                                                [
                                                    2.784,
                                                    -2.44
                                                ],
                                                [
                                                    0.407,
                                                    -0.216
                                                ],
                                                [
                                                    0.28,
                                                    -0.267
                                                ],
                                                [
                                                    -0.063,
                                                    -0.445
                                                ],
                                                [
                                                    -0.419,
                                                    -0.191
                                                ],
                                                [
                                                    -1.03,
                                                    -0.279
                                                ],
                                                [
                                                    -0.928,
                                                    -0.547
                                                ],
                                                [
                                                    -1.385,
                                                    -1.284
                                                ],
                                                [
                                                    -0.903,
                                                    -0.699
                                                ],
                                                [
                                                    -0.979,
                                                    -0.648
                                                ],
                                                [
                                                    -1.182,
                                                    -1.322
                                                ],
                                                [
                                                    -1.716,
                                                    -2.962
                                                ],
                                                [
                                                    -0.991,
                                                    -3.101
                                                ],
                                                [
                                                    -0.203,
                                                    -2.644
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.33,
                                                    -2.974
                                                ],
                                                [
                                                    0.966,
                                                    -3.47
                                                ],
                                                [
                                                    0.979,
                                                    -2.237
                                                ],
                                                [
                                                    0.28,
                                                    -0.662
                                                ],
                                                [
                                                    1.22,
                                                    -2.389
                                                ],
                                                [
                                                    0.686,
                                                    -1.614
                                                ],
                                                [
                                                    0.826,
                                                    -1.589
                                                ],
                                                [
                                                    0.979,
                                                    -1.741
                                                ],
                                                [
                                                    0.737,
                                                    -1.385
                                                ],
                                                [
                                                    1.068,
                                                    -1.525
                                                ],
                                                [
                                                    0.877,
                                                    -1.563
                                                ],
                                                [
                                                    0.661,
                                                    -1.551
                                                ],
                                                [
                                                    0.928,
                                                    -1.55
                                                ],
                                                [
                                                    2.275,
                                                    -3.533
                                                ],
                                                [
                                                    1.258,
                                                    -1.512
                                                ],
                                                [
                                                    0.966,
                                                    -1.36
                                                ],
                                                [
                                                    0.788,
                                                    -1.436
                                                ],
                                                [
                                                    1.131,
                                                    -1.449
                                                ],
                                                [
                                                    2.466,
                                                    -2.847
                                                ],
                                                [
                                                    1.055,
                                                    -0.979
                                                ],
                                                [
                                                    0.801,
                                                    -0.864
                                                ],
                                                [
                                                    1.576,
                                                    -1.475
                                                ],
                                                [
                                                    0.839,
                                                    -0.813
                                                ],
                                                [
                                                    2.364,
                                                    -2.11
                                                ],
                                                [
                                                    0.991,
                                                    -0.941
                                                ],
                                                [
                                                    1.5,
                                                    -1.271
                                                ],
                                                [
                                                    1.436,
                                                    -1.016
                                                ],
                                                [
                                                    1.22,
                                                    -0.992
                                                ],
                                                [
                                                    1.169,
                                                    -1.207
                                                ],
                                                [
                                                    1.258,
                                                    -0.978
                                                ],
                                                [
                                                    1.411,
                                                    -0.979
                                                ],
                                                [
                                                    1.271,
                                                    -0.991
                                                ],
                                                [
                                                    1.322,
                                                    -0.89
                                                ],
                                                [
                                                    1.373,
                                                    -1.081
                                                ],
                                                [
                                                    1.271,
                                                    -1.259
                                                ],
                                                [
                                                    1.144,
                                                    -0.928
                                                ],
                                                [
                                                    3.012,
                                                    -2.262
                                                ],
                                                [
                                                    1.538,
                                                    -0.839
                                                ],
                                                [
                                                    1.258,
                                                    -0.865
                                                ],
                                                [
                                                    1.131,
                                                    -0.966
                                                ],
                                                [
                                                    1.386,
                                                    -0.877
                                                ],
                                                [
                                                    1.665,
                                                    -0.877
                                                ],
                                                [
                                                    1.106,
                                                    -0.635
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.644,
                                                    -1.373
                                                ],
                                                [
                                                    0.064,
                                                    -0.101
                                                ],
                                                [
                                                    3.648,
                                                    -1.716
                                                ],
                                                [
                                                    2.008,
                                                    -0.648
                                                ],
                                                [
                                                    1.551,
                                                    -0.623
                                                ],
                                                [
                                                    1.36,
                                                    -0.61
                                                ],
                                                [
                                                    2.046,
                                                    -0.712
                                                ],
                                                [
                                                    2.288,
                                                    -0.623
                                                ],
                                                [
                                                    1.246,
                                                    -0.356
                                                ],
                                                [
                                                    0.292,
                                                    -0.14
                                                ],
                                                [
                                                    0.178,
                                                    -0.051
                                                ],
                                                [
                                                    3.241,
                                                    -0.686
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.165,
                                                    -0.114
                                                ],
                                                [
                                                    1.296,
                                                    -0.407
                                                ],
                                                [
                                                    1.69,
                                                    -0.267
                                                ],
                                                [
                                                    2.097,
                                                    -0.114
                                                ],
                                                [
                                                    1.106,
                                                    -0.089
                                                ],
                                                [
                                                    2.669,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.445,
                                                    0.038
                                                ],
                                                [
                                                    0.407,
                                                    0.012
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.241,
                                                    0.432
                                                ],
                                                [
                                                    3.33,
                                                    0.865
                                                ],
                                                [
                                                    3.597,
                                                    1.461
                                                ],
                                                [
                                                    1.182,
                                                    0.419
                                                ],
                                                [
                                                    1.97,
                                                    1.131
                                                ],
                                                [
                                                    1.741,
                                                    1.563
                                                ],
                                                [
                                                    1.055,
                                                    0.826
                                                ],
                                                [
                                                    0.966,
                                                    0.699
                                                ],
                                                [
                                                    1.589,
                                                    1.665
                                                ],
                                                [
                                                    0.369,
                                                    0
                                                ],
                                                [
                                                    0.089,
                                                    -0.026
                                                ],
                                                [
                                                    3.877,
                                                    -0.56
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.254,
                                                    -0.318
                                                ],
                                                [
                                                    2.542,
                                                    -0.089
                                                ],
                                                [
                                                    1.22,
                                                    -0.063
                                                ],
                                                [
                                                    4.258,
                                                    0
                                                ],
                                                [
                                                    1.741,
                                                    0.178
                                                ],
                                                [
                                                    1.385,
                                                    0.064
                                                ],
                                                [
                                                    1.398,
                                                    -0.026
                                                ],
                                                [
                                                    1.716,
                                                    0.153
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.695,
                                                    0.368
                                                ],
                                                [
                                                    1.716,
                                                    0.471
                                                ],
                                                [
                                                    1.411,
                                                    0.254
                                                ],
                                                [
                                                    1.474,
                                                    0.089
                                                ],
                                                [
                                                    1.551,
                                                    0.369
                                                ],
                                                [
                                                    1.589,
                                                    0.699
                                                ],
                                                [
                                                    1.474,
                                                    0.432
                                                ],
                                                [
                                                    2.224,
                                                    0.814
                                                ],
                                                [
                                                    0.877,
                                                    0.292
                                                ],
                                                [
                                                    1.589,
                                                    0.699
                                                ],
                                                [
                                                    0.394,
                                                    -0.343
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.669,
                                                    -1.512
                                                ],
                                                [
                                                    2.834,
                                                    -0.902
                                                ],
                                                [
                                                    0.826,
                                                    -0.28
                                                ],
                                                [
                                                    0.852,
                                                    -0.305
                                                ],
                                                [
                                                    2.796,
                                                    -0.432
                                                ],
                                                [
                                                    4.016,
                                                    0
                                                ],
                                                [
                                                    2.072,
                                                    0.382
                                                ],
                                                [
                                                    1.258,
                                                    0.153
                                                ],
                                                [
                                                    1.195,
                                                    0.089
                                                ],
                                                [
                                                    1.97,
                                                    0.47
                                                ],
                                                [
                                                    1.945,
                                                    0.75
                                                ],
                                                [
                                                    1.169,
                                                    0.394
                                                ],
                                                [
                                                    1.398,
                                                    0.343
                                                ],
                                                [
                                                    1.703,
                                                    0.763
                                                ],
                                                [
                                                    2.084,
                                                    1.246
                                                ],
                                                [
                                                    0.788,
                                                    0.445
                                                ],
                                                [
                                                    2.695,
                                                    1.945
                                                ],
                                                [
                                                    1.436,
                                                    1.5
                                                ],
                                                [
                                                    1.017,
                                                    0.902
                                                ],
                                                [
                                                    1.055,
                                                    0.826
                                                ],
                                                [
                                                    1.334,
                                                    1.487
                                                ],
                                                [
                                                    1.945,
                                                    2.695
                                                ],
                                                [
                                                    0.953,
                                                    1.881
                                                ],
                                                [
                                                    0.674,
                                                    1.157
                                                ],
                                                [
                                                    1.373,
                                                    2.949
                                                ],
                                                [
                                                    1.182,
                                                    3.228
                                                ],
                                                [
                                                    1.042,
                                                    3.737
                                                ],
                                                [
                                                    0.356,
                                                    1.144
                                                ],
                                                [
                                                    0.432,
                                                    2.135
                                                ],
                                                [
                                                    0.165,
                                                    2.008
                                                ],
                                                [
                                                    0.203,
                                                    1.436
                                                ],
                                                [
                                                    0.318,
                                                    1.436
                                                ],
                                                [
                                                    0.152,
                                                    1.906
                                                ],
                                                [
                                                    -0.076,
                                                    1.563
                                                ],
                                                [
                                                    0.051,
                                                    1.36
                                                ],
                                                [
                                                    -0.013,
                                                    1.982
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.165,
                                                    1.437
                                                ],
                                                [
                                                    -0.051,
                                                    1.55
                                                ],
                                                [
                                                    -0.292,
                                                    1.64
                                                ],
                                                [
                                                    -0.102,
                                                    1.475
                                                ],
                                                [
                                                    -0.165,
                                                    2.085
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.038,
                                                    1.55
                                                ],
                                                [
                                                    -0.165,
                                                    1.677
                                                ],
                                                [
                                                    -0.089,
                                                    1.373
                                                ],
                                                [
                                                    -0.267,
                                                    1.881
                                                ],
                                                [
                                                    -0.547,
                                                    1.691
                                                ],
                                                [
                                                    -0.305,
                                                    1.589
                                                ],
                                                [
                                                    -0.14,
                                                    1.449
                                                ],
                                                [
                                                    -0.432,
                                                    1.704
                                                ],
                                                [
                                                    -0.724,
                                                    1.805
                                                ],
                                                [
                                                    -0.432,
                                                    1.335
                                                ],
                                                [
                                                    -0.318,
                                                    1.068
                                                ],
                                                [
                                                    -0.826,
                                                    1.97
                                                ],
                                                [
                                                    -2.453,
                                                    4.054
                                                ],
                                                [
                                                    0.127,
                                                    0.382
                                                ],
                                                [
                                                    1.03,
                                                    3.915
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.458,
                                                    2.974
                                                ],
                                                [
                                                    0.038,
                                                    2.732
                                                ],
                                                [
                                                    0.013,
                                                    0.814
                                                ],
                                                [
                                                    0.051,
                                                    1.03
                                                ],
                                                [
                                                    -0.331,
                                                    2.478
                                                ],
                                                [
                                                    -0.623,
                                                    1.741
                                                ],
                                                [
                                                    -0.318,
                                                    1.259
                                                ],
                                                [
                                                    -0.241,
                                                    1.144
                                                ],
                                                [
                                                    -0.648,
                                                    1.83
                                                ],
                                                [
                                                    -1.207,
                                                    2.847
                                                ],
                                                [
                                                    -0.496,
                                                    1.385
                                                ],
                                                [
                                                    -0.712,
                                                    1.512
                                                ],
                                                [
                                                    -1.246,
                                                    2.021
                                                ],
                                                [
                                                    -0.699,
                                                    1.246
                                                ],
                                                [
                                                    -0.661,
                                                    1.283
                                                ],
                                                [
                                                    -1.271,
                                                    1.996
                                                ],
                                                [
                                                    -1.335,
                                                    1.792
                                                ],
                                                [
                                                    -0.902,
                                                    1.296
                                                ],
                                                [
                                                    -0.991,
                                                    1.512
                                                ],
                                                [
                                                    -1.182,
                                                    1.665
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.411,
                                                    2.021
                                                ],
                                                [
                                                    -1.068,
                                                    1.195
                                                ],
                                                [
                                                    -1.042,
                                                    1.576
                                                ],
                                                [
                                                    -0.826,
                                                    1.652
                                                ],
                                                [
                                                    -0.775,
                                                    1.283
                                                ],
                                                [
                                                    -0.813,
                                                    1.144
                                                ],
                                                [
                                                    -0.979,
                                                    1.805
                                                ],
                                                [
                                                    -0.623,
                                                    1.767
                                                ],
                                                [
                                                    -0.635,
                                                    1.36
                                                ],
                                                [
                                                    -0.737,
                                                    1.258
                                                ],
                                                [
                                                    -0.763,
                                                    1.906
                                                ],
                                                [
                                                    -1.03,
                                                    2.974
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.28,
                                                    0.369
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.169,
                                                    3.394
                                                ],
                                                [
                                                    0.076,
                                                    4.728
                                                ],
                                                [
                                                    -1.093,
                                                    3.495
                                                ],
                                                [
                                                    -1.347,
                                                    2.237
                                                ],
                                                [
                                                    -1.843,
                                                    1.843
                                                ],
                                                [
                                                    -2.11,
                                                    1.246
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.555,
                                                    0.788
                                                ],
                                                [
                                                    -0.178,
                                                    0.305
                                                ],
                                                [
                                                    -2.25,
                                                    3.318
                                                ],
                                                [
                                                    -0.648,
                                                    1.017
                                                ],
                                                [
                                                    -1.436,
                                                    1.754
                                                ],
                                                [
                                                    -1.589,
                                                    1.538
                                                ],
                                                [
                                                    -0.864,
                                                    0.915
                                                ],
                                                [
                                                    -0.953,
                                                    1.22
                                                ],
                                                [
                                                    -1.411,
                                                    1.259
                                                ],
                                                [
                                                    -1.779,
                                                    1.169
                                                ],
                                                [
                                                    -1.169,
                                                    0.889
                                                ],
                                                [
                                                    -2.593,
                                                    1.715
                                                ],
                                                [
                                                    -2.428,
                                                    1.373
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.911,
                                                    1.398
                                                ],
                                                [
                                                    -1.106,
                                                    0.572
                                                ],
                                                [
                                                    -2.084,
                                                    0.851
                                                ],
                                                [
                                                    -3.025,
                                                    1.004
                                                ],
                                                [
                                                    -2.669,
                                                    0.673
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.279,
                                                    0.597
                                                ],
                                                [
                                                    -3.19,
                                                    0.47
                                                ],
                                                [
                                                    -1.373,
                                                    0.254
                                                ],
                                                [
                                                    -1.83,
                                                    0.216
                                                ],
                                                [
                                                    -1.449,
                                                    0.241
                                                ],
                                                [
                                                    -1.754,
                                                    0.153
                                                ],
                                                [
                                                    -1.691,
                                                    -0.166
                                                ],
                                                [
                                                    -1.665,
                                                    0.102
                                                ],
                                                [
                                                    -1.055,
                                                    0.076
                                                ],
                                                [
                                                    -2.161,
                                                    0.064
                                                ],
                                                [
                                                    -1.525,
                                                    0.166
                                                ],
                                                [
                                                    -2.974,
                                                    0.063
                                                ],
                                                [
                                                    -1.983,
                                                    -0.063
                                                ],
                                                [
                                                    -1.716,
                                                    -0.267
                                                ],
                                                [
                                                    -1.551,
                                                    -0.102
                                                ],
                                                [
                                                    -1.5,
                                                    -0.012
                                                ],
                                                [
                                                    -1.754,
                                                    -0.178
                                                ],
                                                [
                                                    -1.779,
                                                    -0.356
                                                ],
                                                [
                                                    -1.424,
                                                    -0.204
                                                ],
                                                [
                                                    -1.411,
                                                    -0.127
                                                ],
                                                [
                                                    -1.792,
                                                    -0.33
                                                ],
                                                [
                                                    -1.36,
                                                    -0.191
                                                ],
                                                [
                                                    -1.97,
                                                    -0.547
                                                ],
                                                [
                                                    -0.839,
                                                    -0.191
                                                ],
                                                [
                                                    -1.576,
                                                    -0.204
                                                ],
                                                [
                                                    -1.602,
                                                    -0.407
                                                ],
                                                [
                                                    -1.818,
                                                    -0.597
                                                ],
                                                [
                                                    -1.297,
                                                    -0.381
                                                ],
                                                [
                                                    -1.691,
                                                    -0.687
                                                ],
                                                [
                                                    -1.373,
                                                    -0.458
                                                ],
                                                [
                                                    -1.538,
                                                    -0.343
                                                ],
                                                [
                                                    -1.538,
                                                    -0.584
                                                ],
                                                [
                                                    -1.69,
                                                    -0.852
                                                ],
                                                [
                                                    -1.271,
                                                    -0.547
                                                ],
                                                [
                                                    -1.334,
                                                    -0.508
                                                ],
                                                [
                                                    -1.627,
                                                    -0.813
                                                ],
                                                [
                                                    -1.894,
                                                    -1.156
                                                ],
                                                [
                                                    -0.902,
                                                    -0.521
                                                ],
                                                [
                                                    -2.682,
                                                    -1.843
                                                ],
                                                [
                                                    -1.576,
                                                    -1.398
                                                ],
                                                [
                                                    -0.89,
                                                    -0.725
                                                ],
                                                [
                                                    -2.021,
                                                    -1.995
                                                ],
                                                [
                                                    -2.072,
                                                    -2.517
                                                ],
                                                [
                                                    -1.602,
                                                    -2.517
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.347,
                                                    -2.555
                                                ],
                                                [
                                                    -0.496,
                                                    -0.903
                                                ],
                                                [
                                                    -0.572,
                                                    0.102
                                                ],
                                                [
                                                    -0.737,
                                                    0.165
                                                ],
                                                [
                                                    -1.03,
                                                    0
                                                ],
                                                [
                                                    -3.978,
                                                    -1.233
                                                ],
                                                [
                                                    -3.063,
                                                    -2.084
                                                ],
                                                [
                                                    -2.313,
                                                    -2.898
                                                ],
                                                [
                                                    -1.258,
                                                    -3.215
                                                ],
                                                [
                                                    -0.572,
                                                    0.051
                                                ],
                                                [
                                                    -1.5,
                                                    0.063
                                                ],
                                                [
                                                    -2.059,
                                                    0.177
                                                ],
                                                [
                                                    -1.335,
                                                    0.165
                                                ],
                                                [
                                                    -1.576,
                                                    0.127
                                                ],
                                                [
                                                    -1.131,
                                                    0.114
                                                ],
                                                [
                                                    -1.767,
                                                    0.089
                                                ],
                                                [
                                                    -1.665,
                                                    -0.102
                                                ],
                                                [
                                                    -2.288,
                                                    0.038
                                                ],
                                                [
                                                    -2.275,
                                                    -0.204
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.491,
                                                    -0.483
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.58,
                                                    -0.838
                                                ],
                                                [
                                                    -1.983,
                                                    -1.08
                                                ],
                                                [
                                                    -0.941,
                                                    -0.47
                                                ],
                                                [
                                                    -0.839,
                                                    -0.381
                                                ],
                                                [
                                                    -1.932,
                                                    -1.373
                                                ],
                                                [
                                                    -2.135,
                                                    -2.097
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.576,
                                                    -2.123
                                                ],
                                                [
                                                    -0.953,
                                                    -1.996
                                                ],
                                                [
                                                    -0.623,
                                                    -1.131
                                                ],
                                                [
                                                    -1.119,
                                                    -2.796
                                                ],
                                                [
                                                    -0.864,
                                                    -3.431
                                                ],
                                                [
                                                    -0.419,
                                                    -3.431
                                                ],
                                                [
                                                    -0.318,
                                                    -1.462
                                                ],
                                                [
                                                    -0.038,
                                                    -2.224
                                                ],
                                                [
                                                    0,
                                                    -0.483
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.127,
                                                    1.97
                                                ],
                                                [
                                                    -0.292,
                                                    1.475
                                                ],
                                                [
                                                    -0.191,
                                                    1.373
                                                ],
                                                [
                                                    -0.191,
                                                    2.084
                                                ],
                                                [
                                                    -0.394,
                                                    1.945
                                                ],
                                                [
                                                    -0.496,
                                                    1.411
                                                ],
                                                [
                                                    -0.369,
                                                    1.373
                                                ],
                                                [
                                                    -0.445,
                                                    2.021
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.813,
                                                    2.415
                                                ],
                                                [
                                                    -1.233,
                                                    2.898
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.729,
                                                    3.445
                                                ],
                                                [
                                                    -0.953,
                                                    1.627
                                                ],
                                                [
                                                    -0.991,
                                                    1.208
                                                ],
                                                [
                                                    -0.94,
                                                    1.385
                                                ],
                                                [
                                                    -0.877,
                                                    1.754
                                                ],
                                                [
                                                    -1.22,
                                                    1.589
                                                ],
                                                [
                                                    -1.042,
                                                    1.055
                                                ],
                                                [
                                                    -0.953,
                                                    1.094
                                                ],
                                                [
                                                    -1.258,
                                                    1.601
                                                ],
                                                [
                                                    -2.339,
                                                    2.339
                                                ],
                                                [
                                                    -0.343,
                                                    0.305
                                                ],
                                                [
                                                    -0.407,
                                                    0.216
                                                ],
                                                [
                                                    -0.343,
                                                    0.305
                                                ],
                                                [
                                                    0.076,
                                                    0.457
                                                ],
                                                [
                                                    0.991,
                                                    0.458
                                                ],
                                                [
                                                    1.182,
                                                    0.331
                                                ],
                                                [
                                                    1.678,
                                                    0.928
                                                ],
                                                [
                                                    0.877,
                                                    0.788
                                                ],
                                                [
                                                    0.94,
                                                    0.724
                                                ],
                                                [
                                                    1.665,
                                                    1.106
                                                ],
                                                [
                                                    1.843,
                                                    2.085
                                                ],
                                                [
                                                    1.652,
                                                    2.834
                                                ],
                                                [
                                                    0.813,
                                                    2.58
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.318,
                                                    3.698
                                                ],
                                                [
                                                    -0.331,
                                                    3
                                                ],
                                                [
                                                    -0.712,
                                                    2.542
                                                ],
                                                [
                                                    -0.305,
                                                    0.699
                                                ],
                                                [
                                                    -1.423,
                                                    3.406
                                                ],
                                                [
                                                    -0.788,
                                                    1.538
                                                ],
                                                [
                                                    -0.712,
                                                    1.626
                                                ],
                                                [
                                                    -0.89,
                                                    1.754
                                                ],
                                                [
                                                    -0.75,
                                                    1.36
                                                ],
                                                [
                                                    -0.826,
                                                    1.538
                                                ],
                                                [
                                                    -1.004,
                                                    1.411
                                                ],
                                                [
                                                    -0.839,
                                                    1.5
                                                ],
                                                [
                                                    -0.75,
                                                    1.741
                                                ],
                                                [
                                                    -1.563,
                                                    2.606
                                                ],
                                                [
                                                    -1.004,
                                                    1.551
                                                ],
                                                [
                                                    -1.042,
                                                    1.233
                                                ],
                                                [
                                                    -0.966,
                                                    1.372
                                                ],
                                                [
                                                    -0.941,
                                                    1.716
                                                ],
                                                [
                                                    -1.932,
                                                    2.466
                                                ],
                                                [
                                                    -0.89,
                                                    1.017
                                                ],
                                                [
                                                    -0.864,
                                                    0.801
                                                ],
                                                [
                                                    -1.487,
                                                    1.576
                                                ],
                                                [
                                                    -0.852,
                                                    0.801
                                                ],
                                                [
                                                    -2.58,
                                                    2.491
                                                ],
                                                [
                                                    -1.017,
                                                    0.928
                                                ],
                                                [
                                                    -1.449,
                                                    1.36
                                                ],
                                                [
                                                    -1.347,
                                                    1.131
                                                ],
                                                [
                                                    -1.309,
                                                    0.903
                                                ],
                                                [
                                                    -1.36,
                                                    1.093
                                                ],
                                                [
                                                    -1.195,
                                                    1.246
                                                ],
                                                [
                                                    -1.373,
                                                    1.081
                                                ],
                                                [
                                                    -1.347,
                                                    0.941
                                                ],
                                                [
                                                    -1.271,
                                                    0.979
                                                ],
                                                [
                                                    -1.424,
                                                    0.953
                                                ],
                                                [
                                                    -1.487,
                                                    1.157
                                                ],
                                                [
                                                    -1.144,
                                                    1.106
                                                ],
                                                [
                                                    -2.148,
                                                    1.741
                                                ],
                                                [
                                                    -1.322,
                                                    0.992
                                                ],
                                                [
                                                    -1.309,
                                                    0.724
                                                ],
                                                [
                                                    -1.271,
                                                    0.877
                                                ],
                                                [
                                                    -1.335,
                                                    1.118
                                                ],
                                                [
                                                    -1.601,
                                                    1.004
                                                ],
                                                [
                                                    -1.144,
                                                    0.61
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.593,
                                                    1.474
                                                ],
                                                [
                                                    -0.305,
                                                    0.152
                                                ],
                                                [
                                                    -2.135,
                                                    1.119
                                                ],
                                                [
                                                    -1.818,
                                                    0.839
                                                ],
                                                [
                                                    -1.551,
                                                    0.483
                                                ],
                                                [
                                                    -1.373,
                                                    0.546
                                                ],
                                                [
                                                    -1.983,
                                                    0.89
                                                ],
                                                [
                                                    -2.262,
                                                    0.775
                                                ],
                                                [
                                                    -1.233,
                                                    0.343
                                                ],
                                                [
                                                    -0.318,
                                                    0.102
                                                ],
                                                [
                                                    -0.203,
                                                    0.101
                                                ],
                                                [
                                                    -2.631,
                                                    0.712
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.191,
                                                    0.038
                                                ],
                                                [
                                                    -1.335,
                                                    0.318
                                                ],
                                                [
                                                    -1.792,
                                                    0.546
                                                ],
                                                [
                                                    -2.11,
                                                    0.343
                                                ],
                                                [
                                                    -1.131,
                                                    0.064
                                                ],
                                                [
                                                    -2.733,
                                                    0.229
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.445,
                                                    0
                                                ],
                                                [
                                                    -0.394,
                                                    -0.039
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.508,
                                                    -0.076
                                                ],
                                                [
                                                    -3.648,
                                                    -0.483
                                                ],
                                                [
                                                    -3.229,
                                                    -0.839
                                                ],
                                                [
                                                    -1.169,
                                                    -0.483
                                                ],
                                                [
                                                    -2.313,
                                                    -0.814
                                                ],
                                                [
                                                    -1.906,
                                                    -1.093
                                                ],
                                                [
                                                    -1.004,
                                                    -0.915
                                                ],
                                                [
                                                    -0.966,
                                                    -0.75
                                                ],
                                                [
                                                    -1.957,
                                                    -1.385
                                                ],
                                                [
                                                    -0.254,
                                                    -0.279
                                                ],
                                                [
                                                    -0.089,
                                                    0
                                                ],
                                                [
                                                    -3.47,
                                                    0.674
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.228,
                                                    0.483
                                                ],
                                                [
                                                    -2.555,
                                                    0.254
                                                ],
                                                [
                                                    -1.22,
                                                    0.051
                                                ],
                                                [
                                                    -3.381,
                                                    0.165
                                                ],
                                                [
                                                    -1.754,
                                                    0
                                                ],
                                                [
                                                    -1.385,
                                                    -0.153
                                                ],
                                                [
                                                    -1.411,
                                                    -0.051
                                                ],
                                                [
                                                    -1.83,
                                                    0.025
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.72,
                                                    -0.228
                                                ],
                                                [
                                                    -1.69,
                                                    -0.217
                                                ],
                                                [
                                                    -1.398,
                                                    -0.381
                                                ],
                                                [
                                                    -1.512,
                                                    -0.28
                                                ],
                                                [
                                                    -1.729,
                                                    -0.115
                                                ],
                                                [
                                                    -1.563,
                                                    -0.369
                                                ],
                                                [
                                                    -1.347,
                                                    -0.61
                                                ],
                                                [
                                                    -2.936,
                                                    -0.865
                                                ],
                                                [
                                                    -0.852,
                                                    -0.305
                                                ],
                                                [
                                                    -1.703,
                                                    -0.585
                                                ],
                                                [
                                                    -0.496,
                                                    -0.203
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.339,
                                                    2.097
                                                ],
                                                [
                                                    -2.39,
                                                    1.36
                                                ],
                                                [
                                                    -0.839,
                                                    0.267
                                                ],
                                                [
                                                    -0.839,
                                                    0.279
                                                ],
                                                [
                                                    -2.631,
                                                    0.94
                                                ],
                                                [
                                                    -3.419,
                                                    0.521
                                                ],
                                                [
                                                    -1.932,
                                                    0
                                                ],
                                                [
                                                    -1.258,
                                                    -0.216
                                                ],
                                                [
                                                    -1.195,
                                                    -0.152
                                                ],
                                                [
                                                    -2.174,
                                                    -0.153
                                                ],
                                                [
                                                    -2.034,
                                                    -0.496
                                                ],
                                                [
                                                    -1.169,
                                                    -0.457
                                                ],
                                                [
                                                    -1.385,
                                                    -0.457
                                                ],
                                                [
                                                    -1.957,
                                                    -0.483
                                                ],
                                                [
                                                    -2.224,
                                                    -0.991
                                                ],
                                                [
                                                    -0.788,
                                                    -0.457
                                                ],
                                                [
                                                    -2.885,
                                                    -1.652
                                                ],
                                                [
                                                    -1.589,
                                                    -1.144
                                                ],
                                                [
                                                    -0.941,
                                                    -0.991
                                                ],
                                                [
                                                    -0.991,
                                                    -0.89
                                                ],
                                                [
                                                    -1.652,
                                                    -1.297
                                                ],
                                                [
                                                    -2.25,
                                                    -2.504
                                                ],
                                                [
                                                    -1.169,
                                                    -1.601
                                                ],
                                                [
                                                    -0.597,
                                                    -1.195
                                                ],
                                                [
                                                    -1.868,
                                                    -3.19
                                                ],
                                                [
                                                    -1.411,
                                                    -3.025
                                                ],
                                                [
                                                    -1.017,
                                                    -2.809
                                                ],
                                                [
                                                    -0.318,
                                                    -1.131
                                                ],
                                                [
                                                    -0.635,
                                                    -2.046
                                                ],
                                                [
                                                    -0.381,
                                                    -1.856
                                                ],
                                                [
                                                    -0.114,
                                                    -1.423
                                                ],
                                                [
                                                    -0.191,
                                                    -1.436
                                                ],
                                                [
                                                    -0.394,
                                                    -1.856
                                                ],
                                                [
                                                    -0.114,
                                                    -1.423
                                                ],
                                                [
                                                    0.063,
                                                    -1.335
                                                ],
                                                [
                                                    -0.076,
                                                    -1.932
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    -1.487
                                                ],
                                                [
                                                    -0.203,
                                                    -1.639
                                                ],
                                                [
                                                    0.063,
                                                    -1.551
                                                ],
                                                [
                                                    0.229,
                                                    -1.411
                                                ],
                                                [
                                                    0.152,
                                                    -2.033
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.127,
                                                    -1.576
                                                ],
                                                [
                                                    -0.038,
                                                    -1.69
                                                ],
                                                [
                                                    0.14,
                                                    -1.347
                                                ],
                                                [
                                                    0.114,
                                                    -1.881
                                                ],
                                                [
                                                    0.229,
                                                    -1.614
                                                ],
                                                [
                                                    0.483,
                                                    -1.474
                                                ],
                                                [
                                                    0.28,
                                                    -1.475
                                                ],
                                                [
                                                    0.165,
                                                    -1.843
                                                ],
                                                [
                                                    0.445,
                                                    -1.766
                                                ],
                                                [
                                                    0.521,
                                                    -1.309
                                                ],
                                                [
                                                    0.343,
                                                    -1.042
                                                ],
                                                [
                                                    0.597,
                                                    -2.033
                                                ],
                                                [
                                                    1.983,
                                                    -4.753
                                                ],
                                                [
                                                    0.216,
                                                    -0.343
                                                ],
                                                [
                                                    -1.068,
                                                    -3.076
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.775,
                                                    -2.911
                                                ],
                                                [
                                                    -0.407,
                                                    -2.682
                                                ],
                                                [
                                                    0,
                                                    -0.813
                                                ],
                                                [
                                                    -0.025,
                                                    -1.03
                                                ],
                                                [
                                                    -0.127,
                                                    -2.517
                                                ],
                                                [
                                                    0.254,
                                                    -1.805
                                                ],
                                                [
                                                    0.445,
                                                    -1.246
                                                ],
                                                [
                                                    0.292,
                                                    -1.156
                                                ],
                                                [
                                                    0.432,
                                                    -2.034
                                                ],
                                                [
                                                    1.055,
                                                    -3.038
                                                ],
                                                [
                                                    0.572,
                                                    -1.36
                                                ],
                                                [
                                                    0.61,
                                                    -1.691
                                                ],
                                                [
                                                    1.004,
                                                    -2.174
                                                ],
                                                [
                                                    0.763,
                                                    -1.233
                                                ],
                                                [
                                                    0.712,
                                                    -1.271
                                                ],
                                                [
                                                    1.169,
                                                    -2.212
                                                ],
                                                [
                                                    1.22,
                                                    -1.906
                                                ],
                                                [
                                                    0.94,
                                                    -1.284
                                                ],
                                                [
                                                    1.03,
                                                    -1.5
                                                ],
                                                [
                                                    1.119,
                                                    -1.741
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.411,
                                                    -1.983
                                                ],
                                                [
                                                    0.852,
                                                    -1.22
                                                ],
                                                [
                                                    1.195,
                                                    -1.361
                                                ],
                                                [
                                                    1.042,
                                                    -1.576
                                                ],
                                                [
                                                    0.674,
                                                    -1.335
                                                ],
                                                [
                                                    0.724,
                                                    -1.182
                                                ],
                                                [
                                                    1.119,
                                                    -1.589
                                                ],
                                                [
                                                    0.902,
                                                    -1.665
                                                ],
                                                [
                                                    0.496,
                                                    -1.397
                                                ],
                                                [
                                                    0.585,
                                                    -1.22
                                                ],
                                                [
                                                    0.991,
                                                    -1.678
                                                ],
                                                [
                                                    1.144,
                                                    -2.797
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.153,
                                                    -0.432
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.262,
                                                    -3
                                                ],
                                                [
                                                    -1.093,
                                                    -3.177
                                                ],
                                                [
                                                    -0.051,
                                                    -4.156
                                                ],
                                                [
                                                    1.042,
                                                    -3.279
                                                ],
                                                [
                                                    1.741,
                                                    -2.873
                                                ],
                                                [
                                                    1.665,
                                                    -1.677
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.542,
                                                    -1.538
                                                ],
                                                [
                                                    0.343,
                                                    -0.102
                                                ],
                                                [
                                                    1.513,
                                                    -2.746
                                                ],
                                                [
                                                    0.674,
                                                    -0.991
                                                ],
                                                [
                                                    1.271,
                                                    -1.996
                                                ],
                                                [
                                                    1.398,
                                                    -1.716
                                                ],
                                                [
                                                    0.915,
                                                    -0.877
                                                ],
                                                [
                                                    1.119,
                                                    -1.144
                                                ],
                                                [
                                                    1.258,
                                                    -1.602
                                                ],
                                                [
                                                    1.5,
                                                    -1.334
                                                ],
                                                [
                                                    1.233,
                                                    -0.826
                                                ],
                                                [
                                                    2.974,
                                                    -2.275
                                                ],
                                                [
                                                    2.377,
                                                    -1.551
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.936,
                                                    -1.665
                                                ],
                                                [
                                                    1.119,
                                                    -0.546
                                                ],
                                                [
                                                    2.097,
                                                    -1.067
                                                ],
                                                [
                                                    3.61,
                                                    -1.462
                                                ],
                                                [
                                                    2.682,
                                                    -0.889
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.495,
                                                    -0.903
                                                ],
                                                [
                                                    3.178,
                                                    -0.572
                                                ],
                                                [
                                                    1.373,
                                                    -0.204
                                                ],
                                                [
                                                    1.818,
                                                    -0.343
                                                ],
                                                [
                                                    1.449,
                                                    -0.177
                                                ],
                                                [
                                                    1.729,
                                                    -0.292
                                                ],
                                                [
                                                    1.563,
                                                    -0.14
                                                ],
                                                [
                                                    1.601,
                                                    0.165
                                                ],
                                                [
                                                    1.055,
                                                    -0.063
                                                ],
                                                [
                                                    2.161,
                                                    -0.153
                                                ],
                                                [
                                                    1.525,
                                                    -0.038
                                                ],
                                                [
                                                    3.139,
                                                    -0.343
                                                ],
                                                [
                                                    1.995,
                                                    -0.038
                                                ],
                                                [
                                                    1.716,
                                                    0.051
                                                ],
                                                [
                                                    1.5,
                                                    0.241
                                                ],
                                                [
                                                    1.5,
                                                    0.102
                                                ],
                                                [
                                                    1.856,
                                                    0.012
                                                ],
                                                [
                                                    1.818,
                                                    0.177
                                                ],
                                                [
                                                    1.436,
                                                    0.292
                                                ],
                                                [
                                                    1.424,
                                                    0.203
                                                ],
                                                [
                                                    1.919,
                                                    0.19
                                                ],
                                                [
                                                    1.36,
                                                    0.255
                                                ],
                                                [
                                                    1.957,
                                                    0.279
                                                ],
                                                [
                                                    0.242,
                                                    0.254
                                                ],
                                                [
                                                    1.614,
                                                    0.369
                                                ],
                                                [
                                                    1.767,
                                                    0.241
                                                ],
                                                [
                                                    1.894,
                                                    0.495
                                                ],
                                                [
                                                    1.309,
                                                    0.433
                                                ],
                                                [
                                                    1.779,
                                                    0.521
                                                ],
                                                [
                                                    1.36,
                                                    0.559
                                                ],
                                                [
                                                    1.563,
                                                    0.521
                                                ],
                                                [
                                                    1.754,
                                                    0.381
                                                ],
                                                [
                                                    1.792,
                                                    0.687
                                                ],
                                                [
                                                    1.258,
                                                    0.635
                                                ],
                                                [
                                                    1.322,
                                                    0.584
                                                ],
                                                [
                                                    1.83,
                                                    0.686
                                                ],
                                                [
                                                    2.021,
                                                    1.03
                                                ],
                                                [
                                                    0.902,
                                                    0.547
                                                ],
                                                [
                                                    2.771,
                                                    1.64
                                                ],
                                                [
                                                    1.767,
                                                    1.22
                                                ],
                                                [
                                                    0.877,
                                                    0.762
                                                ],
                                                [
                                                    3.076,
                                                    2.517
                                                ],
                                                [
                                                    2.262,
                                                    2.237
                                                ],
                                                [
                                                    1.919,
                                                    2.364
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.691,
                                                    2.631
                                                ],
                                                [
                                                    0.508,
                                                    0.978
                                                ],
                                                [
                                                    0.267,
                                                    0.495
                                                ],
                                                [
                                                    0.686,
                                                    -0.089
                                                ],
                                                [
                                                    1.195,
                                                    -0.254
                                                ],
                                                [
                                                    3.279,
                                                    0
                                                ],
                                                [
                                                    3.457,
                                                    1.054
                                                ],
                                                [
                                                    2.999,
                                                    2.033
                                                ],
                                                [
                                                    2.555,
                                                    3.204
                                                ],
                                                [
                                                    0.216,
                                                    0.559
                                                ],
                                                [
                                                    1.436,
                                                    -0.102
                                                ],
                                                [
                                                    2.021,
                                                    -0.089
                                                ],
                                                [
                                                    1.335,
                                                    -0.127
                                                ],
                                                [
                                                    1.563,
                                                    -0.178
                                                ],
                                                [
                                                    1.131,
                                                    -0.089
                                                ],
                                                [
                                                    1.754,
                                                    -0.178
                                                ],
                                                [
                                                    1.563,
                                                    -0.076
                                                ],
                                                [
                                                    2.313,
                                                    0.153
                                                ],
                                                [
                                                    2.453,
                                                    -0.038
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.733,
                                                    0.216
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.898,
                                                    0.559
                                                ],
                                                [
                                                    2.173,
                                                    0.712
                                                ],
                                                [
                                                    0.953,
                                                    0.508
                                                ],
                                                [
                                                    0.839,
                                                    0.407
                                                ],
                                                [
                                                    2.301,
                                                    1.081
                                                ],
                                                [
                                                    2.911,
                                                    2.046
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.907,
                                                    1.83
                                                ],
                                                [
                                                    1.208,
                                                    1.614
                                                ],
                                                [
                                                    0.547,
                                                    1.144
                                                ],
                                                [
                                                    1.678,
                                                    3.063
                                                ],
                                                [
                                                    1.411,
                                                    3.495
                                                ],
                                                [
                                                    0.966,
                                                    3.889
                                                ],
                                                [
                                                    0.178,
                                                    1.5
                                                ],
                                                [
                                                    0.458,
                                                    2.148
                                                ],
                                                [
                                                    0.013,
                                                    0.47
                                                ],
                                                [
                                                    0,
                                                    2.885
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    282.507,
                                                    -91.996
                                                ],
                                                [
                                                    281.553,
                                                    -86.022
                                                ],
                                                [
                                                    280.765,
                                                    -81.611
                                                ],
                                                [
                                                    280.321,
                                                    -77.455
                                                ],
                                                [
                                                    279.507,
                                                    -71.164
                                                ],
                                                [
                                                    277.766,
                                                    -65.368
                                                ],
                                                [
                                                    276.38,
                                                    -61.11
                                                ],
                                                [
                                                    275.376,
                                                    -56.966
                                                ],
                                                [
                                                    273.775,
                                                    -50.917
                                                ],
                                                [
                                                    272.872,
                                                    -48.286
                                                ],
                                                [
                                                    270.216,
                                                    -41.003
                                                ],
                                                [
                                                    266.123,
                                                    -32.398
                                                ],
                                                [
                                                    265.666,
                                                    -31.495
                                                ],
                                                [
                                                    260.671,
                                                    -22.229
                                                ],
                                                [
                                                    257.251,
                                                    -17.603
                                                ],
                                                [
                                                    254.328,
                                                    -13.802
                                                ],
                                                [
                                                    251.913,
                                                    -9.469
                                                ],
                                                [
                                                    249.092,
                                                    -4.626
                                                ],
                                                [
                                                    244.986,
                                                    -0.114
                                                ],
                                                [
                                                    241.923,
                                                    3.115
                                                ],
                                                [
                                                    239.165,
                                                    6.509
                                                ],
                                                [
                                                    235.174,
                                                    11.211
                                                ],
                                                [
                                                    227.471,
                                                    18.417
                                                ],
                                                [
                                                    226.251,
                                                    19.193
                                                ],
                                                [
                                                    225.209,
                                                    19.867
                                                ],
                                                [
                                                    224.777,
                                                    21.074
                                                ],
                                                [
                                                    225.565,
                                                    22.104
                                                ],
                                                [
                                                    228.641,
                                                    23.133
                                                ],
                                                [
                                                    231.869,
                                                    24.315
                                                ],
                                                [
                                                    236.381,
                                                    27.849
                                                ],
                                                [
                                                    239.012,
                                                    30.111
                                                ],
                                                [
                                                    241.91,
                                                    32.132
                                                ],
                                                [
                                                    246.333,
                                                    35.589
                                                ],
                                                [
                                                    251.621,
                                                    43.076
                                                ],
                                                [
                                                    255.599,
                                                    52.011
                                                ],
                                                [
                                                    256.819,
                                                    59.968
                                                ],
                                                [
                                                    256.947,
                                                    61.646
                                                ],
                                                [
                                                    257.15,
                                                    71.381
                                                ],
                                                [
                                                    255.218,
                                                    81.003
                                                ],
                                                [
                                                    252.511,
                                                    88.108
                                                ],
                                                [
                                                    251.621,
                                                    90.155
                                                ],
                                                [
                                                    247.503,
                                                    99.141
                                                ],
                                                [
                                                    245.329,
                                                    103.907
                                                ],
                                                [
                                                    243.067,
                                                    108.813
                                                ],
                                                [
                                                    240.233,
                                                    114.037
                                                ],
                                                [
                                                    237.983,
                                                    118.142
                                                ],
                                                [
                                                    235.072,
                                                    122.641
                                                ],
                                                [
                                                    232.162,
                                                    127.064
                                                ],
                                                [
                                                    229.975,
                                                    131.717
                                                ],
                                                [
                                                    227.599,
                                                    136.674
                                                ],
                                                [
                                                    221.968,
                                                    145.672
                                                ],
                                                [
                                                    218.511,
                                                    150.146
                                                ],
                                                [
                                                    215.422,
                                                    154.023
                                                ],
                                                [
                                                    212.855,
                                                    158.306
                                                ],
                                                [
                                                    209.893,
                                                    163.086
                                                ],
                                                [
                                                    203.195,
                                                    171.296
                                                ],
                                                [
                                                    200.259,
                                                    174.22
                                                ],
                                                [
                                                    197.73,
                                                    176.685
                                                ],
                                                [
                                                    193.04,
                                                    181.249
                                                ],
                                                [
                                                    190.51,
                                                    183.65
                                                ],
                                                [
                                                    183.176,
                                                    190.489
                                                ],
                                                [
                                                    180.164,
                                                    193.298
                                                ],
                                                [
                                                    175.779,
                                                    197.289
                                                ],
                                                [
                                                    171.508,
                                                    200.479
                                                ],
                                                [
                                                    167.683,
                                                    203.288
                                                ],
                                                [
                                                    163.946,
                                                    206.847
                                                ],
                                                [
                                                    160.374,
                                                    210.24
                                                ],
                                                [
                                                    156.18,
                                                    213.278
                                                ],
                                                [
                                                    152.227,
                                                    216.138
                                                ],
                                                [
                                                    148.287,
                                                    218.909
                                                ],
                                                [
                                                    144.016,
                                                    221.934
                                                ],
                                                [
                                                    139.936,
                                                    225.633
                                                ],
                                                [
                                                    136.581,
                                                    228.721
                                                ],
                                                [
                                                    129.018,
                                                    234.593
                                                ],
                                                [
                                                    124.709,
                                                    237.211
                                                ],
                                                [
                                                    120.795,
                                                    239.538
                                                ],
                                                [
                                                    117.21,
                                                    242.372
                                                ],
                                                [
                                                    113.232,
                                                    245.435
                                                ],
                                                [
                                                    108.25,
                                                    248.231
                                                ],
                                                [
                                                    104.869,
                                                    250.074
                                                ],
                                                [
                                                    104.437,
                                                    250.328
                                                ],
                                                [
                                                    96.531,
                                                    254.701
                                                ],
                                                [
                                                    95.946,
                                                    255.171
                                                ],
                                                [
                                                    87.812,
                                                    259.15
                                                ],
                                                [
                                                    82.079,
                                                    261.234
                                                ],
                                                [
                                                    77.376,
                                                    262.861
                                                ],
                                                [
                                                    73.284,
                                                    264.627
                                                ],
                                                [
                                                    67.208,
                                                    267.145
                                                ],
                                                [
                                                    60.294,
                                                    269.178
                                                ],
                                                [
                                                    56.583,
                                                    270.207
                                                ],
                                                [
                                                    55.667,
                                                    270.589
                                                ],
                                                [
                                                    55.108,
                                                    270.83
                                                ],
                                                [
                                                    46.186,
                                                    272.889
                                                ],
                                                [
                                                    44.927,
                                                    273.169
                                                ],
                                                [
                                                    44.927,
                                                    273.182
                                                ],
                                                [
                                                    44.381,
                                                    273.436
                                                ],
                                                [
                                                    40.441,
                                                    274.567
                                                ],
                                                [
                                                    35.268,
                                                    275.915
                                                ],
                                                [
                                                    28.887,
                                                    276.486
                                                ],
                                                [
                                                    25.531,
                                                    276.702
                                                ],
                                                [
                                                    17.372,
                                                    276.918
                                                ],
                                                [
                                                    15.808,
                                                    276.906
                                                ],
                                                [
                                                    14.486,
                                                    276.842
                                                ],
                                                [
                                                    13.304,
                                                    276.766
                                                ],
                                                [
                                                    12.593,
                                                    276.753
                                                ],
                                                [
                                                    2.526,
                                                    276.181
                                                ],
                                                [
                                                    -8.023,
                                                    273.969
                                                ],
                                                [
                                                    -18.166,
                                                    270.563
                                                ],
                                                [
                                                    -21.7,
                                                    269.242
                                                ],
                                                [
                                                    -28.156,
                                                    266.521
                                                ],
                                                [
                                                    -33.444,
                                                    262.378
                                                ],
                                                [
                                                    -36.52,
                                                    259.734
                                                ],
                                                [
                                                    -39.43,
                                                    257.586
                                                ],
                                                [
                                                    -44.82,
                                                    253.213
                                                ],
                                                [
                                                    -45.811,
                                                    252.781
                                                ],
                                                [
                                                    -46.065,
                                                    252.807
                                                ],
                                                [
                                                    -57.11,
                                                    254.752
                                                ],
                                                [
                                                    -58.585,
                                                    254.968
                                                ],
                                                [
                                                    -68.397,
                                                    256.251
                                                ],
                                                [
                                                    -76.112,
                                                    256.683
                                                ],
                                                [
                                                    -79.773,
                                                    256.836
                                                ],
                                                [
                                                    -91.136,
                                                    257.077
                                                ],
                                                [
                                                    -96.423,
                                                    256.722
                                                ],
                                                [
                                                    -100.579,
                                                    256.366
                                                ],
                                                [
                                                    -104.786,
                                                    256.353
                                                ],
                                                [
                                                    -110.048,
                                                    256.251
                                                ],
                                                [
                                                    -111.243,
                                                    256.15
                                                ],
                                                [
                                                    -119.454,
                                                    255.311
                                                ],
                                                [
                                                    -124.487,
                                                    254.18
                                                ],
                                                [
                                                    -128.682,
                                                    253.163
                                                ],
                                                [
                                                    -133.194,
                                                    252.693
                                                ],
                                                [
                                                    -138.1,
                                                    252.095
                                                ],
                                                [
                                                    -142.739,
                                                    250.354
                                                ],
                                                [
                                                    -146.959,
                                                    248.676
                                                ],
                                                [
                                                    -154.521,
                                                    246.223
                                                ],
                                                [
                                                    -157.127,
                                                    245.321
                                                ],
                                                [
                                                    -162.173,
                                                    243.439
                                                ],
                                                [
                                                    -163.622,
                                                    243.668
                                                ],
                                                [
                                                    -164.982,
                                                    244.889
                                                ],
                                                [
                                                    -172.405,
                                                    250.671
                                                ],
                                                [
                                                    -180.311,
                                                    253.786
                                                ],
                                                [
                                                    -182.814,
                                                    254.599
                                                ],
                                                [
                                                    -185.344,
                                                    255.476
                                                ],
                                                [
                                                    -193.491,
                                                    257.815
                                                ],
                                                [
                                                    -204.689,
                                                    258.603
                                                ],
                                                [
                                                    -210.65,
                                                    257.866
                                                ],
                                                [
                                                    -214.425,
                                                    257.268
                                                ],
                                                [
                                                    -218.009,
                                                    256.938
                                                ],
                                                [
                                                    -224.199,
                                                    256.163
                                                ],
                                                [
                                                    -230.186,
                                                    254.129
                                                ],
                                                [
                                                    -233.706,
                                                    252.819
                                                ],
                                                [
                                                    -237.901,
                                                    251.663
                                                ],
                                                [
                                                    -243.404,
                                                    249.96
                                                ],
                                                [
                                                    -249.874,
                                                    246.452
                                                ],
                                                [
                                                    -252.225,
                                                    245.079
                                                ],
                                                [
                                                    -260.779,
                                                    239.779
                                                ],
                                                [
                                                    -265.164,
                                                    235.725
                                                ],
                                                [
                                                    -268.062,
                                                    232.839
                                                ],
                                                [
                                                    -271.151,
                                                    230.297
                                                ],
                                                [
                                                    -275.701,
                                                    226.294
                                                ],
                                                [
                                                    -282.018,
                                                    218.464
                                                ],
                                                [
                                                    -285.043,
                                                    213.202
                                                ],
                                                [
                                                    -286.911,
                                                    209.668
                                                ],
                                                [
                                                    -291.677,
                                                    200.848
                                                ],
                                                [
                                                    -295.516,
                                                    191.557
                                                ],
                                                [
                                                    -298.541,
                                                    181.96
                                                ],
                                                [
                                                    -299.571,
                                                    178.554
                                                ],
                                                [
                                                    -301.299,
                                                    172.25
                                                ],
                                                [
                                                    -301.998,
                                                    166.492
                                                ],
                                                [
                                                    -302.43,
                                                    162.196
                                                ],
                                                [
                                                    -303.244,
                                                    157.9
                                                ],
                                                [
                                                    -304.197,
                                                    152.218
                                                ],
                                                [
                                                    -304.172,
                                                    147.757
                                                ],
                                                [
                                                    -304.108,
                                                    143.703
                                                ],
                                                [
                                                    -304.146,
                                                    137.818
                                                ],
                                                [
                                                    -304.134,
                                                    135.212
                                                ],
                                                [
                                                    -304.477,
                                                    130.801
                                                ],
                                                [
                                                    -304.807,
                                                    126.061
                                                ],
                                                [
                                                    -304.197,
                                                    121.32
                                                ],
                                                [
                                                    -303.612,
                                                    116.973
                                                ],
                                                [
                                                    -303.129,
                                                    110.796
                                                ],
                                                [
                                                    -302.824,
                                                    107.161
                                                ],
                                                [
                                                    -302.774,
                                                    102.42
                                                ],
                                                [
                                                    -302.685,
                                                    97.31
                                                ],
                                                [
                                                    -302.367,
                                                    93.217
                                                ],
                                                [
                                                    -301.858,
                                                    87.511
                                                ],
                                                [
                                                    -300.575,
                                                    82.604
                                                ],
                                                [
                                                    -299.291,
                                                    78.004
                                                ],
                                                [
                                                    -298.744,
                                                    73.581
                                                ],
                                                [
                                                    -297.982,
                                                    68.28
                                                ],
                                                [
                                                    -296.126,
                                                    63.018
                                                ],
                                                [
                                                    -294.639,
                                                    59.065
                                                ],
                                                [
                                                    -293.66,
                                                    55.887
                                                ],
                                                [
                                                    -291.614,
                                                    49.787
                                                ],
                                                [
                                                    -284.928,
                                                    36.517
                                                ],
                                                [
                                                    -284.801,
                                                    35.36
                                                ],
                                                [
                                                    -287.865,
                                                    25.116
                                                ],
                                                [
                                                    -288.271,
                                                    23.566
                                                ],
                                                [
                                                    -290.305,
                                                    14.668
                                                ],
                                                [
                                                    -290.775,
                                                    6.445
                                                ],
                                                [
                                                    -290.801,
                                                    4.004
                                                ],
                                                [
                                                    -290.928,
                                                    0.916
                                                ],
                                                [
                                                    -290.851,
                                                    -6.672
                                                ],
                                                [
                                                    -289.339,
                                                    -12.023
                                                ],
                                                [
                                                    -288.144,
                                                    -15.773
                                                ],
                                                [
                                                    -287.369,
                                                    -19.217
                                                ],
                                                [
                                                    -285.894,
                                                    -24.988
                                                ],
                                                [
                                                    -282.374,
                                                    -33.821
                                                ],
                                                [
                                                    -280.81,
                                                    -37.952
                                                ],
                                                [
                                                    -278.929,
                                                    -42.743
                                                ],
                                                [
                                                    -275.383,
                                                    -49.035
                                                ],
                                                [
                                                    -273.171,
                                                    -52.734
                                                ],
                                                [
                                                    -271.125,
                                                    -56.56
                                                ],
                                                [
                                                    -267.592,
                                                    -62.852
                                                ],
                                                [
                                                    -263.651,
                                                    -68.405
                                                ],
                                                [
                                                    -260.855,
                                                    -72.257
                                                ],
                                                [
                                                    -257.856,
                                                    -76.794
                                                ],
                                                [
                                                    -254.449,
                                                    -81.917
                                                ],
                                                [
                                                    -252.86,
                                                    -84.141
                                                ],
                                                [
                                                    -248.615,
                                                    -90.14
                                                ],
                                                [
                                                    -245.692,
                                                    -93.686
                                                ],
                                                [
                                                    -242.222,
                                                    -98.021
                                                ],
                                                [
                                                    -239.502,
                                                    -102.952
                                                ],
                                                [
                                                    -237.367,
                                                    -106.956
                                                ],
                                                [
                                                    -235.028,
                                                    -110.425
                                                ],
                                                [
                                                    -231.774,
                                                    -115.459
                                                ],
                                                [
                                                    -229.601,
                                                    -120.708
                                                ],
                                                [
                                                    -227.961,
                                                    -124.916
                                                ],
                                                [
                                                    -225.94,
                                                    -128.588
                                                ],
                                                [
                                                    -223.169,
                                                    -133.901
                                                ],
                                                [
                                                    -219.941,
                                                    -142.748
                                                ],
                                                [
                                                    -219.649,
                                                    -143.612
                                                ],
                                                [
                                                    -219.852,
                                                    -144.883
                                                ],
                                                [
                                                    -220.259,
                                                    -145.417
                                                ],
                                                [
                                                    -226.029,
                                                    -154.899
                                                ],
                                                [
                                                    -227.745,
                                                    -166.478
                                                ],
                                                [
                                                    -226.182,
                                                    -178.019
                                                ],
                                                [
                                                    -222.636,
                                                    -186.204
                                                ],
                                                [
                                                    -217.234,
                                                    -193.322
                                                ],
                                                [
                                                    -211.273,
                                                    -197.529
                                                ],
                                                [
                                                    -209.887,
                                                    -198.355
                                                ],
                                                [
                                                    -201.6,
                                                    -201.685
                                                ],
                                                [
                                                    -200.799,
                                                    -202.333
                                                ],
                                                [
                                                    -195.194,
                                                    -211.345
                                                ],
                                                [
                                                    -193.211,
                                                    -214.382
                                                ],
                                                [
                                                    -189.297,
                                                    -220.026
                                                ],
                                                [
                                                    -184.657,
                                                    -224.881
                                                ],
                                                [
                                                    -181.963,
                                                    -227.551
                                                ],
                                                [
                                                    -178.9,
                                                    -231.173
                                                ],
                                                [
                                                    -175.036,
                                                    -235.532
                                                ],
                                                [
                                                    -170.079,
                                                    -239.155
                                                ],
                                                [
                                                    -166.444,
                                                    -241.684
                                                ],
                                                [
                                                    -157.826,
                                                    -247.721
                                                ],
                                                [
                                                    -150.505,
                                                    -252.056
                                                ],
                                                [
                                                    -148.128,
                                                    -253.39
                                                ],
                                                [
                                                    -139.498,
                                                    -258.03
                                                ],
                                                [
                                                    -136.181,
                                                    -259.707
                                                ],
                                                [
                                                    -130.016,
                                                    -262.643
                                                ],
                                                [
                                                    -120.14,
                                                    -266.317
                                                ],
                                                [
                                                    -112.031,
                                                    -268.579
                                                ],
                                                [
                                                    -109.972,
                                                    -269.1
                                                ],
                                                [
                                                    -99.677,
                                                    -271.261
                                                ],
                                                [
                                                    -90.132,
                                                    -272.849
                                                ],
                                                [
                                                    -86.026,
                                                    -273.561
                                                ],
                                                [
                                                    -80.561,
                                                    -274.451
                                                ],
                                                [
                                                    -76.214,
                                                    -275.125
                                                ],
                                                [
                                                    -70.952,
                                                    -275.887
                                                ],
                                                [
                                                    -66.109,
                                                    -275.709
                                                ],
                                                [
                                                    -61.203,
                                                    -275.481
                                                ],
                                                [
                                                    -58.026,
                                                    -275.697
                                                ],
                                                [
                                                    -51.543,
                                                    -276.065
                                                ],
                                                [
                                                    -46.968,
                                                    -276.434
                                                ],
                                                [
                                                    -37.943,
                                                    -276.866
                                                ],
                                                [
                                                    -31.982,
                                                    -276.879
                                                ],
                                                [
                                                    -26.784,
                                                    -276.281
                                                ],
                                                [
                                                    -22.17,
                                                    -275.697
                                                ],
                                                [
                                                    -17.671,
                                                    -275.57
                                                ],
                                                [
                                                    -12.307,
                                                    -275.366
                                                ],
                                                [
                                                    -6.88,
                                                    -274.451
                                                ],
                                                [
                                                    -2.596,
                                                    -273.675
                                                ],
                                                [
                                                    1.649,
                                                    -273.206
                                                ],
                                                [
                                                    7.178,
                                                    -272.519
                                                ],
                                                [
                                                    11.258,
                                                    -271.871
                                                ],
                                                [
                                                    17.054,
                                                    -270.778
                                                ],
                                                [
                                                    18.554,
                                                    -269.913
                                                ],
                                                [
                                                    23.371,
                                                    -269.138
                                                ],
                                                [
                                                    28.404,
                                                    -268.273
                                                ],
                                                [
                                                    33.997,
                                                    -266.558
                                                ],
                                                [
                                                    37.911,
                                                    -265.312
                                                ],
                                                [
                                                    43.135,
                                                    -263.393
                                                ],
                                                [
                                                    47.228,
                                                    -261.83
                                                ],
                                                [
                                                    51.918,
                                                    -260.61
                                                ],
                                                [
                                                    56.862,
                                                    -259.275
                                                ],
                                                [
                                                    62.086,
                                                    -256.847
                                                ],
                                                [
                                                    65.861,
                                                    -255.03
                                                ],
                                                [
                                                    69.877,
                                                    -253.428
                                                ],
                                                [
                                                    75.063,
                                                    -251.268
                                                ],
                                                [
                                                    80.923,
                                                    -247.887
                                                ],
                                                [
                                                    83.63,
                                                    -246.26
                                                ],
                                                [
                                                    92.019,
                                                    -241.023
                                                ],
                                                [
                                                    97.014,
                                                    -236.969
                                                ],
                                                [
                                                    99.645,
                                                    -234.719
                                                ],
                                                [
                                                    107.017,
                                                    -228.186
                                                ],
                                                [
                                                    113.728,
                                                    -221.004
                                                ],
                                                [
                                                    118.914,
                                                    -213.519
                                                ],
                                                [
                                                    119.307,
                                                    -212.921
                                                ],
                                                [
                                                    123.731,
                                                    -205.091
                                                ],
                                                [
                                                    125.23,
                                                    -202.257
                                                ],
                                                [
                                                    126.629,
                                                    -201.571
                                                ],
                                                [
                                                    128.777,
                                                    -201.978
                                                ],
                                                [
                                                    132.247,
                                                    -202.486
                                                ],
                                                [
                                                    143.025,
                                                    -200.668
                                                ],
                                                [
                                                    152.837,
                                                    -195.927
                                                ],
                                                [
                                                    160.476,
                                                    -188.225
                                                ],
                                                [
                                                    166.259,
                                                    -178.997
                                                ],
                                                [
                                                    167.632,
                                                    -178.133
                                                ],
                                                [
                                                    172.055,
                                                    -178.362
                                                ],
                                                [
                                                    178.207,
                                                    -178.717
                                                ],
                                                [
                                                    182.21,
                                                    -179.162
                                                ],
                                                [
                                                    186.913,
                                                    -179.658
                                                ],
                                                [
                                                    190.307,
                                                    -179.976
                                                ],
                                                [
                                                    195.594,
                                                    -180.421
                                                ],
                                                [
                                                    200.399,
                                                    -180.294
                                                ],
                                                [
                                                    207.364,
                                                    -180.154
                                                ],
                                                [
                                                    214.405,
                                                    -180.027
                                                ],
                                                [
                                                    216.655,
                                                    -179.849
                                                ],
                                                [
                                                    224.459,
                                                    -178.934
                                                ],
                                                [
                                                    226.099,
                                                    -178.629
                                                ],
                                                [
                                                    234.31,
                                                    -176.71
                                                ],
                                                [
                                                    240.538,
                                                    -173.799
                                                ],
                                                [
                                                    243.372,
                                                    -172.312
                                                ],
                                                [
                                                    245.876,
                                                    -171.13
                                                ],
                                                [
                                                    252.282,
                                                    -167.672
                                                ],
                                                [
                                                    259.895,
                                                    -161.114
                                                ],
                                                [
                                                    261.408,
                                                    -159.652
                                                ],
                                                [
                                                    266.86,
                                                    -153.806
                                                ],
                                                [
                                                    269.911,
                                                    -148.315
                                                ],
                                                [
                                                    271.627,
                                                    -144.883
                                                ],
                                                [
                                                    275.808,
                                                    -135.745
                                                ],
                                                [
                                                    279.037,
                                                    -125.182
                                                ],
                                                [
                                                    281.109,
                                                    -114.302
                                                ],
                                                [
                                                    281.922,
                                                    -109.828
                                                ],
                                                [
                                                    282.888,
                                                    -103.232
                                                ],
                                                [
                                                    282.901,
                                                    -101.808
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ind": 1,
                                    "ty": "sh",
                                    "ix": 2,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [
                                                    0.051,
                                                    3.356
                                                ],
                                                [
                                                    0.483,
                                                    2.275
                                                ],
                                                [
                                                    0.178,
                                                    1.373
                                                ],
                                                [
                                                    0.991,
                                                    3.991
                                                ],
                                                [
                                                    1.474,
                                                    3.66
                                                ],
                                                [
                                                    1.754,
                                                    3.203
                                                ],
                                                [
                                                    0.534,
                                                    1.106
                                                ],
                                                [
                                                    1.36,
                                                    1.831
                                                ],
                                                [
                                                    1.983,
                                                    1.906
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.076,
                                                    2.161
                                                ],
                                                [
                                                    2.301,
                                                    1.08
                                                ],
                                                [
                                                    0.801,
                                                    0.394
                                                ],
                                                [
                                                    0.915,
                                                    0.496
                                                ],
                                                [
                                                    2.415,
                                                    0.788
                                                ],
                                                [
                                                    2.86,
                                                    0.546
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.809,
                                                    0.216
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.529,
                                                    -0.038
                                                ],
                                                [
                                                    2.237,
                                                    0.153
                                                ],
                                                [
                                                    1.716,
                                                    -0.089
                                                ],
                                                [
                                                    1.805,
                                                    -0.19
                                                ],
                                                [
                                                    1.119,
                                                    -0.089
                                                ],
                                                [
                                                    1.589,
                                                    -0.19
                                                ],
                                                [
                                                    1.309,
                                                    -0.127
                                                ],
                                                [
                                                    1.983,
                                                    -0.089
                                                ],
                                                [
                                                    1.156,
                                                    -0.063
                                                ],
                                                [
                                                    2.148,
                                                    2.695
                                                ],
                                                [
                                                    3.317,
                                                    2.25
                                                ],
                                                [
                                                    3.699,
                                                    1.144
                                                ],
                                                [
                                                    3.546,
                                                    0
                                                ],
                                                [
                                                    1.347,
                                                    -0.292
                                                ],
                                                [
                                                    0.343,
                                                    -0.076
                                                ],
                                                [
                                                    0.343,
                                                    0.66
                                                ],
                                                [
                                                    1.754,
                                                    2.72
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.034,
                                                    2.491
                                                ],
                                                [
                                                    2.326,
                                                    2.288
                                                ],
                                                [
                                                    3.152,
                                                    2.581
                                                ],
                                                [
                                                    0.852,
                                                    0.75
                                                ],
                                                [
                                                    1.894,
                                                    1.309
                                                ],
                                                [
                                                    2.822,
                                                    1.652
                                                ],
                                                [
                                                    0.89,
                                                    0.547
                                                ],
                                                [
                                                    2.123,
                                                    1.08
                                                ],
                                                [
                                                    1.817,
                                                    0.686
                                                ],
                                                [
                                                    1.284,
                                                    0.572
                                                ],
                                                [
                                                    1.22,
                                                    0.61
                                                ],
                                                [
                                                    1.919,
                                                    0.737
                                                ],
                                                [
                                                    1.767,
                                                    0.381
                                                ],
                                                [
                                                    1.423,
                                                    0.47
                                                ],
                                                [
                                                    1.322,
                                                    0.534
                                                ],
                                                [
                                                    1.907,
                                                    0.56
                                                ],
                                                [
                                                    1.284,
                                                    0.42
                                                ],
                                                [
                                                    1.983,
                                                    0.508
                                                ],
                                                [
                                                    1.767,
                                                    0.229
                                                ],
                                                [
                                                    1.64,
                                                    0.445
                                                ],
                                                [
                                                    0.826,
                                                    0.191
                                                ],
                                                [
                                                    1.945,
                                                    0.28
                                                ],
                                                [
                                                    1.322,
                                                    0.254
                                                ],
                                                [
                                                    1.894,
                                                    0.178
                                                ],
                                                [
                                                    1.373,
                                                    0.191
                                                ],
                                                [
                                                    1.373,
                                                    0.28
                                                ],
                                                [
                                                    1.945,
                                                    0.191
                                                ],
                                                [
                                                    1.843,
                                                    0.025
                                                ],
                                                [
                                                    1.449,
                                                    0.102
                                                ],
                                                [
                                                    1.512,
                                                    0.229
                                                ],
                                                [
                                                    1.894,
                                                    0.051
                                                ],
                                                [
                                                    2.046,
                                                    -0.039
                                                ],
                                                [
                                                    3,
                                                    -0.331
                                                ],
                                                [
                                                    1.449,
                                                    -0.038
                                                ],
                                                [
                                                    2.199,
                                                    -0.153
                                                ],
                                                [
                                                    1.055,
                                                    -0.063
                                                ],
                                                [
                                                    1.563,
                                                    0.153
                                                ],
                                                [
                                                    1.83,
                                                    -0.165
                                                ],
                                                [
                                                    1.779,
                                                    -0.305
                                                ],
                                                [
                                                    1.411,
                                                    -0.166
                                                ],
                                                [
                                                    1.881,
                                                    -0.343
                                                ],
                                                [
                                                    1.347,
                                                    -0.203
                                                ],
                                                [
                                                    3.203,
                                                    -0.572
                                                ],
                                                [
                                                    3.584,
                                                    -0.928
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.783,
                                                    -0.928
                                                ],
                                                [
                                                    3.673,
                                                    -1.5
                                                ],
                                                [
                                                    2.059,
                                                    -1.054
                                                ],
                                                [
                                                    1.106,
                                                    -0.534
                                                ],
                                                [
                                                    2.847,
                                                    -1.614
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.453,
                                                    -1.614
                                                ],
                                                [
                                                    3.05,
                                                    -2.326
                                                ],
                                                [
                                                    1.182,
                                                    -0.788
                                                ],
                                                [
                                                    1.652,
                                                    -1.448
                                                ],
                                                [
                                                    1.271,
                                                    -1.627
                                                ],
                                                [
                                                    1.004,
                                                    -1.055
                                                ],
                                                [
                                                    0.877,
                                                    -0.852
                                                ],
                                                [
                                                    1.5,
                                                    -1.83
                                                ],
                                                [
                                                    1.271,
                                                    -1.97
                                                ],
                                                [
                                                    0.661,
                                                    -0.979
                                                ],
                                                [
                                                    1.513,
                                                    -2.682
                                                ],
                                                [
                                                    2.656,
                                                    -1.614
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.919,
                                                    -1.919
                                                ],
                                                [
                                                    1.843,
                                                    -3.063
                                                ],
                                                [
                                                    1.119,
                                                    -3.483
                                                ],
                                                [
                                                    -0.063,
                                                    -4.448
                                                ],
                                                [
                                                    -1.182,
                                                    -3.458
                                                ],
                                                [
                                                    -2.39,
                                                    -3.152
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.106,
                                                    -2.72
                                                ],
                                                [
                                                    0.928,
                                                    -1.589
                                                ],
                                                [
                                                    0.623,
                                                    -1.334
                                                ],
                                                [
                                                    0.521,
                                                    -1.475
                                                ],
                                                [
                                                    0.801,
                                                    -1.488
                                                ],
                                                [
                                                    1.08,
                                                    -1.525
                                                ],
                                                [
                                                    0.75,
                                                    -1.233
                                                ],
                                                [
                                                    0.686,
                                                    -1.386
                                                ],
                                                [
                                                    0.94,
                                                    -1.424
                                                ],
                                                [
                                                    1.144,
                                                    -1.283
                                                ],
                                                [
                                                    0.941,
                                                    -1.347
                                                ],
                                                [
                                                    1.423,
                                                    -1.983
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.131,
                                                    -1.766
                                                ],
                                                [
                                                    1.017,
                                                    -1.475
                                                ],
                                                [
                                                    0.928,
                                                    -1.246
                                                ],
                                                [
                                                    1.271,
                                                    -1.983
                                                ],
                                                [
                                                    1.131,
                                                    -2.161
                                                ],
                                                [
                                                    0.687,
                                                    -1.232
                                                ],
                                                [
                                                    0.737,
                                                    -1.195
                                                ],
                                                [
                                                    1.081,
                                                    -2.326
                                                ],
                                                [
                                                    0.61,
                                                    -1.678
                                                ],
                                                [
                                                    0.559,
                                                    -1.309
                                                ],
                                                [
                                                    1.081,
                                                    -3.114
                                                ],
                                                [
                                                    0.432,
                                                    -2.021
                                                ],
                                                [
                                                    0.28,
                                                    -1.106
                                                ],
                                                [
                                                    0.407,
                                                    -1.182
                                                ],
                                                [
                                                    0.292,
                                                    -2.097
                                                ],
                                                [
                                                    -0.127,
                                                    -2.644
                                                ],
                                                [
                                                    -0.025,
                                                    -0.992
                                                ],
                                                [
                                                    -0.013,
                                                    -0.801
                                                ],
                                                [
                                                    -0.432,
                                                    -2.873
                                                ],
                                                [
                                                    -0.788,
                                                    -2.974
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.004,
                                                    -2.974
                                                ],
                                                [
                                                    1.945,
                                                    -4.665
                                                ],
                                                [
                                                    0.623,
                                                    -2.085
                                                ],
                                                [
                                                    0.343,
                                                    -1.03
                                                ],
                                                [
                                                    0.509,
                                                    -1.245
                                                ],
                                                [
                                                    0.496,
                                                    -1.932
                                                ],
                                                [
                                                    0.165,
                                                    -1.881
                                                ],
                                                [
                                                    0.254,
                                                    -1.347
                                                ],
                                                [
                                                    0.47,
                                                    -1.462
                                                ],
                                                [
                                                    0.254,
                                                    -1.843
                                                ],
                                                [
                                                    0.127,
                                                    -1.931
                                                ],
                                                [
                                                    0.14,
                                                    -1.309
                                                ],
                                                [
                                                    -0.051,
                                                    -1.767
                                                ],
                                                [
                                                    0.115,
                                                    -1.437
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.14,
                                                    -2.046
                                                ],
                                                [
                                                    0.241,
                                                    -1.411
                                                ],
                                                [
                                                    0.063,
                                                    -1.729
                                                ],
                                                [
                                                    -0.203,
                                                    -1.665
                                                ],
                                                [
                                                    0,
                                                    -1.334
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.076,
                                                    -1.983
                                                ],
                                                [
                                                    0.051,
                                                    -1.259
                                                ],
                                                [
                                                    -0.14,
                                                    -1.589
                                                ],
                                                [
                                                    -0.42,
                                                    -1.945
                                                ],
                                                [
                                                    -0.191,
                                                    -1.36
                                                ],
                                                [
                                                    -0.114,
                                                    -1.372
                                                ],
                                                [
                                                    -0.419,
                                                    -2.008
                                                ],
                                                [
                                                    -0.661,
                                                    -2.11
                                                ],
                                                [
                                                    -0.305,
                                                    -1.105
                                                ],
                                                [
                                                    -1.055,
                                                    -2.885
                                                ],
                                                [
                                                    -1.436,
                                                    -3.089
                                                ],
                                                [
                                                    -1.5,
                                                    -2.555
                                                ],
                                                [
                                                    -0.572,
                                                    -1.144
                                                ],
                                                [
                                                    -1.284,
                                                    -1.767
                                                ],
                                                [
                                                    -2.313,
                                                    -2.58
                                                ],
                                                [
                                                    -1.678,
                                                    -1.322
                                                ],
                                                [
                                                    -0.941,
                                                    -0.852
                                                ],
                                                [
                                                    -0.902,
                                                    -0.928
                                                ],
                                                [
                                                    -1.792,
                                                    -1.283
                                                ],
                                                [
                                                    -2.936,
                                                    -1.677
                                                ],
                                                [
                                                    -0.775,
                                                    -0.458
                                                ],
                                                [
                                                    -2.377,
                                                    -1.055
                                                ],
                                                [
                                                    -1.983,
                                                    -0.496
                                                ],
                                                [
                                                    -1.309,
                                                    -0.444
                                                ],
                                                [
                                                    -1.144,
                                                    -0.444
                                                ],
                                                [
                                                    -2.212,
                                                    -0.534
                                                ],
                                                [
                                                    -2.173,
                                                    -0.152
                                                ],
                                                [
                                                    -1.131,
                                                    -0.14
                                                ],
                                                [
                                                    -1.195,
                                                    -0.216
                                                ],
                                                [
                                                    -2.173,
                                                    0
                                                ],
                                                [
                                                    -3.546,
                                                    0.547
                                                ],
                                                [
                                                    -2.758,
                                                    0.979
                                                ],
                                                [
                                                    -0.813,
                                                    0.267
                                                ],
                                                [
                                                    -0.826,
                                                    0.268
                                                ],
                                                [
                                                    -2.644,
                                                    1.5
                                                ],
                                                [
                                                    -2.44,
                                                    2.199
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.474,
                                                    -0.496
                                                ],
                                                [
                                                    -0.839,
                                                    -0.292
                                                ],
                                                [
                                                    -2.987,
                                                    -0.864
                                                ],
                                                [
                                                    -1.335,
                                                    -0.598
                                                ],
                                                [
                                                    -1.818,
                                                    -0.432
                                                ],
                                                [
                                                    -1.767,
                                                    -0.114
                                                ],
                                                [
                                                    -1.347,
                                                    -0.254
                                                ],
                                                [
                                                    -1.322,
                                                    -0.369
                                                ],
                                                [
                                                    -1.856,
                                                    -0.254
                                                ],
                                                [
                                                    -2.745,
                                                    -0.242
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.818,
                                                    0.025
                                                ],
                                                [
                                                    -1.347,
                                                    -0.051
                                                ],
                                                [
                                                    -1.335,
                                                    -0.14
                                                ],
                                                [
                                                    -1.894,
                                                    0
                                                ],
                                                [
                                                    -3.432,
                                                    0.166
                                                ],
                                                [
                                                    -1.22,
                                                    0.051
                                                ],
                                                [
                                                    -2.631,
                                                    0.255
                                                ],
                                                [
                                                    -3.254,
                                                    0.483
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -3.292,
                                                    0.635
                                                ],
                                                [
                                                    -1.779,
                                                    -1.271
                                                ],
                                                [
                                                    -0.928,
                                                    -0.725
                                                ],
                                                [
                                                    -0.966,
                                                    -0.864
                                                ],
                                                [
                                                    -2.148,
                                                    -1.232
                                                ],
                                                [
                                                    -2.326,
                                                    -0.826
                                                ],
                                                [
                                                    -1.131,
                                                    -0.458
                                                ],
                                                [
                                                    -3.343,
                                                    -0.865
                                                ],
                                                [
                                                    -3.8,
                                                    -0.509
                                                ],
                                                [
                                                    -3.597,
                                                    -0.076
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.343,
                                                    -0.025
                                                ],
                                                [
                                                    -0.508,
                                                    0
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.313,
                                                    0.204
                                                ],
                                                [
                                                    -1.093,
                                                    0.063
                                                ],
                                                [
                                                    -2.25,
                                                    0.355
                                                ],
                                                [
                                                    -1.792,
                                                    0.559
                                                ],
                                                [
                                                    -1.398,
                                                    0.318
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.153,
                                                    0.114
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.682,
                                                    0.725
                                                ],
                                                [
                                                    -0.305,
                                                    0.14
                                                ],
                                                [
                                                    -0.165,
                                                    0.051
                                                ],
                                                [
                                                    -1.22,
                                                    0.331
                                                ],
                                                [
                                                    -2.352,
                                                    0.814
                                                ],
                                                [
                                                    -2.034,
                                                    0.915
                                                ],
                                                [
                                                    -1.347,
                                                    0.547
                                                ],
                                                [
                                                    -1.513,
                                                    0.483
                                                ],
                                                [
                                                    -1.97,
                                                    0.915
                                                ],
                                                [
                                                    -2.148,
                                                    1.118
                                                ],
                                                [
                                                    -0.063,
                                                    0.114
                                                ],
                                                [
                                                    -2.618,
                                                    1.487
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.119,
                                                    0.598
                                                ],
                                                [
                                                    -1.691,
                                                    1.055
                                                ],
                                                [
                                                    -1.347,
                                                    1.144
                                                ],
                                                [
                                                    -1.157,
                                                    0.801
                                                ],
                                                [
                                                    -1.296,
                                                    0.712
                                                ],
                                                [
                                                    -1.474,
                                                    1.105
                                                ],
                                                [
                                                    -2.161,
                                                    1.766
                                                ],
                                                [
                                                    -1.131,
                                                    1.106
                                                ],
                                                [
                                                    -1.36,
                                                    1.068
                                                ],
                                                [
                                                    -1.449,
                                                    0.979
                                                ],
                                                [
                                                    -1.335,
                                                    1.03
                                                ],
                                                [
                                                    -1.309,
                                                    0.916
                                                ],
                                                [
                                                    -1.411,
                                                    1.118
                                                ],
                                                [
                                                    -1.208,
                                                    1.246
                                                ],
                                                [
                                                    -1.233,
                                                    0.992
                                                ],
                                                [
                                                    -1.246,
                                                    0.877
                                                ],
                                                [
                                                    -1.449,
                                                    1.22
                                                ],
                                                [
                                                    -1.487,
                                                    1.398
                                                ],
                                                [
                                                    -1.004,
                                                    0.902
                                                ],
                                                [
                                                    -2.606,
                                                    2.517
                                                ],
                                                [
                                                    -0.839,
                                                    0.788
                                                ],
                                                [
                                                    -1.538,
                                                    1.64
                                                ],
                                                [
                                                    -0.826,
                                                    0.762
                                                ],
                                                [
                                                    -0.991,
                                                    1.131
                                                ],
                                                [
                                                    -1.945,
                                                    2.504
                                                ],
                                                [
                                                    -0.953,
                                                    1.728
                                                ],
                                                [
                                                    -0.877,
                                                    1.246
                                                ],
                                                [
                                                    -1.004,
                                                    1.195
                                                ],
                                                [
                                                    -1.106,
                                                    1.703
                                                ],
                                                [
                                                    -1.576,
                                                    2.644
                                                ],
                                                [
                                                    -0.75,
                                                    1.767
                                                ],
                                                [
                                                    -0.775,
                                                    1.373
                                                ],
                                                [
                                                    -0.953,
                                                    1.347
                                                ],
                                                [
                                                    -0.902,
                                                    1.691
                                                ],
                                                [
                                                    -0.737,
                                                    1.334
                                                ],
                                                [
                                                    -0.915,
                                                    1.766
                                                ],
                                                [
                                                    -0.712,
                                                    1.678
                                                ],
                                                [
                                                    -0.75,
                                                    1.487
                                                ],
                                                [
                                                    -1.462,
                                                    3.483
                                                ],
                                                [
                                                    -0.305,
                                                    0.673
                                                ],
                                                [
                                                    -0.763,
                                                    2.733
                                                ],
                                                [
                                                    -0.356,
                                                    3.152
                                                ],
                                                [
                                                    0.331,
                                                    3.852
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.915,
                                                    2.885
                                                ],
                                                [
                                                    1.754,
                                                    3.012
                                                ],
                                                [
                                                    1.983,
                                                    2.224
                                                ],
                                                [
                                                    1.729,
                                                    1.144
                                                ],
                                                [
                                                    0.89,
                                                    0.686
                                                ],
                                                [
                                                    0.813,
                                                    0.737
                                                ],
                                                [
                                                    1.919,
                                                    1.08
                                                ],
                                                [
                                                    1.309,
                                                    0.356
                                                ],
                                                [
                                                    0.038,
                                                    0.013
                                                ],
                                                [
                                                    -2.364,
                                                    2.377
                                                ],
                                                [
                                                    -1.309,
                                                    1.678
                                                ],
                                                [
                                                    -0.928,
                                                    1.054
                                                ],
                                                [
                                                    -1.004,
                                                    1.017
                                                ],
                                                [
                                                    -1.322,
                                                    1.715
                                                ],
                                                [
                                                    -0.902,
                                                    1.792
                                                ],
                                                [
                                                    -0.826,
                                                    1.246
                                                ],
                                                [
                                                    -0.991,
                                                    1.207
                                                ],
                                                [
                                                    -1.068,
                                                    1.805
                                                ],
                                                [
                                                    -1.767,
                                                    3.495
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.271,
                                                    2.987
                                                ],
                                                [
                                                    -0.826,
                                                    2.466
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.47,
                                                    2.097
                                                ],
                                                [
                                                    -0.369,
                                                    1.322
                                                ],
                                                [
                                                    -0.47,
                                                    1.347
                                                ],
                                                [
                                                    -0.432,
                                                    2.11
                                                ],
                                                [
                                                    -0.191,
                                                    2.174
                                                ],
                                                [
                                                    -0.191,
                                                    1.334
                                                ],
                                                [
                                                    -0.28,
                                                    1.411
                                                ],
                                                [
                                                    -0.14,
                                                    2.161
                                                ]
                                            ],
                                            "o": [
                                                [
                                                    -0.038,
                                                    -2.478
                                                ],
                                                [
                                                    -0.305,
                                                    -1.475
                                                ],
                                                [
                                                    -0.432,
                                                    -3.546
                                                ],
                                                [
                                                    -0.89,
                                                    -3.521
                                                ],
                                                [
                                                    -1.157,
                                                    -2.86
                                                ],
                                                [
                                                    -0.597,
                                                    -1.08
                                                ],
                                                [
                                                    -0.966,
                                                    -2.021
                                                ],
                                                [
                                                    -1.716,
                                                    -2.3
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.211,
                                                    -2.173
                                                ],
                                                [
                                                    -2.135,
                                                    -1.512
                                                ],
                                                [
                                                    -0.813,
                                                    -0.381
                                                ],
                                                [
                                                    -0.928,
                                                    -0.458
                                                ],
                                                [
                                                    -2.097,
                                                    -1.131
                                                ],
                                                [
                                                    -2.745,
                                                    -0.89
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.644,
                                                    -0.509
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.415,
                                                    -0.216
                                                ],
                                                [
                                                    -2.224,
                                                    0.039
                                                ],
                                                [
                                                    -1.665,
                                                    -0.102
                                                ],
                                                [
                                                    -1.83,
                                                    0.089
                                                ],
                                                [
                                                    -1.119,
                                                    0.115
                                                ],
                                                [
                                                    -1.601,
                                                    0.127
                                                ],
                                                [
                                                    -1.309,
                                                    0.153
                                                ],
                                                [
                                                    -2.021,
                                                    0.178
                                                ],
                                                [
                                                    -1.195,
                                                    0.051
                                                ],
                                                [
                                                    -1.474,
                                                    -3.356
                                                ],
                                                [
                                                    -2.453,
                                                    -3.076
                                                ],
                                                [
                                                    -3.279,
                                                    -2.237
                                                ],
                                                [
                                                    -4.245,
                                                    -1.31
                                                ],
                                                [
                                                    -1.322,
                                                    0
                                                ],
                                                [
                                                    -0.343,
                                                    0.064
                                                ],
                                                [
                                                    -0.33,
                                                    -0.636
                                                ],
                                                [
                                                    -1.309,
                                                    -2.491
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.652,
                                                    -2.581
                                                ],
                                                [
                                                    -2.135,
                                                    -2.618
                                                ],
                                                [
                                                    -2.072,
                                                    -2.059
                                                ],
                                                [
                                                    -0.852,
                                                    -0.699
                                                ],
                                                [
                                                    -1.64,
                                                    -1.449
                                                ],
                                                [
                                                    -2.758,
                                                    -1.906
                                                ],
                                                [
                                                    -0.89,
                                                    -0.521
                                                ],
                                                [
                                                    -1.932,
                                                    -1.182
                                                ],
                                                [
                                                    -1.754,
                                                    -0.89
                                                ],
                                                [
                                                    -1.297,
                                                    -0.483
                                                ],
                                                [
                                                    -1.22,
                                                    -0.534
                                                ],
                                                [
                                                    -1.754,
                                                    -0.89
                                                ],
                                                [
                                                    -1.729,
                                                    -0.661
                                                ],
                                                [
                                                    -1.462,
                                                    -0.33
                                                ],
                                                [
                                                    -1.322,
                                                    -0.445
                                                ],
                                                [
                                                    -1.754,
                                                    -0.699
                                                ],
                                                [
                                                    -1.271,
                                                    -0.369
                                                ],
                                                [
                                                    -1.868,
                                                    -0.623
                                                ],
                                                [
                                                    -1.767,
                                                    -0.458
                                                ],
                                                [
                                                    -1.512,
                                                    -0.204
                                                ],
                                                [
                                                    -0.241,
                                                    -0.254
                                                ],
                                                [
                                                    -1.932,
                                                    -0.445
                                                ],
                                                [
                                                    -1.309,
                                                    -0.191
                                                ],
                                                [
                                                    -1.907,
                                                    -0.343
                                                ],
                                                [
                                                    -1.373,
                                                    -0.126
                                                ],
                                                [
                                                    -1.373,
                                                    -0.19
                                                ],
                                                [
                                                    -1.843,
                                                    -0.369
                                                ],
                                                [
                                                    -1.881,
                                                    -0.19
                                                ],
                                                [
                                                    -1.436,
                                                    0
                                                ],
                                                [
                                                    -1.436,
                                                    -0.089
                                                ],
                                                [
                                                    -1.792,
                                                    -0.292
                                                ],
                                                [
                                                    -2.008,
                                                    -0.076
                                                ],
                                                [
                                                    -3.089,
                                                    0.063
                                                ],
                                                [
                                                    -1.449,
                                                    0.152
                                                ],
                                                [
                                                    -2.212,
                                                    0.063
                                                ],
                                                [
                                                    -1.042,
                                                    0.076
                                                ],
                                                [
                                                    -1.436,
                                                    0.076
                                                ],
                                                [
                                                    -1.741,
                                                    -0.165
                                                ],
                                                [
                                                    -1.843,
                                                    0.166
                                                ],
                                                [
                                                    -1.398,
                                                    0.241
                                                ],
                                                [
                                                    -1.894,
                                                    0.228
                                                ],
                                                [
                                                    -1.322,
                                                    0.254
                                                ],
                                                [
                                                    -3.216,
                                                    0.483
                                                ],
                                                [
                                                    -3.317,
                                                    0.598
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.72,
                                                    0.674
                                                ],
                                                [
                                                    -3.089,
                                                    1.017
                                                ],
                                                [
                                                    -2.199,
                                                    0.889
                                                ],
                                                [
                                                    -1.08,
                                                    0.547
                                                ],
                                                [
                                                    -3,
                                                    1.449
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.479,
                                                    1.398
                                                ],
                                                [
                                                    -2.631,
                                                    1.728
                                                ],
                                                [
                                                    -1.119,
                                                    0.852
                                                ],
                                                [
                                                    -1.78,
                                                    1.182
                                                ],
                                                [
                                                    -1.602,
                                                    1.424
                                                ],
                                                [
                                                    -0.966,
                                                    1.22
                                                ],
                                                [
                                                    -0.864,
                                                    0.89
                                                ],
                                                [
                                                    -1.652,
                                                    1.601
                                                ],
                                                [
                                                    -1.538,
                                                    1.881
                                                ],
                                                [
                                                    -0.635,
                                                    1.004
                                                ],
                                                [
                                                    -2.173,
                                                    3.19
                                                ],
                                                [
                                                    -2.605,
                                                    0.813
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -2.25,
                                                    1.334
                                                ],
                                                [
                                                    -1.995,
                                                    2.008
                                                ],
                                                [
                                                    -1.462,
                                                    2.415
                                                ],
                                                [
                                                    -1.182,
                                                    3.788
                                                ],
                                                [
                                                    0.076,
                                                    5.02
                                                ],
                                                [
                                                    1.309,
                                                    3.788
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.004,
                                                    2.936
                                                ],
                                                [
                                                    -0.699,
                                                    1.728
                                                ],
                                                [
                                                    -0.75,
                                                    1.259
                                                ],
                                                [
                                                    -0.699,
                                                    1.487
                                                ],
                                                [
                                                    -0.623,
                                                    1.729
                                                ],
                                                [
                                                    -0.902,
                                                    1.652
                                                ],
                                                [
                                                    -0.852,
                                                    1.208
                                                ],
                                                [
                                                    -0.839,
                                                    1.373
                                                ],
                                                [
                                                    -0.826,
                                                    1.652
                                                ],
                                                [
                                                    -0.941,
                                                    1.424
                                                ],
                                                [
                                                    -1.068,
                                                    1.208
                                                ],
                                                [
                                                    -1.411,
                                                    2.009
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -1.195,
                                                    1.704
                                                ],
                                                [
                                                    -0.966,
                                                    1.5
                                                ],
                                                [
                                                    -0.89,
                                                    1.271
                                                ],
                                                [
                                                    -1.36,
                                                    1.843
                                                ],
                                                [
                                                    -1.347,
                                                    2.097
                                                ],
                                                [
                                                    -0.661,
                                                    1.258
                                                ],
                                                [
                                                    -0.686,
                                                    1.22
                                                ],
                                                [
                                                    -1.296,
                                                    2.085
                                                ],
                                                [
                                                    -0.762,
                                                    1.627
                                                ],
                                                [
                                                    -0.47,
                                                    1.322
                                                ],
                                                [
                                                    -1.22,
                                                    2.898
                                                ],
                                                [
                                                    -0.699,
                                                    1.995
                                                ],
                                                [
                                                    -0.229,
                                                    1.118
                                                ],
                                                [
                                                    -0.292,
                                                    1.182
                                                ],
                                                [
                                                    -0.661,
                                                    1.855
                                                ],
                                                [
                                                    -0.369,
                                                    2.732
                                                ],
                                                [
                                                    0.051,
                                                    1.004
                                                ],
                                                [
                                                    0.013,
                                                    0.814
                                                ],
                                                [
                                                    0.025,
                                                    2.822
                                                ],
                                                [
                                                    0.483,
                                                    3.114
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.979,
                                                    3.724
                                                ],
                                                [
                                                    -2.402,
                                                    4.017
                                                ],
                                                [
                                                    -0.877,
                                                    2.11
                                                ],
                                                [
                                                    -0.318,
                                                    1.042
                                                ],
                                                [
                                                    -0.419,
                                                    1.284
                                                ],
                                                [
                                                    -0.724,
                                                    1.805
                                                ],
                                                [
                                                    -0.483,
                                                    1.907
                                                ],
                                                [
                                                    -0.14,
                                                    1.449
                                                ],
                                                [
                                                    -0.267,
                                                    1.424
                                                ],
                                                [
                                                    -0.559,
                                                    1.728
                                                ],
                                                [
                                                    -0.28,
                                                    1.983
                                                ],
                                                [
                                                    -0.089,
                                                    1.347
                                                ],
                                                [
                                                    -0.191,
                                                    1.843
                                                ],
                                                [
                                                    0.025,
                                                    1.551
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.178,
                                                    2.085
                                                ],
                                                [
                                                    -0.102,
                                                    1.335
                                                ],
                                                [
                                                    -0.28,
                                                    1.653
                                                ],
                                                [
                                                    -0.064,
                                                    1.766
                                                ],
                                                [
                                                    0.165,
                                                    1.424
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.025,
                                                    2.034
                                                ],
                                                [
                                                    0.051,
                                                    1.283
                                                ],
                                                [
                                                    -0.076,
                                                    1.576
                                                ],
                                                [
                                                    0.165,
                                                    2.084
                                                ],
                                                [
                                                    0.292,
                                                    1.372
                                                ],
                                                [
                                                    0.191,
                                                    1.385
                                                ],
                                                [
                                                    0.152,
                                                    2.008
                                                ],
                                                [
                                                    0.458,
                                                    2.275
                                                ],
                                                [
                                                    0.343,
                                                    1.105
                                                ],
                                                [
                                                    1.068,
                                                    3.801
                                                ],
                                                [
                                                    1.195,
                                                    3.292
                                                ],
                                                [
                                                    1.538,
                                                    3.317
                                                ],
                                                [
                                                    0.635,
                                                    1.105
                                                ],
                                                [
                                                    0.966,
                                                    1.893
                                                ],
                                                [
                                                    2.008,
                                                    2.77
                                                ],
                                                [
                                                    1.487,
                                                    1.652
                                                ],
                                                [
                                                    1.004,
                                                    0.788
                                                ],
                                                [
                                                    0.966,
                                                    0.864
                                                ],
                                                [
                                                    1.449,
                                                    1.525
                                                ],
                                                [
                                                    2.809,
                                                    2.034
                                                ],
                                                [
                                                    0.775,
                                                    0.445
                                                ],
                                                [
                                                    2.161,
                                                    1.283
                                                ],
                                                [
                                                    1.906,
                                                    0.852
                                                ],
                                                [
                                                    1.335,
                                                    0.331
                                                ],
                                                [
                                                    1.144,
                                                    0.382
                                                ],
                                                [
                                                    2.021,
                                                    0.788
                                                ],
                                                [
                                                    2.199,
                                                    0.534
                                                ],
                                                [
                                                    1.157,
                                                    0.089
                                                ],
                                                [
                                                    1.22,
                                                    0.152
                                                ],
                                                [
                                                    2.11,
                                                    0.381
                                                ],
                                                [
                                                    4.156,
                                                    0
                                                ],
                                                [
                                                    3.063,
                                                    -0.47
                                                ],
                                                [
                                                    0.826,
                                                    -0.292
                                                ],
                                                [
                                                    0.826,
                                                    -0.28
                                                ],
                                                [
                                                    2.847,
                                                    -0.902
                                                ],
                                                [
                                                    2.923,
                                                    -1.652
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.449,
                                                    0.597
                                                ],
                                                [
                                                    0.864,
                                                    0.292
                                                ],
                                                [
                                                    2.288,
                                                    0.839
                                                ],
                                                [
                                                    1.284,
                                                    0.381
                                                ],
                                                [
                                                    1.627,
                                                    0.724
                                                ],
                                                [
                                                    1.767,
                                                    0.42
                                                ],
                                                [
                                                    1.462,
                                                    0.102
                                                ],
                                                [
                                                    1.334,
                                                    0.241
                                                ],
                                                [
                                                    1.741,
                                                    0.47
                                                ],
                                                [
                                                    2.758,
                                                    0.369
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.843,
                                                    0.153
                                                ],
                                                [
                                                    1.347,
                                                    -0.013
                                                ],
                                                [
                                                    1.335,
                                                    0.063
                                                ],
                                                [
                                                    1.805,
                                                    0.178
                                                ],
                                                [
                                                    4.309,
                                                    0
                                                ],
                                                [
                                                    1.207,
                                                    -0.063
                                                ],
                                                [
                                                    2.58,
                                                    -0.089
                                                ],
                                                [
                                                    3.33,
                                                    -0.33
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.661,
                                                    -0.534
                                                ],
                                                [
                                                    1.64,
                                                    1.614
                                                ],
                                                [
                                                    0.941,
                                                    0.661
                                                ],
                                                [
                                                    1.004,
                                                    0.788
                                                ],
                                                [
                                                    1.767,
                                                    1.589
                                                ],
                                                [
                                                    2.186,
                                                    1.259
                                                ],
                                                [
                                                    1.144,
                                                    0.407
                                                ],
                                                [
                                                    3.711,
                                                    1.512
                                                ],
                                                [
                                                    3.406,
                                                    0.877
                                                ],
                                                [
                                                    3.381,
                                                    0.444
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.343,
                                                    0.012
                                                ],
                                                [
                                                    0.508,
                                                    0.051
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    2.237,
                                                    0
                                                ],
                                                [
                                                    1.08,
                                                    -0.089
                                                ],
                                                [
                                                    2.173,
                                                    -0.115
                                                ],
                                                [
                                                    1.894,
                                                    -0.305
                                                ],
                                                [
                                                    1.347,
                                                    -0.406
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.178,
                                                    -0.05
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    3.267,
                                                    -0.699
                                                ],
                                                [
                                                    0.419,
                                                    -0.101
                                                ],
                                                [
                                                    0.152,
                                                    -0.089
                                                ],
                                                [
                                                    1.22,
                                                    -0.355
                                                ],
                                                [
                                                    2.326,
                                                    -0.635
                                                ],
                                                [
                                                    2.173,
                                                    -0.75
                                                ],
                                                [
                                                    1.322,
                                                    -0.585
                                                ],
                                                [
                                                    1.462,
                                                    -0.585
                                                ],
                                                [
                                                    2.008,
                                                    -0.636
                                                ],
                                                [
                                                    3.699,
                                                    -1.729
                                                ],
                                                [
                                                    0.305,
                                                    -0.153
                                                ],
                                                [
                                                    2.72,
                                                    -1.398
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.08,
                                                    -0.623
                                                ],
                                                [
                                                    1.703,
                                                    -0.902
                                                ],
                                                [
                                                    1.538,
                                                    -0.979
                                                ],
                                                [
                                                    1.131,
                                                    -0.966
                                                ],
                                                [
                                                    1.144,
                                                    -0.788
                                                ],
                                                [
                                                    1.551,
                                                    -0.852
                                                ],
                                                [
                                                    3.038,
                                                    -2.275
                                                ],
                                                [
                                                    1.246,
                                                    -1.017
                                                ],
                                                [
                                                    1.233,
                                                    -1.195
                                                ],
                                                [
                                                    1.284,
                                                    -1.017
                                                ],
                                                [
                                                    1.373,
                                                    -0.915
                                                ],
                                                [
                                                    1.233,
                                                    -0.953
                                                ],
                                                [
                                                    1.449,
                                                    -1.004
                                                ],
                                                [
                                                    1.398,
                                                    -1.094
                                                ],
                                                [
                                                    1.119,
                                                    -1.156
                                                ],
                                                [
                                                    1.169,
                                                    -0.94
                                                ],
                                                [
                                                    1.487,
                                                    -1.042
                                                ],
                                                [
                                                    1.538,
                                                    -1.297
                                                ],
                                                [
                                                    0.979,
                                                    -0.915
                                                ],
                                                [
                                                    2.377,
                                                    -2.148
                                                ],
                                                [
                                                    0.814,
                                                    -0.788
                                                ],
                                                [
                                                    1.601,
                                                    -1.5
                                                ],
                                                [
                                                    0.775,
                                                    -0.826
                                                ],
                                                [
                                                    1.055,
                                                    -0.979
                                                ],
                                                [
                                                    2.517,
                                                    -2.886
                                                ],
                                                [
                                                    1.271,
                                                    -1.614
                                                ],
                                                [
                                                    0.788,
                                                    -1.424
                                                ],
                                                [
                                                    0.902,
                                                    -1.271
                                                ],
                                                [
                                                    1.271,
                                                    -1.499
                                                ],
                                                [
                                                    2.288,
                                                    -3.546
                                                ],
                                                [
                                                    1.03,
                                                    -1.703
                                                ],
                                                [
                                                    0.661,
                                                    -1.55
                                                ],
                                                [
                                                    0.801,
                                                    -1.436
                                                ],
                                                [
                                                    1.08,
                                                    -1.525
                                                ],
                                                [
                                                    0.724,
                                                    -1.373
                                                ],
                                                [
                                                    0.991,
                                                    -1.767
                                                ],
                                                [
                                                    0.864,
                                                    -1.678
                                                ],
                                                [
                                                    0.674,
                                                    -1.563
                                                ],
                                                [
                                                    1.258,
                                                    -2.44
                                                ],
                                                [
                                                    0.267,
                                                    -0.648
                                                ],
                                                [
                                                    0.979,
                                                    -2.224
                                                ],
                                                [
                                                    1.004,
                                                    -3.61
                                                ],
                                                [
                                                    0.356,
                                                    -3.215
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    -0.216,
                                                    -2.797
                                                ],
                                                [
                                                    -1.042,
                                                    -3.292
                                                ],
                                                [
                                                    -1.805,
                                                    -3.101
                                                ],
                                                [
                                                    -1.411,
                                                    -1.589
                                                ],
                                                [
                                                    -0.928,
                                                    -0.61
                                                ],
                                                [
                                                    -0.826,
                                                    -0.636
                                                ],
                                                [
                                                    -1.512,
                                                    -1.385
                                                ],
                                                [
                                                    -1.208,
                                                    -0.712
                                                ],
                                                [
                                                    -0.025,
                                                    -0.012
                                                ],
                                                [
                                                    2.809,
                                                    -2.491
                                                ],
                                                [
                                                    1.551,
                                                    -1.55
                                                ],
                                                [
                                                    0.864,
                                                    -1.106
                                                ],
                                                [
                                                    0.941,
                                                    -1.068
                                                ],
                                                [
                                                    1.487,
                                                    -1.5
                                                ],
                                                [
                                                    1.258,
                                                    -1.653
                                                ],
                                                [
                                                    0.724,
                                                    -1.436
                                                ],
                                                [
                                                    0.839,
                                                    -1.233
                                                ],
                                                [
                                                    1.284,
                                                    -1.563
                                                ],
                                                [
                                                    1.665,
                                                    -2.847
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    1.423,
                                                    -2.834
                                                ],
                                                [
                                                    1.042,
                                                    -2.453
                                                ],
                                                [
                                                    0,
                                                    0
                                                ],
                                                [
                                                    0.737,
                                                    -2.097
                                                ],
                                                [
                                                    0.305,
                                                    -1.334
                                                ],
                                                [
                                                    0.381,
                                                    -1.386
                                                ],
                                                [
                                                    0.686,
                                                    -1.983
                                                ],
                                                [
                                                    0.458,
                                                    -2.199
                                                ],
                                                [
                                                    0.127,
                                                    -1.347
                                                ],
                                                [
                                                    0.191,
                                                    -1.411
                                                ],
                                                [
                                                    0.432,
                                                    -2.059
                                                ],
                                                [
                                                    0.318,
                                                    -4.474
                                                ]
                                            ],
                                            "v": [
                                                [
                                                    285.621,
                                                    -103.283
                                                ],
                                                [
                                                    284.591,
                                                    -110.4
                                                ],
                                                [
                                                    283.816,
                                                    -114.633
                                                ],
                                                [
                                                    281.693,
                                                    -125.843
                                                ],
                                                [
                                                    278.351,
                                                    -136.774
                                                ],
                                                [
                                                    274.029,
                                                    -146.205
                                                ],
                                                [
                                                    272.377,
                                                    -149.497
                                                ],
                                                [
                                                    269.059,
                                                    -155.446
                                                ],
                                                [
                                                    263.302,
                                                    -161.623
                                                ],
                                                [
                                                    261.814,
                                                    -163.059
                                                ],
                                                [
                                                    253.858,
                                                    -169.91
                                                ],
                                                [
                                                    247.032,
                                                    -173.608
                                                ],
                                                [
                                                    244.592,
                                                    -174.765
                                                ],
                                                [
                                                    241.847,
                                                    -176.214
                                                ],
                                                [
                                                    235.161,
                                                    -179.315
                                                ],
                                                [
                                                    226.607,
                                                    -181.31
                                                ],
                                                [
                                                    224.98,
                                                    -181.628
                                                ],
                                                [
                                                    216.871,
                                                    -182.569
                                                ],
                                                [
                                                    214.647,
                                                    -182.76
                                                ],
                                                [
                                                    207.313,
                                                    -182.887
                                                ],
                                                [
                                                    200.577,
                                                    -183.026
                                                ],
                                                [
                                                    195.467,
                                                    -183.154
                                                ],
                                                [
                                                    190.027,
                                                    -182.696
                                                ],
                                                [
                                                    186.684,
                                                    -182.378
                                                ],
                                                [
                                                    181.893,
                                                    -181.87
                                                ],
                                                [
                                                    177.965,
                                                    -181.438
                                                ],
                                                [
                                                    171.94,
                                                    -181.094
                                                ],
                                                [
                                                    168.42,
                                                    -180.929
                                                ],
                                                [
                                                    162.611,
                                                    -189.928
                                                ],
                                                [
                                                    154.375,
                                                    -198.19
                                                ],
                                                [
                                                    143.838,
                                                    -203.286
                                                ],
                                                [
                                                    132.247,
                                                    -205.231
                                                ],
                                                [
                                                    128.205,
                                                    -204.647
                                                ],
                                                [
                                                    127.162,
                                                    -204.431
                                                ],
                                                [
                                                    126.146,
                                                    -206.362
                                                ],
                                                [
                                                    121.608,
                                                    -214.396
                                                ],
                                                [
                                                    121.227,
                                                    -214.992
                                                ],
                                                [
                                                    115.838,
                                                    -222.733
                                                ],
                                                [
                                                    108.936,
                                                    -230.13
                                                ],
                                                [
                                                    101.373,
                                                    -236.842
                                                ],
                                                [
                                                    98.819,
                                                    -239.028
                                                ],
                                                [
                                                    93.582,
                                                    -243.273
                                                ],
                                                [
                                                    85.015,
                                                    -248.611
                                                ],
                                                [
                                                    82.346,
                                                    -250.226
                                                ],
                                                [
                                                    76.296,
                                                    -253.708
                                                ],
                                                [
                                                    70.844,
                                                    -255.996
                                                ],
                                                [
                                                    66.954,
                                                    -257.534
                                                ],
                                                [
                                                    63.319,
                                                    -259.288
                                                ],
                                                [
                                                    57.841,
                                                    -261.83
                                                ],
                                                [
                                                    52.515,
                                                    -263.279
                                                ],
                                                [
                                                    48.105,
                                                    -264.423
                                                ],
                                                [
                                                    44.152,
                                                    -265.935
                                                ],
                                                [
                                                    38.687,
                                                    -267.931
                                                ],
                                                [
                                                    34.861,
                                                    -269.151
                                                ],
                                                [
                                                    29.09,
                                                    -270.917
                                                ],
                                                [
                                                    23.727,
                                                    -271.845
                                                ],
                                                [
                                                    19.011,
                                                    -272.697
                                                ],
                                                [
                                                    17.524,
                                                    -273.561
                                                ],
                                                [
                                                    11.639,
                                                    -274.578
                                                ],
                                                [
                                                    7.674,
                                                    -275.214
                                                ],
                                                [
                                                    1.916,
                                                    -275.926
                                                ],
                                                [
                                                    -2.215,
                                                    -276.383
                                                ],
                                                [
                                                    -6.333,
                                                    -277.133
                                                ],
                                                [
                                                    -12.027,
                                                    -278.086
                                                ],
                                                [
                                                    -17.658,
                                                    -278.315
                                                ],
                                                [
                                                    -21.992,
                                                    -278.429
                                                ],
                                                [
                                                    -26.364,
                                                    -278.976
                                                ],
                                                [
                                                    -31.906,
                                                    -279.612
                                                ],
                                                [
                                                    -38.007,
                                                    -279.599
                                                ],
                                                [
                                                    -47.26,
                                                    -279.154
                                                ],
                                                [
                                                    -51.62,
                                                    -278.798
                                                ],
                                                [
                                                    -58.216,
                                                    -278.429
                                                ],
                                                [
                                                    -61.368,
                                                    -278.213
                                                ],
                                                [
                                                    -65.842,
                                                    -278.429
                                                ],
                                                [
                                                    -71.206,
                                                    -278.607
                                                ],
                                                [
                                                    -76.684,
                                                    -277.819
                                                ],
                                                [
                                                    -80.891,
                                                    -277.171
                                                ],
                                                [
                                                    -86.535,
                                                    -276.256
                                                ],
                                                [
                                                    -90.538,
                                                    -275.557
                                                ],
                                                [
                                                    -100.173,
                                                    -273.955
                                                ],
                                                [
                                                    -110.658,
                                                    -271.744
                                                ],
                                                [
                                                    -112.692,
                                                    -271.223
                                                ],
                                                [
                                                    -121.005,
                                                    -268.909
                                                ],
                                                [
                                                    -131.046,
                                                    -265.172
                                                ],
                                                [
                                                    -137.426,
                                                    -262.135
                                                ],
                                                [
                                                    -140.693,
                                                    -260.495
                                                ],
                                                [
                                                    -149.476,
                                                    -255.767
                                                ],
                                                [
                                                    -151.84,
                                                    -254.445
                                                ],
                                                [
                                                    -159.326,
                                                    -249.996
                                                ],
                                                [
                                                    -168.109,
                                                    -243.857
                                                ],
                                                [
                                                    -171.591,
                                                    -241.442
                                                ],
                                                [
                                                    -176.853,
                                                    -237.592
                                                ],
                                                [
                                                    -181.048,
                                                    -232.863
                                                ],
                                                [
                                                    -183.92,
                                                    -229.444
                                                ],
                                                [
                                                    -186.551,
                                                    -226.851
                                                ],
                                                [
                                                    -191.419,
                                                    -221.767
                                                ],
                                                [
                                                    -195.525,
                                                    -215.857
                                                ],
                                                [
                                                    -197.457,
                                                    -212.883
                                                ],
                                                [
                                                    -202.935,
                                                    -204.138
                                                ],
                                                [
                                                    -211.311,
                                                    -200.693
                                                ],
                                                [
                                                    -212.671,
                                                    -199.893
                                                ],
                                                [
                                                    -219.178,
                                                    -195.254
                                                ],
                                                [
                                                    -224.974,
                                                    -187.615
                                                ],
                                                [
                                                    -228.8,
                                                    -178.845
                                                ],
                                                [
                                                    -230.478,
                                                    -166.427
                                                ],
                                                [
                                                    -228.622,
                                                    -154.009
                                                ],
                                                [
                                                    -222.47,
                                                    -143.815
                                                ],
                                                [
                                                    -222.534,
                                                    -143.638
                                                ],
                                                [
                                                    -225.699,
                                                    -134.943
                                                ],
                                                [
                                                    -228.292,
                                                    -129.974
                                                ],
                                                [
                                                    -230.427,
                                                    -126.085
                                                ],
                                                [
                                                    -232.181,
                                                    -121.611
                                                ],
                                                [
                                                    -234.177,
                                                    -116.755
                                                ],
                                                [
                                                    -237.265,
                                                    -112.002
                                                ],
                                                [
                                                    -239.705,
                                                    -108.367
                                                ],
                                                [
                                                    -241.942,
                                                    -104.172
                                                ],
                                                [
                                                    -244.497,
                                                    -99.533
                                                ],
                                                [
                                                    -247.751,
                                                    -95.504
                                                ],
                                                [
                                                    -250.852,
                                                    -91.703
                                                ],
                                                [
                                                    -255.097,
                                                    -85.73
                                                ],
                                                [
                                                    -256.686,
                                                    -83.506
                                                ],
                                                [
                                                    -260.156,
                                                    -78.282
                                                ],
                                                [
                                                    -263.105,
                                                    -73.807
                                                ],
                                                [
                                                    -265.85,
                                                    -70.045
                                                ],
                                                [
                                                    -269.892,
                                                    -64.325
                                                ],
                                                [
                                                    -273.54,
                                                    -57.831
                                                ],
                                                [
                                                    -275.548,
                                                    -54.082
                                                ],
                                                [
                                                    -277.709,
                                                    -50.471
                                                ],
                                                [
                                                    -281.408,
                                                    -43.9
                                                ],
                                                [
                                                    -283.39,
                                                    -38.867
                                                ],
                                                [
                                                    -284.903,
                                                    -34.889
                                                ],
                                                [
                                                    -288.475,
                                                    -25.89
                                                ],
                                                [
                                                    -290.051,
                                                    -19.789
                                                ],
                                                [
                                                    -290.801,
                                                    -16.446
                                                ],
                                                [
                                                    -291.919,
                                                    -12.925
                                                ],
                                                [
                                                    -293.559,
                                                    -7.041
                                                ],
                                                [
                                                    -293.66,
                                                    1.056
                                                ],
                                                [
                                                    -293.533,
                                                    4.055
                                                ],
                                                [
                                                    -293.508,
                                                    6.47
                                                ],
                                                [
                                                    -293.012,
                                                    15.088
                                                ],
                                                [
                                                    -290.915,
                                                    24.264
                                                ],
                                                [
                                                    -290.508,
                                                    25.815
                                                ],
                                                [
                                                    -287.598,
                                                    35.653
                                                ],
                                                [
                                                    -294.143,
                                                    48.732
                                                ],
                                                [
                                                    -296.279,
                                                    55.1
                                                ],
                                                [
                                                    -297.245,
                                                    58.213
                                                ],
                                                [
                                                    -298.668,
                                                    61.989
                                                ],
                                                [
                                                    -300.638,
                                                    67.606
                                                ],
                                                [
                                                    -301.464,
                                                    73.338
                                                ],
                                                [
                                                    -301.985,
                                                    77.495
                                                ],
                                                [
                                                    -303.167,
                                                    81.766
                                                ],
                                                [
                                                    -304.566,
                                                    87.129
                                                ],
                                                [
                                                    -305.1,
                                                    93.039
                                                ],
                                                [
                                                    -305.405,
                                                    97.031
                                                ],
                                                [
                                                    -305.506,
                                                    102.483
                                                ],
                                                [
                                                    -305.557,
                                                    106.945
                                                ],
                                                [
                                                    -305.849,
                                                    110.58
                                                ],
                                                [
                                                    -306.332,
                                                    116.782
                                                ],
                                                [
                                                    -306.904,
                                                    120.862
                                                ],
                                                [
                                                    -307.54,
                                                    125.959
                                                ],
                                                [
                                                    -307.197,
                                                    131.119
                                                ],
                                                [
                                                    -306.866,
                                                    135.212
                                                ],
                                                [
                                                    -306.879,
                                                    137.792
                                                ],
                                                [
                                                    -306.841,
                                                    143.804
                                                ],
                                                [
                                                    -306.904,
                                                    147.63
                                                ],
                                                [
                                                    -306.917,
                                                    152.435
                                                ],
                                                [
                                                    -305.913,
                                                    158.472
                                                ],
                                                [
                                                    -305.138,
                                                    162.564
                                                ],
                                                [
                                                    -304.718,
                                                    166.708
                                                ],
                                                [
                                                    -303.981,
                                                    172.796
                                                ],
                                                [
                                                    -302.176,
                                                    179.368
                                                ],
                                                [
                                                    -301.185,
                                                    182.697
                                                ],
                                                [
                                                    -298.083,
                                                    192.497
                                                ],
                                                [
                                                    -294.169,
                                                    201.992
                                                ],
                                                [
                                                    -289.275,
                                                    211.042
                                                ],
                                                [
                                                    -287.483,
                                                    214.435
                                                ],
                                                [
                                                    -284.242,
                                                    220.066
                                                ],
                                                [
                                                    -277.734,
                                                    228.124
                                                ],
                                                [
                                                    -272.841,
                                                    232.458
                                                ],
                                                [
                                                    -269.892,
                                                    234.873
                                                ],
                                                [
                                                    -267.134,
                                                    237.606
                                                ],
                                                [
                                                    -262.38,
                                                    242.003
                                                ],
                                                [
                                                    -253.585,
                                                    247.456
                                                ],
                                                [
                                                    -251.272,
                                                    248.803
                                                ],
                                                [
                                                    -244.51,
                                                    252.464
                                                ],
                                                [
                                                    -238.562,
                                                    254.319
                                                ],
                                                [
                                                    -234.583,
                                                    255.412
                                                ],
                                                [
                                                    -231.177,
                                                    256.683
                                                ],
                                                [
                                                    -224.847,
                                                    258.819
                                                ],
                                                [
                                                    -218.212,
                                                    259.67
                                                ],
                                                [
                                                    -214.768,
                                                    259.976
                                                ],
                                                [
                                                    -211.146,
                                                    260.56
                                                ],
                                                [
                                                    -204.689,
                                                    261.335
                                                ],
                                                [
                                                    -193.084,
                                                    260.522
                                                ],
                                                [
                                                    -184.416,
                                                    258.056
                                                ],
                                                [
                                                    -181.95,
                                                    257.192
                                                ],
                                                [
                                                    -179.484,
                                                    256.391
                                                ],
                                                [
                                                    -171.045,
                                                    253.048
                                                ],
                                                [
                                                    -163.164,
                                                    246.922
                                                ],
                                                [
                                                    -162.453,
                                                    246.287
                                                ],
                                                [
                                                    -158.017,
                                                    247.901
                                                ],
                                                [
                                                    -155.462,
                                                    248.791
                                                ],
                                                [
                                                    -147.734,
                                                    251.294
                                                ],
                                                [
                                                    -143.858,
                                                    252.845
                                                ],
                                                [
                                                    -138.735,
                                                    254.764
                                                ],
                                                [
                                                    -133.372,
                                                    255.412
                                                ],
                                                [
                                                    -129.177,
                                                    255.857
                                                ],
                                                [
                                                    -125.212,
                                                    256.824
                                                ],
                                                [
                                                    -119.823,
                                                    258.031
                                                ],
                                                [
                                                    -111.485,
                                                    258.883
                                                ],
                                                [
                                                    -110.277,
                                                    258.984
                                                ],
                                                [
                                                    -104.748,
                                                    259.086
                                                ],
                                                [
                                                    -100.707,
                                                    259.099
                                                ],
                                                [
                                                    -96.703,
                                                    259.442
                                                ],
                                                [
                                                    -91.136,
                                                    259.81
                                                ],
                                                [
                                                    -79.633,
                                                    259.569
                                                ],
                                                [
                                                    -76.01,
                                                    259.417
                                                ],
                                                [
                                                    -68.13,
                                                    258.984
                                                ],
                                                [
                                                    -58.191,
                                                    257.675
                                                ],
                                                [
                                                    -56.716,
                                                    257.459
                                                ],
                                                [
                                                    -46.269,
                                                    255.629
                                                ],
                                                [
                                                    -41.019,
                                                    259.823
                                                ],
                                                [
                                                    -38.21,
                                                    261.882
                                                ],
                                                [
                                                    -35.274,
                                                    264.411
                                                ],
                                                [
                                                    -29.529,
                                                    268.885
                                                ],
                                                [
                                                    -22.615,
                                                    271.822
                                                ],
                                                [
                                                    -19.196,
                                                    273.093
                                                ],
                                                [
                                                    -8.71,
                                                    276.626
                                                ],
                                                [
                                                    2.17,
                                                    278.901
                                                ],
                                                [
                                                    12.542,
                                                    279.486
                                                ],
                                                [
                                                    13.228,
                                                    279.499
                                                ],
                                                [
                                                    14.27,
                                                    279.562
                                                ],
                                                [
                                                    15.808,
                                                    279.651
                                                ],
                                                [
                                                    18.922,
                                                    279.651
                                                ],
                                                [
                                                    25.76,
                                                    279.422
                                                ],
                                                [
                                                    29.027,
                                                    279.219
                                                ],
                                                [
                                                    35.7,
                                                    278.622
                                                ],
                                                [
                                                    41.241,
                                                    277.172
                                                ],
                                                [
                                                    45.334,
                                                    276.029
                                                ],
                                                [
                                                    45.334,
                                                    276.016
                                                ],
                                                [
                                                    45.843,
                                                    275.762
                                                ],
                                                [
                                                    46.77,
                                                    275.571
                                                ],
                                                [
                                                    55.807,
                                                    273.474
                                                ],
                                                [
                                                    56.875,
                                                    273.055
                                                ],
                                                [
                                                    57.358,
                                                    272.838
                                                ],
                                                [
                                                    61.019,
                                                    271.822
                                                ],
                                                [
                                                    68.098,
                                                    269.724
                                                ],
                                                [
                                                    74.402,
                                                    267.118
                                                ],
                                                [
                                                    78.406,
                                                    265.39
                                                ],
                                                [
                                                    82.906,
                                                    263.84
                                                ],
                                                [
                                                    88.956,
                                                    261.628
                                                ],
                                                [
                                                    97.192,
                                                    257.612
                                                ],
                                                [
                                                    97.764,
                                                    257.141
                                                ],
                                                [
                                                    105.797,
                                                    252.705
                                                ],
                                                [
                                                    106.229,
                                                    252.451
                                                ],
                                                [
                                                    109.533,
                                                    250.646
                                                ],
                                                [
                                                    114.694,
                                                    247.748
                                                ],
                                                [
                                                    118.977,
                                                    244.457
                                                ],
                                                [
                                                    122.345,
                                                    241.787
                                                ],
                                                [
                                                    126.019,
                                                    239.614
                                                ],
                                                [
                                                    130.658,
                                                    236.78
                                                ],
                                                [
                                                    138.297,
                                                    230.844
                                                ],
                                                [
                                                    141.843,
                                                    227.59
                                                ],
                                                [
                                                    145.707,
                                                    224.082
                                                ],
                                                [
                                                    149.812,
                                                    221.171
                                                ],
                                                [
                                                    153.905,
                                                    218.299
                                                ],
                                                [
                                                    157.743,
                                                    215.528
                                                ],
                                                [
                                                    162.065,
                                                    212.389
                                                ],
                                                [
                                                    165.916,
                                                    208.753
                                                ],
                                                [
                                                    169.411,
                                                    205.411
                                                ],
                                                [
                                                    173.072,
                                                    202.716
                                                ],
                                                [
                                                    177.546,
                                                    199.373
                                                ],
                                                [
                                                    182.045,
                                                    195.281
                                                ],
                                                [
                                                    185.007,
                                                    192.535
                                                ],
                                                [
                                                    192.417,
                                                    185.608
                                                ],
                                                [
                                                    194.908,
                                                    183.244
                                                ],
                                                [
                                                    199.712,
                                                    178.566
                                                ],
                                                [
                                                    202.127,
                                                    176.216
                                                ],
                                                [
                                                    205.254,
                                                    173.089
                                                ],
                                                [
                                                    212.041,
                                                    164.763
                                                ],
                                                [
                                                    215.244,
                                                    159.628
                                                ],
                                                [
                                                    217.659,
                                                    155.599
                                                ],
                                                [
                                                    220.595,
                                                    151.9
                                                ],
                                                [
                                                    224.269,
                                                    147.147
                                                ],
                                                [
                                                    229.937,
                                                    138.072
                                                ],
                                                [
                                                    232.492,
                                                    132.784
                                                ],
                                                [
                                                    234.551,
                                                    128.399
                                                ],
                                                [
                                                    237.297,
                                                    124.218
                                                ],
                                                [
                                                    240.398,
                                                    119.426
                                                ],
                                                [
                                                    242.622,
                                                    115.372
                                                ],
                                                [
                                                    245.507,
                                                    110.072
                                                ],
                                                [
                                                    247.833,
                                                    104.987
                                                ],
                                                [
                                                    249.93,
                                                    100.386
                                                ],
                                                [
                                                    254.15,
                                                    91.209
                                                ],
                                                [
                                                    255.015,
                                                    89.214
                                                ],
                                                [
                                                    257.849,
                                                    81.74
                                                ],
                                                [
                                                    259.87,
                                                    71.686
                                                ],
                                                [
                                                    259.679,
                                                    61.417
                                                ],
                                                [
                                                    259.552,
                                                    59.764
                                                ],
                                                [
                                                    258.205,
                                                    51.185
                                                ],
                                                [
                                                    253.985,
                                                    41.69
                                                ],
                                                [
                                                    248.367,
                                                    33.772
                                                ],
                                                [
                                                    243.423,
                                                    29.857
                                                ],
                                                [
                                                    240.677,
                                                    27.938
                                                ],
                                                [
                                                    238.237,
                                                    25.828
                                                ],
                                                [
                                                    233.229,
                                                    21.938
                                                ],
                                                [
                                                    229.365,
                                                    20.502
                                                ],
                                                [
                                                    229.289,
                                                    20.477
                                                ],
                                                [
                                                    237.106,
                                                    13.143
                                                ],
                                                [
                                                    241.326,
                                                    8.186
                                                ],
                                                [
                                                    243.982,
                                                    4.92
                                                ],
                                                [
                                                    246.931,
                                                    1.806
                                                ],
                                                [
                                                    251.265,
                                                    -2.948
                                                ],
                                                [
                                                    254.354,
                                                    -8.235
                                                ],
                                                [
                                                    256.591,
                                                    -12.277
                                                ],
                                                [
                                                    259.361,
                                                    -15.862
                                                ],
                                                [
                                                    263.035,
                                                    -20.844
                                                ],
                                                [
                                                    268.119,
                                                    -30.275
                                                ],
                                                [
                                                    268.564,
                                                    -31.178
                                                ],
                                                [
                                                    272.733,
                                                    -39.935
                                                ],
                                                [
                                                    275.465,
                                                    -47.409
                                                ],
                                                [
                                                    276.355,
                                                    -50.014
                                                ],
                                                [
                                                    278.045,
                                                    -56.369
                                                ],
                                                [
                                                    279.024,
                                                    -60.373
                                                ],
                                                [
                                                    280.346,
                                                    -64.466
                                                ],
                                                [
                                                    282.189,
                                                    -70.605
                                                ],
                                                [
                                                    283.041,
                                                    -77.214
                                                ],
                                                [
                                                    283.473,
                                                    -81.243
                                                ],
                                                [
                                                    284.235,
                                                    -85.475
                                                ],
                                                [
                                                    285.24,
                                                    -91.818
                                                ]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 2",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": {
                                        "a": 0,
                                        "k": [
                                            0.066666670144,
                                            0.027450980619,
                                            0.023529412225,
                                            1
                                        ],
                                        "ix": 4
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 5
                                    },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 2
                                    },
                                    "a": {
                                        "a": 0,
                                        "k": [
                                            0,
                                            0
                                        ],
                                        "ix": 1
                                    },
                                    "s": {
                                        "a": 0,
                                        "k": [
                                            100,
                                            100
                                        ],
                                        "ix": 3
                                    },
                                    "r": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 6
                                    },
                                    "o": {
                                        "a": 0,
                                        "k": 100,
                                        "ix": 7
                                    },
                                    "sk": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 4
                                    },
                                    "sa": {
                                        "a": 0,
                                        "k": 0,
                                        "ix": 5
                                    },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 90,
                    "st": 0,
                    "bm": 0
                }
            ]
        }
    ],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 0,
            "nm": "Logo",
            "parent": 2,
            "refId": "comp_0",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        0,
                        0,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        350,
                        350,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 0,
                    "k": [
                        39.667,
                        39.667,
                        100
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "w": 700,
            "h": 700,
            "ip": 0,
            "op": 90,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Layer 3",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        0,
                        0,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.3,
                                    0.3,
                                    0.3
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 0,
                            "s": [
                                20,
                                20,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.3,
                                    0.3,
                                    0.3
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 45,
                            "s": [
                                40,
                                40,
                                100
                            ]
                        },
                        {
                            "t": 89,
                            "s": [
                                20,
                                20,
                                100
                            ]
                        }
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "d": 1,
                            "ty": "el",
                            "s": {
                                "a": 0,
                                "k": [
                                    328.727,
                                    328.727
                                ],
                                "ix": 2
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 3
                            },
                            "nm": "Ellipse Path 1",
                            "mn": "ADBE Vector Shape - Ellipse",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.9529411764705882,
                                    0.9098039215686275,
                                    0.8313725490196079,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 90,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Layer 2",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 50,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        0,
                        0,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.3,
                                    0.3,
                                    0.3
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 0,
                            "s": [
                                15,
                                15,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.3,
                                    0.3,
                                    0.3
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 45,
                            "s": [
                                40,
                                40,
                                100
                            ]
                        },
                        {
                            "t": 89,
                            "s": [
                                15,
                                15,
                                100
                            ]
                        }
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "d": 1,
                            "ty": "el",
                            "s": {
                                "a": 0,
                                "k": [
                                    416.132,
                                    416.132
                                ],
                                "ix": 2
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 3
                            },
                            "nm": "Ellipse Path 1",
                            "mn": "ADBE Vector Shape - Ellipse",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.9529411764705882,
                                    0.9098039215686275,
                                    0.8313725490196079,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 90,
            "st": 0,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Layer 1",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 20,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        0
                    ],
                    "ix": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        0,
                        0,
                        0
                    ],
                    "ix": 1
                },
                "s": {
                    "a": 1,
                    "k": [
                        {
                            "i": {
                                "x": [
                                    0.3,
                                    0.3,
                                    0.3
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 0,
                            "s": [
                                13,
                                13,
                                100
                            ]
                        },
                        {
                            "i": {
                                "x": [
                                    0.3,
                                    0.3,
                                    0.3
                                ],
                                "y": [
                                    1,
                                    1,
                                    1
                                ]
                            },
                            "o": {
                                "x": [
                                    0.167,
                                    0.167,
                                    0.167
                                ],
                                "y": [
                                    0,
                                    0,
                                    0
                                ]
                            },
                            "t": 45,
                            "s": [
                                40,
                                40,
                                100
                            ]
                        },
                        {
                            "t": 89,
                            "s": [
                                13,
                                13,
                                100
                            ]
                        }
                    ],
                    "ix": 6
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "d": 1,
                            "ty": "el",
                            "s": {
                                "a": 0,
                                "k": [
                                    483.262,
                                    483.262
                                ],
                                "ix": 2
                            },
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 3
                            },
                            "nm": "Ellipse Path 1",
                            "mn": "ADBE Vector Shape - Ellipse",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.9529411764705882,
                                    0.9098039215686275,
                                    0.8313725490196079,
                                    1
                                ],
                                "ix": 4
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 5
                            },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 90,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
}

const Loader = () => {
    return (
        <>
            <div className="flex justify-center items-center min-h-[150px]">
                {/* <CircularProgress /> */}
                <Lottie animationData={json} loop={true} className="w-32 h-32" />
            </div>
        </>
    );
};

export default Loader;
